var $parcel$global = globalThis;
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("2cigx", function(module, exports) {
    $parcel$export(module.exports, "provideHealthcheck", ()=>$eec8e8449eafd9c1$export$90dcee7ddb8a0c0c);
    const $eec8e8449eafd9c1$var$globalObj = window || $parcel$global;
    const $eec8e8449eafd9c1$var$defaultHealthcheck = (callback)=>callback({
            isSuccess: true
        });
    const $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c = (healthcheck = $eec8e8449eafd9c1$var$defaultHealthcheck)=>{
        $eec8e8449eafd9c1$var$globalObj.performHealthcheck = healthcheck;
    };
});
parcelRegister("8aaWz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$450787a793d5ee43$export$2e2bcd8739ae039);
    var $2ChuC = parcelRequire("2ChuC");
    var $8Xjsv = parcelRequire("8Xjsv");
    var $450787a793d5ee43$export$2e2bcd8739ae039 = {
        install: (args)=>{
            const argsWithDefaults = {
                renderNavigation: $8Xjsv.default,
                ...args
            };
            (0, $2ChuC.default).install(argsWithDefaults);
        }
    };
});
parcelRegister("2ChuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe3490a17e762431$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $6YRTH;
    var $co1wz;
    var $j8DrX;
    var $7AZuS = parcelRequire("7AZuS");
    var $7o9iL = parcelRequire("7o9iL");
    const $fe3490a17e762431$var$isHeartbeatEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jfp.heartbeat_vfp2h', false);
    const $fe3490a17e762431$var$renderEngagementMessages = ()=>{
        (parcelRequire("1mY2B"));
    };
    const $fe3490a17e762431$var$renderProfileCardNextLegacy = ()=>{
        (parcelRequire("97qv7"));
    };
    const $fe3490a17e762431$var$renderHeartbeat = ()=>{
        (parcelRequire("5PCBy"));
    };
    const $fe3490a17e762431$var$loadUpFlowAPI = ()=>(parcelRequire("8UcTu"));
    const $fe3490a17e762431$var$installConnectModules = ()=>(parcelRequire("fO7QI"));
    const $fe3490a17e762431$var$markSafeForAnalytics = (str)=>str || null;
    const $fe3490a17e762431$var$renderSearchDwellTimeComponent = ()=>{
        const searchSessionId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id');
        const containerId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-container-id');
        const objectId = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-object-id');
        const objectType = (0, (0, parcelRequire("j8DrX")).default)('ajs-search-content-type');
        (0, (0, parcelRequire("6YRTH")).default)([
            'searchSessionId',
            'searchObjectId',
            'searchContainerId',
            'searchContentType'
        ]);
        (0, $7o9iL.default)('search-dwell-time', $fe3490a17e762431$var$markSafeForAnalytics(searchSessionId), {
            containerId: $fe3490a17e762431$var$markSafeForAnalytics(containerId),
            objectId: $fe3490a17e762431$var$markSafeForAnalytics(objectId),
            objectType: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            actionSubject: $fe3490a17e762431$var$markSafeForAnalytics(objectType),
            source: $fe3490a17e762431$var$markSafeForAnalytics(objectType)
        });
    };
    const $fe3490a17e762431$var$installHighPriorityApps = (args)=>{
        const priorityApps = [];
        if (args.flags) priorityApps.push((0, $7AZuS.renderFlags)());
        if (args.navigation) priorityApps.push(args.renderNavigation());
        return priorityApps;
    };
    const $fe3490a17e762431$var$installLowPriorityApps = (args)=>{
        if (args.upflow) $fe3490a17e762431$var$loadUpFlowAPI();
        if (args.profileCardNextLegacy) $fe3490a17e762431$var$renderProfileCardNextLegacy();
        if (args.connectModules) $fe3490a17e762431$var$installConnectModules();
        if (args.engagementMessages) $fe3490a17e762431$var$renderEngagementMessages();
        if (args.heartbeat) $fe3490a17e762431$var$renderHeartbeat();
        if (args.searchDwellTimeComponent) $fe3490a17e762431$var$renderSearchDwellTimeComponent();
    };
    const $fe3490a17e762431$var$installAppsWithPriorityOrder = async (args)=>{
        await Promise.all($fe3490a17e762431$var$installHighPriorityApps({
            flags: args.flags,
            navigation: args.navigation,
            renderNavigation: args.renderNavigation
        }));
        $fe3490a17e762431$var$installLowPriorityApps((0, ($parcel$interopDefault($fr1K2)))(args, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
    };
    const $fe3490a17e762431$var$defaultArgs = {
        flags: true,
        navigation: true,
        upflow: true,
        profileCardNextLegacy: true,
        heartbeat: $fe3490a17e762431$var$isHeartbeatEnabled(),
        connectModules: true,
        engagementMessages: true,
        searchDwellTimeComponent: true,
        renderNavigation: ()=>null
    };
    var $fe3490a17e762431$export$2e2bcd8739ae039 = {
        install: (args)=>{
            const argsWithDefaults = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installAppsWithPriorityOrder(argsWithDefaults);
        },
        installHighPriorityApps: (args)=>{
            const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            };
            $fe3490a17e762431$var$installHighPriorityApps({
                flags: flags,
                navigation: navigation,
                renderNavigation: renderNavigation
            });
        },
        installLowPriorityApps: (args)=>{
            const installArgs = (0, ($parcel$interopDefault($fr1K2)))({
                ...$fe3490a17e762431$var$defaultArgs,
                ...args
            }, [
                'flags',
                'navigation',
                'renderNavigation'
            ]);
            $fe3490a17e762431$var$installLowPriorityApps(installArgs);
        }
    };
});
parcelRegister("fr1K2", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $7MmCC = parcelRequire("7MmCC");
    var $ftdKz = parcelRequire("ftdKz");
    var $etAYC = parcelRequire("etAYC");
    var $4NkAS = parcelRequire("4NkAS");
    var $b2dLE = parcelRequire("b2dLE");
    var $9SRAA = parcelRequire("9SRAA");
    var $7GWAt = parcelRequire("7GWAt");
    var $b3caba7e25e0a917$var$CLONE_DEEP_FLAG = 1, $b3caba7e25e0a917$var$CLONE_FLAT_FLAG = 2, $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG = 4;
    var $b3caba7e25e0a917$var$omit = $9SRAA(function(object, paths) {
        var result = {};
        if (object == null) return result;
        var isDeep = false;
        paths = $1nIHN(paths, function(path) {
            path = $etAYC(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
        });
        $4NkAS(object, $7GWAt(object), result);
        if (isDeep) result = $7MmCC(result, $b3caba7e25e0a917$var$CLONE_DEEP_FLAG | $b3caba7e25e0a917$var$CLONE_FLAT_FLAG | $b3caba7e25e0a917$var$CLONE_SYMBOLS_FLAG, $b2dLE);
        var length = paths.length;
        while(length--)$ftdKz(result, paths[length]);
        return result;
    });
    module.exports = $b3caba7e25e0a917$var$omit;
});
parcelRegister("ftdKz", function(module, exports) {
    var $etAYC = parcelRequire("etAYC");
    var $hYfgW = parcelRequire("hYfgW");
    var $8lSJl = parcelRequire("8lSJl");
    var $gzebZ = parcelRequire("gzebZ");
    function $b4343aeaece186b7$var$baseUnset(object, path) {
        path = $etAYC(path, object);
        object = $8lSJl(object, path);
        return object == null || delete object[$gzebZ($hYfgW(path))];
    }
    module.exports = $b4343aeaece186b7$var$baseUnset;
});
parcelRegister("8lSJl", function(module, exports) {
    var $fTwLR = parcelRequire("fTwLR");
    var $dM3Z8 = parcelRequire("dM3Z8");
    function $614abd39878e1d90$var$parent(object, path) {
        return path.length < 2 ? object : $fTwLR(object, $dM3Z8(path, 0, -1));
    }
    module.exports = $614abd39878e1d90$var$parent;
});
parcelRegister("b2dLE", function(module, exports) {
    var $1QOns = parcelRequire("1QOns");
    function $808a8f8fca7f9ff7$var$customOmitClone(value) {
        return $1QOns(value) ? undefined : value;
    }
    module.exports = $808a8f8fca7f9ff7$var$customOmitClone;
});
parcelRegister("6YRTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3bd6eeaf3add142$export$2e2bcd8739ae039);
    var $6vAaw = parcelRequire("6vAaw");
    var $fr1K2 = parcelRequire("fr1K2");
    var $e3bd6eeaf3add142$export$2e2bcd8739ae039 = (paramsToStrip)=>{
        try {
            const parsedUrl = (0, ($parcel$interopDefault($6vAaw))).parse(window.location.href, true);
            const strippedQuery = (0, ($parcel$interopDefault($fr1K2)))(parsedUrl.query || {}, paramsToStrip);
            let strippedUrl = (0, ($parcel$interopDefault($6vAaw))).format({
                ...parsedUrl,
                search: undefined,
                query: strippedQuery
            });
            const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
            if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
            window.history.replaceState({}, '', strippedUrl);
        } catch (e) {}
    };
});
parcelRegister("7AZuS", function(module, exports) {
    $parcel$export(module.exports, "renderFlags", ()=>$271711a34feab2aa$export$b6228dc14c5adf51);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $dJl1T;
    var $gG5I6;
    var $1eg3p;
    var $5eQ1m;
    var $kxZPA;
    const $271711a34feab2aa$var$throwError = (message)=>{
        const error = new Error(message);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('flags.entry', message, error);
        throw error;
    };
    const $271711a34feab2aa$var$getContainer = ()=>{
        let container = document.getElementById('flags');
        if (container == null) {
            container = document.createElement('div');
            container.id = 'flags';
            if (document.body) document.body.appendChild(container);
            else $271711a34feab2aa$var$throwError('document.body was not found whilst trying to create the flags container');
        }
        return container;
    };
    const $271711a34feab2aa$var$Flags = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$var$AfterPaintFlags = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aw7rz")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $271711a34feab2aa$export$b6228dc14c5adf51 = ()=>(0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gG5I6")).JiraContextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: "flags-entry"
        }, __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$AfterPaintFlags, null) : (0, ($parcel$interopDefault($5uXOq))).createElement($271711a34feab2aa$var$Flags, null)))), $271711a34feab2aa$var$getContainer());
});
parcelRegister("gG5I6", function(module, exports) {
    $parcel$export(module.exports, "JiraContextContainer", ()=>$2e767f203a33f0d2$export$6f7845cc5e693f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $lRFpu;
    var $lzeFL;
    var $5tsrJ;
    var $jb5yn;
    var $j8DrX;
    var $1nUas;
    var $2HbP2;
    var $8ApFP;
    var $iXVV6;
    var $fiv1r;
    var $14XJw;
    var $9OXo1;
    var $a83ud;
    const $2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: (0, (0, parcelRequire("8ApFP")).routeAnalyticsAttributes)
        }, children);
    const $2e767f203a33f0d2$export$6f7845cc5e693f16 = (props)=>{
        const state = {
            messages: (parcelRequire("hWnRN"))
        };
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2e767f203a33f0d2$var$ContextualAnalyticsDataFeatureFlagged, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, (0, parcelRequire("j8DrX")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1nUas")).IntlProvider), {
                messages: state.messages,
                locale: (0, (0, parcelRequire("lzeFL")).standardizeLocale)(tenantContext.locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRFpu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tsrJ")).default), {
                orgId: orgId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jb5yn")).ExperienceTrackerProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2HbP2")).ModalContextProvider), null, props.children)))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a83ud")).LoadingPhaseManager), null));
    };
});
parcelRegister("jb5yn", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTrackerProvider", ()=>$bcd25bc85dfeb009$export$6f49c95a810d59fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $ha42n;
    var $bSOOm;
    var $9sAyK;
    const $bcd25bc85dfeb009$var$useUnmount = (callback)=>(0, $5uXOq.useEffect)(()=>callback, [
            callback
        ]);
    const $bcd25bc85dfeb009$export$6f49c95a810d59fa = ({ children: children })=>{
        const [experienceTracker] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("ha42n")).ExperienceTracker)());
        const [cleanupSliSub] = (0, $5uXOq.useState)(()=>experienceTracker.subscribe((0, (0, parcelRequire("9sAyK")).sliSubscriber)));
        const cleanup = (0, $5uXOq.useCallback)(()=>{
            cleanupSliSub();
        }, [
            cleanupSliSub
        ]);
        $bcd25bc85dfeb009$var$useUnmount(cleanup);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, children);
    };
});
parcelRegister("9sAyK", function(module, exports) {
    $parcel$export(module.exports, "sliSubscriber", ()=>$6b2f2360dd11edee$export$db0b99fe17114899);
    var $fjcgS;
    var $efvDm;
    var $ldyPw;
    const $6b2f2360dd11edee$var$transformApplication = (application)=>{
        switch(application){
            case 0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE:
                return 'jira-software';
            case 0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, (0, parcelRequire("efvDm")).JIRA_CORE:
                return 'jira-core';
            case 0, (0, parcelRequire("efvDm")).JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, (0, parcelRequire("ldyPw")).FREE_EDITION:
                return 'jedi';
            case 0, (0, parcelRequire("ldyPw")).STANDARD_EDITION:
                return 'standard';
            case 0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION:
                return 'premium';
            case 0, (0, parcelRequire("ldyPw")).UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $6b2f2360dd11edee$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: action,
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                reason: location,
                analyticsSource: analyticsSource,
                application: $6b2f2360dd11edee$var$transformApplication(application),
                edition: $6b2f2360dd11edee$var$transformEdition(edition),
                ...errorMessage && {
                    errorMessage: errorMessage
                }
            }
        });
    const $6b2f2360dd11edee$var$reportSli = (experienceDescription)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const event = $6b2f2360dd11edee$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
    const $6b2f2360dd11edee$export$db0b99fe17114899 = (event)=>{
        const { name: name, action: action } = event;
        const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
        if (disableSli) return;
        switch(action){
            case 0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$b48b3d1872522384:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    ...event.error && {
                        errorMessage: String(event.error)
                    },
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8:
                $6b2f2360dd11edee$var$reportSli({
                    experience: name,
                    action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
                break;
            default:
        }
    };
});
const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';
parcelRegister("1nUas", function(module, exports) {
    $parcel$export(module.exports, "IntlProvider", ()=>$0264700d4de7e638$export$480518999dfc4151);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $0264700d4de7e638$export$480518999dfc4151 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...props,
            defaultLocale: props.locale
        }, children);
});
parcelRegister("2HbP2", function(module, exports) {
    $parcel$export(module.exports, "ModalContextProvider", ()=>$d012230882eb31a4$export$7c9538f5f3c365e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $gJdig;
    function $d012230882eb31a4$export$7c9538f5f3c365e9({ children: children }) {
        const id = (0, $5uXOq.useRef)(1);
        const [modals, setModals] = (0, $5uXOq.useState)([]);
        const modalContext = (0, $5uXOq.useMemo)(()=>({
                openModal: (component)=>{
                    const key = String(id.current++);
                    const close = ()=>{
                        setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                    };
                    setModals((mdls)=>[
                            ...mdls,
                            {
                                close: close,
                                component: component,
                                key: key
                            }
                        ]);
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gJdig")).ModalContext).Provider, {
            value: modalContext
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, modals.map((modal)=>(0, ($parcel$interopDefault($5uXOq))).createElement(modal.component, {
                key: modal.key,
                onClose: modal.close
            }))));
    }
});
parcelRegister("gJdig", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$308ba6e6ba886f08$export$ab57792b9b6974a6);
    var $5uXOq = parcelRequire("5uXOq");
    const $308ba6e6ba886f08$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
        openModal: ()=>{}
    });
});
parcelRegister("8ApFP", function(module, exports) {
    $parcel$export(module.exports, "routeAnalyticsAttributes", ()=>$a83c9e8eeb3d40c2$export$c71778b3a4356b04);
    var $cfDZ3;
    var $hVf1M;
    const $a83c9e8eeb3d40c2$export$c71778b3a4356b04 = Object.defineProperties({}, {
        routeName: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getRouteName)
        },
        userLocation: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getUserLocation)
        },
        previousSubProduct: {
            enumerable: true,
            get: (0, (0, parcelRequire("cfDZ3")).getPreviousSubProduct)
        },
        isProjectAdmin: {
            enumerable: true,
            get: (0, (0, parcelRequire("hVf1M")).getIsProjectAdmin)
        }
    });
});
parcelRegister("hVf1M", function(module, exports) {
    $parcel$export(module.exports, "getIsProjectAdmin", ()=>$d8c128d9b214e073$export$34ff06260ad17f2b);
    $parcel$export(module.exports, "setIsProjectAdmin", ()=>$d8c128d9b214e073$export$d53e6d79d3fa5f31);
    let $d8c128d9b214e073$var$projectAdmin = null;
    const $d8c128d9b214e073$export$34ff06260ad17f2b = ()=>{
        if ($d8c128d9b214e073$var$projectAdmin == null || !$d8c128d9b214e073$var$projectAdmin.loading && $d8c128d9b214e073$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
        if ($d8c128d9b214e073$var$projectAdmin.loading === true) return 'LOADING';
        return Boolean($d8c128d9b214e073$var$projectAdmin.isProjectAdmin);
    };
    const $d8c128d9b214e073$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
        $d8c128d9b214e073$var$projectAdmin = projectAdminState;
    };
});
parcelRegister("fiv1r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41dee5a929ec50c3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useJiraRelayEnvironmentProvider", ()=>$41dee5a929ec50c3$export$83fb48644dee72f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    function $41dee5a929ec50c3$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.RelayEnvironmentProvider), {
            environment: (0, (0, parcelRequire("5yJb9")).default)()
        }, children);
    }
    function $41dee5a929ec50c3$export$83fb48644dee72f0() {
        const environment = (0, $8Uumt.useRelayEnvironment)();
        return (0, $5uXOq.useMemo)(()=>({
                getEnvironment () {
                    return environment;
                }
            }), [
            environment
        ]);
    }
});
parcelRegister("5yJb9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0dfb67cb8d2ba29a$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    var $aWXMn;
    let $0dfb67cb8d2ba29a$var$relayEnvironment;
    function $0dfb67cb8d2ba29a$export$2e2bcd8739ae039() {
        if (!$0dfb67cb8d2ba29a$var$relayEnvironment) {
            const environmentConfig = (0, (0, parcelRequire("aWXMn")).getRelayEnvironmentConfig)();
            $0dfb67cb8d2ba29a$var$relayEnvironment = new (0, $eiowN.Environment)(environmentConfig);
        }
        return $0dfb67cb8d2ba29a$var$relayEnvironment;
    }
});
parcelRegister("aWXMn", function(module, exports) {
    $parcel$export(module.exports, "getRelayEnvironmentConfig", ()=>$eb7981c11bea2531$export$a451c85db2d1cda3);
    var $4XQuR;
    var $d89yU;
    var $6LmWt;
    const $eb7981c11bea2531$export$a451c85db2d1cda3 = ()=>(0, (0, parcelRequire("6LmWt")).getDefaultRelayEnvironmentConfig)({
            network: (0, (0, parcelRequire("d89yU")).getNetwork)(),
            log: (0, (0, parcelRequire("4XQuR")).default),
            requiredFieldLogger: (0, parcelRequire("4XQuR")).requiredFieldLogger
        });
});
parcelRegister("4XQuR", function(module, exports) {
    $parcel$export(module.exports, "requiredFieldLogger", ()=>$50b0aa0805b37d6d$export$1ab8b98d209afe85);
    $parcel$export(module.exports, "default", ()=>$50b0aa0805b37d6d$export$2e2bcd8739ae039);
    var $bFU4G;
    var $dJl1T;
    var $jQsty;
    const $50b0aa0805b37d6d$var$RELAY_CLIENT_ID = 'AGG';
    const $50b0aa0805b37d6d$var$LOG_NAMESPACE = `relay.${$50b0aa0805b37d6d$var$RELAY_CLIENT_ID}.error.graphql`;
    const $50b0aa0805b37d6d$var$requests = {};
    const $50b0aa0805b37d6d$var$queries = {};
    const $50b0aa0805b37d6d$var$resources = {};
    const $50b0aa0805b37d6d$var$executes = {};
    const $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT = 300000;
    const $50b0aa0805b37d6d$export$1ab8b98d209afe85 = (event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($50b0aa0805b37d6d$var$LOG_NAMESPACE, '[relay required field error]', {
            kind: event.kind,
            owner: event.owner,
            fieldPath: event.fieldPath,
            message: event.kind === 'relay_resolver.error' ? event.error?.message : null
        });
    };
    const $50b0aa0805b37d6d$var$getResponseSize = (resp)=>{
        if (resp.data === undefined) return 0;
        try {
            return JSON.stringify(resp.data).length;
        } catch (e) {
            return 0;
        }
    };
    function $50b0aa0805b37d6d$export$2e2bcd8739ae039(event) {
        if ((0, (0, parcelRequire("jQsty")).default)('relay_log')) return;
        switch(event.name){
            case 'network.start':
                {
                    const networkStart = performance.now();
                    const { networkRequestId: networkRequestId } = event;
                    const { name: name } = event.params;
                    const requestInfo = $50b0aa0805b37d6d$var$requests[networkRequestId];
                    if (requestInfo == null) {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: networkStart,
                            networkStart: networkStart
                        };
                        $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                        $50b0aa0805b37d6d$var$requests[networkRequestId] = newRequestInfo;
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$requests[networkRequestId];
                            delete $50b0aa0805b37d6d$var$queries[name];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    } else requestInfo.networkStart = networkStart;
                    break;
                }
            case 'network.next':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (requestInfo != null) {
                        const { response: response } = event;
                        const addFlush = (resp)=>{
                            if (resp.data !== null) {
                                const res = resp;
                                const flush = {
                                    label: res.label != null ? res.label : 'root',
                                    time: performance.now(),
                                    size: $50b0aa0805b37d6d$var$getResponseSize(res)
                                };
                                requestInfo.flushes?.push(flush);
                            }
                        };
                        Array.isArray(response) ? response.forEach(addFlush) : addFlush(response);
                    }
                    break;
                }
            case 'network.error':
                {
                    const info = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    if (info != null) info.error = event.error;
                    break;
                }
            case 'network.info':
                break;
            case 'network.complete':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$requests[event.networkRequestId];
                    const networkComplete = performance.now();
                    if (requestInfo != null) {
                        const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                        requestInfo.size = size;
                        requestInfo.networkComplete = networkComplete;
                        requestInfo.flushes = [];
                        (0, (0, parcelRequire("bFU4G")).addSpanToAll)('relay', requestInfo.name, [
                            {
                                name: 'network'
                            }
                        ], requestInfo.start, requestInfo.networkComplete, size);
                    }
                    break;
                }
            case 'network.unsubscribe':
                break;
            case 'suspense.fragment':
                break;
            case 'suspense.query':
                break;
            case 'queryresource.fetch':
                {
                    const { node: node } = event.operation.root;
                    const fetchStart = performance.now();
                    if (node.name != null) {
                        const { name: name } = node;
                        const requestInfo = $50b0aa0805b37d6d$var$queries[name];
                        if (requestInfo != null) {
                            requestInfo.fetchStart = fetchStart;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = requestInfo;
                        } else {
                            const newRequestInfo = {
                                name: name,
                                flushes: [],
                                start: fetchStart,
                                fetchStart: fetchStart
                            };
                            $50b0aa0805b37d6d$var$queries[name] = newRequestInfo;
                            $50b0aa0805b37d6d$var$resources[event.resourceID] = newRequestInfo;
                            setTimeout(()=>{
                                delete $50b0aa0805b37d6d$var$queries[node.name];
                            }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                        }
                        setTimeout(()=>{
                            delete $50b0aa0805b37d6d$var$resources[event.resourceID];
                        }, $50b0aa0805b37d6d$var$CLEANUP_TIMEOUT);
                    }
                    break;
                }
            case 'queryresource.retain':
                {
                    const requestInfo = $50b0aa0805b37d6d$var$resources[event.resourceID];
                    if (requestInfo != null && event.profilerContext != null) {
                        requestInfo.end = performance.now();
                        const context = event.profilerContext;
                        context?.retainQuery?.(requestInfo);
                    }
                    break;
                }
            case 'execute.start':
                $50b0aa0805b37d6d$var$executes[event.executeId] = {
                    name: event.params.name,
                    kind: event.params.operationKind,
                    start: performance.now(),
                    duration: 0
                };
                break;
            case 'execute.next':
                $50b0aa0805b37d6d$var$executes[event.executeId].duration += event.duration;
                break;
            case 'execute.async.module':
                break;
            case 'execute.flight.payload_deserialize':
                break;
            case 'execute.error':
                delete $50b0aa0805b37d6d$var$executes[event.executeId];
                break;
            case 'execute.complete':
                {
                    const op = $50b0aa0805b37d6d$var$executes[event.executeId];
                    if (op != null) {
                        op.end = performance.now();
                        delete $50b0aa0805b37d6d$var$executes[event.executeId];
                    }
                    break;
                }
            case 'store.publish':
                break;
            case 'store.snapshot':
                break;
            case 'store.restore':
                break;
            case 'store.gc':
                break;
            case 'store.notify.start':
                break;
            case 'store.notify.complete':
                break;
            case 'store.notify.subscription':
                break;
            case 'entrypoint.root.consume':
                break;
            default:
                break;
        }
    }
});
parcelRegister("d89yU", function(module, exports) {
    $parcel$export(module.exports, "getNetwork", ()=>$7997274d03790a98$export$7de4970ebfd8206d);
    var $eiowN = parcelRequire("eiowN");
    var $gIJXH;
    var $k1TrK;
    var $fwvto;
    const $7997274d03790a98$export$7de4970ebfd8206d = ()=>{
        if ((0, (0, parcelRequire("fwvto")).isSSR)()) (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch));
        return (0, $eiowN.Network).create((0, (0, parcelRequire("gIJXH")).fetch), (0, (0, parcelRequire("k1TrK")).subscribe));
    };
});
parcelRegister("gIJXH", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$2963ed038d5e3581$export$e7aa7bc5c1b3cfb3);
    var $hGgHi = parcelRequire("hGgHi");
    var $1UikQ = parcelRequire("1UikQ");
    var $eiowN = parcelRequire("eiowN");
    var $kTK0a;
    var $2I8bw;
    var $aDvGo;
    var $jJZqs;
    var $eusud;
    var $6b2ko;
    var $4tcSU;
    var $5a0Nh;
    var $gwtGO;
    var $kipqU;
    var $7pVV3;
    var $ajjqZ;
    var $4pgHP;
    var $eCZ6m;
    var $5Wobd;
    var $lKFKm;
    var $7isEg;
    let $2963ed038d5e3581$var$redirecting = false;
    const $2963ed038d5e3581$var$redirect = ()=>{
        const identity = (0, (0, parcelRequire("kTK0a")).getATLContextDomain)('id');
        const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
        window.location.href = redirectUrl;
    };
    const $2963ed038d5e3581$var$blocklist = [
        'issueAggQuery'
    ];
    const $2963ed038d5e3581$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
        if (operationKind === 'query') return 0, (0, parcelRequire("6b2ko")).RETRY_ATTEMPTS_LIMIT;
        return 0;
    };
    const $2963ed038d5e3581$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
        if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') return extensions.gateway.request_id;
        return undefined;
    };
    const $2963ed038d5e3581$var$generateOptions = (options = {})=>{
        const csrfToken = !false ? (0, (0, parcelRequire("4tcSU")).default)() : undefined;
        const csrfTokenHeader = (0, ($parcel$interopDefault($hGgHi)))(csrfToken) ? {} : {
            'atl-xsrf-token': csrfToken
        };
        return (0, ($parcel$interopDefault($1UikQ)))({}, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }, {
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(','),
                ...csrfTokenHeader
            }
        });
    };
    const $2963ed038d5e3581$var$checkAuthentication = ()=>{
        if (!false && !$2963ed038d5e3581$var$redirecting) {
            const heartbeatService = (0, (0, parcelRequire("2I8bw")).getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $2963ed038d5e3581$var$redirect();
                $2963ed038d5e3581$var$redirecting = true;
            }
        }
    };
    const $2963ed038d5e3581$export$7bfea3c3d460ecd8 = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) return [
            502,
            503,
            504
        ].includes(error.statusCode);
        return false;
    };
    const $2963ed038d5e3581$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
        $2963ed038d5e3581$var$checkAuthentication();
        if ($2963ed038d5e3581$var$redirecting) return (0, $eiowN.Observable).from(new Promise(()=>{}));
        const { name: queryName, operationKind: operationKind } = request;
        const earlyScriptPromise = !false && (0, (0, parcelRequire("ajjqZ")).claimEarlyScriptPromise)((0, (0, parcelRequire("ajjqZ")).getEarlyScriptPromiseKey)(request, variables)) || undefined;
        const loggingMetadata = {
            queryName: queryName,
            operationKind: operationKind
        };
        const loggingAndMetrics = (0, (0, parcelRequire("7isEg")).getLoggingAndMetricsHelper)(loggingMetadata);
        return (0, $eiowN.Observable).create((sink)=>{
            try {
                const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
                const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(request, cacheConfig);
                const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(request, variables);
                let ssrCache = null;
                if (!false && requestID != null) ssrCache = (0, (0, parcelRequire("7pVV3")).QueryResponseCache).get(requestID, variables);
                if (!false && !(0, ($parcel$interopDefault($hGgHi)))(ssrCache)) {
                    sink.next(ssrCache);
                    if (requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).delete(requestID, variables);
                    sink.complete();
                    return;
                }
                const wrappedEarlyScriptPromise = earlyScriptPromise && (0, (0, parcelRequire("6b2ko")).retryOnError)(()=>(0, (0, parcelRequire("eusud")).applyErrorHandling)(earlyScriptPromise), {
                    retryFunc: ()=>(0, (0, parcelRequire("eusud")).performPostRequest)(endpoint, $2963ed038d5e3581$var$generateOptions({
                            body: body
                        })),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                });
                const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, (0, parcelRequire("eusud")).performPostRequestWithRetry)(endpoint, {
                    ...$2963ed038d5e3581$var$generateOptions({
                        body: body
                    }),
                    retryPredicate: $2963ed038d5e3581$export$7bfea3c3d460ecd8,
                    retryAttempts: $2963ed038d5e3581$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: (error, attempt)=>{
                        loggingAndMetrics.logErrorRetry(error, attempt);
                    }
                }));
                promise.then((response)=>{
                    (0, (0, parcelRequire("5Wobd")).addTraceId)(queryName, $2963ed038d5e3581$var$getTraceIdFromExtensions(response));
                    (0, (0, parcelRequire("4pgHP")).putExtensions)(queryName, response.extensions);
                    const errors = response.errors || undefined;
                    if (errors != null) {
                        const requestId = response?.extensions?.gateway?.request_id;
                        if (!$2963ed038d5e3581$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                        (0, (0, parcelRequire("5a0Nh")).captureErrors)(errors, {
                            operationName: queryName,
                            requestId: requestId
                        });
                        if ((0, (0, parcelRequire("5a0Nh")).isUnauthenticated)(errors)) {
                            (0, (0, parcelRequire("lKFKm")).showUnauthenticatedFlag)(queryName);
                            return;
                        }
                    }
                    if (response.data && (response.data.jira === null || response.data.customerService === null)) response.data = null;
                    if (false && requestID != null) (0, (0, parcelRequire("7pVV3")).QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                    sink.next(response);
                    sink.complete();
                }).catch((error)=>{
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                });
                if (requestID != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).set(requestID, promise);
            } catch (error) {
                loggingAndMetrics.logError(error);
                sink.error(error);
            }
        });
    };
});
parcelRegister("eusud", function(module, exports) {
    $parcel$export(module.exports, "transformValidationErrorFromServer", ()=>$3637c0f7edbd2bb4$export$8e9baed7697e4959);
    $parcel$export(module.exports, "applyErrorHandling", ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff);
    $parcel$export(module.exports, "performGetRequest", ()=>$3637c0f7edbd2bb4$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$3637c0f7edbd2bb4$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$3637c0f7edbd2bb4$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$3637c0f7edbd2bb4$export$8ef51cba9d28f819);
    $parcel$export(module.exports, "performPatchRequest", ()=>$3637c0f7edbd2bb4$export$52be6ab13d7e758d);
    $parcel$export(module.exports, "performGetRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$659b5ee69e6eb976);
    $parcel$export(module.exports, "performPutRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$d7b48b2904a5d812);
    $parcel$export(module.exports, "performPostRequestWithRetry", ()=>$3637c0f7edbd2bb4$export$a5717cbee13f28b7);
    var $aDvGo;
    var $co1wz;
    var $jQsty;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    var $6b2ko;
    var $iwPwz;
    const $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
                field: field,
                error: fieldErrors[field]
            }));
    const $3637c0f7edbd2bb4$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
        const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
        const fieldErrorsJson = json.errors ?? json.fieldErrors;
        const fieldErrors = fieldErrorsJson ? $3637c0f7edbd2bb4$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
        return new (0, (0, parcelRequire("jJZqs")).ValidationError)(message, fieldErrors, statusCode, traceId, json);
    };
    const $3637c0f7edbd2bb4$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $3637c0f7edbd2bb4$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $3637c0f7edbd2bb4$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $3637c0f7edbd2bb4$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $3637c0f7edbd2bb4$var$handleNetworkErrors = (err)=>{
        if (err instanceof TypeError) throw new Error('Failed to fetch', {
            cause: err
        });
        throw err;
    };
    const $3637c0f7edbd2bb4$var$handleErrors = (response)=>{
        const traceId = (0, (0, parcelRequire("iwPwz")).getTraceId)(response);
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status || (0, (0, parcelRequire("co1wz")).ff)('issue.details.hard-limits.milestone-1') && (0, $3cd8a0ece36fbae5$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
            throw $3637c0f7edbd2bb4$export$8e9baed7697e4959(errorContent, response.status, traceId);
        });
        if (!response.ok) {
            if (traceId !== undefined && traceId.length > 0) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, undefined, response);
        }
        return response;
    };
    const $3637c0f7edbd2bb4$var$processResponseFromServer = (response)=>{
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $3637c0f7edbd2bb4$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$22411cbfb09a5c5c = (url, options)=>{
        const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
        const executeRequest = ()=>$3637c0f7edbd2bb4$export$e174dc943a170ff(fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, requestOptions)));
        if ((0, (0, parcelRequire("jQsty")).default)('platform_fetch_retries')) return executeRequest();
        return (0, (0, parcelRequire("6b2ko")).retryOnError)(executeRequest, {
            retryFunc: executeRequest,
            retryPredicate: retryPredicate,
            retryAttempts: retryAttempts,
            onRetry: onRetry
        });
    };
    const $3637c0f7edbd2bb4$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$692a4d9808143175 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        })).then($3637c0f7edbd2bb4$var$handleErrors).then($3637c0f7edbd2bb4$var$processResponseFromServer).catch($3637c0f7edbd2bb4$var$handleNetworkErrors);
    const $3637c0f7edbd2bb4$export$659b5ee69e6eb976 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        });
    const $3637c0f7edbd2bb4$export$d7b48b2904a5d812 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$putOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$a5717cbee13f28b7 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$postOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$6d01bf1146815b9b = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$deleteOptions,
            ...options
        });
    const $3637c0f7edbd2bb4$export$560989ee94ad2a20 = (url, options)=>$3637c0f7edbd2bb4$export$22411cbfb09a5c5c(url, {
            ...$3637c0f7edbd2bb4$var$patchOptions,
            ...options
        });
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("6b2ko", function(module, exports) {
    $parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", ()=>$6910b563ec955346$export$81189edc9b923717);
    $parcel$export(module.exports, "retryOnError", ()=>$6910b563ec955346$export$f859c88bfac2cf2c);
    const $6910b563ec955346$export$81189edc9b923717 = 1;
    const $6910b563ec955346$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6910b563ec955346$export$81189edc9b923717, onRetry: onRetry })=>{
        const maxAttempts = retryAttempts > $6910b563ec955346$export$81189edc9b923717 ? $6910b563ec955346$export$81189edc9b923717 : retryAttempts;
        const execute = async (getPromise, retryAttempt = 0)=>{
            try {
                return await getPromise();
            } catch (error) {
                const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
                if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                    onRetry && onRetry(error, retryAttempt + 1);
                    return execute(retryFunc, retryAttempt + 1);
                }
                throw error;
            }
        };
        return execute(initialPromiseGetter);
    };
});
parcelRegister("5a0Nh", function(module, exports) {
    $parcel$export(module.exports, "startCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$c211170518c6d0f6);
    $parcel$export(module.exports, "stopCaptureGraphQlErrors", ()=>$cf86a52470c84b66$export$e0491a0d974dadfa);
    $parcel$export(module.exports, "captureErrors", ()=>$cf86a52470c84b66$export$7a973c0ff390eb47);
    $parcel$export(module.exports, "isUnauthenticated", ()=>$cf86a52470c84b66$export$1724ecfee73c4768);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $cf86a52470c84b66$var$errorCollector = new Map();
    const $cf86a52470c84b66$export$da396ad2a542b095 = 120000;
    const $cf86a52470c84b66$var$scheduleCleanup = (key)=>{
        setTimeout(()=>{
            $cf86a52470c84b66$var$errorCollector.delete(key);
        }, $cf86a52470c84b66$export$da396ad2a542b095);
    };
    const $cf86a52470c84b66$export$c211170518c6d0f6 = (key = (0, ($parcel$interopDefault($7Jxgt))).v4())=>{
        $cf86a52470c84b66$var$errorCollector.set(key, []);
        $cf86a52470c84b66$var$scheduleCleanup(key);
        return key;
    };
    const $cf86a52470c84b66$export$e0491a0d974dadfa = (key)=>{
        const errors = $cf86a52470c84b66$var$errorCollector.get(key);
        $cf86a52470c84b66$var$errorCollector.delete(key);
        return errors || [];
    };
    const $cf86a52470c84b66$export$7a973c0ff390eb47 = (errors, meta)=>{
        if (errors) $cf86a52470c84b66$var$errorCollector.forEach((value, key)=>{
            $cf86a52470c84b66$var$errorCollector.set(key, [
                ...value,
                {
                    errors: errors,
                    meta: meta
                }
            ]);
        });
    };
    const $cf86a52470c84b66$export$1724ecfee73c4768 = (errors)=>{
        if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
        return false;
    };
});
parcelRegister("gwtGO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1019e315ad42f34a$export$2e2bcd8739ae039);
    var $1019e315ad42f34a$export$2e2bcd8739ae039 = [
        'ariGraph',
        'boardCardMove',
        'deleteCard',
        'JiraJqlBuilder',
        'SoftwareCardTypeTransitions',
        'jira-releases-v0',
        'JiraDevOps',
        'JiraDevOpsProviders',
        'createCustomFilter',
        'updateCustomFilter',
        'deleteCustomFilter',
        'customFilters',
        'PermissionScheme',
        'JiraIssue',
        'projectStyle',
        'startSprintPrototype',
        'AddIssuesToFixVersion',
        'JiraVersionResult',
        'JiraIssueConnectionJql',
        'JiraFieldOptionSearching',
        'JiraIssueFieldMutations',
        'JiraIssueDevInfoDetails',
        'JiraIssueDevSummaryCache',
        'JiraVersionWarningConfig',
        'JiraReleaseNotesConfiguration',
        'JiraUpdateReleaseNotesConfiguration',
        'ReleaseNotes',
        'ReleaseNotesOptions',
        'DeploymentsFeaturePrecondition',
        'UpdateVersionWarningConfig',
        'UpdateVersionName',
        'UpdateVersionDescription',
        'UpdateVersionStartDate',
        'UpdateVersionReleaseDate',
        'VersionsForProject',
        'RelatedWork',
        'SuggestedRelatedWorkCategories',
        'setIssueMediaVisibility',
        'toggleBoardFeature',
        'DevOpsProvider',
        'DevOpsSummarisedDeployments',
        'JiraProject',
        'DevOpsSummarisedEntities',
        'RoadmapsMutation',
        'RoadmapsQuery',
        'JiraApplicationProperties',
        'JiraIssueSearch',
        'JiraFilter',
        'featureGroups',
        'setBoardEstimationType',
        'devOps',
        'softwareBoards',
        'name',
        'AddRelatedWorkToVersion',
        'RemoveRelatedWorkFromVersion',
        'admins',
        'canAdministerBoard',
        'jql',
        'globalCardCreateAdditionalFields',
        'GlobalTimeTrackingSettings',
        'ReleaseNotesOptions',
        'search-experience',
        'MoveOrRemoveIssuesToFixVersion',
        'compass-beta',
        'JiraIssueSearchStatus',
        'Townsquare',
        'JiraNavigationItems',
        'JiraVersionsForProjects',
        'columnConfigs'
    ];
});
parcelRegister("kipqU", function(module, exports) {
    $parcel$export(module.exports, "QueryPromisesMap", ()=>$f428f7f15822f637$export$607b80f5bc6e396d);
    const $f428f7f15822f637$export$607b80f5bc6e396d = new Map();
});
parcelRegister("7pVV3", function(module, exports) {
    $parcel$export(module.exports, "QueryResponseCache", ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $eiowN = parcelRequire("eiowN");
    var $dJl1T;
    var $jJZqs;
    var $kizcd;
    function $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables) {
        return JSON.stringify((0, $eiowN.stableCopy)({
            queryID: queryID,
            variables: variables
        }));
    }
    function $675c7f0a9d659efe$export$1e65e863cf3a0f21(cacheKey) {
        return JSON.parse(cacheKey).queryID;
    }
    class $675c7f0a9d659efe$export$be21c283b097d175 extends (0, $eiowN.QueryResponseCache) {
        constructor({ cacheName: cacheName, size: size, ttl: ttl }){
            super({
                size: size,
                ttl: ttl
            });
            const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
            this.cacheName = cacheName;
            this.requestMetadata = new Map(cachedData.requestMetadata);
            this._responses = new Map(cachedData.responses);
            if (!false) setTimeout(()=>{
                this.logUnusedPayloadErrors();
                this.requestMetadata.clear();
                this._responses.clear();
            }, 60000);
        }
        logUnusedPayloadErrors() {
            const loggedQueries = new Set();
            this._responses.forEach((response, key)=>{
                const queryID = $675c7f0a9d659efe$export$1e65e863cf3a0f21(key);
                const metadata = this.requestMetadata.get(queryID);
                const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                    queryName: 'unknown',
                    operationKind: 'unknown'
                };
                if (!loggedQueries.has(queryName)) {
                    loggedQueries.add(queryName);
                    const error = new (0, (0, parcelRequire("kizcd")).UnusedRelayResponseError)(queryID);
                    const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'statusCode'
                    ], null);
                    const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                        message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                        errorType: errorType,
                        statusCode: statusCode,
                        queryName: queryName,
                        operationKind: operationKind,
                        errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                            'name'
                        ], null)
                    });
                }
            });
        }
        setWithMetadata(queryID, variables, payload, metadata) {
            this.requestMetadata.set(queryID, metadata);
            this.set(queryID, variables, payload);
        }
        delete(queryID, variables) {
            const cacheKey = $675c7f0a9d659efe$export$611736262b635f8d(queryID, variables);
            return this._responses.delete(cacheKey);
        }
        serialize() {
            return {
                [this.cacheName]: {
                    requestMetadata: Array.from(this.requestMetadata.entries()),
                    responses: Array.from(this._responses.entries())
                }
            };
        }
    }
    const $675c7f0a9d659efe$export$688bd21be71b9e5d = new $675c7f0a9d659efe$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
    const $675c7f0a9d659efe$export$94e535e06b7ade61 = ()=>$675c7f0a9d659efe$export$688bd21be71b9e5d.serialize();
});
parcelRegister("kizcd", function(module, exports) {
    $parcel$export(module.exports, "UnusedRelayResponseError", ()=>$f174935352f053b0$export$8431e42d062de453);
    class $f174935352f053b0$export$8431e42d062de453 extends Error {
        constructor(queryID){
            super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
            this.name = 'UnusedRelayResponseError';
        }
    }
});
parcelRegister("ajjqZ", function(module, exports) {
    $parcel$export(module.exports, "getEarlyScriptPromiseKey", ()=>$383b599fde987e1e$export$1102c06c7da91223);
    $parcel$export(module.exports, "claimEarlyScriptPromise", ()=>$383b599fde987e1e$export$828ac0325bce4536);
    $parcel$export(module.exports, "putEarlyScriptPromise", ()=>$383b599fde987e1e$export$e1336d32be02faf4);
    $parcel$export(module.exports, "earlyFetch", ()=>$383b599fde987e1e$export$5b55058781674413);
    var $tcn7E;
    var $l83Uu;
    var $eKonk;
    var $eCZ6m;
    const $383b599fde987e1e$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
    const $383b599fde987e1e$export$b5fbc1430cbfd6e1 = (value)=>value;
    const $383b599fde987e1e$export$6d670d323806bb37 = new Map();
    const $383b599fde987e1e$export$1102c06c7da91223 = (params, variables)=>{
        const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
        const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
        return `${params.name}|${String(queryId)}|${serializedVariables}`;
    };
    const $383b599fde987e1e$export$828ac0325bce4536 = (key)=>{
        const result = $383b599fde987e1e$export$6d670d323806bb37.get(key);
        if (result != null) $383b599fde987e1e$export$6d670d323806bb37.delete(key);
        return result;
    };
    const $383b599fde987e1e$export$e1336d32be02faf4 = (key, promise)=>{
        if (!$383b599fde987e1e$export$6d670d323806bb37.has(key)) $383b599fde987e1e$export$6d670d323806bb37.set(key, promise);
    };
    const $383b599fde987e1e$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
        (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:start');
        const endpoint = (0, (0, parcelRequire("eCZ6m")).getAggEndpoint)(compiledQuery.params);
        const body = (0, (0, parcelRequire("eCZ6m")).getRequestBody)(compiledQuery.params, variables);
        const capabilityHeader = (0, (0, parcelRequire("eKonk")).getEnhancedCapabilityHeader)(capability ?? null);
        $383b599fde987e1e$export$e1336d32be02faf4($383b599fde987e1e$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
            credentials: 'same-origin',
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'Content-Type': 'application/json',
                Accept: 'application/json,text/javascript,*/*',
                'X-ExperimentalApi': experimentalApis.join(','),
                ...(0, (0, parcelRequire("tcn7E")).getActiveTraceHttpRequestHeaders)(endpoint),
                ...capabilityHeader ? {
                    [$383b599fde987e1e$var$CAPABILITY_HEADER_NAME]: capabilityHeader
                } : {}
            },
            method: 'POST',
            body: body
        }).then((response)=>{
            (0, (0, parcelRequire("l83Uu")).setMark)('jira.fe-spa.early-preload:end');
            return response;
        }));
    };
});
parcelRegister("l83Uu", function(module, exports) {
    $parcel$export(module.exports, "setMark", ()=>$ef655a7b07a35675$export$f7a1fb90d8604165);
    $parcel$export(module.exports, "getTraceId", ()=>$ef655a7b07a35675$export$e88cb5bfb57ce9c4);
    const $ef655a7b07a35675$export$f7a1fb90d8604165 = (mark)=>{
        if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
        performance.mark(mark);
    };
    const $ef655a7b07a35675$var$TRACE_ID_HEADER = 'atl-traceid';
    const $ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
    const $ef655a7b07a35675$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER) || response.headers.get($ef655a7b07a35675$var$TRACE_ID_HEADER_MICROS);
});
parcelRegister("lKFKm", function(module, exports) {
    $parcel$export(module.exports, "showUnauthenticatedFlag", ()=>$42cb6e1c2fdc593e$export$758fcc357484571e);
    var $pa9q9;
    var $fjcgS;
    var $8iiwm;
    const $42cb6e1c2fdc593e$var$reloadPage = ()=>window.location.reload();
    const $42cb6e1c2fdc593e$var$sendAnalyticEvent = (operationName)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendTrackEvent({
                action: 'showed',
                actionSubject: 'unauthorizedFlag',
                attributes: {
                    operation: operationName
                },
                source: 'jiraRelayFetch'
            });
        });
    };
    const $42cb6e1c2fdc593e$export$758fcc357484571e = (operationName)=>{
        (0, (0, parcelRequire("pa9q9")).showFlag)({
            type: 'error',
            title: (0, (0, parcelRequire("8iiwm")).default).title,
            description: (0, (0, parcelRequire("8iiwm")).default).description,
            actions: [
                {
                    content: (0, (0, parcelRequire("8iiwm")).default).login,
                    onClick: $42cb6e1c2fdc593e$var$reloadPage
                }
            ]
        });
        $42cb6e1c2fdc593e$var$sendAnalyticEvent(operationName);
    };
});
parcelRegister("pa9q9", function(module, exports) {
    $parcel$export(module.exports, "showFlag", ()=>$00ff685527f9e8c1$export$e12b2cc6b75b006b);
    $parcel$export(module.exports, "dismissFlag", ()=>$00ff685527f9e8c1$export$900a08a292ad23cd);
    $parcel$export(module.exports, "flagService", ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0);
    $parcel$export(module.exports, "useFlagsService", ()=>$00ff685527f9e8c1$export$eee61a1aafe3884);
    $parcel$export(module.exports, "useFlagService", ()=>$00ff685527f9e8c1$export$dc4f8132c3090b32);
    $parcel$export(module.exports, "isDismissFlag", ()=>$00ff685527f9e8c1$export$14b1864d9cf0809f);
    $parcel$export(module.exports, "isFlagComponent", ()=>$00ff685527f9e8c1$export$d84ce5adcee46025);
    $parcel$export(module.exports, "isBatchAction", ()=>$00ff685527f9e8c1$export$c126d8b307b8ab86);
    var $fHfPB;
    var $gEdnQ;
    var $01A9Z;
    var $7HGHK;
    const $00ff685527f9e8c1$export$e12b2cc6b75b006b = (0, (0, parcelRequire("gEdnQ")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$export$900a08a292ad23cd = (0, (0, parcelRequire("fHfPB")).default)((0, (0, parcelRequire("01A9Z")).store).dispatch);
    const $00ff685527f9e8c1$var$dismissFlagById = (id)=>{
        $00ff685527f9e8c1$export$900a08a292ad23cd((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
    };
    const $00ff685527f9e8c1$var$hasFlag = (id)=>Boolean((0, (0, parcelRequire("01A9Z")).store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
    const $00ff685527f9e8c1$export$dbb055af53fd81a0 = {
        showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
        dismissFlag: $00ff685527f9e8c1$export$900a08a292ad23cd
    };
    const $00ff685527f9e8c1$export$eee61a1aafe3884 = ()=>({
            showFlag: $00ff685527f9e8c1$export$e12b2cc6b75b006b,
            dismissFlag: $00ff685527f9e8c1$var$dismissFlagById,
            hasFlag: $00ff685527f9e8c1$var$hasFlag
        });
    const $00ff685527f9e8c1$export$dc4f8132c3090b32 = ()=>$00ff685527f9e8c1$export$dbb055af53fd81a0;
    const $00ff685527f9e8c1$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND);
    const $00ff685527f9e8c1$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
    const $00ff685527f9e8c1$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
    const $00ff685527f9e8c1$export$63ffd7d99470afd4 = (flag)=>!$00ff685527f9e8c1$export$14b1864d9cf0809f(flag) && !$00ff685527f9e8c1$export$d84ce5adcee46025(flag) && !$00ff685527f9e8c1$export$cd5f9f2b991b82d9(flag);
    const $00ff685527f9e8c1$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);
});
parcelRegister("fHfPB", function(module, exports) {
    $parcel$export(module.exports, "dismissFlag", ()=>$8eb241d1a1f5d9b7$export$900a08a292ad23cd);
    $parcel$export(module.exports, "default", ()=>$8eb241d1a1f5d9b7$export$2e2bcd8739ae039);
    var $d6YjM;
    var $7HGHK;
    const $8eb241d1a1f5d9b7$export$900a08a292ad23cd = (flagId)=>({
            command: (0, (0, parcelRequire("7HGHK")).DISMISS_COMMAND),
            id: flagId
        });
    var $8eb241d1a1f5d9b7$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
            dispatch((0, (0, parcelRequire("d6YjM")).dismissFlagAction)(action.id));
        };
});
parcelRegister("d6YjM", function(module, exports) {
    $parcel$export(module.exports, "SHOW", ()=>$07f19e2fef34903b$export$9d04158a25ce4cd);
    $parcel$export(module.exports, "show", ()=>$07f19e2fef34903b$export$57bf213be019eeb0);
    $parcel$export(module.exports, "DISMISS_INSTANCE", ()=>$07f19e2fef34903b$export$b31a07d2e6382678);
    $parcel$export(module.exports, "dismiss", ()=>$07f19e2fef34903b$export$abf286bbe7073aba);
    $parcel$export(module.exports, "DISMISS_FLAG", ()=>$07f19e2fef34903b$export$1eb56620df104bf);
    $parcel$export(module.exports, "dismissFlagAction", ()=>$07f19e2fef34903b$export$4818b3c52448050d);
    $parcel$export(module.exports, "RESET", ()=>$07f19e2fef34903b$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$07f19e2fef34903b$export$aad8462122ac592b);
    const $07f19e2fef34903b$export$9d04158a25ce4cd = 'state.SHOW';
    const $07f19e2fef34903b$export$57bf213be019eeb0 = (payload)=>({
            type: $07f19e2fef34903b$export$9d04158a25ce4cd,
            payload: payload
        });
    const $07f19e2fef34903b$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
    const $07f19e2fef34903b$export$abf286bbe7073aba = (payload)=>({
            type: $07f19e2fef34903b$export$b31a07d2e6382678,
            payload: payload
        });
    const $07f19e2fef34903b$export$1eb56620df104bf = 'state.DISMISS_FLAG';
    const $07f19e2fef34903b$export$4818b3c52448050d = (payload)=>({
            type: $07f19e2fef34903b$export$1eb56620df104bf,
            payload: payload
        });
    const $07f19e2fef34903b$export$4a991c87e640ef77 = 'state.RESET';
    const $07f19e2fef34903b$export$aad8462122ac592b = ()=>({
            type: $07f19e2fef34903b$export$4a991c87e640ef77
        });
});
parcelRegister("7HGHK", function(module, exports) {
    $parcel$export(module.exports, "DISMISS_COMMAND", ()=>$9deb2cdefe93babb$export$e705274c5e156b93);
    $parcel$export(module.exports, "toFlagId", ()=>$9deb2cdefe93babb$export$8184bc29de2aea90);
    $parcel$export(module.exports, "fromFlagId", ()=>$9deb2cdefe93babb$export$188cdb77b72629d7);
    const $9deb2cdefe93babb$export$e705274c5e156b93 = 'DISMISS';
    const $9deb2cdefe93babb$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
    const $9deb2cdefe93babb$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();
});
parcelRegister("gEdnQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c019df33694ffbe1$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    var $7HGHK;
    var $c019df33694ffbe1$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
            if (typeof flag === 'function') {
                dispatch((0, (0, parcelRequire("d6YjM")).show)(flag));
                return undefined;
            }
            const flagId = flag.id || (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt))).v4());
            const newFlag = {
                ...flag,
                id: flagId
            };
            dispatch((0, (0, parcelRequire("d6YjM")).show)(newFlag));
            return flagId;
        };
});
parcelRegister("01A9Z", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$5787309a6ab0ba9c$export$6f57813fe9f31bf9);
    var $imvpl;
    const $5787309a6ab0ba9c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("imvpl")).createStore)();
});
parcelRegister("imvpl", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$6bbcd4b408b9a94e$export$f51a9068ac82ea43);
    var $F2Mxm;
    var $gG398;
    const $6bbcd4b408b9a94e$export$f51a9068ac82ea43 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'flags',
            rootReducer: (0, parcelRequire("gG398")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("F2Mxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fca77440264e922e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $aB8eX = parcelRequire("aB8eX");
    var $e1AU2 = parcelRequire("e1AU2");
    var $iGv2H;
    var $hkadP;
    var $i9gPl;
    var $fca77440264e922e$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
        const actionListenerMiddleware = new (0, (0, parcelRequire("i9gPl")).default)();
        middlewares.push(actionListenerMiddleware.perform);
        if ((0, (0, parcelRequire("iGv2H")).debugEnabled)('redux-logger')) {
            const { logger: logger } = (parcelRequire("korqb"));
            middlewares.push(logger);
        }
        if (rootEpic) middlewares.push((0, $e1AU2.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
            dependencies: rootEpicDependencies
        } : undefined));
        const store = (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)(rootReducer), initialState, (0, (0, parcelRequire("hkadP")).default)({
            name: appName,
            serialize: {
                replacer: (key, value)=>{
                    if ((0, $5uXOq.isValidElement)(value)) {
                        if (value.type && value.type.displayName) return `React Element <${value.type.displayName}>`;
                        return 'React Element';
                    }
                    if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                    return value;
                }
            }
        })((0, $3f2cs.compose)(...enhancers, (0, $3f2cs.applyMiddleware)(...middlewares))));
        store.addActionListener = actionListenerMiddleware.add;
        store.removeActionListener = actionListenerMiddleware.remove;
        return store;
    };
});
parcelRegister("iGv2H", function(module, exports) {
    $parcel$export(module.exports, "debugEnabled", ()=>$a4079cece44c0fab$export$342c99cc1e9bc5c6);
    const $a4079cece44c0fab$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);
});
parcelRegister("hkadP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$607c98afd3082218$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $607c98afd3082218$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
        const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        const config = {
            ...devtoolsConfig
        };
        if (config.name != null && config.instanceId == null) config.instanceId = config.name;
        return 0, $3f2cs.compose;
    };
});
parcelRegister("i9gPl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$330df53c22ed8aaf$export$2e2bcd8739ae039);
    class $330df53c22ed8aaf$export$2e2bcd8739ae039 {
        constructor(){
            this.listeners = [];
            this.add = (listener)=>{
                this.listeners.push(listener);
            };
            this.remove = (listener)=>{
                this.listeners = this.listeners.filter((l)=>l !== listener);
            };
            this.perform = (api)=>(next)=>(action)=>{
                        const result = next(action);
                        this.listeners.forEach((listener)=>listener(action, api.getState()));
                        return result;
                    };
        }
    }
});
parcelRegister("gG398", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1feeabef4760da78$export$2e2bcd8739ae039);
    var $ifg6x = parcelRequire("ifg6x");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $d6YjM;
    const $1feeabef4760da78$var$defaultState = {
        flags: []
    };
    var $1feeabef4760da78$export$2e2bcd8739ae039 = (state = $1feeabef4760da78$var$defaultState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("d6YjM")).SHOW:
                {
                    const [lowPriorityFlags, highPriorityFlags] = (0, ($parcel$interopDefault($ifg6x)))([
                        {
                            id: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                            flag: action.payload
                        },
                        ...state.flags
                    ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                    const flags = [
                        ...highPriorityFlags,
                        ...lowPriorityFlags
                    ];
                    return {
                        ...state,
                        flags: flags
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_INSTANCE:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).DISMISS_FLAG:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>{
                            if (flagInstance.flag.id) return flagInstance.flag.id !== id;
                            return true;
                        })
                    };
                }
            case 0, (0, parcelRequire("d6YjM")).RESET:
                return $1feeabef4760da78$var$defaultState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("8iiwm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7ec0f26423b786$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2c7ec0f26423b786$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "relay-fetch.services.error-flags.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "relay-fetch.services.error-flags.description",
            "defaultMessage": "Looks like you've been signed out. Try logging in again. "
        },
        login: {
            "id": "relay-fetch.services.error-flags.login",
            "defaultMessage": "Log in"
        }
    });
});
parcelRegister("7isEg", function(module, exports) {
    $parcel$export(module.exports, "getLoggingAndMetricsHelper", ()=>$6c554999a424d172$export$726e1df8186bb981);
    var $jqONe = parcelRequire("jqONe");
    var $9XE6b = parcelRequire("9XE6b");
    var $hGgHi = parcelRequire("hGgHi");
    var $dJl1T;
    var $jJZqs;
    const $6c554999a424d172$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
    const $6c554999a424d172$export$726e1df8186bb981 = (graphqlDetails)=>{
        const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
        return {
            logNonBreakingErrors: (errors, requestId)=>{
                if (false || (0, ($parcel$interopDefault($hGgHi)))(errors) || !Array.isArray(errors)) return;
                errors.forEach((error)=>{
                    error && (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, '[graphql error]', {
                        queryName: queryName,
                        operationKind: operationKind,
                        errorType: 'graphql',
                        message: error.message,
                        requestId: requestId
                    });
                });
            },
            logError: (error)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null)
                });
            },
            logErrorRetry: (error, retryAttempt)=>{
                const statusCode = (0, ($parcel$interopDefault($9XE6b)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? 'network' : 'unknown';
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($6c554999a424d172$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($jqONe)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($9XE6b)))(error, [
                        'name'
                    ], null),
                    retryAttempt: retryAttempt
                });
            }
        };
    };
});
parcelRegister("k1TrK", function(module, exports) {
    $parcel$export(module.exports, "subscribe", ()=>$4ced6779db298dc0$export$ec068583843480e7);
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $lWhTC;
    var $1Uhm6;
    var $cfDZ3;
    const $4ced6779db298dc0$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $eiowN.Observable).create((sink)=>{
            const client = (0, (0, parcelRequire("lWhTC")).getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id
                }
            };
            let requestId;
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    const aggRequestId = value?.extensions?.agg?.request_id;
                    requestId = aggRequestId ?? requestId;
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, (0, parcelRequire("1Uhm6")).getSinkError)(sinkError);
                    const attributes = {
                        operationName: operationName,
                        requestId: requestId,
                        userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                    };
                    sink.error(errorInfo);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'subscription',
                            packageName: 'jiraRelaySubscription',
                            teamName: 'uip-graphql'
                        },
                        error: errorInfo,
                        attributes: attributes,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        });
});
parcelRegister("lWhTC", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$2a46eca1e9133707$export$6bb76d6eba7e258c);
    var $4U1PW;
    var $jQsty;
    var $gwtGO;
    var $hoQbP;
    let $2a46eca1e9133707$var$client;
    const $2a46eca1e9133707$export$6bb76d6eba7e258c = ()=>{
        if ((0, (0, parcelRequire("hoQbP")).isSSR)() || (0, (0, parcelRequire("jQsty")).default)('graphql_subscriptions')) return null;
        if (!$2a46eca1e9133707$var$client) $2a46eca1e9133707$var$client = (0, (0, parcelRequire("4U1PW")).createClient)({
            url: (0, (0, parcelRequire("hoQbP")).getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $37d1b046897e548f$export$8b012b965402e06a),
            retryAttempts: (0, $37d1b046897e548f$export$bf6cd96e19b2987f),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, (0, parcelRequire("gwtGO")).default).join(',')
            }
        });
        return $2a46eca1e9133707$var$client;
    };
    const $2a46eca1e9133707$export$2f0afd443356d36f = ()=>{
        $2a46eca1e9133707$var$client = null;
    };
});
const $37d1b046897e548f$export$8b012b965402e06a = 580000;
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000;
parcelRegister("hoQbP", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$9e6d9986231c3fe5$export$48d7c418edadb60c);
    $parcel$export(module.exports, "getAggSubscriptionEndpoint", ()=>$9e6d9986231c3fe5$export$29a72e89601dfc59);
    const $9e6d9986231c3fe5$export$48d7c418edadb60c = ()=>false ?? false;
    const $9e6d9986231c3fe5$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
});
parcelRegister("1Uhm6", function(module, exports) {
    $parcel$export(module.exports, "getSinkError", ()=>$db2d4e9951ebaa0f$export$ece4736473c28965);
    const $db2d4e9951ebaa0f$export$ece4736473c28965 = (error)=>{
        let errorInfo;
        if (Array.isArray(error)) [errorInfo] = error;
        else if (error instanceof Error) errorInfo = error;
        else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
        else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
        else errorInfo = new Error(`Unknown sink error: ${error}`);
        return errorInfo;
    };
});
parcelRegister("fwvto", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$c5bf640417859136$export$48d7c418edadb60c);
    const $c5bf640417859136$export$48d7c418edadb60c = ()=>false ?? false;
});
parcelRegister("a83ud", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$852e6ed10ffe3afe$export$6e4bfef9e80c7eb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7rCb;
    const $852e6ed10ffe3afe$export$6e4bfef9e80c7eb0 = ()=>{
        const { startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            if (__SPA__) return;
            setTimeout(()=>{
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            }, 2000);
        }, [
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("hWnRN", function(module, exports) {
    module.exports = __LANG;
});
parcelRegister("1eg3p", function(module, exports) {
    $parcel$export(module.exports, "FlagsBoundary", ()=>$6fa78f2e53e42d4a$export$8b4a0fffcddd96f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    const $6fa78f2e53e42d4a$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "flags",
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "flags-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, children));
});
parcelRegister("5eQ1m", function(module, exports) {
    $parcel$export(module.exports, "StrictMode", ()=>$64cfd661e498c7fe$export$5f8d39834fd61797);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    const $64cfd661e498c7fe$export$5f8d39834fd61797 = ({ children: children })=>{
        return (0, (0, parcelRequire("co1wz")).ff)('jfp.magma.enable-strict-mode') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).StrictMode, null, children) : children;
    };
});
parcelRegister("aw7rz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h46oV")
    ]).then(()=>parcelRequire('3jTq3'));
});
parcelRegister("7o9iL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87698987077682aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $5eQ1m;
    var $TtQEC;
    const $87698987077682aa$var$getPlaceholder = (placeholderId)=>{
        const existingPlaceholder = document.getElementById(placeholderId);
        if (existingPlaceholder) return existingPlaceholder;
        const div = document.createElement('div');
        div.id = placeholderId;
        if (document.body) document.body.appendChild(div);
        else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
        return div;
    };
    const $87698987077682aa$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
        if (placeholder && sessionId) (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TtQEC")).default), {
            sessionId: sessionId,
            data: data
        })), $87698987077682aa$var$getPlaceholder(placeholder));
    };
    var $87698987077682aa$export$2e2bcd8739ae039 = $87698987077682aa$var$renderDwellTimeComponent;
});
parcelRegister("TtQEC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8ee37fd26b4ccf1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $jzjy1;
    var $jD5no;
    var $l7nSX;
    const $c8ee37fd26b4ccf1$var$defaultSource = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$defaultActionSubject = 'dwellComponent';
    const $c8ee37fd26b4ccf1$var$getDwellComponent = (source, actionSubject)=>(0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("jzjy1")).AnalyticsSubject)(actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject), (0, (0, parcelRequire("jzjy1")).AnalyticsSource)(source || $c8ee37fd26b4ccf1$var$defaultSource, (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))((0, (0, parcelRequire("l7nSX")).default));
    class $c8ee37fd26b4ccf1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props) {
            const { data: data } = props;
            return {
                DwellTimeComponent: $c8ee37fd26b4ccf1$var$getDwellComponent(data.source, data.actionSubject)
            };
        }
        constructor(props){
            super(props);
            this.state = {
                DwellTimeComponent: null
            };
        }
        render() {
            const { sessionId: sessionId, data: data } = this.props;
            const { DwellTimeComponent: DwellTimeComponent } = this.state;
            const enrichedData = {
                ...data,
                source: data && data.source || $c8ee37fd26b4ccf1$var$defaultSource,
                actionSubject: data && data.actionSubject || $c8ee37fd26b4ccf1$var$defaultActionSubject
            };
            if (sessionId && DwellTimeComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(DwellTimeComponent, {
                sessionId: sessionId,
                data: enrichedData
            }));
            return null;
        }
    }
});
parcelRegister("jzjy1", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsSource", ()=>$578c443a5ba38dde$export$6890652a1aff7d1c);
    $parcel$export(module.exports, "AnalyticsSubject", ()=>$578c443a5ba38dde$export$ec9f54bd4341ceb);
    var $994MI;
    const $578c443a5ba38dde$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)({
                source: `${name}${type}`
            })(WrappedComponent);
    const $578c443a5ba38dde$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)({
                actionSubject: name,
                attributes: attributes
            })(WrappedComponent);
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("l7nSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c5cee06f4a100e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9E7Uh;
    var $8oe80;
    var $hhweD;
    class $8c5cee06f4a100e3$export$1c7ccff61c195c75 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { data: data, sessionId: sessionId } = this.props;
            this.dwellHelper = new (0, (0, parcelRequire("9E7Uh")).default)(this.sendDwellEvent, data, sessionId);
            this.dwellHelper.start();
        }
        componentDidUpdate(oldProps) {
            if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) this.dwellHelper.newPage(this.props.data, this.props.sessionId);
        }
        componentWillUnmount() {
            if (this.dwellHelper) {
                this.dwellHelper.stop();
                this.dwellHelper.destroy();
            }
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.sendDwellEvent = (payload)=>(0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
        }
    }
    var $8c5cee06f4a100e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('dwellTime', {
        onDwell: 'dwelled'
    })($8c5cee06f4a100e3$export$1c7ccff61c195c75);
});
parcelRegister("8oe80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd6b229cbb45328e$export$2e2bcd8739ae039);
    var $994MI;
    var $cb25w;
    const $cd6b229cbb45328e$export$871de8747c9eaa88 = (props)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key]
                }
            }), {});
    function $cd6b229cbb45328e$var$componentWithAnalytics(componentName, eventActions) {
        return function(WrappedComponent) {
            return (0, (0, parcelRequire("994MI")).default)({
                componentName: componentName
            })((0, (0, parcelRequire("cb25w")).default)($cd6b229cbb45328e$export$871de8747c9eaa88(eventActions))(WrappedComponent));
        };
    }
    var $cd6b229cbb45328e$export$2e2bcd8739ae039 = $cd6b229cbb45328e$var$componentWithAnalytics;
});
parcelRegister("hhweD", function(module, exports) {
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$a4297ed46523d116$export$13990ad4625571ed);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $a4297ed46523d116$var$isNotUndefined = (a)=>a !== undefined;
    const $a4297ed46523d116$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { action: action, actionSubjectId: actionSubjectId } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            action: action,
            actionSubjectId: actionSubjectId
        }, $a4297ed46523d116$var$isNotUndefined);
    };
    const $a4297ed46523d116$export$13990ad4625571ed = (event, payload)=>{
        event.update({
            ...$a4297ed46523d116$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).TRACK_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("i4iBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a364fe632bf506b$export$2e2bcd8739ae039);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8a364fe632bf506b$export$2e2bcd8739ae039 = (payload)=>{
        const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
        return (0, ($parcel$interopDefault($9xWGk)))({
            tags: tags,
            containerId: containerId,
            containers: containers,
            containerType: containerType,
            objectId: objectId,
            objectType: objectType,
            attributes: attributes
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
});
parcelRegister("1mY2B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZtG1")
    ]).then(()=>parcelRequire('2Q8el'));
});
parcelRegister("97qv7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("54DPr")
    ]).then(()=>parcelRequire('forzB'));
});
parcelRegister("5PCBy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bERdS").then(()=>parcelRequire('8ymsB'));
});
parcelRegister("8UcTu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kWrFZ"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("561Jq"),
        $6fhBS("1QYl5"),
        $6fhBS("2Lfdl"),
        $6fhBS("hPzOn"),
        $6fhBS("dsiAd"),
        $6fhBS("eNmuD"),
        $6fhBS("dzRix")
    ]).then(()=>parcelRequire('faPQm'));
});
parcelRegister("fO7QI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("Nlduf")
    ]).then(()=>parcelRequire('jEc6C'));
});
parcelRegister("8Xjsv", function(module, exports) {
    $parcel$export(module.exports, "renderPageContainer", ()=>$17cccc58f3ff23f2$export$53746a9158b8b9c8);
    $parcel$export(module.exports, "default", ()=>$17cccc58f3ff23f2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $4Pf62;
    var $frBVt;
    var $iqr2y;
    var $7bkFJ;
    var $j8DrX;
    parcelRequire("2YzDH");
    var $cfDZ3;
    var $5eQ1m;
    var $b7awD;
    var $81ezV;
    var $a2tI7;
    var $5HG6S;
    var $3qHVS;
    var $lGgkA;
    var $dIdda = parcelRequire("dIdda");
    const $17cccc58f3ff23f2$var$pageContainerImport = (parcelRequire("gIFpA"));
    var $hWnRN = parcelRequire("hWnRN");
    const $17cccc58f3ff23f2$export$53746a9158b8b9c8 = async ({ App: App = null, containerId: containerId = 'navigation-app', onLoad: onLoad, pageType: pageType = 'legacy-page' } = {})=>{
        const container = document.getElementById(containerId);
        if (container) {
            const { default: PageContainerV2 } = await $17cccc58f3ff23f2$var$pageContainerImport;
            (0, (0, parcelRequire("lGgkA")).LooselyLazy).init({
                mode: 'RENDER',
                crossOrigin: 'anonymous'
            });
            const tenantContext = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
            $parcel$global.__NAV_VERSION__ = '3.0.0';
            (0, (0, parcelRequire("7bkFJ")).initPlatformFeatureFlags)((0, (0, parcelRequire("3qHVS")).visualRefreshResolverOverride));
            const history = (0, $dIdda.createLegacyHistory)();
            const routes = (0, (0, parcelRequire("a2tI7")).getRoutes)();
            const matchedRoute = (0, $dIdda.matchRoute)(routes, window.location.pathname, window.location.search, '');
            (0, (0, parcelRequire("cfDZ3")).setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
            const resourceContext = (0, (0, parcelRequire("5HG6S")).getSpaRouterContext)({
                tenantContext: tenantContext
            });
            const resourceData = window.SKELETON_NAVIGATION;
            const LegacyRouter = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b7awD")).Router), {
                    history: history,
                    routes: routes,
                    resourceContext: resourceContext,
                    resourceData: resourceData
                }, children);
            const placeholders = (0, (0, parcelRequire("frBVt")).getPlaceholdersFromHTML)();
            (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQ1m")).StrictMode), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frBVt")).EntryPointPlaceholderContext).Provider, {
                value: placeholders
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(PageContainerV2, {
                id: "jira.entry.legacy",
                locale: tenantContext.locale,
                baseUrl: "",
                messages: $hWnRN,
                onLoad: onLoad,
                Router: LegacyRouter,
                routerLinkComponent: (0, (0, parcelRequire("81ezV")).JiraRouterLinkConfiguration),
                pageType: pageType
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorBoundaryFlag), {
                id: "jira.route-app.legacy-bootstrap"
            }, App ? (0, ($parcel$interopDefault($5uXOq))).createElement(App, null) : null)))), container);
        }
    };
    var $17cccc58f3ff23f2$export$2e2bcd8739ae039 = ()=>{
        const isGlobalSidebarEnabled = (0, (0, parcelRequire("j8DrX")).default)('ajs-global-sidebar-enabled') === 'true';
        if (!isGlobalSidebarEnabled) return;
        if (document.getElementById('navigation-app')) $17cccc58f3ff23f2$export$53746a9158b8b9c8();
        else document.addEventListener('DOMContentLoaded', ()=>$17cccc58f3ff23f2$export$53746a9158b8b9c8());
    };
});
parcelRegister("frBVt", function(module, exports) {
    $parcel$export(module.exports, "getPlaceholdersFromHTML", ()=>$126443352ff757de$export$9e9f35acc3af3a9a);
    $parcel$export(module.exports, "EntryPointPlaceholderContext", ()=>$126443352ff757de$export$b5b377bb81310c48);
    $parcel$export(module.exports, "EntryPointPlaceholder", ()=>$126443352ff757de$export$db2828f683d11042);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    function $126443352ff757de$export$9e9f35acc3af3a9a() {
        const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
        return new Map(Array.from(placeholders, (el)=>[
                el.dataset.epPlaceholderId,
                el.innerHTML
            ]));
    }
    const $126443352ff757de$export$b5b377bb81310c48 = (0, $5uXOq.createContext)(new Map());
    function $126443352ff757de$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
        const { root: root } = entryPoint;
        const hasMounted = (0, $5uXOq.useRef)(false);
        const placeholders = (0, $5uXOq.useContext)($126443352ff757de$export$b5b377bb81310c48);
        const ssrFallback = placeholders.get(name);
        const [fallback, setFallback] = (0, $5uXOq.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: ssrFallback
            },
            "data-ep-placeholder-id": name
        }));
        const lastOriginalFallback = (0, $5uXOq.useRef)(originalFallback);
        lastOriginalFallback.current = originalFallback;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (hasMounted.current && placeholders.has(name)) {
                placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            }
        }, [
            entryPoint,
            name,
            placeholders,
            setFallback
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onComplete = ()=>{
                if (placeholders.has(name)) placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            };
            const unsubscribe = root.onComplete(onComplete, onComplete);
            return ()=>{
                unsubscribe();
                onComplete();
            };
        }, [
            name,
            placeholders,
            root
        ]);
        (0, $5uXOq.useEffect)(()=>{
            hasMounted.current = true;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: fallback,
            name: name,
            ...placeholderProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-ep-placeholder-id": name
        }, children));
    }
});
parcelRegister("7bkFJ", function(module, exports) {
    $parcel$export(module.exports, "initPlatformFeatureFlags", ()=>$fef4d3d4b4c51b47$export$2d291317456ada16);
    var $VSDnB;
    var $4R6GH;
    var $co1wz;
    const $fef4d3d4b4c51b47$export$2d291317456ada16 = ([isOverride, resolver])=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('fix_jira_ssr_platform_ff_oxim4')) (0, (0, parcelRequire("VSDnB")).setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, (0, parcelRequire("4R6GH")).fg)(flagKey) || (0, (0, parcelRequire("co1wz")).ff)(flagKey));
    };
});
parcelRegister("2YzDH", function(module, exports) {
    var $7JoAD = parcelRequire("7JoAD");
    if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
        (parcelRequire("2Geeh"));
        const isDevMode = false;
        (0, $7JoAD.defaults).devtools = isDevMode && (()=>({
                serialize: {
                    replacer: (key, value)=>value instanceof HTMLElement ? {
                            data: {
                                tagName: value.tagName,
                                className: value.className,
                                id: value.id,
                                __SANITIZED__: true
                            },
                            __serializedType__: 'HTMLElement'
                        } : value
                }
            }));
        (0, $7JoAD.defaults).batchUpdates = !false;
        Object.freeze((0, $7JoAD.defaults));
        $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
    }
});
parcelRegister("2Geeh", function(module, exports) {
    const $1f3a8aadd86b4cc5$var$style = document.createElement('style');
    $1f3a8aadd86b4cc5$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
    document.querySelector('head').appendChild($1f3a8aadd86b4cc5$var$style);
});
parcelRegister("b7awD", function(module, exports) {
    $parcel$export(module.exports, "Router", ()=>$87aa2fd82c8be71a$export$55185c17a0fcbe46);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $d8orV;
    const $87aa2fd82c8be71a$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
        const pluginsWithOverride = (0, (0, parcelRequire("d8orV")).usePlugins)({
            resourceContext: props.resourceContext,
            resourceData: props.resourceData
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Router), {
            plugins: pluginsWithOverride,
            ...props
        }, children);
    };
});
parcelRegister("d8orV", function(module, exports) {
    $parcel$export(module.exports, "usePlugins", ()=>$0614c9d3afc2dd7f$export$c41e96fd89bc6106);
    var $5uXOq = parcelRequire("5uXOq");
    var $a2g00;
    var $5yJb9;
    var $9OXo1;
    var $8Y8sk;
    const $0614c9d3afc2dd7f$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [pluginsWithOverride] = (0, $5uXOq.useState)(()=>{
            const jiraPlugins = [];
            const resourcesPlugin = (0, (0, parcelRequire("8Y8sk")).createResourcesPlugin)({
                context: resourceContext,
                resourceData: resourceData
            });
            jiraPlugins.push(resourcesPlugin);
            jiraPlugins.push((0, (0, parcelRequire("a2g00")).createEntryPointsPlugin)({
                environment: (0, (0, parcelRequire("5yJb9")).default)(),
                entryPointParams: {
                    tenantContext: tenantContext
                }
            }));
            return jiraPlugins;
        });
        return pluginsWithOverride;
    };
});
parcelRegister("a2g00", function(module, exports) {
    $parcel$export(module.exports, "createEntryPointsPlugin", ()=>$e3cbf02360bc6f96$export$33586718f82f356f);
    var $8Uumt = parcelRequire("8Uumt");
    var $3gC8D;
    var $3I4nj;
    var $ktB2C;
    const $e3cbf02360bc6f96$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
            id: 'entry-points-plugin',
            routeLoad: ({ context: context })=>{
                const entryPoint = context.route.entryPoint?.();
                const prefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                let entryPointReference = null;
                if (entryPoint) {
                    if (prefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prefetchingRoute.routerContext.match,
                        nextContextMatch: context.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                    else entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: context,
                        ...entryPointParams
                    });
                }
                (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setLastLoadedRoute({
                    route: context.route,
                    entryPointReference: entryPointReference
                });
                return {
                    entryPoint: entryPointReference
                };
            },
            routePrefetch: ({ nextContext: nextContext })=>{
                const entryPoint = nextContext.route.entryPoint?.();
                if (entryPoint) {
                    const prevPrefetchingRoute = (0, (0, parcelRequire("3I4nj")).getPrefetchingRoute)();
                    if (prevPrefetchingRoute && (0, (0, parcelRequire("3gC8D")).isSameRouteMatch)({
                        prevContextMatch: prevPrefetchingRoute.routerContext.match,
                        nextContextMatch: nextContext.match
                    }) && !(0, (0, parcelRequire("3gC8D")).isExpired)(prevPrefetchingRoute.expiresAt)) return;
                    const entryPointReference = (0, $8Uumt.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: nextContext,
                        ...entryPointParams
                    });
                    (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                        routerContext: nextContext,
                        expiresAt: (0, (0, parcelRequire("3gC8D")).getExpiresAt)(),
                        entryPointReference: entryPointReference
                    });
                } else (0, (0, parcelRequire("3I4nj")).getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: 0,
                    entryPointReference: null
                });
            },
            waitForEntryPoint: ()=>{
                const lastLoadedRoute = (0, (0, parcelRequire("3I4nj")).getLastLoadedRoute)();
                const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
                if (entryPointReference) return (0, (0, parcelRequire("ktB2C")).waitForEntryPoint)(entryPointReference);
                return Promise.resolve();
            }
        });
});
parcelRegister("3gC8D", function(module, exports) {
    $parcel$export(module.exports, "getExpiresAt", ()=>$f48ce76f20803aec$export$b65d7ba7fbf150f1);
    $parcel$export(module.exports, "isExpired", ()=>$f48ce76f20803aec$export$57947cfd429801a2);
    $parcel$export(module.exports, "isSameRouteMatch", ()=>$f48ce76f20803aec$export$5997e70fc4543270);
    const $f48ce76f20803aec$export$37d3126be6549b13 = 10000;
    const $f48ce76f20803aec$export$b65d7ba7fbf150f1 = ()=>$f48ce76f20803aec$export$37d3126be6549b13 + Date.now();
    const $f48ce76f20803aec$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
    const $f48ce76f20803aec$var$isShallowEqual = (o1, o2)=>{
        const objKeys1 = Object.keys(o1);
        const objKeys2 = Object.keys(o2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>o1[key] === o2[key]);
    };
    const $f48ce76f20803aec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $f48ce76f20803aec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
});
parcelRegister("3I4nj", function(module, exports) {
    $parcel$export(module.exports, "useLastLoadedRoute", ()=>$f09634e8d32626d1$export$895238443fc3eae4);
    $parcel$export(module.exports, "getEntryPointsStore", ()=>$f09634e8d32626d1$export$fe654a734624d17f);
    $parcel$export(module.exports, "getLastLoadedRoute", ()=>$f09634e8d32626d1$export$5763b2305b3056df);
    $parcel$export(module.exports, "getPrefetchingRoute", ()=>$f09634e8d32626d1$export$7e18f3e3cbd04326);
    var $7JoAD = parcelRequire("7JoAD");
    const $f09634e8d32626d1$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
            setState({
                lastLoadedRoute: {
                    route: route,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
            setState({
                prefetchingRoute: {
                    routerContext: routerContext,
                    expiresAt: expiresAt,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $f09634e8d32626d1$var$actions = {
        setLastLoadedRoute: $f09634e8d32626d1$export$1cec83a23d40a9fa,
        setPrefetchingRoute: $f09634e8d32626d1$export$bb3dc9c55f78173e
    };
    const $f09634e8d32626d1$var$EntryPointsStore = (0, $7JoAD.createStore)({
        initialState: {
            lastLoadedRoute: null,
            prefetchingRoute: null
        },
        actions: $f09634e8d32626d1$var$actions,
        name: 'react-resource-router/entry-points'
    });
    const $f09634e8d32626d1$export$895238443fc3eae4 = (0, $7JoAD.createHook)($f09634e8d32626d1$var$EntryPointsStore, {
        selector: (state)=>state.lastLoadedRoute
    });
    const $f09634e8d32626d1$export$fe654a734624d17f = ()=>(0, $7JoAD.defaultRegistry).getStore($f09634e8d32626d1$var$EntryPointsStore);
    const $f09634e8d32626d1$export$b28ecd0e4705f6b7 = ()=>$f09634e8d32626d1$export$fe654a734624d17f().storeState.getState();
    const $f09634e8d32626d1$export$5763b2305b3056df = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().lastLoadedRoute;
    const $f09634e8d32626d1$export$7e18f3e3cbd04326 = ()=>$f09634e8d32626d1$export$b28ecd0e4705f6b7().prefetchingRoute;
});
parcelRegister("ktB2C", function(module, exports) {
    $parcel$export(module.exports, "waitForEntryPoint", ()=>$67d2b262678828c6$export$944f853f194e5dd5);
    var $kipqU;
    const $67d2b262678828c6$export$944f853f194e5dd5 = (entryPointConfig)=>{
        const promises = [];
        try {
            entryPointConfig.getComponent();
        } catch (err) {
            if (err instanceof Promise) promises.push(err);
            else throw err;
        }
        const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) {
                const queryPromise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(String(queries[key].id));
                if (queryPromise) promises.push(queryPromise);
            }
        });
        if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
            const nestedEntryPointPromise = $67d2b262678828c6$export$944f853f194e5dd5(entryPoints[key]);
            promises.push(nestedEntryPointPromise);
        });
        return Promise.allSettled(promises);
    };
});
parcelRegister("8Y8sk", function(module, exports) {
    $parcel$export(module.exports, "createResourcesPlugin", ()=>$d3b2f44f58ee61bb$export$23ed892c481a96fe);
    var $8fYaK;
    var $4CEu1;
    const $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c = 'resources-plugin';
    const $d3b2f44f58ee61bb$var$loadOnUrlChange = (context, prevContext)=>{
        const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
        return Promise.all(requestResources(nextResources, context, {}));
    };
    const $d3b2f44f58ee61bb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
        const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
        const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
        cleanExpiredResources(nextResources, nextContext);
    };
    const $d3b2f44f58ee61bb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
        let latestLoadedResources = Promise.resolve([]);
        (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.hydrate({
            resourceContext: initialResourceContext,
            resourceData: initialResourceData
        });
        return {
            id: $d3b2f44f58ee61bb$export$a9bc0bb87abc2c4c,
            beforeRouteLoad: $d3b2f44f58ee61bb$var$beforeLoad,
            routeLoad: ({ context: context, prevContext: prevContext })=>{
                const { route: route, match: match, query: query } = context;
                if (prevContext) latestLoadedResources = $d3b2f44f58ee61bb$var$loadOnUrlChange(context, prevContext);
                else latestLoadedResources = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.requestAllResources({
                    route: route,
                    match: match,
                    query: query
                }, {
                    timeout: timeout
                });
            },
            routePrefetch: ({ context: context, nextContext: nextContext })=>{
                const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions;
                const nextResources = (0, (0, parcelRequire("4CEu1")).getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
                return {
                    resources: prefetchResources(nextResources, nextContext, {})
                };
            },
            getLatestResources: ()=>latestLoadedResources,
            getSerializedResources: async ()=>{
                await latestLoadedResources;
                return (0, (0, parcelRequire("8fYaK")).getResourceStore)().actions.getSafeData();
            }
        };
    };
});
parcelRegister("4CEu1", function(module, exports) {
    $parcel$export(module.exports, "getResourcesForNextLocation", ()=>$448a0fea894dd469$export$7cbbc763e2f3d65d);
    var $9KbzN;
    var $dj41J;
    const $448a0fea894dd469$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
        const { route: prevRoute } = prevRouterStoreContext;
        const { resources: prevResources = [] } = prevRoute || {};
        const { route: nextRoute } = nextRouterStoreContext;
        const { resources: nextResources = [] } = nextRoute || {};
        if (!(0, (0, parcelRequire("dj41J")).routeHasResources)(nextRoute)) return [];
        if ((0, (0, parcelRequire("dj41J")).routeHasChanged)(prevRoute, nextRoute)) return nextResources;
        const prevResourceIdentifiers = (0, (0, parcelRequire("9KbzN")).getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
        return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, (0, parcelRequire("9KbzN")).getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
    };
});
parcelRegister("9KbzN", function(module, exports) {
    $parcel$export(module.exports, "getResourceIdentifier", ()=>$82cfa1d66d41fab5$export$c616b176adf9ad4a);
    $parcel$export(module.exports, "getResourceIdentifiers", ()=>$82cfa1d66d41fab5$export$cd7fbe7e979df558);
    const $82cfa1d66d41fab5$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
        const { type: type, getKey: getKey } = resource;
        const key = getKey(routerStoreContext, resourceStoreContext);
        return `${type}/${key}`;
    };
    const $82cfa1d66d41fab5$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$82cfa1d66d41fab5$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
});
parcelRegister("dj41J", function(module, exports) {
    $parcel$export(module.exports, "routeHasResources", ()=>$9c8422e0259b24f6$export$740886389191c640);
    $parcel$export(module.exports, "routeHasChanged", ()=>$9c8422e0259b24f6$export$221027ff1aa38f82);
    const $9c8422e0259b24f6$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
    const $9c8422e0259b24f6$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
});
parcelRegister("81ezV", function(module, exports) {
    $parcel$export(module.exports, "JiraRouterLinkConfiguration", ()=>$33ea5bfeb747665b$export$a580704a2f3cfca);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $33ea5bfeb747665b$export$a580704a2f3cfca = (0, $5uXOq.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
        if (!href || typeof href === 'string') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ref: ref,
            href: href || '#',
            ...rest
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ref: ref,
            href: href.href,
            to: href.to,
            replace: href.replace,
            params: href.params,
            query: href.query,
            prefetch: href.prefetch,
            ...rest
        }, children);
    });
});
parcelRegister("a2tI7", function(module, exports) {
    $parcel$export(module.exports, "getRoutes", ()=>$be0f5dfaba17147f$export$2f7745f2f5ab3897);
    var $65Ltd;
    var $3RJkv;
    var $6QKrH;
    var $51f7x;
    var $2rSKc;
    var $etW4g;
    var $cww4s;
    var $bNq9X;
    var $eThIt;
    var $cpQ1x;
    var $lT1ZM;
    var $8Pux3;
    var $4RrJu;
    var $l87wS;
    var $ixNqV;
    var $8D07Q;
    var $kyH4Y;
    var $lwy1a;
    var $iBTsr;
    var $foqfA;
    var $9yX2q;
    var $afkjn;
    var $j8gaF;
    var $g0GVs;
    var $a2seC;
    var $hGmIt;
    var $fN1YT;
    var $glG2a;
    var $cYSpk;
    var $3WQFs;
    var $67rDY;
    var $dRlY8;
    var $4GwLj;
    var $fS7Zg;
    var $2B1hR;
    var $9jvhK;
    var $hMwq2;
    var $iwi8A;
    var $12CWk;
    var $g33xc;
    var $b5v7R;
    var $eODBO;
    var $hlfSP;
    var $5z6KH;
    var $eLVEp;
    var $lagzw;
    var $3latU;
    var $5Nnqm;
    var $d6dRh;
    var $4VzuS;
    var $cMeMl;
    var $uTJdq;
    var $gQaJ7;
    var $fGB22;
    var $6R0vY;
    var $9VVuX;
    var $iwnR1;
    var $1JdXH;
    var $clrfj;
    var $1yWGC;
    var $9CQ2b;
    var $62QWI;
    var $nNkX7;
    var $j6X8z;
    var $dSPOH;
    var $7PWgz;
    var $ekikx;
    var $dVehM;
    var $jr2Mg;
    var $8aJ2b;
    var $43Uc9;
    var $kHniB;
    var $i9iZS;
    var $hvbGw;
    var $aiZ7o;
    var $apLiY;
    var $5Wx3t;
    var $42kD1;
    var $9Ahl6;
    var $6bzuG;
    var $iSsNS;
    var $jJpgV;
    var $eWkcy;
    var $2QaYg;
    var $8kL76;
    var $c2Cpo;
    var $jolwb;
    var $3EIJ8;
    var $kPDwm;
    var $cfZHb;
    var $3zySp;
    var $drG3A;
    var $hQSWw;
    var $7t6RT;
    var $1NqcA;
    var $iEOv0;
    var $eoQjS;
    var $gZV6Y;
    var $17yPk;
    var $cLAit;
    var $Th6e7;
    var $cJLbl;
    var $1eB7K;
    var $l9OjQ;
    var $1i9Xk;
    var $egtWh;
    var $eidif;
    var $fy4Yg;
    var $aQQaa;
    var $eBuTH;
    var $4nY0z;
    var $itMEc;
    var $38epV;
    var $5V9SB;
    var $9H4pw;
    var $fmiQQ;
    var $dPPJY;
    var $9AJay;
    var $8bpAh;
    var $58oS1;
    var $6MOc5;
    var $g6iev;
    var $iQqGv;
    var $lqFNV;
    var $48mkc;
    var $fg9n4;
    var $jfSTr;
    var $iWPtZ;
    var $d4DfK;
    var $aOHs8;
    var $l6LGS;
    var $391UN;
    var $9I8yf;
    var $iaCCR;
    var $4erM2;
    var $56QIn;
    var $7SwDB;
    var $69II0;
    var $2Xl2E;
    var $1DqI0;
    var $erXHa;
    var $6pQVv;
    var $BV4TM;
    var $f3iyT;
    var $anp69;
    var $a5QOt;
    var $kBqwn;
    var $84Mhu;
    var $dTxTT;
    var $lVivS;
    var $b1Nwt;
    var $lvMv1;
    var $5b2gi;
    var $kQ04T;
    var $bj17J;
    var $4eIbF;
    var $c6t9I;
    var $luBtt;
    var $dkKsD;
    var $ebHSU;
    var $6Mj9c;
    var $8gFkr;
    var $dZUFc;
    var $8SVcH;
    var $79bmJ;
    var $8Uour;
    var $2RLw5;
    var $fVyU8;
    var $di1Zu;
    var $e1V9T;
    var $ckFGJ;
    var $0PAJi;
    var $7mtPT;
    var $5xSTz;
    var $hkGft;
    var $6BVPh;
    var $7DU6a;
    var $dAqez;
    var $6GuVf;
    var $6PPXt;
    var $dizV4;
    var $fcvqo;
    var $5YP8f;
    var $k9lPR;
    var $2KRqQ;
    var $kfJc9;
    var $hBU7y;
    var $4C3AQ;
    var $jmGsg;
    var $iR4bc;
    var $aE4J4;
    var $bItBj;
    var $hsLjW;
    var $2U6zO;
    var $47ilh;
    var $4bfvE;
    var $2s4t1;
    var $cf68o;
    var $6zerj;
    var $fP5WF;
    var $esrDU;
    var $fScJq;
    var $l6l6T;
    var $fZCTK;
    var $lkegl;
    var $9YVJw;
    var $7Aduu;
    var $5Zo8J;
    var $1IurR;
    var $7SWln;
    var $dPtSd;
    var $687JO;
    var $6Y9SN;
    var $3rTLb;
    var $jUy8v;
    var $llQfO;
    var $kmoqG;
    var $bfZmE;
    var $3FzLz;
    var $kz3Cm;
    var $fJ7EK;
    var $jd9Qm;
    var $llrP2;
    var $5WsTv;
    var $61puu;
    var $eMPkb;
    var $1iPRl;
    var $lbAbl;
    var $1yecM;
    var $ffqgy;
    var $8AXFc;
    var $kkkBS;
    var $f620M;
    var $78hVF;
    var $cZ7VE;
    var $cQgjC;
    var $l39a8;
    var $7atcL;
    var $anXSE;
    const $be0f5dfaba17147f$var$getRawRoutes = ()=>[
            (0, (0, parcelRequire("4C3AQ")).legacyJsdGettingStartedRouteEntry),
            (0, (0, parcelRequire("hBU7y")).legacyJsdCustomersRouteEntry),
            (0, (0, parcelRequire("iR4bc")).legacyJsdKnowledgeRouteEntry),
            (0, (0, parcelRequire("bItBj")).legacyJsdQueuesManageRouteEntry),
            (0, (0, parcelRequire("aE4J4")).legacyJsdQueuesRouteEntry),
            (0, (0, parcelRequire("hsLjW")).legacyJsdReportsCustomRouteEntry),
            (0, (0, parcelRequire("2U6zO")).legacyJsdReportsRouteEntry),
            (0, (0, parcelRequire("4bfvE")).legacyJsdSettingsLanguageRouteEntry),
            (0, (0, parcelRequire("2s4t1")).legacyJsdSettingsLanguagePagesRouteEntry),
            (0, (0, parcelRequire("jmGsg")).legacyJsdJiraAutomationRouteEntry),
            (0, (0, parcelRequire("cf68o")).legacyJsdWidgetsRouteEntry),
            (0, (0, parcelRequire("47ilh")).legacyJsdSettingsFallbackRouteEntry),
            (0, (0, parcelRequire("lT1ZM")).legacyCustomReportRouteEntry),
            (0, (0, parcelRequire("cww4s")).legacyBacklogRouteEntry),
            (0, (0, parcelRequire("bNq9X")).legacyBoardRouteEntry),
            (0, (0, parcelRequire("bNq9X")).legacyBoard1RouteEntry),
            (0, (0, parcelRequire("etW4g")).legacyAllReportsRouteEntry),
            (0, (0, parcelRequire("fS7Zg")).globalIssueNavigatorRouteEntry),
            (0, (0, parcelRequire("fS7Zg")).globalIssueNavigatorBrowseRouteEntry),
            (0, (0, parcelRequire("fS7Zg")).globalIssueNavigatorRedirectRouteEntry),
            (0, (0, parcelRequire("kfJc9")).legacyIssueRouteEntry),
            (0, (0, parcelRequire("fP5WF")).legacyPinRouteEntry),
            (0, (0, parcelRequire("fZCTK")).legacyProjectReleasesRouteEntry),
            (0, (0, parcelRequire("9YVJw")).legacyProjectReleasesNoteRouteEntry),
            (0, (0, parcelRequire("lkegl")).legacyProjectReleasesNoteConfigRouteEntry),
            (0, (0, parcelRequire("l6l6T")).legacyProjectReleasesBambooRouteEntry),
            (0, (0, parcelRequire("eMPkb")).legacyReportsAverageAgeRouteEntry),
            (0, (0, parcelRequire("lbAbl")).legacyReportsCreatedVsResolvedRouteEntry),
            (0, (0, parcelRequire("ffqgy")).legacyReportsPieRouteEntry),
            (0, (0, parcelRequire("8AXFc")).legacyReportsRecentlyCreatedRouteEntry),
            (0, (0, parcelRequire("kkkBS")).legacyReportsResolutionTimeRouteEntry),
            (0, (0, parcelRequire("f620M")).legacyReportsSingleLevelGroupByRouteEntry),
            (0, (0, parcelRequire("78hVF")).legacyReportsTimeSinceRouteEntry),
            (0, (0, parcelRequire("cZ7VE")).legacyReportsTimeTrackingReportRouteEntry),
            (0, (0, parcelRequire("1yecM")).legacyReportsDeveloperWorkloadRouteEntry),
            (0, (0, parcelRequire("cQgjC")).legacyReportsVersionWorkloadRouteEntry),
            (0, (0, parcelRequire("l39a8")).legacyReportsWorkloadPieRouteEntry),
            (0, (0, parcelRequire("1iPRl")).legacyReportsConfigRouteEntry),
            (0, (0, parcelRequire("cpQ1x")).legacyConnectProjectRouteEntry),
            (0, (0, parcelRequire("fJ7EK")).legacyProjectSettingsPeopleRouteEntry),
            (0, (0, parcelRequire("5WsTv")).legacyProjectSettingsSummaryRouteEntry),
            (0, (0, parcelRequire("bfZmE")).legacyProjectSettingsIssueTypesRouteEntry),
            (0, (0, parcelRequire("bfZmE")).legacyProjectSettingsIssueTypesAssociateRouteEntry),
            (0, (0, parcelRequire("llQfO")).legacyProjectSettingsIssueLayoutRouteEntry),
            (0, (0, parcelRequire("61puu")).legacyProjectSettingsWorkflowsRouteEntry),
            (0, (0, parcelRequire("61puu")).legacyProjectSettingsWorkflowsAssociateRouteEntry),
            (0, (0, parcelRequire("llrP2")).legacyProjectSettingsScreensRouteEntry),
            (0, (0, parcelRequire("llrP2")).legacyProjectSettingsScreensAssociateRouteEntry),
            (0, (0, parcelRequire("jUy8v")).legacyProjectSettingsFieldsRouteEntry),
            (0, (0, parcelRequire("jUy8v")).legacyProjectSettingsFieldsAssociateRouteEntry),
            (0, (0, parcelRequire("kz3Cm")).legacyProjectSettingsOpsgenieRouteEntry),
            (0, (0, parcelRequire("jd9Qm")).legacyProjectSettingsPermissionsRouteEntry),
            (0, (0, parcelRequire("kmoqG")).legacyProjectSettingsIssueSecurityRouteEntry),
            (0, (0, parcelRequire("kmoqG")).legacyProjectSettingsIssueSecurityAssociateRouteEntry),
            (0, (0, parcelRequire("3FzLz")).legacyProjectSettingsNotificationsRouteEntry),
            (0, (0, parcelRequire("3FzLz")).legacyProjectSettingsNotificationsAssociateRouteEntry),
            (0, (0, parcelRequire("dPtSd")).legacyProjectSettingsConfigRouteEntry),
            (0, (0, parcelRequire("3rTLb")).legacyProjectSettingsEditRouteEntry),
            (0, (0, parcelRequire("687JO")).legacyProjectSettingsDeleteRouteEntry),
            (0, (0, parcelRequire("5Zo8J")).legacyProjectSettingsCollectorsRouteEntry),
            (0, (0, parcelRequire("7Aduu")).legacyProjectSettingsCollectorsAddRouteEntry),
            (0, (0, parcelRequire("1IurR")).legacyProjectSettingsCollectorsHelpRouteEntry),
            (0, (0, parcelRequire("7SWln")).legacyProjectSettingsCollectorsViewRouteEntry),
            (0, (0, parcelRequire("6Y9SN")).legacyProjectSettingsDevRouteEntry),
            (0, (0, parcelRequire("4RrJu")).legacyDashboardsConfigureRouteEntry),
            (0, (0, parcelRequire("ixNqV")).dashboardsDirectoryRouteEntry),
            (0, (0, parcelRequire("8Pux3")).legacyDashboardsAddRouteEntry),
            (0, (0, parcelRequire("8D07Q")).legacyDashboardsEditRouteEntry),
            (0, (0, parcelRequire("l87wS")).legacyDashboardsDeleteRouteEntry),
            (0, (0, parcelRequire("kyH4Y")).legacyDashboardsRestoreRouteEntry),
            (0, (0, parcelRequire("glG2a")).legacyGinManageRouteEntry),
            (0, (0, parcelRequire("9yX2q")).legacyGinBulkeditRouteEntry),
            (0, (0, parcelRequire("foqfA")).legacyGinBulkRouteEntry),
            (0, (0, parcelRequire("fN1YT")).legacyGinIssueMoveRouteEntry),
            (0, (0, parcelRequire("67rDY")).legacyGinSubtaskActionRouteEntry),
            (0, (0, parcelRequire("j8gaF")).legacyGinIssueCloneRouteEntry),
            (0, (0, parcelRequire("afkjn")).legacyGinIssueAssignRouteEntry),
            (0, (0, parcelRequire("a2seC")).legacyGinIssueCreateRouteEntry),
            (0, (0, parcelRequire("g0GVs")).legacyGinIssueConvertRouteEntry),
            (0, (0, parcelRequire("hGmIt")).legacyGinIssueEditRouteEntry),
            (0, (0, parcelRequire("dRlY8")).legacyGinWatchersIssueRouteEntry),
            (0, (0, parcelRequire("iBTsr")).legacyGinActionRouteEntry),
            (0, (0, parcelRequire("3WQFs")).legacyGinSubscriptionsRouteEntry),
            (0, (0, parcelRequire("cYSpk")).legacyGinSubscriptionEditRouteEntry),
            (0, (0, parcelRequire("esrDU")).legacyPortfolioPagesRouteEntry),
            (0, (0, parcelRequire("fScJq")).legacyPortfolioTeamRouteEntry),
            (0, (0, parcelRequire("f3iyT")).globalSettingsSystemApplicationViewRouteEntry),
            (0, (0, parcelRequire("6pQVv")).globalSettingsSystemApplicationAdvancedRouteEntry),
            (0, (0, parcelRequire("BV4TM")).globalSettingsSystemApplicationEditRouteEntry),
            (0, (0, parcelRequire("a5QOt")).globalSettingsSystemAuditingRouteEntry),
            (0, (0, parcelRequire("6GuVf")).globalSettingsSystemRolesViewRouteEntry),
            (0, (0, parcelRequire("dAqez")).globalSettingsSystemRolesUsageRouteEntry),
            (0, (0, parcelRequire("7mtPT")).globalSettingsSystemRolesActorsRouteEntry),
            (0, (0, parcelRequire("5xSTz")).globalSettingsSystemRolesActorsGroupsRouteEntry),
            (0, (0, parcelRequire("hkGft")).globalSettingsSystemRolesActorsUsersRouteEntry),
            (0, (0, parcelRequire("7DU6a")).globalSettingsSystemRolesEditRouteEntry),
            (0, (0, parcelRequire("6BVPh")).globalSettingsSystemRolesDeleteRouteEntry),
            (0, (0, parcelRequire("ckFGJ")).globalSettingsSystemProjectDeleteRouteEntry),
            (0, (0, parcelRequire("e1V9T")).globalSettingsSystemProjectAssignSecurityRouteEntry),
            (0, (0, parcelRequire("di1Zu")).globalSettingsSystemPermissionsRouteEntry),
            (0, (0, parcelRequire("kBqwn")).globalSettingsSystemCollectorsRouteEntry),
            (0, (0, parcelRequire("84Mhu")).globalSettingsSystemDefaultSettingsRouteEntry),
            (0, (0, parcelRequire("8gFkr")).globalSettingsSystemLookRouteEntry),
            (0, (0, parcelRequire("lVivS")).globalSettingsSystemExportRouteEntry),
            (0, (0, parcelRequire("b1Nwt")).globalSettingsSystemGlobalPermissionsRouteEntry),
            (0, (0, parcelRequire("c6t9I")).globalSettingsSystemImportExternalRouteEntry),
            (0, (0, parcelRequire("luBtt")).globalSettingsSystemImportExternalPagesRouteEntry),
            (0, (0, parcelRequire("4eIbF")).globalSettingsSystemImportCsvRouteEntry),
            (0, (0, parcelRequire("dkKsD")).globalSettingsSystemImportJsonRouteEntry),
            (0, (0, parcelRequire("ebHSU")).globalSettingsSystemImportTrelloRouteEntry),
            (0, (0, parcelRequire("bj17J")).globalSettingsSystemImportCloudRouteEntry),
            (0, (0, parcelRequire("kQ04T")).globalSettingsSystemImportBulkRouteEntry),
            (0, (0, parcelRequire("4GwLj")).globalAutomationRouteEntry),
            (0, (0, parcelRequire("2RLw5")).globalSettingsSystemMailSettingsRouteEntry),
            (0, (0, parcelRequire("79bmJ")).globalSettingsSystemMailOutgoingRouteEntry),
            (0, (0, parcelRequire("8SVcH")).globalSettingsSystemMailDeleteMailHandlerRouteEntry),
            (0, (0, parcelRequire("8SVcH")).globalSettingsSystemMailIncomingRouteEntry),
            (0, (0, parcelRequire("dZUFc")).globalSettingsSystemMailAddRouteEntry),
            (0, (0, parcelRequire("fVyU8")).globalSettingsSystemMailVerifyRouteEntry),
            (0, (0, parcelRequire("8Uour")).globalSettingsSystemMailSendRouteEntry),
            (0, (0, parcelRequire("5b2gi")).globalSettingsSystemHelperPermissionRouteEntry),
            (0, (0, parcelRequire("lvMv1")).globalSettingsSystemHelperNotificationRouteEntry),
            (0, (0, parcelRequire("fcvqo")).globalSettingsSystemSharedFiltersRouteEntry),
            (0, (0, parcelRequire("dizV4")).globalSettingsSystemSharedDashboardsRouteEntry),
            (0, (0, parcelRequire("anp69")).globalSettingsSystemAttachmentsRouteEntry),
            (0, (0, parcelRequire("dTxTT")).globalSettingsSystemEventsRouteEntry),
            (0, (0, parcelRequire("dTxTT")).globalSettingsSystemEventsAddRouteEntry),
            (0, (0, parcelRequire("dTxTT")).globalSettingsSystemEventsDeleteRouteEntry),
            (0, (0, parcelRequire("dTxTT")).globalSettingsSystemEventsEditRouteEntry),
            (0, (0, parcelRequire("5YP8f")).globalSettingsSystemUserInterfaceDashboardEditRouteEntry),
            (0, (0, parcelRequire("k9lPR")).globalSettingsSystemUserInterfacePreferencesRouteEntry),
            (0, (0, parcelRequire("2KRqQ")).globalSettingsSystemWebhooksRouteEntry),
            (0, (0, parcelRequire("6PPXt")).globalSettingsSystemServicesRouteEntry),
            (0, (0, parcelRequire("6Mj9c")).globalSettingsSystemLexorankRouteEntry),
            (0, (0, parcelRequire("aOHs8")).globalSettingsProductsAccessRouteEntry),
            (0, (0, parcelRequire("69II0")).globalSettingsProductsSoftwareConfigRouteEntry),
            (0, (0, parcelRequire("l6LGS")).globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry),
            (0, (0, parcelRequire("56QIn")).globalSettingsProductsSdconfigRouteEntry),
            (0, (0, parcelRequire("7SwDB")).globalSettingsProductsSdmailRouteEntry),
            (0, (0, parcelRequire("391UN")).globalSettingsProductsApplinksRouteEntry),
            (0, (0, parcelRequire("iaCCR")).globalSettingsProductsDvcsRouteEntry),
            (0, (0, parcelRequire("9I8yf")).globalSettingsProductsDvcsBitbucketRouteEntry),
            (0, (0, parcelRequire("4erM2")).globalSettingsProductsJsdStatusRouteEntry),
            (0, (0, parcelRequire("erXHa")).globalSettingsProjectsCategoriesViewRouteEntry),
            (0, (0, parcelRequire("1DqI0")).globalSettingsProjectsCategoriesEditRouteEntry),
            (0, (0, parcelRequire("2Xl2E")).globalSettingsProjectsCategoriesDeleteRouteEntry),
            (0, (0, parcelRequire("9H4pw")).globalSettingsIssuesTypesEditRouteEntry),
            (0, (0, parcelRequire("5V9SB")).globalSettingsIssuesTypesDeleteRouteEntry),
            (0, (0, parcelRequire("fmiQQ")).globalSettingsIssuesTypesMigrateRouteEntry),
            (0, (0, parcelRequire("fg9n4")).globalSettingsIssuesTypesTranslationsRouteEntry),
            (0, (0, parcelRequire("58oS1")).globalSettingsIssuesTypesSchemesOptionRouteEntry),
            (0, (0, parcelRequire("dPPJY")).globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry),
            (0, (0, parcelRequire("9AJay")).globalSettingsIssuesTypesSchemesAssociateRouteEntry),
            (0, (0, parcelRequire("8bpAh")).globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry),
            (0, (0, parcelRequire("b5v7R")).globalSettingsIssueSubtasksRouteEntry),
            (0, (0, parcelRequire("4nY0z")).globalSettingsIssuesSubtasksDisableRouteEntry),
            (0, (0, parcelRequire("itMEc")).globalSettingsIssuesSubtasksEditRouteEntry),
            (0, (0, parcelRequire("38epV")).globalSettingsIssuesSubtasksTranlationsRouteEntry),
            (0, (0, parcelRequire("7atcL")).workflowDesignerRouteEntry),
            (0, (0, parcelRequire("hlfSP")).globalSettingsIssueWorkflowRouteEntry),
            (0, (0, parcelRequire("jfSTr")).globalSettingsIssuesWorkflowTransitionRouteEntry),
            (0, (0, parcelRequire("jfSTr")).globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry),
            (0, (0, parcelRequire("iWPtZ")).globalSettingsIssuesWorkflowsImportRouteEntry),
            (0, (0, parcelRequire("5z6KH")).globalSettingsIssueWorkflowSchemesRouteEntry),
            (0, (0, parcelRequire("d4DfK")).globalSettingsIssuesWorkflowsSchemesEditRouteEntry),
            (0, (0, parcelRequire("nNkX7")).globalSettingsIssuesFieldViewRouteEntry),
            (0, (0, parcelRequire("cMeMl")).globalSettingsIssuesFieldAddRouteEntry),
            (0, (0, parcelRequire("gQaJ7")).globalSettingsIssuesFieldConfigureRouteEntry),
            (0, (0, parcelRequire("uTJdq")).globalSettingsIssuesFieldConfigureEditRouteEntry),
            (0, (0, parcelRequire("9VVuX")).globalSettingsIssuesFieldEditRouteEntry),
            (0, (0, parcelRequire("fGB22")).globalSettingsIssuesFieldCopyRouteEntry),
            (0, (0, parcelRequire("6R0vY")).globalSettingsIssuesFieldDeleteRouteEntry),
            (0, (0, parcelRequire("iwnR1")).globalSettingsIssuesFieldSchemesAddRouteEntry),
            (0, (0, parcelRequire("1JdXH")).globalSettingsIssuesFieldSchemesConfigureRouteEntry),
            (0, (0, parcelRequire("9CQ2b")).globalSettingsIssuesFieldSchemesEditRouteEntry),
            (0, (0, parcelRequire("62QWI")).globalSettingsIssuesFieldSchemesEditItemRouteEntry),
            (0, (0, parcelRequire("clrfj")).globalSettingsIssuesFieldSchemesCopyRouteEntry),
            (0, (0, parcelRequire("1yWGC")).globalSettingsIssuesFieldSchemesDeleteRouteEntry),
            (0, (0, parcelRequire("6MOc5")).globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry),
            (0, (0, parcelRequire("48mkc")).globalSettingsIssuesTypesScreenSchemesEntityRouteEntry),
            (0, (0, parcelRequire("lqFNV")).globalSettingsIssuesTypesScreenSchemesEditRouteEntry),
            (0, (0, parcelRequire("g6iev")).globalSettingsIssuesTypesScreenSchemesCopyRouteEntry),
            (0, (0, parcelRequire("iQqGv")).globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry),
            (0, (0, parcelRequire("iwi8A")).globalSettingsCustomFieldsRouteEntry),
            (0, (0, parcelRequire("lagzw")).globalSettingsIssuesCustomFieldsConfigRouteEntry),
            (0, (0, parcelRequire("5Nnqm")).globalSettingsIssuesCustomFieldsEditRouteEntry),
            (0, (0, parcelRequire("4VzuS")).globalSettingsIssuesCustomFieldsTranslateRouteEntry),
            (0, (0, parcelRequire("3latU")).globalSettingsIssuesCustomFieldsDeleteRouteEntry),
            (0, (0, parcelRequire("d6dRh")).globalSettingsIssuesCustomFieldsManageRouteEntry),
            (0, (0, parcelRequire("eLVEp")).globalSettingsIssuesCustomFieldsAssociateRouteEntry),
            (0, (0, parcelRequire("51f7x")).globalSettingsIssuesExplicitFieldAssociationRouteEntry),
            (0, (0, parcelRequire("g33xc")).globalSettingsFieldLayoutsRouteEntry),
            (0, (0, parcelRequire("j6X8z")).globalSettingsIssuesFieldlayoutsConfigRouteEntry),
            (0, (0, parcelRequire("i9iZS")).globalSettingsIssuesFieldviewRouteEntry),
            (0, (0, parcelRequire("dSPOH")).globalSettingsIssuesFieldlayoutsCopyRouteEntry),
            (0, (0, parcelRequire("ekikx")).globalSettingsIssuesFieldlayoutsEditRouteEntry),
            (0, (0, parcelRequire("7PWgz")).globalSettingsIssuesFieldlayoutsDeleteRouteEntry),
            (0, (0, parcelRequire("12CWk")).globalSettingsFieldLayoutSchemesRouteEntry),
            (0, (0, parcelRequire("dVehM")).globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry),
            (0, (0, parcelRequire("kHniB")).globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry),
            (0, (0, parcelRequire("jr2Mg")).globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry),
            (0, (0, parcelRequire("43Uc9")).globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry),
            (0, (0, parcelRequire("8aJ2b")).globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry),
            (0, (0, parcelRequire("eODBO")).globalSettingsIssueTimeTrackingRouteEntry),
            (0, (0, parcelRequire("aiZ7o")).globalSettingsIssuesLinkTypesRouteEntry),
            (0, (0, parcelRequire("aiZ7o")).globalSettingsIssuesLinkTypesActivateRouteEntry),
            (0, (0, parcelRequire("aiZ7o")).globalSettingsIssuesLinkTypesDeactivateRouteEntry),
            (0, (0, parcelRequire("5Wx3t")).globalSettingsIssuesLinktypesEditRouteEntry),
            (0, (0, parcelRequire("apLiY")).globalSettingsIssuesLinktypesDeleteRouteEntry),
            (0, (0, parcelRequire("aQQaa")).globalSettingsIssuesStatusesRouteEntry),
            (0, (0, parcelRequire("eBuTH")).globalSettingsIssuesStatusesTranslationsRouteEntry),
            (0, (0, parcelRequire("17yPk")).globalSettingsIssuesResolutionsRouteEntry),
            (0, (0, parcelRequire("cLAit")).globalSettingsIssuesResolutionsTranslationsRouteEntry),
            (0, (0, parcelRequire("iEOv0")).globalSettingsIssuesResolutionsDefaultRouteEntry),
            (0, (0, parcelRequire("gZV6Y")).globalSettingsIssuesResolutionsEditRouteEntry),
            (0, (0, parcelRequire("eoQjS")).globalSettingsIssuesResolutionsDeleteRouteEntry),
            (0, (0, parcelRequire("7t6RT")).globalSettingsIssuesPrioritiesRouteEntry),
            (0, (0, parcelRequire("1NqcA")).globalSettingsIssuesPrioritiesTranslationsRouteEntry),
            (0, (0, parcelRequire("hvbGw")).globalSettingsIssuesGeneralTranslationsRouteEntry),
            (0, (0, parcelRequire("hQSWw")).globalSettingsIssuesPrioritiesEditRouteEntry),
            (0, (0, parcelRequire("drG3A")).globalSettingsIssuesPrioritiesDeleteRouteEntry),
            (0, (0, parcelRequire("3zySp")).globalSettingsIssuesPrioritiesDefaultRouteEntry),
            (0, (0, parcelRequire("fy4Yg")).globalSettingsIssuesSecuritySchemesRouteEntry),
            (0, (0, parcelRequire("Th6e7")).globalSettingsIssuesSecurityEditRouteEntry),
            (0, (0, parcelRequire("cJLbl")).globalSettingsIssuesSecurityLevelAddRouteEntry),
            (0, (0, parcelRequire("l9OjQ")).globalSettingsIssuesSecurityLevelEditRouteEntry),
            (0, (0, parcelRequire("1eB7K")).globalSettingsIssuesSecurityLevelDeleteRouteEntry),
            (0, (0, parcelRequire("1i9Xk")).globalSettingsIssuesSecuritySchemesAddRouteEntry),
            (0, (0, parcelRequire("eidif")).globalSettingsIssuesSecuritySchemesEditRouteEntry),
            (0, (0, parcelRequire("egtWh")).globalSettingsIssuesSecuritySchemesDeleteRouteEntry),
            (0, (0, parcelRequire("2QaYg")).globalSettingsIssuesNotificationViewRouteEntry),
            (0, (0, parcelRequire("iSsNS")).globalSettingsIssuesNotificationSchemeAddRouteEntry),
            (0, (0, parcelRequire("eWkcy")).globalSettingsIssuesNotificationSchemeEditRouteEntry),
            (0, (0, parcelRequire("jJpgV")).globalSettingsIssuesNotificationSchemeDeleteRouteEntry),
            (0, (0, parcelRequire("42kD1")).globalSettingsIssuesNotificationAddRouteEntry),
            (0, (0, parcelRequire("6bzuG")).globalSettingsIssuesNotificationEditRouteEntry),
            (0, (0, parcelRequire("9Ahl6")).globalSettingsIssuesNotificationDeleteRouteEntry),
            (0, (0, parcelRequire("kPDwm")).globalSettingsIssuesPermissionsSchemesRouteEntry),
            (0, (0, parcelRequire("c2Cpo")).globalSettingsIssuesPermissionsSchemesAddRouteEntry),
            (0, (0, parcelRequire("8kL76")).globalSettingsIssuesPermissionsEditRouteEntry),
            (0, (0, parcelRequire("3EIJ8")).globalSettingsIssuesPermissionsSchemesEditRouteEntry),
            (0, (0, parcelRequire("cfZHb")).globalSettingsIssuesPermissionsSchemesProjectRouteEntry),
            (0, (0, parcelRequire("jolwb")).globalSettingsIssuesPermissionsSchemesDeleteRouteEntry),
            (0, (0, parcelRequire("2rSKc")).addonsEmceePublicRouteEntry),
            (0, (0, parcelRequire("9jvhK")).emceeAppRouteEntry),
            (0, (0, parcelRequire("hMwq2")).manageAppsRouteEntry),
            (0, (0, parcelRequire("2B1hR")).globalSettingsAddonsOauthRouteEntry),
            (0, (0, parcelRequire("0PAJi")).globalSettingsSystemProjectSelectRouteEntry),
            (0, (0, parcelRequire("6zerj")).legacyPersonalSettingsAccessTokensRouteEntry),
            (0, (0, parcelRequire("eThIt")).legacyConnectGeneralRouteEntry),
            (0, (0, parcelRequire("lwy1a")).legacyFallbackRouteEntry)
        ];
    const $be0f5dfaba17147f$export$dd1385a42388b11b = ()=>$be0f5dfaba17147f$var$getRawRoutes().filter(({ path: path })=>path).map((0, (0, parcelRequire("anXSE")).default)).map(({ group: group, name: name, path: path, query: query, preloadOptions: preloadOptions, meta: meta })=>({
                group: group,
                name: name,
                path: path,
                query: query,
                preloadOptions: preloadOptions,
                meta: meta
            }));
    const $be0f5dfaba17147f$export$2f7745f2f5ab3897 = ()=>{
        const routes = $be0f5dfaba17147f$var$getRawRoutes().map((0, (0, parcelRequire("anXSE")).default)).map((route)=>({
                ...route,
                group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_LEGACY),
                component: route.component || (0, (0, parcelRequire("6QKrH")).LegacyPage),
                resources: [
                    ...new Set([
                        ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                        ...route.resources ? route.resources : []
                    ])
                ]
            }));
        return routes;
    };
});
parcelRegister("65Ltd", function(module, exports) {
    $parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", ()=>$d90d8ce15e0e3233$export$1ba937db1fe6ef01);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$bbf08d4d25df5504);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", ()=>$d90d8ce15e0e3233$export$e3e759b7f50aaee1);
    $parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$89337611b52bc9a3);
    $parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", ()=>$d90d8ce15e0e3233$export$3d7937b12eb9e5d5);
    $parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$7a3d181d86fce9e6);
    $parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", ()=>$d90d8ce15e0e3233$export$7a22726acd7d6021);
    $parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", ()=>$d90d8ce15e0e3233$export$f3f4a9f53ba00861);
    $parcel$export(module.exports, "ROUTE_GROUPS_EOC", ()=>$d90d8ce15e0e3233$export$112d69653b2f1d8b);
    $parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", ()=>$d90d8ce15e0e3233$export$74e0426b66571086);
    $parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$c2e20e142c95c1ce);
    $parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$f8cea29bebf098c);
    $parcel$export(module.exports, "ROUTE_GROUPS_HOME", ()=>$d90d8ce15e0e3233$export$5801ef8dfc9a2f70);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", ()=>$d90d8ce15e0e3233$export$7246838143f848f3);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$54f96702980a2f87);
    $parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", ()=>$d90d8ce15e0e3233$export$5566db8fbd042fc4);
    $parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", ()=>$d90d8ce15e0e3233$export$656d0cc2c67b2708);
    $parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", ()=>$d90d8ce15e0e3233$export$bfdbcebc4c81b043);
    $parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$82021d71ad19e227);
    $parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", ()=>$d90d8ce15e0e3233$export$6f266218a6973848);
    $parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", ()=>$d90d8ce15e0e3233$export$a846fcaeeea8e0ff);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", ()=>$d90d8ce15e0e3233$export$6c87a9dff4e7a2de);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", ()=>$d90d8ce15e0e3233$export$ab79970dcfac06a1);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", ()=>$d90d8ce15e0e3233$export$d1a70f80bb22f18a);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$bd925e9fcb6ce37f);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$86509a1baabd62ee);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$98823ed9eedfc756);
    $parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", ()=>$d90d8ce15e0e3233$export$da8d13fe1ccd5c09);
    $parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$78fb2f6176b7c6b8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", ()=>$d90d8ce15e0e3233$export$26efaec7a7a8b361);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", ()=>$d90d8ce15e0e3233$export$88041353cc69458d);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$f88d57dcb03ba452);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$e8aa63af071c2da9);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$b114d0da2ebcff6c);
    $parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$29cc94b8cea5c920);
    $parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$4d1b45005cdcfb39);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", ()=>$d90d8ce15e0e3233$export$a42ea04fdf53eeaf);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", ()=>$d90d8ce15e0e3233$export$ca4c5f5b3e2daa18);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", ()=>$d90d8ce15e0e3233$export$d58a5411a2ac6260);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$24514ee19772b5af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", ()=>$d90d8ce15e0e3233$export$ec333dd1d6a8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", ()=>$d90d8ce15e0e3233$export$ed495fbad44791af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", ()=>$d90d8ce15e0e3233$export$5281552f8109b7c0);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", ()=>$d90d8ce15e0e3233$export$6e8473713ed4557a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", ()=>$d90d8ce15e0e3233$export$cbdd5c24d69b2cb1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$e7f012f402be01ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", ()=>$d90d8ce15e0e3233$export$b34d3882b42d660d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$ed869c60c6a56182);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", ()=>$d90d8ce15e0e3233$export$5013269f29c75b37);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$fc8b48319e993d43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", ()=>$d90d8ce15e0e3233$export$d6e60a2059f028d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$3d589aae17a00bc9);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$bd92ef03b23dd672);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", ()=>$d90d8ce15e0e3233$export$fa7fc44c718fc850);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$1dffaf831e01e2b4);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$5f8187412dd60f35);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$3d2c1c04d18f6c43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", ()=>$d90d8ce15e0e3233$export$cd22a5d8f560a1d8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$cad1b1aa5ce26bbc);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$ee073463b4144367);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", ()=>$d90d8ce15e0e3233$export$ea034943499772ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$19bc888bcf37d22d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$e0746183e11767fb);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", ()=>$d90d8ce15e0e3233$export$3e2d215ce157adc8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$8a8485bb05daf40b);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$a2799b01de5bb62);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", ()=>$d90d8ce15e0e3233$export$2d4f89c4b1ee3640);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$75609d3416c31f79);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$79793dc26e0b7b1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2eda7466fbfdef43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$417297669917ee1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$8c79f3309ac0737);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$ef71a22e7befd35c);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", ()=>$d90d8ce15e0e3233$export$62ba1e294f5007c1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", ()=>$d90d8ce15e0e3233$export$a4315324546ecc89);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$a653cf6d478b3df1);
    $parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$b0f268fe53a03e98);
    $parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", ()=>$d90d8ce15e0e3233$export$f4160b48e4ab8f39);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$608f359cf8b08d2e);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", ()=>$d90d8ce15e0e3233$export$8bfbf790fe89f8d3);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", ()=>$d90d8ce15e0e3233$export$d7011d1ed949f970);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$bd2506db44585db6);
    $parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$200fa5ad16f8c112);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", ()=>$d90d8ce15e0e3233$export$a296bb962bea95b5);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$b9960c143c0414eb);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$411171d2fcaefaea);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$ee104ed514f63003);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", ()=>$d90d8ce15e0e3233$export$9233f9ddcecd3062);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", ()=>$d90d8ce15e0e3233$export$b3240ec044a6c70f);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", ()=>$d90d8ce15e0e3233$export$2463c779e12367e3);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", ()=>$d90d8ce15e0e3233$export$dd3e5187eae2abe9);
    $parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", ()=>$d90d8ce15e0e3233$export$38ca7e07048a5bfd);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$48749e87cc44a5a5);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$21c230ef79df9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$d2d813dd057a8352);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$54ed2374d14a7e88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$58368fe796f5ecb4);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", ()=>$d90d8ce15e0e3233$export$bbb4032f8f259109);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", ()=>$d90d8ce15e0e3233$export$5b17b30c2dd69cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", ()=>$d90d8ce15e0e3233$export$d18d0b9a9e85e59c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", ()=>$d90d8ce15e0e3233$export$5126a481501fc518);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$40e720d8c26e6804);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$dc8ac1f7e9373a32);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", ()=>$d90d8ce15e0e3233$export$8ca3e3f0326ba27f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", ()=>$d90d8ce15e0e3233$export$c3d17be12795c864);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", ()=>$d90d8ce15e0e3233$export$9cd1c70eda5cae15);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", ()=>$d90d8ce15e0e3233$export$99f769b27f537a72);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", ()=>$d90d8ce15e0e3233$export$5c5fe79d3f9ec214);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$901b974cf0954c88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$b2dd23a345bd5cb3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$8ae7cbc0a73f9351);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$8057ebe7fb7f7f8d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a22387b9744e62e3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", ()=>$d90d8ce15e0e3233$export$f6fefa9d2e5bbda1);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", ()=>$d90d8ce15e0e3233$export$e6de4aa6c719d2b);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", ()=>$d90d8ce15e0e3233$export$b195ada84b7e695f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", ()=>$d90d8ce15e0e3233$export$1800d32171b754a6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", ()=>$d90d8ce15e0e3233$export$d22a153bfcbaaaa0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a9a41c76994b6ae9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", ()=>$d90d8ce15e0e3233$export$5bd6f2569c3cfd5c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", ()=>$d90d8ce15e0e3233$export$dc70eff53ff26c70);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", ()=>$d90d8ce15e0e3233$export$1fe2ca96b360df19);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$1ff01e77517a80b0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$de3f8f3198f8213a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", ()=>$d90d8ce15e0e3233$export$b2cb569d360db382);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_SCHEDULES", ()=>$d90d8ce15e0e3233$export$a0d9033eb64fd80f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", ()=>$d90d8ce15e0e3233$export$da985e953465731f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", ()=>$d90d8ce15e0e3233$export$b7eee2afd0a5c6b9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", ()=>$d90d8ce15e0e3233$export$9b6c84986db47d98);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", ()=>$d90d8ce15e0e3233$export$89276f76fdd700d6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", ()=>$d90d8ce15e0e3233$export$ea64769f19da8c95);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", ()=>$d90d8ce15e0e3233$export$4a584839d9a9eb6f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", ()=>$d90d8ce15e0e3233$export$27d27c817eeb97cc);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", ()=>$d90d8ce15e0e3233$export$9f533c13cfb48a8f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", ()=>$d90d8ce15e0e3233$export$6889e571e5aa6ba6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", ()=>$d90d8ce15e0e3233$export$bdd811277711c53d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", ()=>$d90d8ce15e0e3233$export$c7b51c0e8ad6f77a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", ()=>$d90d8ce15e0e3233$export$a348fc7f3b4cfe34);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", ()=>$d90d8ce15e0e3233$export$a4eff769c94da831);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", ()=>$d90d8ce15e0e3233$export$7c928ca9c9822772);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", ()=>$d90d8ce15e0e3233$export$b48311a8f24f4b63);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", ()=>$d90d8ce15e0e3233$export$20649eac204f7661);
    $parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$62170875a111d729);
    $parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$2928f3d69e7ac609);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$259e18cafd820487);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", ()=>$d90d8ce15e0e3233$export$4b8f333757e638a4);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", ()=>$d90d8ce15e0e3233$export$ac4f65a14002f892);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", ()=>$d90d8ce15e0e3233$export$c73ddc4b44ccb359);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$7ad826b482229119);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", ()=>$d90d8ce15e0e3233$export$3df864df9b639033);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", ()=>$d90d8ce15e0e3233$export$7d67bf4077ebe18d);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", ()=>$d90d8ce15e0e3233$export$5ff797dfd5df551f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", ()=>$d90d8ce15e0e3233$export$8a66ba1da5efa2c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$eadf5aff28def565);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", ()=>$d90d8ce15e0e3233$export$8f9c045e8fd449b7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$1bf439327974644b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", ()=>$d90d8ce15e0e3233$export$e2a9d163770d0d46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$21b497c57bcd299a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$df5ca261227a6052);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", ()=>$d90d8ce15e0e3233$export$9f2f4303259b8508);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", ()=>$d90d8ce15e0e3233$export$7fd53fe07eecc273);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", ()=>$d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$e05a6c9e9b9b0c48);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", ()=>$d90d8ce15e0e3233$export$f9759b206b651b1f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$7a337a2687b5d5e3);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", ()=>$d90d8ce15e0e3233$export$a41998c1a3572e41);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$2c9fe9e6005a9c36);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", ()=>$d90d8ce15e0e3233$export$5d8d82ff1de3586e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", ()=>$d90d8ce15e0e3233$export$8a0ed100d885c17c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$1c7041445acf79e8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$e4712523d95125f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$7401274ad357ff94);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$6984b21077857555);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", ()=>$d90d8ce15e0e3233$export$5a2dae98f768aedf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", ()=>$d90d8ce15e0e3233$export$5eef1c6eb1388ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", ()=>$d90d8ce15e0e3233$export$69bcf2c26d45e030);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$ba1417cf5de80f81);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", ()=>$d90d8ce15e0e3233$export$fdcfcb2e2eb16afd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", ()=>$d90d8ce15e0e3233$export$5d3e6bffd6b5abfe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", ()=>$d90d8ce15e0e3233$export$5c676bbb7e3aae9e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$8bb013ced097489a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$e384ae6a87fadedd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", ()=>$d90d8ce15e0e3233$export$8f55a911c4bd95bf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", ()=>$d90d8ce15e0e3233$export$d7b98892cb31fba5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", ()=>$d90d8ce15e0e3233$export$8be4b203f526b2cd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", ()=>$d90d8ce15e0e3233$export$df09947903c514c4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", ()=>$d90d8ce15e0e3233$export$cf4a57a81e0bfbca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", ()=>$d90d8ce15e0e3233$export$bc64365bbb09c05e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", ()=>$d90d8ce15e0e3233$export$5b12571311ebe766);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", ()=>$d90d8ce15e0e3233$export$56dc46fe1de63994);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", ()=>$d90d8ce15e0e3233$export$65af0e5a36d4b4e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", ()=>$d90d8ce15e0e3233$export$dec448f9d2e50c90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$9ff4144e1dcf9fa4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$8aab6fb9a62dda95);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$9f804a2650117f51);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", ()=>$d90d8ce15e0e3233$export$7dd4b916600f670);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", ()=>$d90d8ce15e0e3233$export$c1b40a8a70c0aafa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", ()=>$d90d8ce15e0e3233$export$ff10d812380db045);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$8deeffdf8dfed878);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$561687f2fa9b9cc9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", ()=>$d90d8ce15e0e3233$export$691d30818c14141c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", ()=>$d90d8ce15e0e3233$export$8fa58495105f8fb0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", ()=>$d90d8ce15e0e3233$export$8304c57494d82ffd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", ()=>$d90d8ce15e0e3233$export$353609deec72a2ba);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$1cb56e4c132ac8fd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", ()=>$d90d8ce15e0e3233$export$5fe3eec0a6bda09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", ()=>$d90d8ce15e0e3233$export$12b56880d6fb7ac7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", ()=>$d90d8ce15e0e3233$export$9986e8be82998857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", ()=>$d90d8ce15e0e3233$export$3280ec16231916af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", ()=>$d90d8ce15e0e3233$export$54885d105d1e2b37);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$f34d87c870f3bf43);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$4108ebf71e36e461);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$d42ec33a6e69686e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", ()=>$d90d8ce15e0e3233$export$8d2cfabd01e2feaa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$d0fe3726dffeca80);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", ()=>$d90d8ce15e0e3233$export$b4aa4b2b8fb7267a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", ()=>$d90d8ce15e0e3233$export$3743711165f5dd4f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", ()=>$d90d8ce15e0e3233$export$5df6f81deab9567c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", ()=>$d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$a03360d8b616ef34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$336e54edc189df7f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$53572e9a81205523);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", ()=>$d90d8ce15e0e3233$export$b71f2ef452117a2a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", ()=>$d90d8ce15e0e3233$export$f79745fee583cd62);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", ()=>$d90d8ce15e0e3233$export$2281663e19f399c1);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", ()=>$d90d8ce15e0e3233$export$38c52d8c5e5dad29);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", ()=>$d90d8ce15e0e3233$export$10babc3f11b4e6e2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", ()=>$d90d8ce15e0e3233$export$adf2f51c41b4e22a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", ()=>$d90d8ce15e0e3233$export$11b217754d4c7d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", ()=>$d90d8ce15e0e3233$export$3414f0d81f1c11d);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", ()=>$d90d8ce15e0e3233$export$5574c73a9a5878ca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", ()=>$d90d8ce15e0e3233$export$cb2626c385b72992);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", ()=>$d90d8ce15e0e3233$export$fa7aa7cabc3ec459);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", ()=>$d90d8ce15e0e3233$export$8b0450672651ef67);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$ef510a15f840e437);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", ()=>$d90d8ce15e0e3233$export$bc159fa4984a907f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", ()=>$d90d8ce15e0e3233$export$47bfbce13af95d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", ()=>$d90d8ce15e0e3233$export$c8cb78e94cd3f83c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", ()=>$d90d8ce15e0e3233$export$4496279df22177be);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$afdfef5d17c56988);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$ac9b4b1136300033);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", ()=>$d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", ()=>$d90d8ce15e0e3233$export$c56f5509b93eba68);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", ()=>$d90d8ce15e0e3233$export$dd9462e97e11637a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", ()=>$d90d8ce15e0e3233$export$11f8c53e10f63cfb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$758ad3ad6916c9f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", ()=>$d90d8ce15e0e3233$export$9d65a754315eb617);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", ()=>$d90d8ce15e0e3233$export$564b665f6ca740dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", ()=>$d90d8ce15e0e3233$export$256fc89c38c1b9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", ()=>$d90d8ce15e0e3233$export$ddeae77164bfac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", ()=>$d90d8ce15e0e3233$export$fa2b355372963545);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", ()=>$d90d8ce15e0e3233$export$45511e437e54fa02);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", ()=>$d90d8ce15e0e3233$export$ad76895f03f27a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", ()=>$d90d8ce15e0e3233$export$1c291d65a59b1636);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", ()=>$d90d8ce15e0e3233$export$d9bb14d665bfeea5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b44cb3da7b8f857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", ()=>$d90d8ce15e0e3233$export$9ca6a09e1518d3bb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", ()=>$d90d8ce15e0e3233$export$4c211b3188348679);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", ()=>$d90d8ce15e0e3233$export$24757bb1837e33af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", ()=>$d90d8ce15e0e3233$export$95b5d0bd29a3a076);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", ()=>$d90d8ce15e0e3233$export$d55d4330b58683da);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", ()=>$d90d8ce15e0e3233$export$f4d5833f0b40a26b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", ()=>$d90d8ce15e0e3233$export$c78577545f514ca8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", ()=>$d90d8ce15e0e3233$export$253eb3db7152d010);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", ()=>$d90d8ce15e0e3233$export$16b4392a63a3eacf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", ()=>$d90d8ce15e0e3233$export$b2d5a7bc804ed9c9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", ()=>$d90d8ce15e0e3233$export$f870832f94ca5009);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", ()=>$d90d8ce15e0e3233$export$8b3a1b2e8e954dc2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", ()=>$d90d8ce15e0e3233$export$15603150075c3d64);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", ()=>$d90d8ce15e0e3233$export$92536fe760c41862);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", ()=>$d90d8ce15e0e3233$export$3f4d05032349dae0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", ()=>$d90d8ce15e0e3233$export$8ff94a2e5f98315f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", ()=>$d90d8ce15e0e3233$export$c906c6946fef5d99);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", ()=>$d90d8ce15e0e3233$export$a1916b723e186494);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", ()=>$d90d8ce15e0e3233$export$5070b4c974017f28);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", ()=>$d90d8ce15e0e3233$export$bee7f9f93cb74124);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", ()=>$d90d8ce15e0e3233$export$efe4008073ab3b69);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", ()=>$d90d8ce15e0e3233$export$9e40228f1c62d4d9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", ()=>$d90d8ce15e0e3233$export$223f8094878fea34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$2f589c572415c043);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", ()=>$d90d8ce15e0e3233$export$8cc394a1f5ca4ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", ()=>$d90d8ce15e0e3233$export$a11311cd333dae90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", ()=>$d90d8ce15e0e3233$export$2b2f159267202dcc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", ()=>$d90d8ce15e0e3233$export$c5a6874288d2e609);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", ()=>$d90d8ce15e0e3233$export$55dd30b027c838fe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$aee9c7dbf672403c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", ()=>$d90d8ce15e0e3233$export$75f2fbd33e76028e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", ()=>$d90d8ce15e0e3233$export$ca57c3dfefb2c826);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", ()=>$d90d8ce15e0e3233$export$8f2e6f133c022a59);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", ()=>$d90d8ce15e0e3233$export$bcd741cf5a35ece8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", ()=>$d90d8ce15e0e3233$export$bfd8ab4625d5c275);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", ()=>$d90d8ce15e0e3233$export$750a33c4058af733);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", ()=>$d90d8ce15e0e3233$export$1b66c7594340363f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", ()=>$d90d8ce15e0e3233$export$fe2fa966509db649);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", ()=>$d90d8ce15e0e3233$export$373b97e8d136f558);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", ()=>$d90d8ce15e0e3233$export$64909bb6f2181592);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", ()=>$d90d8ce15e0e3233$export$53d6ade2eaa2ae84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", ()=>$d90d8ce15e0e3233$export$e49d7a1ddf301d09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", ()=>$d90d8ce15e0e3233$export$9469cfde1d14fcac);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", ()=>$d90d8ce15e0e3233$export$be2e231547dca6dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", ()=>$d90d8ce15e0e3233$export$ad6f28bbfe57d0a0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", ()=>$d90d8ce15e0e3233$export$2fb73d5c1c0e7186);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", ()=>$d90d8ce15e0e3233$export$46b4f43d6ece38fc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", ()=>$d90d8ce15e0e3233$export$49d1c20d84d46735);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", ()=>$d90d8ce15e0e3233$export$265062715b11a1ef);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", ()=>$d90d8ce15e0e3233$export$e9f5eae9444c9b46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", ()=>$d90d8ce15e0e3233$export$e19bf9459d6eba56);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", ()=>$d90d8ce15e0e3233$export$40097704c31872d8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$dcdf0405aa7e2078);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", ()=>$d90d8ce15e0e3233$export$fb75113636566d39);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", ()=>$d90d8ce15e0e3233$export$e27baa0c7747e67f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", ()=>$d90d8ce15e0e3233$export$40d189100899f572);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", ()=>$d90d8ce15e0e3233$export$341933b279728599);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ae4b815061537207);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", ()=>$d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", ()=>$d90d8ce15e0e3233$export$bee46016693b19dc);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS", ()=>$d90d8ce15e0e3233$export$ca253bc3d237c17f);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT", ()=>$d90d8ce15e0e3233$export$a4cba48257cb118a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", ()=>$d90d8ce15e0e3233$export$2e90ab5aa3463c0d);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", ()=>$d90d8ce15e0e3233$export$d70320ae3b4d9e43);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", ()=>$d90d8ce15e0e3233$export$b2b57cde1fa39bf5);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE", ()=>$d90d8ce15e0e3233$export$e8e3b3a04b70a016);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", ()=>$d90d8ce15e0e3233$export$1a3116351e4f3550);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", ()=>$d90d8ce15e0e3233$export$6e2629d41c380b47);
    $parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", ()=>$d90d8ce15e0e3233$export$ced38e55e6d33a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$d61d16755cb40ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", ()=>$d90d8ce15e0e3233$export$bb6392f1b2e80781);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", ()=>$d90d8ce15e0e3233$export$6fd25e722e91a0d8);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", ()=>$d90d8ce15e0e3233$export$18f32f825e7a5a6f);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", ()=>$d90d8ce15e0e3233$export$b17f22f274f4cd5e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", ()=>$d90d8ce15e0e3233$export$285854ec33f7cc);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", ()=>$d90d8ce15e0e3233$export$77cf9c44bbdaa05b);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", ()=>$d90d8ce15e0e3233$export$d6f1b92110a16f2a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", ()=>$d90d8ce15e0e3233$export$fea47b97c6086336);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", ()=>$d90d8ce15e0e3233$export$264d0a2b60d052cd);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", ()=>$d90d8ce15e0e3233$export$991ba0c465b48539);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", ()=>$d90d8ce15e0e3233$export$904b472d57dee40d);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", ()=>$d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", ()=>$d90d8ce15e0e3233$export$8cfdaccf43a32440);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", ()=>$d90d8ce15e0e3233$export$37bd400c00057d64);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", ()=>$d90d8ce15e0e3233$export$eb66bd587b5f093d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", ()=>$d90d8ce15e0e3233$export$521baa72494c2a67);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", ()=>$d90d8ce15e0e3233$export$ca255c93be51d5bc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$51e45f736a60769b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", ()=>$d90d8ce15e0e3233$export$e64c3c8f45d7eb28);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", ()=>$d90d8ce15e0e3233$export$5475ba822739444a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", ()=>$d90d8ce15e0e3233$export$8483f5c57513e386);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", ()=>$d90d8ce15e0e3233$export$93c4d1960660bdb3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", ()=>$d90d8ce15e0e3233$export$a5421dcc88027406);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", ()=>$d90d8ce15e0e3233$export$81d5ef2e5cb06446);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", ()=>$d90d8ce15e0e3233$export$77f5621cd10b53c5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", ()=>$d90d8ce15e0e3233$export$41008c2b014795bf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3001841111579cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", ()=>$d90d8ce15e0e3233$export$28dc2fac9c08502e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", ()=>$d90d8ce15e0e3233$export$4487dfcd6dce7088);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", ()=>$d90d8ce15e0e3233$export$c344587fa7092e8c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", ()=>$d90d8ce15e0e3233$export$3fbd487079a23c0f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$d6822df31c37b21a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", ()=>$d90d8ce15e0e3233$export$d39bcac6fced7707);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", ()=>$d90d8ce15e0e3233$export$da975f212e8a3e43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", ()=>$d90d8ce15e0e3233$export$6e6feddeb62a0825);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", ()=>$d90d8ce15e0e3233$export$d7df906c2ffbeab4);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", ()=>$d90d8ce15e0e3233$export$c71836085985a7d3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", ()=>$d90d8ce15e0e3233$export$a17a19a9de903839);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", ()=>$d90d8ce15e0e3233$export$e66c1e847a52ebb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", ()=>$d90d8ce15e0e3233$export$f0254c80025ed0fc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", ()=>$d90d8ce15e0e3233$export$1d4a64220d5b474d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", ()=>$d90d8ce15e0e3233$export$8af215d394bc18c1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", ()=>$d90d8ce15e0e3233$export$b6b536a795b08b39);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", ()=>$d90d8ce15e0e3233$export$59cde094247fca1a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", ()=>$d90d8ce15e0e3233$export$d27bf19e22921164);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", ()=>$d90d8ce15e0e3233$export$3467807847c0a87d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$1996eeee6a067f1c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", ()=>$d90d8ce15e0e3233$export$ec7cb9394e8994c9);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", ()=>$d90d8ce15e0e3233$export$f01730982626c4af);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", ()=>$d90d8ce15e0e3233$export$9d1758ddc1563e90);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", ()=>$d90d8ce15e0e3233$export$ecff223feb9d08be);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$487bc26cddb34312);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$d90d8ce15e0e3233$export$118290072826cd87);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", ()=>$d90d8ce15e0e3233$export$e5994b7b1acebe82);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$84b0e53f785e02cf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$d58992a667105ce8);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$bb1cea2d23743f65);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$76dac5f55ab3705e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$a7c4adb03bc6e997);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", ()=>$d90d8ce15e0e3233$export$2dc565d0b2334780);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", ()=>$d90d8ce15e0e3233$export$28687a1181a7676f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$2e74a7026073fa54);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$58fdfc78d176c564);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", ()=>$d90d8ce15e0e3233$export$cb8548f16119b181);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$66e3f6af203a567f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", ()=>$d90d8ce15e0e3233$export$658e7e21f1c7b69b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", ()=>$d90d8ce15e0e3233$export$1fa628a4527d424c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", ()=>$d90d8ce15e0e3233$export$c2989c5c00f9f64b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$2d21e5416485b195);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", ()=>$d90d8ce15e0e3233$export$e514491aa85dd54a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", ()=>$d90d8ce15e0e3233$export$d9662297242bfcb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", ()=>$d90d8ce15e0e3233$export$2a53516b15393945);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", ()=>$d90d8ce15e0e3233$export$62e00190aa938a43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", ()=>$d90d8ce15e0e3233$export$22a3924a6eab79ab);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", ()=>$d90d8ce15e0e3233$export$677cf3d89d18bb74);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", ()=>$d90d8ce15e0e3233$export$7eef86163449ad98);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", ()=>$d90d8ce15e0e3233$export$8f56061e1403fa5a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", ()=>$d90d8ce15e0e3233$export$adeb429de8df1e02);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", ()=>$d90d8ce15e0e3233$export$931d6222073b5708);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", ()=>$d90d8ce15e0e3233$export$2106f1ac8ba807e1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", ()=>$d90d8ce15e0e3233$export$36678521a86f620b);
    $parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", ()=>$d90d8ce15e0e3233$export$55248356780fc584);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", ()=>$d90d8ce15e0e3233$export$cd84c5a333c8d16a);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", ()=>$d90d8ce15e0e3233$export$624af6f61b05f55);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", ()=>$d90d8ce15e0e3233$export$2ed9525182145b82);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", ()=>$d90d8ce15e0e3233$export$7fb2b42fc4e7df8b);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", ()=>$d90d8ce15e0e3233$export$fa962db82ae571b2);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", ()=>$d90d8ce15e0e3233$export$e145bf76b1aef705);
    $parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", ()=>$d90d8ce15e0e3233$export$8febbfb647e4c8b9);
    $parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", ()=>$d90d8ce15e0e3233$export$4b34f3d336f4ccd2);
    $parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", ()=>$d90d8ce15e0e3233$export$a979a5c1f5e3631c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$ffcbf91dfadffd0);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", ()=>$d90d8ce15e0e3233$export$1807a39cc63b856c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$2be8d3c6fedd5276);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$6268da7263eb670d);
    $parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$93bd4a896a0fc581);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", ()=>$d90d8ce15e0e3233$export$2b9b1bfb538ab810);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", ()=>$d90d8ce15e0e3233$export$d1217085321b2648);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", ()=>$d90d8ce15e0e3233$export$39624171b7c8a10a);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", ()=>$d90d8ce15e0e3233$export$1654cd6813e90e6b);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$33059cd02df2febd);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", ()=>$d90d8ce15e0e3233$export$1d746ff2bc48ceb4);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", ()=>$d90d8ce15e0e3233$export$145c578104a45fd2);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", ()=>$d90d8ce15e0e3233$export$a51df1bc877c58e5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", ()=>$d90d8ce15e0e3233$export$45208fff8de46880);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", ()=>$d90d8ce15e0e3233$export$c710a35d40378fa5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", ()=>$d90d8ce15e0e3233$export$15d6b93ff5273ce3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", ()=>$d90d8ce15e0e3233$export$e26f2863c7ccd504);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", ()=>$d90d8ce15e0e3233$export$496da9aa0fe819ff);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", ()=>$d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$53ce69fb34f6d286);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", ()=>$d90d8ce15e0e3233$export$b6e861786143eb1b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", ()=>$d90d8ce15e0e3233$export$f7e3d3b413c017e1);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", ()=>$d90d8ce15e0e3233$export$b84d34b8175abde5);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", ()=>$d90d8ce15e0e3233$export$50e4e3e5231fb74f);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", ()=>$d90d8ce15e0e3233$export$39d913ae557ba8f3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$a2d9bcceac584c93);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$eb2e5f1608ec8b32);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ac90b948c53bf58);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", ()=>$d90d8ce15e0e3233$export$bb5665894498893f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$fc61479fdfdd263a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$5ae82b891e42770e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE", ()=>$d90d8ce15e0e3233$export$8dcc46e162f2235b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$a934caa57ac0ac0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$25a4e6c77f91c259);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", ()=>$d90d8ce15e0e3233$export$2a9a9bab313fd713);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$82ad2da638fc34d8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$ff67cffdbd881a41);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", ()=>$d90d8ce15e0e3233$export$c41c7d73df3fc08c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS", ()=>$d90d8ce15e0e3233$export$65f234e4799edddc);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK", ()=>$d90d8ce15e0e3233$export$215ea4e7405fa88c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE", ()=>$d90d8ce15e0e3233$export$927b1972180d9cc4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$ff1365ce4d652337);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", ()=>$d90d8ce15e0e3233$export$79b30013cbfdee04);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", ()=>$d90d8ce15e0e3233$export$33c2dcc7c7abc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", ()=>$d90d8ce15e0e3233$export$a6ef20aa08a533b1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", ()=>$d90d8ce15e0e3233$export$5908e15483da8a45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", ()=>$d90d8ce15e0e3233$export$a3812f6f4e60d897);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$3c8c119f40a061a9);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", ()=>$d90d8ce15e0e3233$export$47e034646abefdb2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", ()=>$d90d8ce15e0e3233$export$f36f4cf8b17f250f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", ()=>$d90d8ce15e0e3233$export$841e880a0d425b3e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", ()=>$d90d8ce15e0e3233$export$1fde4a6e7df24a97);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$69335bf8b709edc7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", ()=>$d90d8ce15e0e3233$export$946b472f7559a889);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", ()=>$d90d8ce15e0e3233$export$373fdf6888021ed0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", ()=>$d90d8ce15e0e3233$export$d6a5f13a3d30923c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", ()=>$d90d8ce15e0e3233$export$adfff93b0b015409);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", ()=>$d90d8ce15e0e3233$export$404de4ddea701cff);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$596e1f6f6f4997b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$d610a17dff3a01fa);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$284db5107f3db516);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", ()=>$d90d8ce15e0e3233$export$fbce46826eefc586);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", ()=>$d90d8ce15e0e3233$export$c86b29c76317ac6f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$3160b86e1b5dc391);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$690c0080c930fca);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", ()=>$d90d8ce15e0e3233$export$171ba8c33c05c4ef);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$e2f2c23286c3255c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$5a262d40e10207a1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$ab790cb87175797e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$db780b39656c673a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", ()=>$d90d8ce15e0e3233$export$a77cb4dafc511d3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$253fd82874264ee4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", ()=>$d90d8ce15e0e3233$export$eaf9ab4ec0c25813);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$574bcdf6b73fcf1f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", ()=>$d90d8ce15e0e3233$export$a14853dfff8da872);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba8fd0e6db8d3e08);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$1c74da1e52e6d212);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", ()=>$d90d8ce15e0e3233$export$d416059b17fe7d4e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", ()=>$d90d8ce15e0e3233$export$d5a3a037d2760bb7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", ()=>$d90d8ce15e0e3233$export$eb187d42a7448d45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", ()=>$d90d8ce15e0e3233$export$688de32d31fc70f5);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", ()=>$d90d8ce15e0e3233$export$13d770f8814d480a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$3a628f9376166ffb);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$649dafa225625f30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$dbfe76dd37018b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$20db7bb9d1bd8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$a1fa8e6e125780ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", ()=>$d90d8ce15e0e3233$export$fc6b949fd2bc782d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$c940f866ac7760a0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$184d4979f6f9fe7e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", ()=>$d90d8ce15e0e3233$export$959f50de166cc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", ()=>$d90d8ce15e0e3233$export$b13b8c8bb4e30a75);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", ()=>$d90d8ce15e0e3233$export$40d6fc2b9a4f09d2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", ()=>$d90d8ce15e0e3233$export$cc1af211e3feda50);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", ()=>$d90d8ce15e0e3233$export$3873539001f5aed7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", ()=>$d90d8ce15e0e3233$export$89fcbafce559080b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", ()=>$d90d8ce15e0e3233$export$c3f05da9e4e13249);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", ()=>$d90d8ce15e0e3233$export$619694ab37142384);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", ()=>$d90d8ce15e0e3233$export$cb89b516b9cf418b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", ()=>$d90d8ce15e0e3233$export$50680f54e95bb859);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", ()=>$d90d8ce15e0e3233$export$194c2b4da7e38757);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", ()=>$d90d8ce15e0e3233$export$962d838817f090f8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", ()=>$d90d8ce15e0e3233$export$eacbdb340a470309);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", ()=>$d90d8ce15e0e3233$export$6a7782d87a21425d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", ()=>$d90d8ce15e0e3233$export$c2f56336162e799e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", ()=>$d90d8ce15e0e3233$export$ba419378ad70624e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$d90d8ce15e0e3233$export$62f38c589a73d386);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", ()=>$d90d8ce15e0e3233$export$77c8066c0822f152);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", ()=>$d90d8ce15e0e3233$export$90900ebfa6f48861);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", ()=>$d90d8ce15e0e3233$export$93ff02c205edd1a8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$d90d8ce15e0e3233$export$db7f5d93be70ee30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$d90d8ce15e0e3233$export$432229516b7f82da);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", ()=>$d90d8ce15e0e3233$export$8f554d4ef9f084c0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", ()=>$d90d8ce15e0e3233$export$6b2b99b0055772a3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", ()=>$d90d8ce15e0e3233$export$83c7a51057be6264);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", ()=>$d90d8ce15e0e3233$export$46706d786aab3829);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", ()=>$d90d8ce15e0e3233$export$b690025ef7e3cf6c);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", ()=>$d90d8ce15e0e3233$export$ea48cc6bf1183d11);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", ()=>$d90d8ce15e0e3233$export$930e4881302bbd54);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$375801b708576466);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", ()=>$d90d8ce15e0e3233$export$5b1e8463bd590143);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", ()=>$d90d8ce15e0e3233$export$1606662a398a24be);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", ()=>$d90d8ce15e0e3233$export$c5b19a37e49ceb28);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", ()=>$d90d8ce15e0e3233$export$c46680afe70295f3);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", ()=>$d90d8ce15e0e3233$export$831fc7eba98b58c9);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", ()=>$d90d8ce15e0e3233$export$4061c0c586f3b7c8);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", ()=>$d90d8ce15e0e3233$export$99e0abd8ba1de289);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", ()=>$d90d8ce15e0e3233$export$cd96a6a0cc4831ab);
    $parcel$export(module.exports, "ROUTE_NAMES_ROVO_DEMAND_TESTS", ()=>$d90d8ce15e0e3233$export$36e61e70347174cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", ()=>$d90d8ce15e0e3233$export$db1b3d2fee80859);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", ()=>$d90d8ce15e0e3233$export$b0f3f3214ab1b150);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", ()=>$d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", ()=>$d90d8ce15e0e3233$export$8c8f03e75b6708ac);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", ()=>$d90d8ce15e0e3233$export$3c3d8caf61c9aa0c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", ()=>$d90d8ce15e0e3233$export$f9cc808094ce0ddd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", ()=>$d90d8ce15e0e3233$export$9bde4a0b155f2972);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", ()=>$d90d8ce15e0e3233$export$a52f5ffbbe135078);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$e6773bf0fbccdb9c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$8e3dd8487a7b65bd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$258b44fcc29a5961);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", ()=>$d90d8ce15e0e3233$export$ea1146ebce07be6d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", ()=>$d90d8ce15e0e3233$export$53731240ce2d3b76);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", ()=>$d90d8ce15e0e3233$export$956eb40834ddee22);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", ()=>$d90d8ce15e0e3233$export$9057470ebf41169);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", ()=>$d90d8ce15e0e3233$export$c42e107c5275b36);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", ()=>$d90d8ce15e0e3233$export$3e7c6a54a9d2267a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", ()=>$d90d8ce15e0e3233$export$c3e2697b35a149c4);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", ()=>$d90d8ce15e0e3233$export$288c7dd61dd0c291);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", ()=>$d90d8ce15e0e3233$export$37161a981d69c891);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$cfe61aa92a4d585d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$9ed512ab4c81669c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", ()=>$d90d8ce15e0e3233$export$37a9bdd8513f462d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", ()=>$d90d8ce15e0e3233$export$f01162415f3a2ee3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", ()=>$d90d8ce15e0e3233$export$860dd13b1e836ed8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", ()=>$d90d8ce15e0e3233$export$5eaf1dce55090ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", ()=>$d90d8ce15e0e3233$export$1fe309e7cdbd1c1);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", ()=>$d90d8ce15e0e3233$export$fcd9750494ff0236);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", ()=>$d90d8ce15e0e3233$export$ad856b38e93b93b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", ()=>$d90d8ce15e0e3233$export$a833209ca71d2e56);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", ()=>$d90d8ce15e0e3233$export$829d1776460a6ad3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", ()=>$d90d8ce15e0e3233$export$d30ab2da08d8b7b9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", ()=>$d90d8ce15e0e3233$export$3c71889849aeaa08);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", ()=>$d90d8ce15e0e3233$export$354bf2df81f6ffb0);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", ()=>$d90d8ce15e0e3233$export$f8880b461acd270d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", ()=>$d90d8ce15e0e3233$export$876055c0ede2f8df);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", ()=>$d90d8ce15e0e3233$export$bf493c66e34711c8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", ()=>$d90d8ce15e0e3233$export$212f6e2c7c2a53bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$7c28c6e8d8a6545);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", ()=>$d90d8ce15e0e3233$export$8d55b6ef2cd92f8c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", ()=>$d90d8ce15e0e3233$export$f7fbe9a4717b7a50);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", ()=>$d90d8ce15e0e3233$export$8c800f176d079d28);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", ()=>$d90d8ce15e0e3233$export$1c5fbcbfc0923176);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$59644e5d8d69a016);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", ()=>$d90d8ce15e0e3233$export$c7074ebe0ca83f98);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", ()=>$d90d8ce15e0e3233$export$2b4737953287a354);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", ()=>$d90d8ce15e0e3233$export$e7a8d6d534c5e2fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$5dcba309e2bfa88b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", ()=>$d90d8ce15e0e3233$export$2d961b0101f8733e);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", ()=>$d90d8ce15e0e3233$export$195fe2558f1a8591);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", ()=>$d90d8ce15e0e3233$export$1b3cf68be370a45b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", ()=>$d90d8ce15e0e3233$export$45c35381e5da2232);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", ()=>$d90d8ce15e0e3233$export$d479ba53b9bf65a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", ()=>$d90d8ce15e0e3233$export$ccd12890649c59cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", ()=>$d90d8ce15e0e3233$export$8c84064031188e80);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", ()=>$d90d8ce15e0e3233$export$46c6fef035fbe8ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", ()=>$d90d8ce15e0e3233$export$6fb23ec5a12d5c24);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", ()=>$d90d8ce15e0e3233$export$156b2dfbd87d576f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", ()=>$d90d8ce15e0e3233$export$6961f1ed0407cb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", ()=>$d90d8ce15e0e3233$export$ba284efd679bf637);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", ()=>$d90d8ce15e0e3233$export$e48a3df597407767);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", ()=>$d90d8ce15e0e3233$export$c73718d4a6efea1d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", ()=>$d90d8ce15e0e3233$export$ed454783ba1bacb9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$48f6285d4729ca9d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", ()=>$d90d8ce15e0e3233$export$8066418cead2d2ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", ()=>$d90d8ce15e0e3233$export$b3db7857ac710a89);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", ()=>$d90d8ce15e0e3233$export$d574810e3edad044);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", ()=>$d90d8ce15e0e3233$export$be4b2ffade787316);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", ()=>$d90d8ce15e0e3233$export$3caf79b5f4be02d7);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", ()=>$d90d8ce15e0e3233$export$29bc361328055683);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", ()=>$d90d8ce15e0e3233$export$a4a5a333fe874d97);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", ()=>$d90d8ce15e0e3233$export$2193b681ac1ae132);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$f1bfd5b3918619a9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$a4c4f7898d6b914a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", ()=>$d90d8ce15e0e3233$export$6cffae90b9277bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", ()=>$d90d8ce15e0e3233$export$17e76ebd53424ed5);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", ()=>$d90d8ce15e0e3233$export$b1329dc26a81a277);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", ()=>$d90d8ce15e0e3233$export$e1cba0bfe330f5c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", ()=>$d90d8ce15e0e3233$export$8e68c55c334de101);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", ()=>$d90d8ce15e0e3233$export$5cb7cfba189a0240);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", ()=>$d90d8ce15e0e3233$export$d28aab4a6d6f1d0d);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", ()=>$d90d8ce15e0e3233$export$1cf56e2d6c4edb35);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", ()=>$d90d8ce15e0e3233$export$27c1770584d7e3fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", ()=>$d90d8ce15e0e3233$export$22e0ebdea08537f7);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", ()=>$d90d8ce15e0e3233$export$4db732436e4edfaf);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$e832418dbed0717e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", ()=>$d90d8ce15e0e3233$export$ee09be798f0e4471);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", ()=>$d90d8ce15e0e3233$export$653bf90ae3578f21);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", ()=>$d90d8ce15e0e3233$export$9da4125a0c62444d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", ()=>$d90d8ce15e0e3233$export$fbcc0fd9b402bb12);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$e74fe5bd41e23fbd);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", ()=>$d90d8ce15e0e3233$export$1a93e63ddbe4aa06);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", ()=>$d90d8ce15e0e3233$export$3b6dbbe49882589d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", ()=>$d90d8ce15e0e3233$export$eb01394789016fd4);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", ()=>$d90d8ce15e0e3233$export$f17f4523583fa8e5);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$eaa4d6eec75a6778);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", ()=>$d90d8ce15e0e3233$export$dcc96e4abbdc0d39);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", ()=>$d90d8ce15e0e3233$export$9eaf39ba5a56c72a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", ()=>$d90d8ce15e0e3233$export$495be3320b67814a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", ()=>$d90d8ce15e0e3233$export$25752eb5bb5e3d32);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", ()=>$d90d8ce15e0e3233$export$f116716aedb35e10);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", ()=>$d90d8ce15e0e3233$export$36fffb6b49d9f31d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", ()=>$d90d8ce15e0e3233$export$a6d07be4ff318f84);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$a9a43f1114df1ad9);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$3a4c7a521a900b4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", ()=>$d90d8ce15e0e3233$export$9dcf51a9040a4fd6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", ()=>$d90d8ce15e0e3233$export$a74f9f6bd0d4fb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", ()=>$d90d8ce15e0e3233$export$f8cb86acf6b74661);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", ()=>$d90d8ce15e0e3233$export$2d3d850c64058bfb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", ()=>$d90d8ce15e0e3233$export$af6b51164f66908b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$12efc96fc9c9fb34);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", ()=>$d90d8ce15e0e3233$export$6ab1901e04e623ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", ()=>$d90d8ce15e0e3233$export$bccc7d0812737c4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", ()=>$d90d8ce15e0e3233$export$458fb992f2637a20);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9c9c64f68ba51e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", ()=>$d90d8ce15e0e3233$export$50264cbc90a39f19);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", ()=>$d90d8ce15e0e3233$export$b9d0cbe0888fa72e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", ()=>$d90d8ce15e0e3233$export$b8045610416fa8ca);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", ()=>$d90d8ce15e0e3233$export$8e80136ad13099e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", ()=>$d90d8ce15e0e3233$export$b5fe44c0bc324494);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$7a4f52d9060a20d2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", ()=>$d90d8ce15e0e3233$export$d6a9e4695952522e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", ()=>$d90d8ce15e0e3233$export$deab88d0814c564b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", ()=>$d90d8ce15e0e3233$export$906faff110f898ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", ()=>$d90d8ce15e0e3233$export$ab3f2a34a3b0db87);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", ()=>$d90d8ce15e0e3233$export$4ed84a2011fdc400);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", ()=>$d90d8ce15e0e3233$export$f7b286b39bf6051b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", ()=>$d90d8ce15e0e3233$export$6c4337c0332c8c7f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", ()=>$d90d8ce15e0e3233$export$e7c78887745b2326);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", ()=>$d90d8ce15e0e3233$export$3805e4f07dca7584);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", ()=>$d90d8ce15e0e3233$export$f77254983320e888);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", ()=>$d90d8ce15e0e3233$export$2e784832f1c6bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", ()=>$d90d8ce15e0e3233$export$7f97fa79520a4c5b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", ()=>$d90d8ce15e0e3233$export$9e53cdb1ac02195c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED", ()=>$d90d8ce15e0e3233$export$58bd507904dc221c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", ()=>$d90d8ce15e0e3233$export$7a821e22be2c2f14);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", ()=>$d90d8ce15e0e3233$export$ca8966ef80bfafc6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", ()=>$d90d8ce15e0e3233$export$e7423156dba31a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", ()=>$d90d8ce15e0e3233$export$cba7e383b2409c7b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", ()=>$d90d8ce15e0e3233$export$d5378fb71d5242c0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", ()=>$d90d8ce15e0e3233$export$4b16b72c72da8833);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", ()=>$d90d8ce15e0e3233$export$10114d78cefb1f53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", ()=>$d90d8ce15e0e3233$export$92fe23ed30100817);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", ()=>$d90d8ce15e0e3233$export$e824495554c83069);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", ()=>$d90d8ce15e0e3233$export$8df2e9efdd625a44);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", ()=>$d90d8ce15e0e3233$export$aeb4d3006e298033);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", ()=>$d90d8ce15e0e3233$export$e15d3c40985c4b53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", ()=>$d90d8ce15e0e3233$export$1d8c84454fd2d571);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", ()=>$d90d8ce15e0e3233$export$db61a12efb59745c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", ()=>$d90d8ce15e0e3233$export$2da67fb5bd6bc2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", ()=>$d90d8ce15e0e3233$export$182e0167fd960de6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d9e2484ee02e7da);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", ()=>$d90d8ce15e0e3233$export$b7fff19fd89b617f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", ()=>$d90d8ce15e0e3233$export$ea23f150f64e8a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", ()=>$d90d8ce15e0e3233$export$116338bd93f78ad0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", ()=>$d90d8ce15e0e3233$export$c9cd65a78227cf18);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", ()=>$d90d8ce15e0e3233$export$d75d93e5d44182cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", ()=>$d90d8ce15e0e3233$export$cc3027ae3767801);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", ()=>$d90d8ce15e0e3233$export$3492ce83b8884e0e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", ()=>$d90d8ce15e0e3233$export$b4798b7e62733393);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", ()=>$d90d8ce15e0e3233$export$388685c701d6e0d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", ()=>$d90d8ce15e0e3233$export$5ff4d2d4257ea2b0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", ()=>$d90d8ce15e0e3233$export$fa83895c1eac55e7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", ()=>$d90d8ce15e0e3233$export$5c82bb95a06a1846);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", ()=>$d90d8ce15e0e3233$export$c725b9c7e11dd69e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", ()=>$d90d8ce15e0e3233$export$90594f89c675ba05);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", ()=>$d90d8ce15e0e3233$export$ae0d999dd2bdd59b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS", ()=>$d90d8ce15e0e3233$export$43bbf6935a91d277);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC", ()=>$d90d8ce15e0e3233$export$92e23977438282b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", ()=>$d90d8ce15e0e3233$export$296115eb5b7129d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", ()=>$d90d8ce15e0e3233$export$17574f41c3925d64);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", ()=>$d90d8ce15e0e3233$export$955692fbfe35fc16);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", ()=>$d90d8ce15e0e3233$export$30af3a767b8ad2d8);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", ()=>$d90d8ce15e0e3233$export$f47d664298c2c2f0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY", ()=>$d90d8ce15e0e3233$export$2d1ed852d9885250);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC", ()=>$d90d8ce15e0e3233$export$312796fc15876480);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", ()=>$d90d8ce15e0e3233$export$1714b5ad9b672bc7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", ()=>$d90d8ce15e0e3233$export$c9634bf15518a3a1);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", ()=>$d90d8ce15e0e3233$export$3b5eb3ea8cbeeed);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED", ()=>$d90d8ce15e0e3233$export$118bb1785acc3d0b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", ()=>$d90d8ce15e0e3233$export$c29d90ae9a4b648e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", ()=>$d90d8ce15e0e3233$export$8f2717a951373c25);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", ()=>$d90d8ce15e0e3233$export$831acb5098f5706d);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", ()=>$d90d8ce15e0e3233$export$d218cda46c433fe1);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", ()=>$d90d8ce15e0e3233$export$61147168ac2833f9);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$9fe0117c0fd486a8);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", ()=>$d90d8ce15e0e3233$export$a49474778d15635d);
    $parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", ()=>$d90d8ce15e0e3233$export$af3296e54e7fb362);
    $parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", ()=>$d90d8ce15e0e3233$export$281f2e01ee9e4977);
    const $d90d8ce15e0e3233$export$1ba937db1fe6ef01 = 'archive-issues';
    const $d90d8ce15e0e3233$export$3fd002e197e83a30 = 'arj-settings';
    const $d90d8ce15e0e3233$export$bbf08d4d25df5504 = 'classic-business';
    const $d90d8ce15e0e3233$export$e3e759b7f50aaee1 = 'classic-software';
    const $d90d8ce15e0e3233$export$89337611b52bc9a3 = 'components';
    const $d90d8ce15e0e3233$export$3d7937b12eb9e5d5 = 'connect';
    const $d90d8ce15e0e3233$export$7a3d181d86fce9e6 = 'dashboard';
    const $d90d8ce15e0e3233$export$294c878a3842c859 = 'dashboards';
    const $d90d8ce15e0e3233$export$7a22726acd7d6021 = 'devops';
    const $d90d8ce15e0e3233$export$f3f4a9f53ba00861 = 'directories';
    const $d90d8ce15e0e3233$export$112d69653b2f1d8b = 'eoc';
    const $d90d8ce15e0e3233$export$74e0426b66571086 = 'errors';
    const $d90d8ce15e0e3233$export$c2e20e142c95c1ce = 'global-settings';
    const $d90d8ce15e0e3233$export$f8cea29bebf098c = 'helpcenter-settings';
    const $d90d8ce15e0e3233$export$5801ef8dfc9a2f70 = 'home';
    const $d90d8ce15e0e3233$export$7246838143f848f3 = 'issue';
    const $d90d8ce15e0e3233$export$54f96702980a2f87 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$5566db8fbd042fc4 = 'legacy';
    const $d90d8ce15e0e3233$export$20344ad17b5fca86 = 'legacy-jsd-settings';
    const $d90d8ce15e0e3233$export$656d0cc2c67b2708 = 'marketplace';
    const $d90d8ce15e0e3233$export$bfdbcebc4c81b043 = 'people-profiles';
    const $d90d8ce15e0e3233$export$82021d71ad19e227 = 'personal-settings';
    const $d90d8ce15e0e3233$export$6f266218a6973848 = 'plan-settings';
    const $d90d8ce15e0e3233$export$a846fcaeeea8e0ff = 'polaris';
    const $d90d8ce15e0e3233$export$6c87a9dff4e7a2de = 'proforma';
    const $d90d8ce15e0e3233$export$ab79970dcfac06a1 = 'project-settings-classic';
    const $d90d8ce15e0e3233$export$d1a70f80bb22f18a = 'project-settings-core';
    const $d90d8ce15e0e3233$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
    const $d90d8ce15e0e3233$export$86509a1baabd62ee = 'project-settings-software';
    const $d90d8ce15e0e3233$export$98823ed9eedfc756 = 'project-settings-software-boards';
    const $d90d8ce15e0e3233$export$da8d13fe1ccd5c09 = 'redirects';
    const $d90d8ce15e0e3233$export$78fb2f6176b7c6b8 = 'servicedesk';
    const $d90d8ce15e0e3233$export$d4a2a2e87da2135a = 'services';
    const $d90d8ce15e0e3233$export$26efaec7a7a8b361 = 'software';
    const $d90d8ce15e0e3233$export$db781fb68c08f7e2 = 'versions';
    const $d90d8ce15e0e3233$export$88041353cc69458d = 'archived-issues-directory';
    const $d90d8ce15e0e3233$export$f88d57dcb03ba452 = 'archived-plans-directory';
    const $d90d8ce15e0e3233$export$e8aa63af071c2da9 = 'archived-projects-directory';
    const $d90d8ce15e0e3233$export$b114d0da2ebcff6c = 'archived-project-direct-link';
    const $d90d8ce15e0e3233$export$29cc94b8cea5c920 = 'boards-directory';
    const $d90d8ce15e0e3233$export$4d1b45005cdcfb39 = 'browse-project-redirect';
    const $d90d8ce15e0e3233$export$a42ea04fdf53eeaf = 'next-gen-business-board';
    const $d90d8ce15e0e3233$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
    const $d90d8ce15e0e3233$export$d58a5411a2ac6260 = 'next-gen-business-reports';
    const $d90d8ce15e0e3233$export$24514ee19772b5af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-onboarding-get-started`;
    const $d90d8ce15e0e3233$export$ec333dd1d6a8b38 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-calendar`;
    const $d90d8ce15e0e3233$export$ed495fbad44791af = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-redirect`;
    const $d90d8ce15e0e3233$export$5281552f8109b7c0 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-summary`;
    const $d90d8ce15e0e3233$export$6e8473713ed4557a = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-overview-timeline`;
    const $d90d8ce15e0e3233$export$cbdd5c24d69b2cb1 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-approvals`;
    const $d90d8ce15e0e3233$export$e7f012f402be01ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-attachments`;
    const $d90d8ce15e0e3233$export$b34d3882b42d660d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board`;
    const $d90d8ce15e0e3233$export$ed869c60c6a56182 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-board-embed`;
    const $d90d8ce15e0e3233$export$5013269f29c75b37 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar`;
    const $d90d8ce15e0e3233$export$fc8b48319e993d43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-calendar-embed`;
    const $d90d8ce15e0e3233$export$40903feb5b038923 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-files`;
    const $d90d8ce15e0e3233$export$d6e60a2059f028d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form`;
    const $d90d8ce15e0e3233$export$3d589aae17a00bc9 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-builder`;
    const $d90d8ce15e0e3233$export$bd92ef03b23dd672 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit`;
    const $d90d8ce15e0e3233$export$fa7fc44c718fc850 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-form-submit-embed`;
    const $d90d8ce15e0e3233$export$1dffaf831e01e2b4 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list`;
    const $d90d8ce15e0e3233$export$5f8187412dd60f35 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-list-embed`;
    const $d90d8ce15e0e3233$export$3d2c1c04d18f6c43 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-sample-onboarding`;
    const $d90d8ce15e0e3233$export$cd22a5d8f560a1d8 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-shortcut`;
    const $d90d8ce15e0e3233$export$cad1b1aa5ce26bbc = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary`;
    const $d90d8ce15e0e3233$export$ee073463b4144367 = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-summary-embed`;
    const $d90d8ce15e0e3233$export$ea034943499772ea = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline`;
    const $d90d8ce15e0e3233$export$19bc888bcf37d22d = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-timeline-embed`;
    const $d90d8ce15e0e3233$export$e0746183e11767fb = `${$d90d8ce15e0e3233$export$bbf08d4d25df5504}-redirect`;
    const $d90d8ce15e0e3233$export$3e2d215ce157adc8 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-code`;
    const $d90d8ce15e0e3233$export$8a8485bb05daf40b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a2799b01de5bb62 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-data-classifications`;
    const $d90d8ce15e0e3233$export$1bc2b66dcb07293a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$2d4f89c4b1ee3640 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-features`;
    const $d90d8ce15e0e3233$export$75609d3416c31f79 = `${$d90d8ce15e0e3233$export$ab79970dcfac06a1}-issue-layout`;
    const $d90d8ce15e0e3233$export$79793dc26e0b7b1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$2eda7466fbfdef43 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$417297669917ee1a = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-details`;
    const $d90d8ce15e0e3233$export$8c79f3309ac0737 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications`;
    const $d90d8ce15e0e3233$export$ef71a22e7befd35c = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$62ba1e294f5007c1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-edit-forms`;
    const $d90d8ce15e0e3233$export$a4315324546ecc89 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$a653cf6d478b3df1 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-company-managed`;
    const $d90d8ce15e0e3233$export$b0f268fe53a03e98 = 'compass-product-settings';
    const $d90d8ce15e0e3233$export$f4160b48e4ab8f39 = 'confluence-product-settings';
    const $d90d8ce15e0e3233$export$608f359cf8b08d2e = 'connect-general';
    const $d90d8ce15e0e3233$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
    const $d90d8ce15e0e3233$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
    const $d90d8ce15e0e3233$export$bd2506db44585db6 = 'connect-project';
    const $d90d8ce15e0e3233$export$200fa5ad16f8c112 = 'create-project';
    const $d90d8ce15e0e3233$export$21702f145fe1bbb0 = 'customer-service-accounts';
    const $d90d8ce15e0e3233$export$a296bb962bea95b5 = 'dashboard';
    const $d90d8ce15e0e3233$export$b9960c143c0414eb = 'dashboards-directory';
    const $d90d8ce15e0e3233$export$411171d2fcaefaea = 'dashboards-directory-secure';
    const $d90d8ce15e0e3233$export$ee104ed514f63003 = 'dashboard-edit';
    const $d90d8ce15e0e3233$export$9233f9ddcecd3062 = 'dashboard-selected';
    const $d90d8ce15e0e3233$export$b3240ec044a6c70f = 'dashboard-view';
    const $d90d8ce15e0e3233$export$2463c779e12367e3 = 'dashboard-view-embed';
    const $d90d8ce15e0e3233$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
    const $d90d8ce15e0e3233$export$38ca7e07048a5bfd = 'devops-connected-project';
    const $d90d8ce15e0e3233$export$a9044bbb0247378d = 'eoc-alerts';
    const $d90d8ce15e0e3233$export$ae7376e552380ac0 = 'eoc-alert-detail';
    const $d90d8ce15e0e3233$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$54ed2374d14a7e88 = 'eoc-api-key-management';
    const $d90d8ce15e0e3233$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
    const $d90d8ce15e0e3233$export$bbb4032f8f259109 = 'eoc-automations';
    const $d90d8ce15e0e3233$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
    const $d90d8ce15e0e3233$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
    const $d90d8ce15e0e3233$export$5126a481501fc518 = 'eoc-global-alert-detail';
    const $d90d8ce15e0e3233$export$40e720d8c26e6804 = 'eoc-global-group-detail';
    const $d90d8ce15e0e3233$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
    const $d90d8ce15e0e3233$export$8ca3e3f0326ba27f = 'eoc-global-reports';
    const $d90d8ce15e0e3233$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
    const $d90d8ce15e0e3233$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
    const $d90d8ce15e0e3233$export$99f769b27f537a72 = 'eoc-incoming-call';
    const $d90d8ce15e0e3233$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
    const $d90d8ce15e0e3233$export$901b974cf0954c88 = 'eoc-integrations';
    const $d90d8ce15e0e3233$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
    const $d90d8ce15e0e3233$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
    const $d90d8ce15e0e3233$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
    const $d90d8ce15e0e3233$export$a22387b9744e62e3 = 'eoc-integration-log';
    const $d90d8ce15e0e3233$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
    const $d90d8ce15e0e3233$export$e6de4aa6c719d2b = 'eoc-on-call';
    const $d90d8ce15e0e3233$export$b195ada84b7e695f = `${$d90d8ce15e0e3233$export$e6de4aa6c719d2b}-redirect`;
    const $d90d8ce15e0e3233$export$1800d32171b754a6 = 'eoc-overview';
    const $d90d8ce15e0e3233$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
    const $d90d8ce15e0e3233$export$a9a41c76994b6ae9 = 'eoc-permissions';
    const $d90d8ce15e0e3233$export$5bd6f2569c3cfd5c = 'eoc-policies';
    const $d90d8ce15e0e3233$export$dc70eff53ff26c70 = 'eoc-reports';
    const $d90d8ce15e0e3233$export$1fe2ca96b360df19 = 'eoc-reports-team';
    const $d90d8ce15e0e3233$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
    const $d90d8ce15e0e3233$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
    const $d90d8ce15e0e3233$export$a0d9033eb64fd80f = 'eoc-schedules';
    const $d90d8ce15e0e3233$export$c4531cbbea51b6a1 = 'eoc-settings';
    const $d90d8ce15e0e3233$export$da985e953465731f = 'eoc-team-alerts';
    const $d90d8ce15e0e3233$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
    const $d90d8ce15e0e3233$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
    const $d90d8ce15e0e3233$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
    const $d90d8ce15e0e3233$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
    const $d90d8ce15e0e3233$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
    const $d90d8ce15e0e3233$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
    const $d90d8ce15e0e3233$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
    const $d90d8ce15e0e3233$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
    const $d90d8ce15e0e3233$export$bdd811277711c53d = 'eoc-team-integration-create';
    const $d90d8ce15e0e3233$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
    const $d90d8ce15e0e3233$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
    const $d90d8ce15e0e3233$export$a4eff769c94da831 = 'eoc-team-integration-log';
    const $d90d8ce15e0e3233$export$7c928ca9c9822772 = 'eoc-team-policies';
    const $d90d8ce15e0e3233$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
    const $d90d8ce15e0e3233$export$20649eac204f7661 = 'eoc-who-is-on-call';
    const $d90d8ce15e0e3233$export$62170875a111d729 = 'errors-not-found';
    const $d90d8ce15e0e3233$export$2928f3d69e7ac609 = 'external-import';
    const $d90d8ce15e0e3233$export$259e18cafd820487 = 'filters-directory';
    const $d90d8ce15e0e3233$export$4b8f333757e638a4 = 'filters-directory-secure';
    const $d90d8ce15e0e3233$export$ac4f65a14002f892 = 'forge-spa-admin';
    const $d90d8ce15e0e3233$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
    const $d90d8ce15e0e3233$export$7ad826b482229119 = 'forge-spa-field-context-config';
    const $d90d8ce15e0e3233$export$3df864df9b639033 = 'forge-spa-global';
    const $d90d8ce15e0e3233$export$7d67bf4077ebe18d = 'forge-spa-project';
    const $d90d8ce15e0e3233$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
    const $d90d8ce15e0e3233$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
    const $d90d8ce15e0e3233$export$eadf5aff28def565 = 'global-issue-navigator';
    const $d90d8ce15e0e3233$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
    const $d90d8ce15e0e3233$export$1bf439327974644b = 'global-mail-settings';
    const $d90d8ce15e0e3233$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
    const $d90d8ce15e0e3233$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
    const $d90d8ce15e0e3233$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
    const $d90d8ce15e0e3233$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
    const $d90d8ce15e0e3233$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
    const $d90d8ce15e0e3233$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
    const $d90d8ce15e0e3233$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
    const $d90d8ce15e0e3233$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
    const $d90d8ce15e0e3233$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
    const $d90d8ce15e0e3233$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
    const $d90d8ce15e0e3233$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
    const $d90d8ce15e0e3233$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
    const $d90d8ce15e0e3233$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
    const $d90d8ce15e0e3233$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
    const $d90d8ce15e0e3233$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
    const $d90d8ce15e0e3233$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
    const $d90d8ce15e0e3233$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
    const $d90d8ce15e0e3233$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
    const $d90d8ce15e0e3233$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
    const $d90d8ce15e0e3233$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
    const $d90d8ce15e0e3233$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
    const $d90d8ce15e0e3233$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
    const $d90d8ce15e0e3233$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
    const $d90d8ce15e0e3233$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
    const $d90d8ce15e0e3233$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
    const $d90d8ce15e0e3233$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
    const $d90d8ce15e0e3233$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
    const $d90d8ce15e0e3233$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
    const $d90d8ce15e0e3233$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
    const $d90d8ce15e0e3233$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
    const $d90d8ce15e0e3233$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
    const $d90d8ce15e0e3233$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
    const $d90d8ce15e0e3233$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
    const $d90d8ce15e0e3233$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
    const $d90d8ce15e0e3233$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
    const $d90d8ce15e0e3233$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
    const $d90d8ce15e0e3233$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
    const $d90d8ce15e0e3233$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
    const $d90d8ce15e0e3233$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
    const $d90d8ce15e0e3233$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
    const $d90d8ce15e0e3233$export$7dd4b916600f670 = 'global-settings-issues-priorities';
    const $d90d8ce15e0e3233$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
    const $d90d8ce15e0e3233$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
    const $d90d8ce15e0e3233$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
    const $d90d8ce15e0e3233$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
    const $d90d8ce15e0e3233$export$691d30818c14141c = 'global-settings-issues-resolutions';
    const $d90d8ce15e0e3233$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
    const $d90d8ce15e0e3233$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
    const $d90d8ce15e0e3233$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
    const $d90d8ce15e0e3233$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
    const $d90d8ce15e0e3233$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
    const $d90d8ce15e0e3233$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
    const $d90d8ce15e0e3233$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
    const $d90d8ce15e0e3233$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
    const $d90d8ce15e0e3233$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
    const $d90d8ce15e0e3233$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
    const $d90d8ce15e0e3233$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
    const $d90d8ce15e0e3233$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
    const $d90d8ce15e0e3233$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
    const $d90d8ce15e0e3233$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
    const $d90d8ce15e0e3233$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
    const $d90d8ce15e0e3233$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
    const $d90d8ce15e0e3233$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
    const $d90d8ce15e0e3233$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
    const $d90d8ce15e0e3233$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
    const $d90d8ce15e0e3233$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
    const $d90d8ce15e0e3233$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
    const $d90d8ce15e0e3233$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
    const $d90d8ce15e0e3233$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
    const $d90d8ce15e0e3233$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
    const $d90d8ce15e0e3233$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
    const $d90d8ce15e0e3233$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
    const $d90d8ce15e0e3233$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
    const $d90d8ce15e0e3233$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
    const $d90d8ce15e0e3233$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
    const $d90d8ce15e0e3233$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
    const $d90d8ce15e0e3233$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
    const $d90d8ce15e0e3233$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
    const $d90d8ce15e0e3233$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
    const $d90d8ce15e0e3233$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
    const $d90d8ce15e0e3233$export$ef510a15f840e437 = 'global-settings-issues-types-view';
    const $d90d8ce15e0e3233$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
    const $d90d8ce15e0e3233$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
    const $d90d8ce15e0e3233$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
    const $d90d8ce15e0e3233$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
    const $d90d8ce15e0e3233$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
    const $d90d8ce15e0e3233$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
    const $d90d8ce15e0e3233$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
    const $d90d8ce15e0e3233$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
    const $d90d8ce15e0e3233$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
    const $d90d8ce15e0e3233$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
    const $d90d8ce15e0e3233$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
    const $d90d8ce15e0e3233$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
    const $d90d8ce15e0e3233$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
    const $d90d8ce15e0e3233$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
    const $d90d8ce15e0e3233$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
    const $d90d8ce15e0e3233$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
    const $d90d8ce15e0e3233$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
    const $d90d8ce15e0e3233$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
    const $d90d8ce15e0e3233$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
    const $d90d8ce15e0e3233$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
    const $d90d8ce15e0e3233$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
    const $d90d8ce15e0e3233$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
    const $d90d8ce15e0e3233$export$4c211b3188348679 = 'global-settings-performance-custom-field';
    const $d90d8ce15e0e3233$export$24757bb1837e33af = 'global-settings-performance-issue';
    const $d90d8ce15e0e3233$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
    const $d90d8ce15e0e3233$export$d55d4330b58683da = 'global-settings-performance-overview';
    const $d90d8ce15e0e3233$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
    const $d90d8ce15e0e3233$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
    const $d90d8ce15e0e3233$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
    const $d90d8ce15e0e3233$export$16b4392a63a3eacf = 'global-settings-products-applinks';
    const $d90d8ce15e0e3233$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
    const $d90d8ce15e0e3233$export$f870832f94ca5009 = 'global-settings-products-sdmail';
    const $d90d8ce15e0e3233$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
    const $d90d8ce15e0e3233$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
    const $d90d8ce15e0e3233$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
    const $d90d8ce15e0e3233$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
    const $d90d8ce15e0e3233$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
    const $d90d8ce15e0e3233$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
    const $d90d8ce15e0e3233$export$a1916b723e186494 = 'global-settings-system-helper-permission';
    const $d90d8ce15e0e3233$export$5070b4c974017f28 = 'global-settings-system-attachments';
    const $d90d8ce15e0e3233$export$bee7f9f93cb74124 = 'global-settings-system-events';
    const $d90d8ce15e0e3233$export$efe4008073ab3b69 = 'global-settings-system-events-add';
    const $d90d8ce15e0e3233$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
    const $d90d8ce15e0e3233$export$223f8094878fea34 = 'global-settings-system-events-edit';
    const $d90d8ce15e0e3233$export$2f589c572415c043 = 'global-settings-system-lexorank';
    const $d90d8ce15e0e3233$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
    const $d90d8ce15e0e3233$export$a11311cd333dae90 = 'global-settings-system-webhooks';
    const $d90d8ce15e0e3233$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
    const $d90d8ce15e0e3233$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
    const $d90d8ce15e0e3233$export$55dd30b027c838fe = 'global-settings-system-application-edit';
    const $d90d8ce15e0e3233$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
    const $d90d8ce15e0e3233$export$75f2fbd33e76028e = 'global-settings-system-export';
    const $d90d8ce15e0e3233$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
    const $d90d8ce15e0e3233$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
    const $d90d8ce15e0e3233$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
    const $d90d8ce15e0e3233$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
    const $d90d8ce15e0e3233$export$750a33c4058af733 = 'global-settings-system-import-trello';
    const $d90d8ce15e0e3233$export$1b66c7594340363f = 'global-settings-system-collectors';
    const $d90d8ce15e0e3233$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
    const $d90d8ce15e0e3233$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
    const $d90d8ce15e0e3233$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
    const $d90d8ce15e0e3233$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
    const $d90d8ce15e0e3233$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
    const $d90d8ce15e0e3233$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
    const $d90d8ce15e0e3233$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
    const $d90d8ce15e0e3233$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
    const $d90d8ce15e0e3233$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
    const $d90d8ce15e0e3233$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
    const $d90d8ce15e0e3233$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
    const $d90d8ce15e0e3233$export$265062715b11a1ef = 'global-settings-system-roles-usage';
    const $d90d8ce15e0e3233$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
    const $d90d8ce15e0e3233$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
    const $d90d8ce15e0e3233$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
    const $d90d8ce15e0e3233$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
    const $d90d8ce15e0e3233$export$fb75113636566d39 = 'global-settings-system-look';
    const $d90d8ce15e0e3233$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
    const $d90d8ce15e0e3233$export$40d189100899f572 = 'global-settings-system-default-settings';
    const $d90d8ce15e0e3233$export$341933b279728599 = $d90d8ce15e0e3233$export$f8cea29bebf098c;
    const $d90d8ce15e0e3233$export$ae4b815061537207 = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-customer-notifications`;
    const $d90d8ce15e0e3233$export$5cd0dd5a6be6aa2b = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-email`;
    const $d90d8ce15e0e3233$export$bee46016693b19dc = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-kb`;
    const $d90d8ce15e0e3233$export$ca253bc3d237c17f = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-forms`;
    const $d90d8ce15e0e3233$export$a4cba48257cb118a = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-form-edit`;
    const $d90d8ce15e0e3233$export$2e90ab5aa3463c0d = `${$d90d8ce15e0e3233$export$f8cea29bebf098c}-web-portal`;
    const $d90d8ce15e0e3233$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
    const $d90d8ce15e0e3233$export$b2b57cde1fa39bf5 = 'home-redirect';
    const $d90d8ce15e0e3233$export$e8e3b3a04b70a016 = 'issue';
    const $d90d8ce15e0e3233$export$1a3116351e4f3550 = 'issue-create-embed';
    const $d90d8ce15e0e3233$export$6e2629d41c380b47 = 'issue-embed';
    const $d90d8ce15e0e3233$export$ced38e55e6d33a4e = 'jira-search';
    const $d90d8ce15e0e3233$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
    const $d90d8ce15e0e3233$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
    const $d90d8ce15e0e3233$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
    const $d90d8ce15e0e3233$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
    const $d90d8ce15e0e3233$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
    const $d90d8ce15e0e3233$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
    const $d90d8ce15e0e3233$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
    const $d90d8ce15e0e3233$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
    const $d90d8ce15e0e3233$export$fea47b97c6086336 = 'knowledge-hub-drafts';
    const $d90d8ce15e0e3233$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
    const $d90d8ce15e0e3233$export$991ba0c465b48539 = 'knowledge-hub-landing';
    const $d90d8ce15e0e3233$export$904b472d57dee40d = 'knowledge-hub-search';
    const $d90d8ce15e0e3233$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
    const $d90d8ce15e0e3233$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
    const $d90d8ce15e0e3233$export$37bd400c00057d64 = 'legacy-all-reports';
    const $d90d8ce15e0e3233$export$eb66bd587b5f093d = 'legacy-backlog';
    const $d90d8ce15e0e3233$export$521baa72494c2a67 = 'legacy-board';
    const $d90d8ce15e0e3233$export$ca255c93be51d5bc = 'legacy-connect-general';
    const $d90d8ce15e0e3233$export$51e45f736a60769b = 'legacy-connect-project';
    const $d90d8ce15e0e3233$export$2da88c0583f7fff0 = 'legacy-core-reports';
    const $d90d8ce15e0e3233$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
    const $d90d8ce15e0e3233$export$5475ba822739444a = 'legacy-fallback';
    const $d90d8ce15e0e3233$export$8483f5c57513e386 = 'legacy-gin';
    const $d90d8ce15e0e3233$export$93c4d1960660bdb3 = 'legacy-gin-issue';
    const $d90d8ce15e0e3233$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
    const $d90d8ce15e0e3233$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
    const $d90d8ce15e0e3233$export$bf4001a5c23bef67 = 'legacy-issue';
    const $d90d8ce15e0e3233$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
    const $d90d8ce15e0e3233$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
    const $d90d8ce15e0e3233$export$41008c2b014795bf = 'legacy-jsd-getting-started';
    const $d90d8ce15e0e3233$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
    const $d90d8ce15e0e3233$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
    const $d90d8ce15e0e3233$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
    const $d90d8ce15e0e3233$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
    const $d90d8ce15e0e3233$export$3fbd487079a23c0f = 'legacy-jsd-reports';
    const $d90d8ce15e0e3233$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
    const $d90d8ce15e0e3233$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
    const $d90d8ce15e0e3233$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
    const $d90d8ce15e0e3233$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
    const $d90d8ce15e0e3233$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
    const $d90d8ce15e0e3233$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
    const $d90d8ce15e0e3233$export$c71836085985a7d3 = 'legacy-pin';
    const $d90d8ce15e0e3233$export$a17a19a9de903839 = 'legacy-project-releases';
    const $d90d8ce15e0e3233$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
    const $d90d8ce15e0e3233$export$f0254c80025ed0fc = 'legacy-project-releases-note';
    const $d90d8ce15e0e3233$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
    const $d90d8ce15e0e3233$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
    const $d90d8ce15e0e3233$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
    const $d90d8ce15e0e3233$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
    const $d90d8ce15e0e3233$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
    const $d90d8ce15e0e3233$export$3467807847c0a87d = 'legacy-project-settings-config';
    const $d90d8ce15e0e3233$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
    const $d90d8ce15e0e3233$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
    const $d90d8ce15e0e3233$export$f01730982626c4af = 'legacy-project-settings-dev';
    const $d90d8ce15e0e3233$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
    const $d90d8ce15e0e3233$export$ecff223feb9d08be = 'legacy-project-settings-fields';
    const $d90d8ce15e0e3233$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
    const $d90d8ce15e0e3233$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
    const $d90d8ce15e0e3233$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
    const $d90d8ce15e0e3233$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
    const $d90d8ce15e0e3233$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
    const $d90d8ce15e0e3233$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
    const $d90d8ce15e0e3233$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
    const $d90d8ce15e0e3233$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
    const $d90d8ce15e0e3233$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
    const $d90d8ce15e0e3233$export$28687a1181a7676f = 'legacy-project-settings-people';
    const $d90d8ce15e0e3233$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
    const $d90d8ce15e0e3233$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
    const $d90d8ce15e0e3233$export$cb8548f16119b181 = 'legacy-project-settings-screens';
    const $d90d8ce15e0e3233$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
    const $d90d8ce15e0e3233$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
    const $d90d8ce15e0e3233$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
    const $d90d8ce15e0e3233$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
    const $d90d8ce15e0e3233$export$2d21e5416485b195 = 'legacy-redirect';
    const $d90d8ce15e0e3233$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
    const $d90d8ce15e0e3233$export$d9662297242bfcb5 = 'legacy-reports-configure';
    const $d90d8ce15e0e3233$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
    const $d90d8ce15e0e3233$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
    const $d90d8ce15e0e3233$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
    const $d90d8ce15e0e3233$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
    const $d90d8ce15e0e3233$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
    const $d90d8ce15e0e3233$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
    const $d90d8ce15e0e3233$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
    const $d90d8ce15e0e3233$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
    const $d90d8ce15e0e3233$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
    const $d90d8ce15e0e3233$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
    const $d90d8ce15e0e3233$export$55248356780fc584 = 'login-embed';
    const $d90d8ce15e0e3233$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
    const $d90d8ce15e0e3233$export$624af6f61b05f55 = 'addons-emcee-public';
    const $d90d8ce15e0e3233$export$2ed9525182145b82 = 'marketplace-app-requests';
    const $d90d8ce15e0e3233$export$7fb2b42fc4e7df8b = 'marketplace-index';
    const $d90d8ce15e0e3233$export$fa962db82ae571b2 = 'global-settings-addons-upm';
    const $d90d8ce15e0e3233$export$e145bf76b1aef705 = 'marketplace-promotions';
    const $d90d8ce15e0e3233$export$8febbfb647e4c8b9 = 'notification-logs';
    const $d90d8ce15e0e3233$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
    const $d90d8ce15e0e3233$export$a979a5c1f5e3631c = 'people-index';
    const $d90d8ce15e0e3233$export$ffcbf91dfadffd0 = 'personal-settings';
    const $d90d8ce15e0e3233$export$1807a39cc63b856c = 'personal-settings-general';
    const $d90d8ce15e0e3233$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
    const $d90d8ce15e0e3233$export$6268da7263eb670d = 'personal-settings-ops-notifications';
    const $d90d8ce15e0e3233$export$93bd4a896a0fc581 = 'plans-directory';
    const $d90d8ce15e0e3233$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
    const $d90d8ce15e0e3233$export$d1217085321b2648 = 'project-settings-playbooks-list';
    const $d90d8ce15e0e3233$export$39624171b7c8a10a = 'polaris-collections';
    const $d90d8ce15e0e3233$export$1654cd6813e90e6b = 'polaris-ideas';
    const $d90d8ce15e0e3233$export$33059cd02df2febd = 'polaris-insights';
    const $d90d8ce15e0e3233$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
    const $d90d8ce15e0e3233$export$145c578104a45fd2 = 'polaris-plays';
    const $d90d8ce15e0e3233$export$a51df1bc877c58e5 = 'polaris-rooms';
    const $d90d8ce15e0e3233$export$45208fff8de46880 = 'polaris-settings-access';
    const $d90d8ce15e0e3233$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
    const $d90d8ce15e0e3233$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
    const $d90d8ce15e0e3233$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
    const $d90d8ce15e0e3233$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
    const $d90d8ce15e0e3233$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
    const $d90d8ce15e0e3233$export$53ce69fb34f6d286 = 'products-jsm-configuration';
    const $d90d8ce15e0e3233$export$b6e861786143eb1b = 'products-jsm-customer-access';
    const $d90d8ce15e0e3233$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
    const $d90d8ce15e0e3233$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
    const $d90d8ce15e0e3233$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
    const $d90d8ce15e0e3233$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
    const $d90d8ce15e0e3233$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
    const $d90d8ce15e0e3233$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
    const $d90d8ce15e0e3233$export$9ac90b948c53bf58 = 'products-jsw-configuration';
    const $d90d8ce15e0e3233$export$bb5665894498893f = 'products-jsw-storage-management';
    const $d90d8ce15e0e3233$export$fc61479fdfdd263a = 'classic-business-proforma-export';
    const $d90d8ce15e0e3233$export$5ae82b891e42770e = 'servicedesk-proforma-export';
    const $d90d8ce15e0e3233$export$8dcc46e162f2235b = 'software-proforma-export';
    const $d90d8ce15e0e3233$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
    const $d90d8ce15e0e3233$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
    const $d90d8ce15e0e3233$export$65f234e4799edddc = 'classic-business-proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$215ea4e7405fa88c = 'servicedesk-proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$927b1972180d9cc4 = 'software-proforma-issue-forms-general';
    const $d90d8ce15e0e3233$export$ff1365ce4d652337 = 'projects-directory';
    const $d90d8ce15e0e3233$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
    const $d90d8ce15e0e3233$export$33c2dcc7c7abc45e = 'projects-directory-manage';
    const $d90d8ce15e0e3233$export$a6ef20aa08a533b1 = 'projects-redirect';
    const $d90d8ce15e0e3233$export$5908e15483da8a45 = 'project-components';
    const $d90d8ce15e0e3233$export$a3812f6f4e60d897 = 'project-directory-redirect';
    const $d90d8ce15e0e3233$export$3c8c119f40a061a9 = 'issue-navigator';
    const $d90d8ce15e0e3233$export$47e034646abefdb2 = 'issue-navigator-classic';
    const $d90d8ce15e0e3233$export$f36f4cf8b17f250f = 'issue-navigator-core';
    const $d90d8ce15e0e3233$export$841e880a0d425b3e = 'project-not-found';
    const $d90d8ce15e0e3233$export$1fde4a6e7df24a97 = 'project-pages';
    const $d90d8ce15e0e3233$export$69335bf8b709edc7 = 'project-settings-automation';
    const $d90d8ce15e0e3233$export$946b472f7559a889 = 'project-settings-components';
    const $d90d8ce15e0e3233$export$373fdf6888021ed0 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access`;
    const $d90d8ce15e0e3233$export$d6a5f13a3d30923c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-access-redirect`;
    const $d90d8ce15e0e3233$export$adfff93b0b015409 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-approvals`;
    const $d90d8ce15e0e3233$export$404de4ddea701cff = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps`;
    const $d90d8ce15e0e3233$export$596e1f6f6f4997b2 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-apps-fields`;
    const $d90d8ce15e0e3233$export$8da0e4cdbdd0cd0b = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-automation`;
    const $d90d8ce15e0e3233$export$d610a17dff3a01fa = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-data-classifications`;
    const $d90d8ce15e0e3233$export$284db5107f3db516 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-redirect`;
    const $d90d8ce15e0e3233$export$fbce46826eefc586 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-details`;
    const $d90d8ce15e0e3233$export$c86b29c76317ac6f = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-fields`;
    const $d90d8ce15e0e3233$export$3160b86e1b5dc391 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-forge-apps`;
    const $d90d8ce15e0e3233$export$690c0080c930fca = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes`;
    const $d90d8ce15e0e3233$export$171ba8c33c05c4ef = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-issuetypes-workflow`;
    const $d90d8ce15e0e3233$export$e2f2c23286c3255c = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications`;
    const $d90d8ce15e0e3233$export$5a262d40e10207a1 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$ab790cb87175797e = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$db780b39656c673a = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
    const $d90d8ce15e0e3233$export$a77cb4dafc511d3 = `${$d90d8ce15e0e3233$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $d90d8ce15e0e3233$export$253fd82874264ee4 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-forge-apps`;
    const $d90d8ce15e0e3233$export$eaf9ab4ec0c25813 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-forge`;
    const $d90d8ce15e0e3233$export$574bcdf6b73fcf1f = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-apps-fields`;
    const $d90d8ce15e0e3233$export$a14853dfff8da872 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-chat`;
    const $d90d8ce15e0e3233$export$ba8fd0e6db8d3e08 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-notifications`;
    const $d90d8ce15e0e3233$export$1c74da1e52e6d212 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-customer-permissions`;
    const $d90d8ce15e0e3233$export$d416059b17fe7d4e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-email`;
    const $d90d8ce15e0e3233$export$d5a3a037d2760bb7 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-widget`;
    const $d90d8ce15e0e3233$export$eb187d42a7448d45 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
    const $d90d8ce15e0e3233$export$688de32d31fc70f5 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-details`;
    const $d90d8ce15e0e3233$export$13d770f8814d480a = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-forge-apps`;
    const $d90d8ce15e0e3233$export$3a628f9376166ffb = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
    const $d90d8ce15e0e3233$export$649dafa225625f30 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$dbfe76dd37018b2 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications`;
    const $d90d8ce15e0e3233$export$20db7bb9d1bd8b38 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notifications-notification-email`;
    const $d90d8ce15e0e3233$export$a1fa8e6e125780ae = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-notification-email`;
    const $d90d8ce15e0e3233$export$fc6b949fd2bc782d = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-portal-settings`;
    const $d90d8ce15e0e3233$export$c940f866ac7760a0 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-types-config`;
    const $d90d8ce15e0e3233$export$184d4979f6f9fe7e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$959f50de166cc45e = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
    const $d90d8ce15e0e3233$export$b13b8c8bb4e30a75 = `${$d90d8ce15e0e3233$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
    const $d90d8ce15e0e3233$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
    const $d90d8ce15e0e3233$export$cc1af211e3feda50 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-apps-fields`;
    const $d90d8ce15e0e3233$export$3873539001f5aed7 = 'project-settings-software-automation';
    const $d90d8ce15e0e3233$export$89fcbafce559080b = 'project-settings-software-boards-card';
    const $d90d8ce15e0e3233$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
    const $d90d8ce15e0e3233$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
    const $d90d8ce15e0e3233$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
    const $d90d8ce15e0e3233$export$50680f54e95bb859 = 'project-settings-software-boards-features';
    const $d90d8ce15e0e3233$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
    const $d90d8ce15e0e3233$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
    const $d90d8ce15e0e3233$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
    const $d90d8ce15e0e3233$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
    const $d90d8ce15e0e3233$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
    const $d90d8ce15e0e3233$export$ba419378ad70624e = 'project-settings-software-data-classifications';
    const $d90d8ce15e0e3233$export$62f38c589a73d386 = 'project-settings-software-details';
    const $d90d8ce15e0e3233$export$77c8066c0822f152 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-fields`;
    const $d90d8ce15e0e3233$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
    const $d90d8ce15e0e3233$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
    const $d90d8ce15e0e3233$export$db7f5d93be70ee30 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications`;
    const $d90d8ce15e0e3233$export$432229516b7f82da = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-notifications-issue-logs`;
    const $d90d8ce15e0e3233$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
    const $d90d8ce15e0e3233$export$6b2b99b0055772a3 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-link-opsgenie`;
    const $d90d8ce15e0e3233$export$83c7a51057be6264 = `${$d90d8ce15e0e3233$export$86509a1baabd62ee}-toolchain-team-managed`;
    const $d90d8ce15e0e3233$export$46706d786aab3829 = 'project-settings-versions';
    const $d90d8ce15e0e3233$export$b690025ef7e3cf6c = 'project-versions';
    const $d90d8ce15e0e3233$export$ea48cc6bf1183d11 = 'rapidboard';
    const $d90d8ce15e0e3233$export$930e4881302bbd54 = 'rapidboard-backlog';
    const $d90d8ce15e0e3233$export$375801b708576466 = 'rapidboard-backlog-embed';
    const $d90d8ce15e0e3233$export$5b1e8463bd590143 = 'rapidboard-board';
    const $d90d8ce15e0e3233$export$1606662a398a24be = 'rapidboard-board-embed';
    const $d90d8ce15e0e3233$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
    const $d90d8ce15e0e3233$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
    const $d90d8ce15e0e3233$export$c46680afe70295f3 = 'rapidboard-report';
    const $d90d8ce15e0e3233$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
    const $d90d8ce15e0e3233$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
    const $d90d8ce15e0e3233$export$99e0abd8ba1de289 = 'rapidboard-user-board';
    const $d90d8ce15e0e3233$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
    const $d90d8ce15e0e3233$export$36e61e70347174cc = 'rovo-demand-tests';
    const $d90d8ce15e0e3233$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
    const $d90d8ce15e0e3233$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
    const $d90d8ce15e0e3233$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
    const $d90d8ce15e0e3233$export$8c8f03e75b6708ac = 'servicedesk-calendar';
    const $d90d8ce15e0e3233$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
    const $d90d8ce15e0e3233$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
    const $d90d8ce15e0e3233$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
    const $d90d8ce15e0e3233$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
    const $d90d8ce15e0e3233$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
    const $d90d8ce15e0e3233$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
    const $d90d8ce15e0e3233$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
    const $d90d8ce15e0e3233$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
    const $d90d8ce15e0e3233$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
    const $d90d8ce15e0e3233$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
    const $d90d8ce15e0e3233$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
    const $d90d8ce15e0e3233$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
    const $d90d8ce15e0e3233$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
    const $d90d8ce15e0e3233$export$37a9bdd8513f462d = 'servicedesk-connect-project';
    const $d90d8ce15e0e3233$export$f01162415f3a2ee3 = 'servicedesk-create-project';
    const $d90d8ce15e0e3233$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
    const $d90d8ce15e0e3233$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
    const $d90d8ce15e0e3233$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
    const $d90d8ce15e0e3233$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
    const $d90d8ce15e0e3233$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
    const $d90d8ce15e0e3233$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
    const $d90d8ce15e0e3233$export$829d1776460a6ad3 = 'servicedesk-incidents';
    const $d90d8ce15e0e3233$export$d30ab2da08d8b7b9 = 'servicedesk-index';
    const $d90d8ce15e0e3233$export$3c71889849aeaa08 = 'servicedesk-issue';
    const $d90d8ce15e0e3233$export$354bf2df81f6ffb0 = 'servicedesk-issues';
    const $d90d8ce15e0e3233$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
    const $d90d8ce15e0e3233$export$876055c0ede2f8df = 'servicedesk-automation';
    const $d90d8ce15e0e3233$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
    const $d90d8ce15e0e3233$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
    const $d90d8ce15e0e3233$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
    const $d90d8ce15e0e3233$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
    const $d90d8ce15e0e3233$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
    const $d90d8ce15e0e3233$export$8c800f176d079d28 = 'servicedesk-organization-details';
    const $d90d8ce15e0e3233$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
    const $d90d8ce15e0e3233$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
    const $d90d8ce15e0e3233$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
    const $d90d8ce15e0e3233$export$2b4737953287a354 = 'servicedesk-practice-issue';
    const $d90d8ce15e0e3233$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
    const $d90d8ce15e0e3233$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
    const $d90d8ce15e0e3233$export$2d961b0101f8733e = 'servicedesk-practice-new';
    const $d90d8ce15e0e3233$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
    const $d90d8ce15e0e3233$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
    const $d90d8ce15e0e3233$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
    const $d90d8ce15e0e3233$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
    const $d90d8ce15e0e3233$export$ccd12890649c59cc = 'servicedesk-queues-issue';
    const $d90d8ce15e0e3233$export$8c84064031188e80 = 'servicedesk-queues-landing';
    const $d90d8ce15e0e3233$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
    const $d90d8ce15e0e3233$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
    const $d90d8ce15e0e3233$export$156b2dfbd87d576f = 'servicedesk-redirect';
    const $d90d8ce15e0e3233$export$6961f1ed0407cb26 = 'servicedesk-reports';
    const $d90d8ce15e0e3233$export$ba284efd679bf637 = 'servicedesk-reports-custom';
    const $d90d8ce15e0e3233$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
    const $d90d8ce15e0e3233$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
    const $d90d8ce15e0e3233$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
    const $d90d8ce15e0e3233$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
    const $d90d8ce15e0e3233$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
    const $d90d8ce15e0e3233$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
    const $d90d8ce15e0e3233$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
    const $d90d8ce15e0e3233$export$be4b2ffade787316 = 'servicedesk-reports-summary';
    const $d90d8ce15e0e3233$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
    const $d90d8ce15e0e3233$export$29bc361328055683 = 'servicedesk-reports-workload';
    const $d90d8ce15e0e3233$export$a4a5a333fe874d97 = 'servicedesk-services';
    const $d90d8ce15e0e3233$export$2193b681ac1ae132 = 'servicedesk-services-new';
    const $d90d8ce15e0e3233$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
    const $d90d8ce15e0e3233$export$a4c4f7898d6b914a = 'servicedesk-service-details';
    const $d90d8ce15e0e3233$export$6cffae90b9277bb = 'servicedesk-service-details-new';
    const $d90d8ce15e0e3233$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
    const $d90d8ce15e0e3233$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
    const $d90d8ce15e0e3233$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
    const $d90d8ce15e0e3233$export$8e68c55c334de101 = 'servicedesk-sla-settings';
    const $d90d8ce15e0e3233$export$5cb7cfba189a0240 = 'service-hub-services';
    const $d90d8ce15e0e3233$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
    const $d90d8ce15e0e3233$export$1cf56e2d6c4edb35 = 'global-automation';
    const $d90d8ce15e0e3233$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
    const $d90d8ce15e0e3233$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
    const $d90d8ce15e0e3233$export$4db732436e4edfaf = 'recommendations';
    const $d90d8ce15e0e3233$export$e832418dbed0717e = 'view-custom-fields';
    const $d90d8ce15e0e3233$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
    const $d90d8ce15e0e3233$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
    const $d90d8ce15e0e3233$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
    const $d90d8ce15e0e3233$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
    const $d90d8ce15e0e3233$export$e74fe5bd41e23fbd = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies`;
    const $d90d8ce15e0e3233$export$1a93e63ddbe4aa06 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-dependencies-redirect`;
    const $d90d8ce15e0e3233$export$3b6dbbe49882589d = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-financial-year`;
    const $d90d8ce15e0e3233$export$eb01394789016fd4 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits`;
    const $d90d8ce15e0e3233$export$f17f4523583fa8e5 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-loading-limits-redirect`;
    const $d90d8ce15e0e3233$export$eaa4d6eec75a6778 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions`;
    const $d90d8ce15e0e3233$export$dcc96e4abbdc0d39 = `${$d90d8ce15e0e3233$export$3fd002e197e83a30}-permissions-redirect`;
    const $d90d8ce15e0e3233$export$9eaf39ba5a56c72a = 'software-backlog';
    const $d90d8ce15e0e3233$export$495be3320b67814a = 'software-backlog-embed';
    const $d90d8ce15e0e3233$export$25752eb5bb5e3d32 = 'software-boards';
    const $d90d8ce15e0e3233$export$f116716aedb35e10 = 'software-boards-embed';
    const $d90d8ce15e0e3233$export$36fffb6b49d9f31d = 'software-calendar';
    const $d90d8ce15e0e3233$export$a6d07be4ff318f84 = 'software-calendar-classic';
    const $d90d8ce15e0e3233$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
    const $d90d8ce15e0e3233$export$3a4c7a521a900b4d = 'software-calendar-embed';
    const $d90d8ce15e0e3233$export$9dcf51a9040a4fd6 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
    const $d90d8ce15e0e3233$export$a74f9f6bd0d4fb26 = `${$d90d8ce15e0e3233$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
    const $d90d8ce15e0e3233$export$f8cb86acf6b74661 = 'software-code';
    const $d90d8ce15e0e3233$export$2d3d850c64058bfb = 'software-code-classic';
    const $d90d8ce15e0e3233$export$af6b51164f66908b = 'software-deployments';
    const $d90d8ce15e0e3233$export$12efc96fc9c9fb34 = 'software-deployments-classic';
    const $d90d8ce15e0e3233$export$6ab1901e04e623ba = 'software-form';
    const $d90d8ce15e0e3233$export$bccc7d0812737c4e = 'software-form-classic';
    const $d90d8ce15e0e3233$export$458fb992f2637a20 = 'software-form-builder';
    const $d90d8ce15e0e3233$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
    const $d90d8ce15e0e3233$export$50264cbc90a39f19 = 'software-form-submit';
    const $d90d8ce15e0e3233$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
    const $d90d8ce15e0e3233$export$b8045610416fa8ca = 'software-goals';
    const $d90d8ce15e0e3233$export$8e80136ad13099e3 = 'software-goals-classic';
    const $d90d8ce15e0e3233$export$b5fe44c0bc324494 = 'software-incidents';
    const $d90d8ce15e0e3233$export$7a4f52d9060a20d2 = 'software-incidents-classic';
    const $d90d8ce15e0e3233$export$d6a9e4695952522e = 'software-issue-navigator';
    const $d90d8ce15e0e3233$export$deab88d0814c564b = 'software-list';
    const $d90d8ce15e0e3233$export$906faff110f898ef = 'software-list-classic';
    const $d90d8ce15e0e3233$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
    const $d90d8ce15e0e3233$export$4ed84a2011fdc400 = 'software-list-embed';
    const $d90d8ce15e0e3233$export$f7b286b39bf6051b = 'software-nextgen-redirect';
    const $d90d8ce15e0e3233$export$6c4337c0332c8c7f = 'software-onboarding';
    const $d90d8ce15e0e3233$export$e7c78887745b2326 = 'software-onboarding-get-started';
    const $d90d8ce15e0e3233$export$3805e4f07dca7584 = 'software-periscope';
    const $d90d8ce15e0e3233$export$f77254983320e888 = 'software-periscope-classic';
    const $d90d8ce15e0e3233$export$2e784832f1c6bb = 'software-plan-calendar';
    const $d90d8ce15e0e3233$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
    const $d90d8ce15e0e3233$export$9e53cdb1ac02195c = 'software-plan-dependencies';
    const $d90d8ce15e0e3233$export$58bd507904dc221c = 'software-plan-dependencies-embed';
    const $d90d8ce15e0e3233$export$7a821e22be2c2f14 = 'software-plan-increment';
    const $d90d8ce15e0e3233$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
    const $d90d8ce15e0e3233$export$e7423156dba31a7c = 'software-plan-increments';
    const $d90d8ce15e0e3233$export$cba7e383b2409c7b = 'software-plan-releases';
    const $d90d8ce15e0e3233$export$d5378fb71d5242c0 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-auto-scheduler`;
    const $d90d8ce15e0e3233$export$4b16b72c72da8833 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-custom-fields`;
    const $d90d8ce15e0e3233$export$10114d78cefb1f53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-exclusion-rules`;
    const $d90d8ce15e0e3233$export$92fe23ed30100817 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-find-your-issue`;
    const $d90d8ce15e0e3233$export$e824495554c83069 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-issue-sources`;
    const $d90d8ce15e0e3233$export$8df2e9efdd625a44 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-permissions`;
    const $d90d8ce15e0e3233$export$aeb4d3006e298033 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-plan-info`;
    const $d90d8ce15e0e3233$export$e15d3c40985c4b53 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-program-boards`;
    const $d90d8ce15e0e3233$export$1d8c84454fd2d571 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-removed-issues`;
    const $d90d8ce15e0e3233$export$db61a12efb59745c = `${$d90d8ce15e0e3233$export$6f266218a6973848}-saved-views`;
    const $d90d8ce15e0e3233$export$2da67fb5bd6bc2ee = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scenarios`;
    const $d90d8ce15e0e3233$export$182e0167fd960de6 = `${$d90d8ce15e0e3233$export$6f266218a6973848}-scheduling`;
    const $d90d8ce15e0e3233$export$2d9e2484ee02e7da = 'software-plan-summary';
    const $d90d8ce15e0e3233$export$b7fff19fd89b617f = 'software-plan-summary-embed';
    const $d90d8ce15e0e3233$export$ea23f150f64e8a4e = 'software-plan-teams';
    const $d90d8ce15e0e3233$export$116338bd93f78ad0 = 'software-plan-timeline';
    const $d90d8ce15e0e3233$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
    const $d90d8ce15e0e3233$export$d75d93e5d44182cc = 'software-release-notes';
    const $d90d8ce15e0e3233$export$cc3027ae3767801 = 'software-reports';
    const $d90d8ce15e0e3233$export$3492ce83b8884e0e = 'software-reports-burndown';
    const $d90d8ce15e0e3233$export$b4798b7e62733393 = 'software-reports-burnup';
    const $d90d8ce15e0e3233$export$388685c701d6e0d3 = 'software-reports-control';
    const $d90d8ce15e0e3233$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
    const $d90d8ce15e0e3233$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
    const $d90d8ce15e0e3233$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
    const $d90d8ce15e0e3233$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
    const $d90d8ce15e0e3233$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
    const $d90d8ce15e0e3233$export$ae0d999dd2bdd59b = 'software-reports-velocity';
    const $d90d8ce15e0e3233$export$43bbf6935a91d277 = 'software-requests';
    const $d90d8ce15e0e3233$export$92e23977438282b2 = 'software-requests-classic';
    const $d90d8ce15e0e3233$export$296115eb5b7129d3 = 'software-roadmap';
    const $d90d8ce15e0e3233$export$17574f41c3925d64 = 'software-roadmap-classic';
    const $d90d8ce15e0e3233$export$955692fbfe35fc16 = 'software-roadmap-redirect';
    const $d90d8ce15e0e3233$export$30af3a767b8ad2d8 = 'software-security';
    const $d90d8ce15e0e3233$export$f47d664298c2c2f0 = 'software-security-classic';
    const $d90d8ce15e0e3233$export$2d1ed852d9885250 = 'software-summary';
    const $d90d8ce15e0e3233$export$312796fc15876480 = 'software-summary-classic';
    const $d90d8ce15e0e3233$export$a16645495fb1d5ef = 'software-staffing';
    const $d90d8ce15e0e3233$export$1714b5ad9b672bc7 = 'software-timeline';
    const $d90d8ce15e0e3233$export$c9634bf15518a3a1 = 'software-timeline-classic';
    const $d90d8ce15e0e3233$export$3b5eb3ea8cbeeed = 'software-version-detail';
    const $d90d8ce15e0e3233$export$118bb1785acc3d0b = 'software-version-detail-embed';
    const $d90d8ce15e0e3233$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
    const $d90d8ce15e0e3233$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
    const $d90d8ce15e0e3233$export$831acb5098f5706d = 'system-configuration-general';
    const $d90d8ce15e0e3233$export$d218cda46c433fe1 = 'system-dashboard-edit';
    const $d90d8ce15e0e3233$export$61147168ac2833f9 = 'trashed-plan-direct-link';
    const $d90d8ce15e0e3233$export$9fe0117c0fd486a8 = 'trash-plans-directory';
    const $d90d8ce15e0e3233$export$a49474778d15635d = 'trash-projects-directory';
    const $d90d8ce15e0e3233$export$af3296e54e7fb362 = 'user-segmentation';
    const $d90d8ce15e0e3233$export$281f2e01ee9e4977 = 'your-work';
});
parcelRegister("3RJkv", function(module, exports) {
    $parcel$export(module.exports, "getModernIssueTransitionResources", ()=>$4f455891fb36bf50$export$e1afa08027b1e44b);
    $parcel$export(module.exports, "getNavigationResources", ()=>$4f455891fb36bf50$export$75cffd1aaecf4a2c);
    $parcel$export(module.exports, "getUserBoardNavigationResources", ()=>$4f455891fb36bf50$export$c57dc1ea7f76f91f);
    $parcel$export(module.exports, "getNavigationSidebarProjectResource", ()=>$4f455891fb36bf50$export$c4cf7264f95bae78);
    $parcel$export(module.exports, "getNavigationSidebarPlanResources", ()=>$4f455891fb36bf50$export$af2259a87f79645d);
    $parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", ()=>$4f455891fb36bf50$export$a103e99ad51f7bc3);
    $parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", ()=>$4f455891fb36bf50$export$808691f5a412afa3);
    var $5kYzp;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $8uKLe;
    var $7xTO3;
    var $c1N9v;
    var $6zFAI;
    var $loy04;
    var $ggg5j;
    var $iEUaw;
    var $2fwuR;
    var $3HwlS;
    var $h9iZl;
    var $2eyDn;
    var $drGWM;
    var $kMiZJ;
    var $bHhiy;
    var $aA974;
    var $f5nIZ;
    var $hZhhj;
    var $9MiT2;
    var $fNOVA;
    var $14XJw;
    var $kJQXA;
    var $atU1t;
    var $c34Wf;
    var $eOlBz;
    var $3X1Xr;
    var $dxCvy;
    var $kkNtb;
    var $7GnDe;
    var $2Ql51;
    var $9vlEn;
    var $gNStA;
    const $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
            'OFF',
            'BY_DEFAULT_USER_OPT_IN',
            'BY_DEFAULT_USER_OPT_OUT'
        ]);
    const $4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled = ()=>{
        const variation = $4f455891fb36bf50$var$getNewIssueTransitionExperienceInJiraLabsVariation();
        return variation !== 'OFF';
    };
    const $4f455891fb36bf50$var$conditionalGicOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('project.config.pce.modern.global-issue-create'), (0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
    const $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)($4f455891fb36bf50$var$isModernIssueTransitionSettingEnabled, (0, (0, parcelRequire("fNOVA")).issueTransitionOptInStatusResource));
    const $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('gic-smart-fields-jira-labs_8uwvr') || (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs'), (0, (0, parcelRequire("aA974")).gicSmartFieldsFeatureResource));
    const $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.moonjelly.browser-storage-controls-v2'), (0, (0, parcelRequire("2eyDn")).consentBannerUserPreferencesResource));
    const $4f455891fb36bf50$export$e1afa08027b1e44b = ()=>[
            $4f455891fb36bf50$var$conditionalIssueTransitionOptInStatusResource,
            (0, (0, parcelRequire("9MiT2")).issueTransitionChangeboardingPreferencesResource)
        ];
    const $4f455891fb36bf50$var$dedupableConditionalResources = [
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("kMiZJ")).consolidationUserStateResource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4Resource)),
        (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("2fwuR")).sidebarNav4UiStateResource))
    ];
    const $4f455891fb36bf50$export$75cffd1aaecf4a2c = ()=>[
            (0, (0, parcelRequire("c34Wf")).navigationUiStateResource),
            (0, (0, parcelRequire("h9iZl")).navigationPlansVisibilityResource),
            (0, (0, parcelRequire("9vlEn")).userHomepageResource),
            $4f455891fb36bf50$var$conditionalGicOptInStatusResource,
            (0, (0, parcelRequire("5kYzp")).announcementBannerSettingsV4Resource),
            $4f455891fb36bf50$var$conditionalConsentBannerUserPreferencesResource,
            ...$4f455891fb36bf50$var$dedupableConditionalResources,
            (0, (0, parcelRequire("14XJw")).organizationIdResource),
            (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
            ...$4f455891fb36bf50$export$e1afa08027b1e44b(),
            (0, (0, parcelRequire("3X1Xr")).persistentIssueCreateModalViewResource),
            $4f455891fb36bf50$var$conditionalGicSmartFieldsOptoutResource,
            (0, (0, parcelRequire("hZhhj")).incomingMailServerExpiryStatusResource),
            (0, (0, parcelRequire("kkNtb")).rovoEntitlementResource)
        ];
    const $4f455891fb36bf50$export$c57dc1ea7f76f91f = ()=>[
            (0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$c4cf7264f95bae78 = ()=>[
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
        ];
    const $4f455891fb36bf50$export$af2259a87f79645d = ()=>[
            (0, (0, parcelRequire("c1N9v")).staticPlanSidebarNavigationResource)
        ];
    const $4f455891fb36bf50$export$a103e99ad51f7bc3 = ()=>[
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
            (0, (0, parcelRequire("drGWM")).checkApiKeyManagementKeysResource)()
        ];
    const $4f455891fb36bf50$export$808691f5a412afa3 = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
});
parcelRegister("5kYzp", function(module, exports) {
    $parcel$export(module.exports, "announcementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$8fbe7f8de07afffd);
    $parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", ()=>$76a68e4d8702ab58$export$6fb72f4a0c177494);
    var $dIdda = parcelRequire("dIdda");
    var $4AdUG;
    var $2EmJy;
    var $9UEf0;
    const $76a68e4d8702ab58$export$2a421cd16fa9a95a = (0, $dIdda.createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("2EmJy")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$8fbe7f8de07afffd = (0, $dIdda.createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, (0, parcelRequire("4AdUG")).get)(),
                (0, (0, parcelRequire("9UEf0")).get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $76a68e4d8702ab58$export$43d4950a3e443fd3 = ()=>(0, $dIdda.useResource)($76a68e4d8702ab58$export$2a421cd16fa9a95a);
    const $76a68e4d8702ab58$export$6fb72f4a0c177494 = ()=>(0, $dIdda.useResource)($76a68e4d8702ab58$export$8fbe7f8de07afffd);
});
parcelRegister("4AdUG", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$90a9ae99ea774144$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$90a9ae99ea774144$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $90a9ae99ea774144$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/4/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                content: '',
                bgColor: 'grey',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Get',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
    const $90a9ae99ea774144$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/4/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'settingsV4Set',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
});
parcelRegister("2EmJy", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$02ac2f2e29fd92e6$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$02ac2f2e29fd92e6$export$adaa4cf7ef1b65be);
    var $jcw0u;
    var $eusud;
    const $02ac2f2e29fd92e6$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/3/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                message: '',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $02ac2f2e29fd92e6$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/3/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'settingsSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
const $981adbf91eeefd26$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $981adbf91eeefd26$export$5e0c0e8c940630f8 = 'private';
const $981adbf91eeefd26$export$1d5a5b6462188eb3 = 'public';
parcelRegister("9UEf0", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$0fff4d2d98ff5692$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$0fff4d2d98ff5692$export$adaa4cf7ef1b65be);
    var $89SaW;
    var $jcw0u;
    const $0fff4d2d98ff5692$var$key = 'announcementBannerDismissedLast';
    const $0fff4d2d98ff5692$export$3988ae62b71be9a3 = async (accoundId)=>{
        try {
            return accoundId != null ? (await (0, (0, parcelRequire("89SaW")).getUserProperty)(accoundId, $0fff4d2d98ff5692$var$key)).hashId : null;
        } catch (error) {
            if (error.statusCode === 404) return null;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissGet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $0fff4d2d98ff5692$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
        try {
            return await (0, (0, parcelRequire("89SaW")).setUserProperties)(accoundId, $0fff4d2d98ff5692$var$key, JSON.stringify({
                hashId: hashId
            }));
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'userDismissSet',
                packageName: (0, $981adbf91eeefd26$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
parcelRegister("89SaW", function(module, exports) {
    $parcel$export(module.exports, "getUserPropertiesUrl", ()=>$646571db30c23ce6$export$f474e53c8191800a);
    $parcel$export(module.exports, "setUserProperties", ()=>$646571db30c23ce6$export$d0e176862bf869b8);
    $parcel$export(module.exports, "getUserProperty", ()=>$646571db30c23ce6$export$b3126db2ef6e34ed);
    var $gHS8W;
    var $jJZqs;
    const $646571db30c23ce6$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
    const $646571db30c23ce6$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), {
            ...(0, (0, parcelRequire("gHS8W")).default),
            method: 'PUT',
            body: data
        });
    const $646571db30c23ce6$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($646571db30c23ce6$export$f474e53c8191800a(accountId, propertyKey), (0, (0, parcelRequire("gHS8W")).default)).then((res)=>{
            if (res.status === 200) return res.json();
            return res.text().then((errResp)=>{
                throw new (0, (0, parcelRequire("jJZqs")).default)(res.status, errResp);
            });
        }).then((data)=>data.value);
});
parcelRegister("gHS8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33c6318209de3901$export$2e2bcd8739ae039);
    const $33c6318209de3901$var$defaultOptions = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    var $33c6318209de3901$export$2e2bcd8739ae039 = $33c6318209de3901$var$defaultOptions;
});
parcelRegister("5bkvv", function(module, exports) {
    $parcel$export(module.exports, "forgeAdminModuleV1Resource", ()=>$3d515a0fe8e87c81$export$168ac1f97221e90b);
    $parcel$export(module.exports, "forgeAdminModuleV2Resource", ()=>$3d515a0fe8e87c81$export$536a08360f048bac);
    $parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", ()=>$3d515a0fe8e87c81$export$dcc98f4b36ce9223);
    $parcel$export(module.exports, "forgeProjectModuleV1Resource", ()=>$3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    $parcel$export(module.exports, "forgeProjectModuleV2Resource", ()=>$3d515a0fe8e87c81$export$1a17680eb0746291);
    $parcel$export(module.exports, "forgeProjectModuleResource", ()=>$3d515a0fe8e87c81$export$72db683c2914a65e);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", ()=>$3d515a0fe8e87c81$export$fa67d109c2a45864);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", ()=>$3d515a0fe8e87c81$export$23c2bb87c561c9db);
    $parcel$export(module.exports, "forgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$7a928d209faf75f);
    $parcel$export(module.exports, "useForgeProjectSettingsModuleResource", ()=>$3d515a0fe8e87c81$export$e81e11bbc3239153);
    $parcel$export(module.exports, "forgeGlobalModuleV1Resource", ()=>$3d515a0fe8e87c81$export$60e774d0427b56fc);
    $parcel$export(module.exports, "forgeGlobalModuleV2Resource", ()=>$3d515a0fe8e87c81$export$75f594fe5ce76af);
    $parcel$export(module.exports, "getNavigationForgeGlobalPageResources", ()=>$3d515a0fe8e87c81$export$80b2f91dabb3dd65);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", ()=>$3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", ()=>$3d515a0fe8e87c81$export$d2d6bc2f3bd0f942);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", ()=>$3d515a0fe8e87c81$export$ebf5369e4dcfad00);
    $parcel$export(module.exports, "forgeCustomFieldTypeResource", ()=>$3d515a0fe8e87c81$export$e6be2f0ca0849869);
    var $8O7FC;
    var $4R6GH;
    var $k2DRb;
    var $iVaKa;
    var $5vSAE;
    var $dK8AG;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    var $47m5i;
    var $1yLrr;
    const $3d515a0fe8e87c81$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
        const isModuleWithAccessNarrowing = [
            (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(moduleName);
        const projectIdOrKey = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(params);
        if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
            projectIdOrKey: projectIdOrKey
        };
        return null;
    };
    const $3d515a0fe8e87c81$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            const { match: params } = route;
            const dataClassification = $3d515a0fe8e87c81$export$eb46cc3d7c1a6649(params, moduleName);
            const contextIds = typeof createContextIds === 'function' && createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }) || undefined;
            return (0, (0, parcelRequire("47m5i")).fetchForgeModule)({
                cloudId: cloudId,
                moduleName: moduleName,
                dataClassification: dataClassification,
                shouldReturnANExtensions: shouldReturnANExtensions,
                contextIds: contextIds,
                locale: locale
            });
        };
    const $3d515a0fe8e87c81$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
    const $3d515a0fe8e87c81$export$168ac1f97221e90b = (0, $dIdda.createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$536a08360f048bac = (0, $dIdda.createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).adminPageFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeAdminModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$536a08360f048bac, $3d515a0fe8e87c81$export$168ac1f97221e90b);
    const $3d515a0fe8e87c81$export$dcc98f4b36ce9223 = ()=>[
            $3d515a0fe8e87c81$var$forgeAdminModuleResource
        ];
    const $3d515a0fe8e87c81$export$ad95e2d07d6fa1a = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$1a17680eb0746291 = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$72db683c2914a65e = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$1a17680eb0746291, $3d515a0fe8e87c81$export$ad95e2d07d6fa1a);
    const $3d515a0fe8e87c81$export$fa67d109c2a45864 = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$23c2bb87c561c9db = (0, $dIdda.createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$7a928d209faf75f = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$23c2bb87c561c9db, $3d515a0fe8e87c81$export$fa67d109c2a45864);
    const $3d515a0fe8e87c81$export$e81e11bbc3239153 = ()=>(0, $dIdda.useResource)($3d515a0fe8e87c81$export$7a928d209faf75f);
    const $3d515a0fe8e87c81$export$60e774d0427b56fc = (0, $dIdda.createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE), false, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$75f594fe5ce76af = (0, $dIdda.createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE)
                ],
                context: {},
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$var$forgeGlobalModuleResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$75f594fe5ce76af, $3d515a0fe8e87c81$export$60e774d0427b56fc);
    const $3d515a0fe8e87c81$export$80b2f91dabb3dd65 = ()=>[
            $3d515a0fe8e87c81$var$forgeGlobalModuleResource
        ];
    const $3d515a0fe8e87c81$export$b555dc3ff28ae9cc = (0, $dIdda.createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $3d515a0fe8e87c81$var$createDataGetter((0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE), true, $3d515a0fe8e87c81$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942 = (0, $dIdda.createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$3d515a0fe8e87c81$var$normalizeModules(modules[0, (0, parcelRequire("k2DRb")).SERVICEDESK_QUEUE_PAGE_MODULE], (0, (0, parcelRequire("1yLrr")).uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $3d515a0fe8e87c81$export$ebf5369e4dcfad00 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $3d515a0fe8e87c81$export$d2d6bc2f3bd0f942, $3d515a0fe8e87c81$export$b555dc3ff28ae9cc);
    const $3d515a0fe8e87c81$export$e6be2f0ca0849869 = (0, $dIdda.createResource)({
        type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
        getKey: ()=>'extensions',
        getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, (0, parcelRequire("5vSAE")).fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION)
            }).then((modules)=>modules[0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE]) : (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_NAVIGATION), $3d515a0fe8e87c81$var$createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }), locale).then((modules)=>modules.extensions.jiraCustomFieldType),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    function $3d515a0fe8e87c81$var$normalizeModules(modules, filter) {
        return filter(modules).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title));
    }
});
parcelRegister("8O7FC", function(module, exports) {
    $parcel$export(module.exports, "alphabeticalSort", ()=>$7c4745a46edf6307$export$89a1f01f2a7cb2a1);
    var $dJl1T;
    const $7c4745a46edf6307$export$89a1f01f2a7cb2a1 = (a, b)=>{
        if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
            numeric: true,
            caseFirst: 'upper'
        });
        const typeOfA = a === null ? 'null' : typeof a;
        const typeOfB = b === null ? 'null' : typeof b;
        const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
        return 1;
    };
});
parcelRegister("k2DRb", function(module, exports) {
    $parcel$export(module.exports, "STAGING_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$71acbd662c478c42);
    $parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", ()=>$e80aa4d4aac5b0dc$export$978072fd3fd149);
    $parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", ()=>$e80aa4d4aac5b0dc$export$ebc15d9cebfd6063);
    $parcel$export(module.exports, "ISSUE_ACTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$fcc4a18f46f80f16);
    $parcel$export(module.exports, "ISSUE_GLANCE_MODULE", ()=>$e80aa4d4aac5b0dc$export$259bab989b0129d0);
    $parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", ()=>$e80aa4d4aac5b0dc$export$75f224942f595e13);
    $parcel$export(module.exports, "ISSUE_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$ba0968f9752844);
    $parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", ()=>$e80aa4d4aac5b0dc$export$cc20a5638825fbb0);
    $parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$9069d4b945c3d532);
    $parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", ()=>$e80aa4d4aac5b0dc$export$811b7f067a43b422);
    $parcel$export(module.exports, "CUSTOM_FIELD_MODULE", ()=>$e80aa4d4aac5b0dc$export$e3887d6bafe8a17);
    $parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$7b7866c04a2ad947);
    $parcel$export(module.exports, "ADMIN_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$52e4945e96bd2aa0);
    $parcel$export(module.exports, "PROJECT_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$151b03356f566603);
    $parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$ea0d6ac082b0d636);
    $parcel$export(module.exports, "GLOBAL_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$31ac745ab2add7cc);
    $parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", ()=>$e80aa4d4aac5b0dc$export$353acf28daa75c79);
    $parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", ()=>$e80aa4d4aac5b0dc$export$25627f012b21b0b9);
    $parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", ()=>$e80aa4d4aac5b0dc$export$42d6a8740fd42e58);
    $parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", ()=>$e80aa4d4aac5b0dc$export$a7186e5a73395db4);
    $parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", ()=>$e80aa4d4aac5b0dc$export$8fbcfe84dc845d17);
    $parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", ()=>$e80aa4d4aac5b0dc$export$8af4cb794979f60d);
    $parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", ()=>$e80aa4d4aac5b0dc$export$5592ab836d562168);
    $parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", ()=>$e80aa4d4aac5b0dc$export$842eb4236828ac9);
    $parcel$export(module.exports, "SUPPORTED_MODULES", ()=>$e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7);
    $parcel$export(module.exports, "ENTRY_POINT_EDIT", ()=>$e80aa4d4aac5b0dc$export$2b8aeda236486576);
    $parcel$export(module.exports, "ENTRY_POINT_VIEW", ()=>$e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d);
    $parcel$export(module.exports, "ENTRY_POINT_CREATE", ()=>$e80aa4d4aac5b0dc$export$b37d58c3ed77c139);
    $parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", ()=>$e80aa4d4aac5b0dc$export$ab94dbd1d02ac251);
    $parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", ()=>$e80aa4d4aac5b0dc$export$b6a67a3131c6c48d);
    $parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", ()=>$e80aa4d4aac5b0dc$export$b75dc2bfd20898fe);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", ()=>$e80aa4d4aac5b0dc$export$8e96118a698216cb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", ()=>$e80aa4d4aac5b0dc$export$9b72a8e9b92658fb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", ()=>$e80aa4d4aac5b0dc$export$2d6539e7d0553ae7);
    $parcel$export(module.exports, "SOURCE_UNKNOWN", ()=>$e80aa4d4aac5b0dc$export$ecbd7135d66cb322);
    $parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", ()=>$e80aa4d4aac5b0dc$export$61d882aa7aba51c);
    $parcel$export(module.exports, "SOURCE_ISSUE_VIEW", ()=>$e80aa4d4aac5b0dc$export$46cb92762d68a048);
    $parcel$export(module.exports, "SOURCE_NAVIGATION", ()=>$e80aa4d4aac5b0dc$export$fe90e46aea58e30b);
    $parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", ()=>$e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a);
    $parcel$export(module.exports, "SOURCE_ROUTER", ()=>$e80aa4d4aac5b0dc$export$eae46a3c13473a8d);
    $parcel$export(module.exports, "SOURCE_LEGACY", ()=>$e80aa4d4aac5b0dc$export$ac11ee191d09688f);
    $parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", ()=>$e80aa4d4aac5b0dc$export$4346e4e240c84319);
    $parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", ()=>$e80aa4d4aac5b0dc$export$d719bb340dc354e4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", ()=>$e80aa4d4aac5b0dc$export$4b6228758e800433);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", ()=>$e80aa4d4aac5b0dc$export$70495c8cc141a7a4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", ()=>$e80aa4d4aac5b0dc$export$bc3d408418fdf9d2);
    $parcel$export(module.exports, "getEmptyExtensionsObject", ()=>$e80aa4d4aac5b0dc$export$218a328f66b86f7d);
    $parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$3193d714ab54ee26);
    $parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$df7774a415710cce);
    $parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$e80aa4d4aac5b0dc$export$51ab2784839ce348);
    const $e80aa4d4aac5b0dc$export$9af0088c49bdedb = 'PRODUCTION';
    const $e80aa4d4aac5b0dc$export$71acbd662c478c42 = 'STAGING';
    const $e80aa4d4aac5b0dc$export$978072fd3fd149 = 'DEVELOPMENT';
    const $e80aa4d4aac5b0dc$export$ebc15d9cebfd6063 = 'default';
    const $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16 = 'jira:issueAction';
    const $e80aa4d4aac5b0dc$export$259bab989b0129d0 = 'jira:issueGlance';
    const $e80aa4d4aac5b0dc$export$75f224942f595e13 = 'jira:issueContext';
    const $e80aa4d4aac5b0dc$export$ba0968f9752844 = 'jira:issuePanel';
    const $e80aa4d4aac5b0dc$export$cc20a5638825fbb0 = 'jira:issueActivity';
    const $e80aa4d4aac5b0dc$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
    const $e80aa4d4aac5b0dc$export$811b7f067a43b422 = 'jira:uiModifications';
    const $e80aa4d4aac5b0dc$export$e3887d6bafe8a17 = 'jira:customField';
    const $e80aa4d4aac5b0dc$export$7b7866c04a2ad947 = 'jira:customFieldType';
    const $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0 = 'jira:adminPage';
    const $e80aa4d4aac5b0dc$export$151b03356f566603 = 'jira:projectPage';
    const $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
    const $e80aa4d4aac5b0dc$export$31ac745ab2add7cc = 'jira:globalPage';
    const $e80aa4d4aac5b0dc$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
    const $e80aa4d4aac5b0dc$export$25627f012b21b0b9 = 'jira:dashboardGadget';
    const $e80aa4d4aac5b0dc$export$42d6a8740fd42e58 = 'jira:workflowValidator';
    const $e80aa4d4aac5b0dc$export$a7186e5a73395db4 = 'jira:workflowCondition';
    const $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
    const $e80aa4d4aac5b0dc$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
    const $e80aa4d4aac5b0dc$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
    const $e80aa4d4aac5b0dc$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
    const $e80aa4d4aac5b0dc$export$9b1a91242ce2a1b7 = [
        $e80aa4d4aac5b0dc$export$fcc4a18f46f80f16,
        $e80aa4d4aac5b0dc$export$259bab989b0129d0,
        $e80aa4d4aac5b0dc$export$75f224942f595e13,
        $e80aa4d4aac5b0dc$export$ba0968f9752844,
        $e80aa4d4aac5b0dc$export$cc20a5638825fbb0,
        $e80aa4d4aac5b0dc$export$9069d4b945c3d532,
        $e80aa4d4aac5b0dc$export$811b7f067a43b422,
        $e80aa4d4aac5b0dc$export$e3887d6bafe8a17,
        $e80aa4d4aac5b0dc$export$7b7866c04a2ad947,
        $e80aa4d4aac5b0dc$export$52e4945e96bd2aa0,
        $e80aa4d4aac5b0dc$export$151b03356f566603,
        $e80aa4d4aac5b0dc$export$ea0d6ac082b0d636,
        $e80aa4d4aac5b0dc$export$31ac745ab2add7cc,
        $e80aa4d4aac5b0dc$export$353acf28daa75c79,
        $e80aa4d4aac5b0dc$export$25627f012b21b0b9,
        $e80aa4d4aac5b0dc$export$8af4cb794979f60d,
        $e80aa4d4aac5b0dc$export$5592ab836d562168,
        $e80aa4d4aac5b0dc$export$842eb4236828ac9,
        $e80aa4d4aac5b0dc$export$42d6a8740fd42e58,
        $e80aa4d4aac5b0dc$export$a7186e5a73395db4,
        $e80aa4d4aac5b0dc$export$8fbcfe84dc845d17
    ];
    const $e80aa4d4aac5b0dc$export$2b8aeda236486576 = 'edit';
    const $e80aa4d4aac5b0dc$export$c41ce1ec1ea6e73d = 'view';
    const $e80aa4d4aac5b0dc$export$b37d58c3ed77c139 = 'create';
    const $e80aa4d4aac5b0dc$export$ab94dbd1d02ac251 = 'contextConfig';
    const $e80aa4d4aac5b0dc$export$b6a67a3131c6c48d = 'none';
    const $e80aa4d4aac5b0dc$export$b75dc2bfd20898fe = 5;
    const $e80aa4d4aac5b0dc$export$8e96118a698216cb = 'native';
    const $e80aa4d4aac5b0dc$export$9b72a8e9b92658fb = 'basic';
    const $e80aa4d4aac5b0dc$export$2d6539e7d0553ae7 = 'blank';
    const $e80aa4d4aac5b0dc$export$ecbd7135d66cb322 = 'unknownSource';
    const $e80aa4d4aac5b0dc$export$61d882aa7aba51c = 'global-issue-create';
    const $e80aa4d4aac5b0dc$export$46cb92762d68a048 = 'issue-view';
    const $e80aa4d4aac5b0dc$export$fe90e46aea58e30b = 'navigation';
    const $e80aa4d4aac5b0dc$export$c5ccbdb9893f2a6a = 'full-page-app';
    const $e80aa4d4aac5b0dc$export$eae46a3c13473a8d = 'router';
    const $e80aa4d4aac5b0dc$export$ac11ee191d09688f = 'legacy';
    const $e80aa4d4aac5b0dc$export$6d00582aa947900f = 'workflow-list';
    const $e80aa4d4aac5b0dc$export$4346e4e240c84319 = 'organization-panel';
    const $e80aa4d4aac5b0dc$export$d719bb340dc354e4 = 'assets-import-type';
    const $e80aa4d4aac5b0dc$export$bf75cf7720bd8fde = 'transition-view';
    const $e80aa4d4aac5b0dc$export$4b6228758e800433 = 'jira';
    const $e80aa4d4aac5b0dc$export$70495c8cc141a7a4 = 'jsm';
    const $e80aa4d4aac5b0dc$export$bc3d408418fdf9d2 = 'cmdb';
    const $e80aa4d4aac5b0dc$export$a48dade1864725a = {
        jiraIssueAction: [],
        jiraIssueContext: [],
        jiraIssueGlance: [],
        jiraIssuePanel: [],
        jiraIssueActivity: [],
        jiraIssueViewBackgroundScript: [],
        jiraCustomField: [],
        jiraCustomFieldType: [],
        jiraUiModifications: [],
        jiraAdminPage: [],
        jiraGlobalPage: [],
        jiraProjectPage: [],
        jiraProjectSettingsPage: [],
        jiraDashboardBackgroundScript: [],
        jiraDashboardGadget: [],
        jiraServiceManagementQueuePage: [],
        jiraServiceManagementOrganizationPanel: [],
        jiraServiceManagementAssetsImportType: [],
        jiraWorkflowValidator: [],
        jiraWorkflowCondition: [],
        jiraWorkflowPostFunction: []
    };
    const $e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
        ...$e80aa4d4aac5b0dc$export$a48dade1864725a
    };
    const $e80aa4d4aac5b0dc$export$218a328f66b86f7d = ()=>({
            ...$e80aa4d4aac5b0dc$var$STABLE_EMPTY_EXTENSIONS_OBJECT
        });
    const $e80aa4d4aac5b0dc$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
    const $e80aa4d4aac5b0dc$export$df7774a415710cce = 'com.atlassian.forge:';
    const $e80aa4d4aac5b0dc$export$51ab2784839ce348 = `${$e80aa4d4aac5b0dc$export$df7774a415710cce}${$e80aa4d4aac5b0dc$export$3193d714ab54ee26}`;
});
parcelRegister("iVaKa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b1a9656c7bb4ee4$export$2e2bcd8739ae039);
    var $e4eHl = parcelRequire("e4eHl");
    var $fn8B5 = parcelRequire("fn8B5");
    var $cuHs1 = parcelRequire("cuHs1");
    var $1UikQ = parcelRequire("1UikQ");
    var $4R6GH;
    var $eusud;
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $d5W4H;
    var $1MlDe;
    var $lG6pQ;
    var $ioGTN;
    var $dnsCJ;
    var $eIGUr;
    const $1b1a9656c7bb4ee4$var$moduleToVariableKey = (module)=>(0, ($parcel$interopDefault($e4eHl)))(module);
    const $1b1a9656c7bb4ee4$export$3361e9be8093ddcc = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key));
        return (0, ($parcel$interopDefault($1UikQ)))(groupedExtensionsWithMappedKeys, (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
    };
    const $1b1a9656c7bb4ee4$export$44097e02a91cd11a = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($1UikQ)))((0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$1b1a9656c7bb4ee4$var$moduleToVariableKey(key)), (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
        const filteredOutDuplicatedExtensions = (0, (0, parcelRequire("1MlDe")).filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
        const allowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        const accessNarrowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
            const allowedExtensionsMap = new Map();
            const accessNarrowedExtensionsMap = new Map();
            module.forEach((moduleItem)=>{
                if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
                else allowedExtensionsMap.set(moduleItem.id, moduleItem);
            });
            allowedExtensions[key] = [
                ...allowedExtensionsMap.values()
            ];
            accessNarrowedExtensions[key] = [
                ...accessNarrowedExtensionsMap.values()
            ];
        });
        return {
            extensions: allowedExtensions,
            accessNarrowedExtensions: accessNarrowedExtensions
        };
    };
    const $1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
    const $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
        if (modules.length === 0) throw new Error('No modules to fetch provided');
        const dataClassificationTags = await (0, (0, parcelRequire("lG6pQ")).getDataClassification)(dataClassification, source);
        const includeConfig = extras?.include || {};
        const query = (0, (0, parcelRequire("eIGUr")).buildForgeQuery)(includeConfig);
        const variables = {
            contextIds: contextIds || [
                `ari:cloud:jira::site/${cloudId}`
            ],
            extensionsFilter: [
                {
                    type: 'EXTENSION_TYPE',
                    value: modules
                }
            ],
            dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
            locale: (0, (0, parcelRequire("4R6GH")).fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
        };
        const { data: data, errors: errors, extensions: extensions } = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: variables
                }),
                method: 'POST'
            }));
        const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromExtensions)({
            extensions: extensions
        });
        if (errors) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
        if (!data) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No data returned', traceId, errors);
        if (data.extensionContexts.length < 1) throw new (0, (0, parcelRequire("ioGTN")).ForgeFetchError)('No extensionContext returned', traceId, errors);
        return {
            data: data,
            traceId: traceId
        };
    };
    var $1b1a9656c7bb4ee4$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN), contextIds, locale)=>{
        try {
            if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModules)()) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            const { data: data, traceId: traceId } = await $1b1a9656c7bb4ee4$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source, {
                traceId: traceId
            });
            return $1b1a9656c7bb4ee4$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            const traceId = (0, (0, parcelRequire("dnsCJ")).getTraceIdFromError)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error,
                traceId: traceId
            });
            if ($1b1a9656c7bb4ee4$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
                extensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)()
            };
            throw error;
        }
    };
});
parcelRegister("bPtOr", function(module, exports) {
    $parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", ()=>$e4bddb38a31390d9$export$23de3198bfe70090);
    $parcel$export(module.exports, "FAILED_TO_FETCH", ()=>$e4bddb38a31390d9$export$f52aa41ccd776f01);
    $parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", ()=>$e4bddb38a31390d9$export$31d2ab0be67934f0);
    $parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", ()=>$e4bddb38a31390d9$export$89a175d4190df42e);
    $parcel$export(module.exports, "userConsentErrorRegex", ()=>$e4bddb38a31390d9$export$dddade71b333c01d);
    $parcel$export(module.exports, "getErrorType", ()=>$e4bddb38a31390d9$export$e19f9f08a6d79fd2);
    var $fZneA;
    var $bCf8q;
    const $e4bddb38a31390d9$var$commonErrors = {
        MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
        OPERATION_ABORTED: 'The operation was aborted. ',
        CANCELLED: 'cancelled',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        TIMEOUT: 'The request timed out.',
        AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
        GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
        GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
    };
    const $e4bddb38a31390d9$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
    const $e4bddb38a31390d9$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
    const $e4bddb38a31390d9$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
    const $e4bddb38a31390d9$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
    const $e4bddb38a31390d9$export$89a175d4190df42e = 'Invoke value functions failed:';
    const $e4bddb38a31390d9$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
    const $e4bddb38a31390d9$export$8a5d666d6e5b82fc = (error)=>{
        if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
        const KNOWN_NETWORK_ERRORS = [
            'Failed to fetch dynamically imported module',
            'error loading dynamically imported module',
            'Importing a module script failed'
        ];
        const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
        return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
    };
    const $e4bddb38a31390d9$export$e19f9f08a6d79fd2 = (_error)=>{
        if (_error == null) return 'NULL_OR_UNDEFINED';
        const error = _error;
        const message = String(error instanceof Error ? error.message : error).trim();
        const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
        if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
        const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
        if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
        const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
        const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
        if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $e4bddb38a31390d9$export$7a1bd8c001e7e9c;
        const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
        if (serverErrorRegex.test(message)) {
            const match = message.match(serverErrorRegex);
            const statusCode = match ? match[1] : 'NO_STATUS_CODE';
            return `ERROR_SERVER_RESPONSE_${statusCode}`;
        }
        const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
        if (aggGiraServerErrorRegex.test(message)) {
            const match = message.match(aggGiraServerErrorRegex);
            const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
            return `AGG_GIRA_ERROR_${statusCode}`;
        }
        const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
        const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
        if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $e4bddb38a31390d9$export$23de3198bfe70090;
        if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
        const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
        if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
        if ($e4bddb38a31390d9$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
        const appValueFunction = new RegExp("The app's value function failed", 'i');
        const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
        const invokeValueFunctionFailed = new RegExp($e4bddb38a31390d9$export$89a175d4190df42e, 'i');
        const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977);
        const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $3cd8a0ece36fbae5$export$fa405bbf47d510e2);
        if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
        const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
        if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
        const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
        if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
        if ($e4bddb38a31390d9$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
        if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
        if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
        if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
        const entry = Object.entries($e4bddb38a31390d9$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        if (entry) return entry[0];
        if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return $e4bddb38a31390d9$export$f52aa41ccd776f01;
        return 'OTHER';
    };
});
parcelRegister("dYScp", function(module, exports) {
    $parcel$export(module.exports, "measureExecutionTimeMetrics", ()=>$d79aabebae5ffeb3$export$a859f6866f4653e0);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $hBuqR;
    var $8kVg1;
    const $d79aabebae5ffeb3$export$a859f6866f4653e0 = async (action)=>{
        const concurrentId = (0, ($parcel$interopDefault($7Jxgt)))();
        const shouldSendTimeMetric = Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE);
        if ((0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentFetchTime)(concurrentId).cancel();
            throw error;
        }
        else try {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, (0, parcelRequire("8kVg1")).forgeModulesFetchTime).cancel();
            throw error;
        }
    };
});
parcelRegister("hBuqR", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME_GASV3", ()=>$bbc089ab376d4a7b$export$f892f621fb508154);
    $parcel$export(module.exports, "MODULE_TYPE_TRIGGER", ()=>$bbc089ab376d4a7b$export$ed63b053e04e26df);
    $parcel$export(module.exports, "MODULE_TYPE_EXTENSION", ()=>$bbc089ab376d4a7b$export$725bacc669333eef);
    $parcel$export(module.exports, "FORGE_SAMPLING_RATE", ()=>$bbc089ab376d4a7b$export$d920cee73ec094d0);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$bbc089ab376d4a7b$export$f048d91ccaf92408);
    $parcel$export(module.exports, "UI_ACTIONS", ()=>$bbc089ab376d4a7b$export$2b7367f125154866);
    $parcel$export(module.exports, "OPERATIONAL_ACTIONS", ()=>$bbc089ab376d4a7b$export$42bcca5cae2ce90b);
    $parcel$export(module.exports, "TRACK_ACTIONS", ()=>$bbc089ab376d4a7b$export$2af0438304d7c4b2);
    const $bbc089ab376d4a7b$export$f892f621fb508154 = 'jiraForgeUi';
    const $bbc089ab376d4a7b$export$273f5980517336e2 = 'jiraforgeui';
    const $bbc089ab376d4a7b$export$ed63b053e04e26df = 'trigger';
    const $bbc089ab376d4a7b$export$725bacc669333eef = 'extension';
    const $bbc089ab376d4a7b$export$d920cee73ec094d0 = 10;
    const $bbc089ab376d4a7b$export$f048d91ccaf92408 = {
        FORGE_MODULES: {
            FETCH_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.fetch-time`,
            LOAD_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.forge-modules.load-time`
        },
        REAL_TIME_ISSUE_EVENTS: {
            INVOKE_TIME: `${$bbc089ab376d4a7b$export$273f5980517336e2}.real-time-issue-events.invoke-time`
        },
        MARKS: {
            TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
            TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
        }
    };
    const $bbc089ab376d4a7b$export$2b7367f125154866 = {
        CLICKED: 'clicked',
        SELECTED: 'selected',
        CANCELED: 'canceled',
        ACTION_CLICKED: 'action clicked',
        COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
        REMOVE_CLICKED: 'remove clicked'
    };
    const $bbc089ab376d4a7b$export$42bcca5cae2ce90b = {
        FAILED: 'failed',
        INITIALIZED: 'initialized',
        EDIT_FAILED: 'edit failed',
        ACTION_FAILED: 'action failed',
        SAVE_FAILED: 'save failed',
        REMOVE_FAILED: 'remove failed',
        UPDATE_FAILED: 'update failed'
    };
    const $bbc089ab376d4a7b$export$2af0438304d7c4b2 = {
        EDITED: 'edited',
        SAVED: 'saved',
        REMOVED: 'removed',
        ACTION_SUCCEED: 'action succeed',
        UPDATE_SUCCEED: 'update succeed'
    };
});
parcelRegister("8kVg1", function(module, exports) {
    $parcel$export(module.exports, "forgeModulesFetchTime", ()=>$f1fed22795d0c676$export$cd129f3639657eae);
    $parcel$export(module.exports, "forgeModulesConcurrentFetchTime", ()=>$f1fed22795d0c676$export$c3d8833fbea3e976);
    $parcel$export(module.exports, "forgeModulesConcurrentLoadTime", ()=>$f1fed22795d0c676$export$292f3b557281044f);
    $parcel$export(module.exports, "realTimeIssueEventInvokeTime", ()=>$f1fed22795d0c676$export$89ace7e2bb7d7685);
    $parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", ()=>$f1fed22795d0c676$export$94f65f3b2556df23);
    $parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", ()=>$f1fed22795d0c676$export$116d5e25caf0018d);
    $parcel$export(module.exports, "customFieldPageSegmentLoadMetric", ()=>$f1fed22795d0c676$export$3bd38623c2543fc0);
    $parcel$export(module.exports, "customFieldInteractionMetric", ()=>$f1fed22795d0c676$export$a318f99472db73c8);
    var $dGrdR;
    var $6RCeq;
    var $atdLB;
    var $duUGa;
    var $hBuqR;
    const $f1fed22795d0c676$export$cd129f3639657eae = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$c3d8833fbea3e976 = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $f1fed22795d0c676$export$292f3b557281044f = (0, (0, parcelRequire("dGrdR")).metrics).concurrent.custom({
        key: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
    });
    const $f1fed22795d0c676$export$89ace7e2bb7d7685 = new (0, (0, parcelRequire("duUGa")).UFOExperience)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    });
    async function $f1fed22795d0c676$export$94f65f3b2556df23(startMark, endMark, fn) {
        if (false || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).length > 0 || (0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).length > 0) return fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(startMark);
        const result = await fn();
        (0, (0, parcelRequire("6RCeq")).default).mark(endMark);
        return result;
    }
    const $f1fed22795d0c676$export$116d5e25caf0018d = (metric, additionalTimings)=>{
        additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(startMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: cleanStart,
                        cleanEnd: undefined
                    })),
                ...(0, (0, parcelRequire("6RCeq")).default).getEntriesByName(endMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: undefined,
                        cleanEnd: cleanEnd
                    }))
            ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
            metric.mark(name, startTime);
            if (cleanStart || cleanEnd) (0, (0, parcelRequire("6RCeq")).default).clearMarks(name);
        });
    };
    const $f1fed22795d0c676$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings,
                {
                    key: 'tti',
                    startMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_START,
                    endMark: (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.TTI_END
                }
            ]
        });
    const $f1fed22795d0c676$export$a318f99472db73c8 = (additionalTimings = [])=>(0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings
            ]
        });
});
parcelRegister("bOLUk", function(module, exports) {
    $parcel$export(module.exports, "fireInitializationFetchFinishedEvent", ()=>$2f4555f4bd0f0eef$export$132ca822850e455f);
    $parcel$export(module.exports, "fireInitializationFetchFailedEvent", ()=>$2f4555f4bd0f0eef$export$b5ca88b1053f1ad0);
    $parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", ()=>$2f4555f4bd0f0eef$export$e914f7df1e4ad79b);
    $parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", ()=>$2f4555f4bd0f0eef$export$b274c658390b491b);
    var $4R6GH;
    var $6yg2S;
    var $8uOa6;
    const $2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS = {
        STARTED: 'started',
        FINISHED: 'finished',
        FAILED: 'failed'
    };
    const $2f4555f4bd0f0eef$export$917d0643b0111a02 = (0, (0, parcelRequire("6yg2S")).toEventId)('issueViewInitialization');
    const $2f4555f4bd0f0eef$export$43e875fd63e64525 = (0, (0, parcelRequire("6yg2S")).toEventId)('fetchModulesInitialization');
    const $2f4555f4bd0f0eef$export$132ca822850e455f = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$43e875fd63e64525,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$e914f7df1e4ad79b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
    const $2f4555f4bd0f0eef$export$b274c658390b491b = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireInitializationEvent)($2f4555f4bd0f0eef$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2f4555f4bd0f0eef$export$917d0643b0111a02,
            source: source,
            attributes: {
                ...attributes,
                fetchModulesV2Query: (0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')
            }
        });
});
parcelRegister("6yg2S", function(module, exports) {
    $parcel$export(module.exports, "toEventId", ()=>$cb46d7d052e3d68d$export$75e84ef5a3771f9a);
    const $cb46d7d052e3d68d$export$75e84ef5a3771f9a = (value)=>value;
});
parcelRegister("8uOa6", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$73635d33815c9f98$export$a1fb57756f0de62b);
    $parcel$export(module.exports, "fireUiEvent", ()=>$73635d33815c9f98$export$bed7f228c94e5f2a);
    $parcel$export(module.exports, "fireTrackEvent", ()=>$73635d33815c9f98$export$574d2f19a52d67ca);
    $parcel$export(module.exports, "fireInitializationEvent", ()=>$73635d33815c9f98$export$390a62413962e4f0);
    var $fjcgS;
    var $hBuqR;
    var $6MtPV;
    var $7yD9b;
    var $eGXs2;
    const $73635d33815c9f98$var$createAnalyticsProps = ({ id: id, source: source = 'unknownSource', action: action, attributes: attributes })=>({
            actionSubject: `${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${id}`,
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes),
            source: source,
            action: action
        });
    const $73635d33815c9f98$var$getAnalyticsClient = async ()=>(await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)()).getInstance();
    const $73635d33815c9f98$var$sendOperationalEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendOperationalEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendUiEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendUIEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$var$sendTrackEvent = async (props)=>(await $73635d33815c9f98$var$getAnalyticsClient()).sendTrackEvent($73635d33815c9f98$var$createAnalyticsProps(props));
    const $73635d33815c9f98$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendOperationalEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendUiEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$73635d33815c9f98$var$sendTrackEvent({
            ...eventProps,
            source: (0, (0, parcelRequire("6MtPV")).parseSource)(source),
            action: action
        });
    const $73635d33815c9f98$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
            $73635d33815c9f98$export$a1fb57756f0de62b(action, {
                id: id,
                attributes: attributes,
                source: source
            }),
            attributes?.error && (0, (0, parcelRequire("7yD9b")).logError)((0, (0, parcelRequire("7yD9b")).ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, (0, parcelRequire("eGXs2")).isSynthetic)().toString()}, id=${id}, source=${(0, (0, parcelRequire("6MtPV")).parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
        ]);
});
parcelRegister("6MtPV", function(module, exports) {
    $parcel$export(module.exports, "parseSource", ()=>$31dca5b0e1651a2f$export$e98201ef9a88ba70);
    $parcel$export(module.exports, "createAttributes", ()=>$31dca5b0e1651a2f$export$c7c9603a6b1fd815);
    var $84Tib = parcelRequire("84Tib");
    var $9uiWt;
    var $bPtOr;
    var $eGXs2;
    const $31dca5b0e1651a2f$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
    const $31dca5b0e1651a2f$export$78c6267359db7e73 = (error)=>({
            ...error,
            stack: error.stack,
            message: error?.message
        });
    const $31dca5b0e1651a2f$export$c7c9603a6b1fd815 = (rawAttributes)=>{
        const attributes = {
            isSynthetic: (0, (0, parcelRequire("eGXs2")).isSynthetic)(),
            isOverridingFragments: (0, (0, parcelRequire("9uiWt")).isOverridingFragments)(),
            isSSR: false
        };
        if (rawAttributes) {
            const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
            if (source) attributes.source = $31dca5b0e1651a2f$export$e98201ef9a88ba70(source);
            if (error) {
                attributes.error = $31dca5b0e1651a2f$export$78c6267359db7e73(error);
                attributes.errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            }
            if ((0, ($parcel$interopDefault($84Tib)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
        }
        return {
            ...rawAttributes,
            ...attributes
        };
    };
});
parcelRegister("9uiWt", function(module, exports) {
    $parcel$export(module.exports, "isOverridingFragments", ()=>$c677f4c9cc5e982f$export$1d1321d2b374d697);
    const $c677f4c9cc5e982f$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
});
parcelRegister("eGXs2", function(module, exports) {
    $parcel$export(module.exports, "isSynthetic", ()=>$58ae13ec31f88266$export$947749d756ccb0a);
    var $4R6GH;
    var $j8DrX;
    const $58ae13ec31f88266$export$947749d756ccb0a = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true' || (0, (0, parcelRequire("4R6GH")).fg)('forge_ui_synthetic_check');
});
parcelRegister("7yD9b", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_UTIL", ()=>$187fc325525eefe3$export$d1e4f308040bb0d5);
    $parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", ()=>$187fc325525eefe3$export$36f315a5c6daf40b);
    $parcel$export(module.exports, "logError", ()=>$187fc325525eefe3$export$58da9968c3170cb1);
    var $dJl1T;
    var $hBuqR;
    const $187fc325525eefe3$export$e31edcd35abe3bb1 = 'environment-mapping';
    const $187fc325525eefe3$export$d1e4f308040bb0d5 = 'analytics';
    const $187fc325525eefe3$export$36f315a5c6daf40b = 'custom-field-object-type';
    const $187fc325525eefe3$export$6ee8198f29fffdb4 = {
        [$187fc325525eefe3$export$d1e4f308040bb0d5]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.analytics`,
        [$187fc325525eefe3$export$e31edcd35abe3bb1]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
        [$187fc325525eefe3$export$36f315a5c6daf40b]: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
    };
    const $187fc325525eefe3$export$58da9968c3170cb1 = (key, message, event)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($187fc325525eefe3$export$6ee8198f29fffdb4[key], message, event);
    };
});
parcelRegister("d5W4H", function(module, exports) {
    $parcel$export(module.exports, "canFetchForgeModules", ()=>$f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08);
    var $4Pf62;
    const $f4d6ea2b45e6b20f$export$bb3a4a3b8e654c08 = ()=>{
        const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
});
parcelRegister("1MlDe", function(module, exports) {
    $parcel$export(module.exports, "filterOutDuplicatedExtensions", ()=>$11a6461020d3329a$export$e0393e97f15a28a5);
    var $lbWm4 = parcelRequire("lbWm4");
    var $k2DRb;
    const $11a6461020d3329a$export$e0393e97f15a28a5 = (modules)=>{
        const filteredModules = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        (0, ($parcel$interopDefault($lbWm4)))(modules, (module, propName)=>{
            const moduleExtensions = new Map();
            (0, ($parcel$interopDefault($lbWm4)))(module, (moduleItem)=>{
                const moduleExtension = moduleExtensions.get(moduleItem.id);
                const appVersion = moduleItem?.appVersion || '0.0.0';
                const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
                if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
            });
            filteredModules[propName] = [
                ...moduleExtensions.values()
            ];
        });
        return filteredModules;
    };
});
parcelRegister("lG6pQ", function(module, exports) {
    $parcel$export(module.exports, "getDataClassification", ()=>$013c8a0b6d7ef450$export$1635afa94064952c);
    var $eusud;
    var $bPtOr;
    var $bOLUk;
    var $dqtU7;
    var $6P5IG;
    const $013c8a0b6d7ef450$var$handleError = (err, source)=>{
        const errorMessage = err instanceof Error ? err.message : String(err);
        const error = Error(`Data classification request failed: ${errorMessage}`);
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        if (errorType === (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)) throw error;
        (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        return [];
    };
    async function $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).issueKeyPrefix)}-${props.issueKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    async function $013c8a0b6d7ef450$var$getDataClassificationProject(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).get(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, (0, parcelRequire("6P5IG")).TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
                (0, (0, parcelRequire("6P5IG")).DataClassificationTagsCache).set(`${(0, (0, parcelRequire("6P5IG")).projectKeyPrefix)}-${props.projectIdOrKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $013c8a0b6d7ef450$var$handleError(err, source);
        }
    }
    const $013c8a0b6d7ef450$export$1635afa94064952c = async (props, source)=>{
        if (props !== null) {
            if ((0, (0, parcelRequire("dqtU7")).hasPrefetchedData)(props)) return props.tags;
            if ((0, (0, parcelRequire("dqtU7")).hasProjectIdOrKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationProject(props, source);
                return tags;
            }
            if ((0, (0, parcelRequire("dqtU7")).hasIssueKey)(props)) {
                const tags = await $013c8a0b6d7ef450$var$getDataClassificationIssue(props, source);
                return tags;
            }
        }
        return [];
    };
});
parcelRegister("dqtU7", function(module, exports) {
    $parcel$export(module.exports, "hasPrefetchedData", ()=>$3920146879a40338$export$c19d255b92c7c2da);
    $parcel$export(module.exports, "hasProjectIdOrKey", ()=>$3920146879a40338$export$494434246e5dea0d);
    $parcel$export(module.exports, "hasIssueKey", ()=>$3920146879a40338$export$b1490cfc7a90c75b);
    var $8LQ84 = parcelRequire("8LQ84");
    const $3920146879a40338$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, ($parcel$interopDefault($8LQ84)))(props.tags);
    const $3920146879a40338$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
    const $3920146879a40338$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;
});
parcelRegister("6P5IG", function(module, exports) {
    $parcel$export(module.exports, "TTL", ()=>$ca591e08be1a6f54$export$6ebb1381174e92a7);
    $parcel$export(module.exports, "issueKeyPrefix", ()=>$ca591e08be1a6f54$export$a040db2850f159b0);
    $parcel$export(module.exports, "projectKeyPrefix", ()=>$ca591e08be1a6f54$export$df256a06d24ff906);
    $parcel$export(module.exports, "DataClassificationTagsCache", ()=>$ca591e08be1a6f54$export$b7adc37405b5ff0d);
    const $ca591e08be1a6f54$export$6ebb1381174e92a7 = 60000;
    const $ca591e08be1a6f54$export$a040db2850f159b0 = 'issue';
    const $ca591e08be1a6f54$export$df256a06d24ff906 = 'project';
    const $ca591e08be1a6f54$export$b7adc37405b5ff0d = new Map();
});
parcelRegister("ioGTN", function(module, exports) {
    $parcel$export(module.exports, "ForgeFetchError", ()=>$03e8a2344fd340fa$export$2e3b53e53bafa);
    class $03e8a2344fd340fa$export$2e3b53e53bafa extends Error {
        constructor(message, traceId, errors){
            super(message);
            this.name = $03e8a2344fd340fa$export$2e3b53e53bafa.name;
            this.traceId = traceId;
            this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, $03e8a2344fd340fa$export$2e3b53e53bafa);
        }
    }
});
parcelRegister("dnsCJ", function(module, exports) {
    $parcel$export(module.exports, "getTraceIdFromExtensions", ()=>$06cecb1cf20a09b8$export$eefb7f54c3b07211);
    $parcel$export(module.exports, "getTraceIdFromError", ()=>$06cecb1cf20a09b8$export$9955d05ba83067ba);
    var $jJZqs;
    var $ioGTN;
    const $06cecb1cf20a09b8$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
        const traceId = extensions?.gateway?.request_id;
        if (traceId && typeof traceId === 'string') return traceId;
        return undefined;
    };
    const $06cecb1cf20a09b8$export$9955d05ba83067ba = (error)=>{
        if (error instanceof (0, (0, parcelRequire("ioGTN")).ForgeFetchError) || error instanceof (0, (0, parcelRequire("jJZqs")).default)) return error.traceId;
        return undefined;
    };
});
parcelRegister("eIGUr", function(module, exports) {
    $parcel$export(module.exports, "buildForgeQuery", ()=>$5112ddb3344b355d$export$497b2dc04db7bd76);
    var $co1wz;
    const $5112ddb3344b355d$export$497b2dc04db7bd76 = (include)=>{
        const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
        const scopesField = include.scopes === true ? 'scopes' : '';
        const capabilitySetField = (0, (0, parcelRequire("co1wz")).ff)('platform.forge-ui.license-capability-set') ? 'capabilitySet' : '';
        const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
		    ${capabilitySetField}
    }`;
        return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
    };
});
parcelRegister("5vSAE", function(module, exports) {
    $parcel$export(module.exports, "fetchModules", ()=>$f16089506a319d17$export$24d8e11b15325c53);
    var $gPjkL;
    var $8Uumt = parcelRequire("8Uumt");
    var $bPtOr;
    var $dYScp;
    var $hBuqR;
    var $bOLUk;
    var $k2DRb;
    var $5yJb9;
    var $d5W4H;
    var $dyPNS;
    const $f16089506a319d17$export$24d8e11b15325c53 = async (params)=>{
        const { types: types, source: source = (0, (0, parcelRequire("k2DRb")).SOURCE_UNKNOWN) } = params;
        if (!(0, (0, parcelRequire("d5W4H")).canFetchForgeModules)()) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
        try {
            const extensions = await (0, (0, parcelRequire("dYScp")).measureExecutionTimeMetrics)(()=>$f16089506a319d17$export$8ff66c70be1c563a(params));
            if (Math.random() * 100 < (0, (0, parcelRequire("hBuqR")).FORGE_SAMPLING_RATE)) (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFinishedEvent)(source);
            return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, extensions);
        } catch (error) {
            const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
            (0, (0, parcelRequire("bOLUk")).fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error
            });
            if ($f16089506a319d17$export$458cbcb6374269d2.includes(errorType)) return (0, (0, parcelRequire("dyPNS")).toMappedExtensions)(types, []);
            throw error;
        }
    };
    function $f16089506a319d17$export$8ff66c70be1c563a(props) {
        const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
        if (types.length === 0) throw new Error('No modules to fetch provided');
        return (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("gPjkL")).default), {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes
        }).toPromise().then((response)=>{
            return response.jira.forge.extensions.concat();
        });
    }
    const $f16089506a319d17$export$458cbcb6374269d2 = [
        (0, (0, parcelRequire("bPtOr")).FAILED_TO_FETCH),
        (0, (0, parcelRequire("bPtOr")).AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, (0, parcelRequire("bPtOr")).DATA_CLASSIFICATION_NO_ACCESS)
    ];
});
parcelRegister("gPjkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13cd104237d48c31$export$2e2bcd8739ae039);
    const $13cd104237d48c31$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeScopes"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }, v5 = {
            "kind": "ScalarField",
            "name": "type"
        }, v6 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "condition": "includeHidden",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hiddenBy"
                        }
                    ]
                },
                {
                    "condition": "includeScopes",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "scopes"
                        }
                    ]
                },
                v5,
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "properties"
                },
                {
                    "concreteType": "JiraForgeAppEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        v5
                    ]
                },
                {
                    "concreteType": "JiraForgeExtensionLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        v5,
                        {
                            "kind": "ScalarField",
                            "name": "supportEntitlementNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        }
                    ]
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "fetchModulesV2Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraForgeQuery",
                                        "kind": "LinkedField",
                                        "name": "forge",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v6,
                                                "action": "THROW",
                                                "path": "jira.forge.extensions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.forge"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v2,
                    v3
                ],
                "kind": "Operation",
                "name": "fetchModulesV2Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraForgeQuery",
                                "kind": "LinkedField",
                                "name": "forge",
                                "plural": false,
                                "selections": [
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05",
                "metadata": {},
                "name": "fetchModulesV2Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $13cd104237d48c31$var$node.hash = "7d0cf33c9221c468dec00db8d99ae484";
    var $13cd104237d48c31$export$2e2bcd8739ae039 = $13cd104237d48c31$var$node;
});
parcelRegister("dyPNS", function(module, exports) {
    $parcel$export(module.exports, "toMappedExtensions", ()=>$12d1a959cf63073a$export$e073e0c0d1c23345);
    function $12d1a959cf63073a$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
        const result = Object.fromEntries(requestedModules.map((type)=>[
                type,
                []
            ]));
        returnedExtensions.forEach((extension)=>{
            result[extension.type]?.push(extension);
        });
        return result;
    }
});
parcelRegister("dK8AG", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyOrId", ()=>$9ffe1ab8f180b628$export$43cde151f667c69e);
    $parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", ()=>$9ffe1ab8f180b628$export$b87af5b274141bd6);
    var $1nb22;
    const $9ffe1ab8f180b628$export$43cde151f667c69e = (match)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, match.query);
        return projectKey || projectId || '';
    };
    const $9ffe1ab8f180b628$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
});
parcelRegister("1nb22", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyId", ()=>$061afadfbcc74f44$export$1f7213d0f9054f06);
    const $061afadfbcc74f44$export$1f7213d0f9054f06 = (match, query)=>{
        const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
        const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
        return {
            projectKey: projectKey,
            projectId: projectId
        };
    };
});
parcelRegister("gNStA", function(module, exports) {
    $parcel$export(module.exports, "resourceWithCondition", ()=>$4fbc57fe7e788209$export$cac04afc5a06c544);
    $parcel$export(module.exports, "resourceWithCondition2", ()=>$4fbc57fe7e788209$export$78488a529a07cd46);
    $parcel$export(module.exports, "browserOnlyResourceWithCondition", ()=>$4fbc57fe7e788209$export$5284559c6d2f1a7b);
    var $kbVA4;
    const $4fbc57fe7e788209$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
            get type () {
                return conditionGetter() ? resourceTrue.type : (0, (0, parcelRequire("kbVA4")).RESOURCE_TYPE_NOOP);
            },
            getKey: resourceTrue.getKey,
            get maxAge () {
                return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
            },
            getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
            maxCache: resourceTrue.maxCache,
            get isBrowserOnly () {
                return resourceTrue.isBrowserOnly;
            },
            get depends () {
                return resourceTrue.depends;
            },
            get skipBrowser () {
                return resourceTrue.skipBrowser;
            }
        };
    const $4fbc57fe7e788209$export$fbf6681b373be4c4 = (resource, amendments = {})=>resource && Object.defineProperties({}, {
            ...Object.getOwnPropertyDescriptors(resource),
            ...Object.getOwnPropertyDescriptors(amendments)
        });
    const $4fbc57fe7e788209$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $4fbc57fe7e788209$export$fbf6681b373be4c4(itemTrue, {
        getKey: ()=>'DEGENERATE_KEY',
        getData: ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER
    }))=>itemTrue && Object.defineProperties({}, Object.fromEntries([
            ...Object.keys(itemTrue),
            ...Object.keys(itemFalse)
        ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
                key,
                {
                    configurable: false,
                    enumerable: true,
                    get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
                }
            ])));
    const $4fbc57fe7e788209$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
            ...resource,
            get isBrowserOnly () {
                return !!conditionGetter();
            }
        };
});
parcelRegister("kbVA4", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NOOP", ()=>$513d12eeb22c04a1$export$eb37f5d331ea4de4);
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$513d12eeb22c04a1$export$5664a170ac5a9781);
    const $513d12eeb22c04a1$export$eb37f5d331ea4de4 = 'NOOP';
    const $513d12eeb22c04a1$export$5664a170ac5a9781 = 5000;
});
parcelRegister("47m5i", function(module, exports) {
    $parcel$export(module.exports, "fetchForgeModule", ()=>$9024d8f047e9df37$export$e1683e15cedb5f17);
    var $e4eHl = parcelRequire("e4eHl");
    var $8O7FC;
    var $k2DRb;
    var $iVaKa;
    var $g5X3G;
    var $gLloR;
    const $9024d8f047e9df37$var$dataClassificatedModulesConfig = {
        names: new Set(),
        request: Promise.resolve({})
    };
    const $9024d8f047e9df37$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
        $9024d8f047e9df37$var$dataClassificatedModulesConfig.names.add(moduleName);
        await new Promise((resolve)=>setTimeout(resolve, 0));
        const moduleNamesToFetch = Array.from($9024d8f047e9df37$var$dataClassificatedModulesConfig.names);
        let extensions = [];
        let accessNarrowedExtensions = [];
        if (moduleNamesToFetch.length > 0) {
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.names = new Set();
            $9024d8f047e9df37$var$dataClassificatedModulesConfig.request = (0, (0, parcelRequire("iVaKa")).default)((0, (0, parcelRequire("g5X3G")).toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
        }
        const result = await $9024d8f047e9df37$var$dataClassificatedModulesConfig.request;
        extensions = result.extensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, ($parcel$interopDefault($e4eHl)))(moduleName)];
        const getExtensionsFilter = (fullPageModuleName)=>{
            switch(fullPageModuleName){
                case 0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE:
                    return 0, (0, parcelRequire("gLloR")).adminPageFilter;
                default:
                    return 0, (0, parcelRequire("gLloR")).uniqueExtensionsFilter;
            }
        };
        return {
            extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title)),
            accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, (0, parcelRequire("8O7FC")).alphabeticalSort)(a.properties.title, b.properties.title))
        };
    };
});
parcelRegister("gLloR", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$11790a142fe832e3$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$11790a142fe832e3$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $11790a142fe832e3$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $11790a142fe832e3$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        const adminExtensions = extensions;
        return [
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
            ...$11790a142fe832e3$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("e0AC8", function(module, exports) {
    $parcel$export(module.exports, "parseExtensionId", ()=>$d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b);
    $parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", ()=>$d4c89d40e0b3eaac$export$a92b17288693d366);
    const $d4c89d40e0b3eaac$export$bae42cbaf7fa3e1b = (extensionId)=>{
        const [, appId, envId] = extensionId.split('/');
        return {
            appId: appId,
            envId: envId
        };
    };
    const $d4c89d40e0b3eaac$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');
});
parcelRegister("1yLrr", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$8bb90f56b7c2b78a$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$8bb90f56b7c2b78a$export$1eefd1d9cde49fd5);
    var $3JOCw = parcelRequire("3JOCw");
    var $e0AC8;
    const $8bb90f56b7c2b78a$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($3JOCw)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $8bb90f56b7c2b78a$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        return [
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
            ...$8bb90f56b7c2b78a$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("8uKLe", function(module, exports) {
    $parcel$export(module.exports, "staticSoftwareProjectHorizontalNavResource", ()=>$ee0fa1168e64c074$export$c5680a2101ae5345);
    var $k24Fu;
    var $ljMDN;
    var $95bh0;
    var $dJl1T;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $aqYy6;
    var $8YTna;
    var $1nb22;
    var $gNStA;
    const $ee0fa1168e64c074$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.software-horizontal-navigation', 'Failed to get project ari');
            return '';
        }
    };
    const $ee0fa1168e64c074$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        let scope;
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (isTMPBoardRoute) scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
        else scope = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
        const boardAri = scope.identifierType === 'boardId' ? (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: String(match.params.boardId)
        }).toString() : null;
        const projectAri = $ee0fa1168e64c074$var$getProjectAri(projectId, tenantContext.cloudId);
        const containerNavigationInput = boardAri || projectAri ? {
            scopeId: String(boardAri || projectAri)
        } : {
            projectKeyQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey
            }
        };
        const boardAriTemp = boardId ? (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: boardId
        }).toString() : (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).create({
            siteId: tenantContext.cloudId,
            boardId: '0'
        }).toString();
        return {
            parameters: (0, (0, parcelRequire("aqYy6")).default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                projectAri: projectAri,
                boardId: boardAriTemp,
                containerNavigationInput: containerNavigationInput,
                first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                useProjectKey: Boolean(projectKey),
                useProjectAri: Boolean(projectAri),
                hasBoardId: Boolean(boardId),
                isTmpRoute: Boolean(isTMPBoardRoute)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    };
    const $ee0fa1168e64c074$export$c5680a2101ae5345 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)(), (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'HORIZONTAL_NAVIGATION_PROJECT_QUERY',
        getQuery: $ee0fa1168e64c074$export$71eec30d9db46a56
    }));
});
parcelRegister("95bh0", function(module, exports) {
    $parcel$export(module.exports, "getScopeIdentifier", ()=>$4cc145d0cf66273c$export$68278f7cf66944f9);
    const $4cc145d0cf66273c$export$68278f7cf66944f9 = (scope)=>{
        const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
        let identifierType = null;
        if (scope.boardId) identifierType = (0, $87844bbe4c23d937$export$929d50f83189406c);
        else if (scope.projectKey) identifierType = (0, $87844bbe4c23d937$export$b5a308a17bc991f3);
        else if (scope.projectId) identifierType = (0, $87844bbe4c23d937$export$da6f46390e1a426f);
        return {
            identifierValue: identifierValue,
            identifierType: identifierType
        };
    };
});
const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';
parcelRegister("3HwlS", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4", ()=>$30254f1a9a5ebb1a$export$f1ce4aa22fe8768a);
    var $4R6GH;
    var $c0dQj;
    var $ifO6r;
    var $9qXgw;
    const $30254f1a9a5ebb1a$export$f1ce4aa22fe8768a = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4') && ((0, (0, parcelRequire("ifO6r")).getWillShowNav4ForDogfooding)() || (0, (0, parcelRequire("9qXgw")).getWillShowNav4ForEap)() || (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)());
});
parcelRegister("c0dQj", function(module, exports) {
    $parcel$export(module.exports, "isMobileAndInMVPExperiment", ()=>$7275e40842570ace$export$f29d7974ab92d702);
    $parcel$export(module.exports, "MobileWebExperimentExposure", ()=>$7275e40842570ace$export$b93f740e619fc842);
    var $bCdIp;
    var $6s1PB;
    var $4R6GH;
    const $7275e40842570ace$export$f29d7974ab92d702 = ()=>{
        const [mobileWebConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp');
        return ((0, (0, parcelRequire("4R6GH")).fg)('jira_mobile_web_mvp_feature_gate') && (0, (0, parcelRequire("bCdIp")).default)() && mobileWebConfig.get('isEnabled', false));
    };
    const $7275e40842570ace$export$b93f740e619fc842 = ()=>{
        const [, manuallyFireExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_mobile_web_mvp');
        if ((0, (0, parcelRequire("bCdIp")).default)()) manuallyFireExposure();
        return null;
    };
});
parcelRegister("6s1PB", function(module, exports) {
    $parcel$export(module.exports, "expVal", ()=>$d0d3e1363a65fa96$export$9db1624a8af791a4);
    $parcel$export(module.exports, "expValEquals", ()=>$d0d3e1363a65fa96$export$45abdb3f977b5b14);
    $parcel$export(module.exports, "UNSAFE_noExposureExp", ()=>$d0d3e1363a65fa96$export$677f9fa2e1ae6fec);
    var $5IPCv;
    var $gSA3s;
    var $40Gox;
    function $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, defaultValue) {
        (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
        const value = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue(experimentName, param, defaultValue);
        (0, (0, parcelRequire("gSA3s")).addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
        return value;
    }
    function $d0d3e1363a65fa96$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
        return $d0d3e1363a65fa96$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
    }
    class $d0d3e1363a65fa96$var$ExperimentConfig {
        constructor(experimentName, config){
            this._experimentName = experimentName;
            this._config = config;
        }
        get(key, defaultValue, typeGuard) {
            const value = this._config.get(key, defaultValue, typeGuard);
            (0, (0, parcelRequire("gSA3s")).addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
            return value;
        }
    }
    const $d0d3e1363a65fa96$var$cache = new Map();
    function $d0d3e1363a65fa96$export$677f9fa2e1ae6fec(experimentName) {
        let instance = $d0d3e1363a65fa96$var$cache.get(experimentName);
        if (instance == null) {
            (0, (0, parcelRequire("40Gox")).UNSAFE_initIfNeeded)();
            const config = (0, (0, parcelRequire("5IPCv")).default).getExperiment(experimentName, {
                fireExperimentExposure: false
            });
            const fireExposure = ()=>(0, (0, parcelRequire("5IPCv")).default).manuallyLogExperimentExposure(experimentName);
            instance = [
                new $d0d3e1363a65fa96$var$ExperimentConfig(experimentName, config),
                fireExposure
            ];
            $d0d3e1363a65fa96$var$cache.set(experimentName, instance);
        }
        return instance;
    }
});
parcelRegister("ifO6r", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForDogfooding", ()=>$b6db23b0cddd1764$export$9ca0d92d31816d4f);
    var $4R6GH;
    var $1MhR0;
    var $8MTso;
    const $b6db23b0cddd1764$export$9ca0d92d31816d4f = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding')) return false;
        const phase1 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-1');
        const phase2 = (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_dogfooding_phase-2');
        const phase3 = !(phase1 || phase2);
        return phase3 || phase2 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() || phase1 && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)() && !(0, (0, parcelRequire("8MTso")).getIsRouteExcludedForDogfoodingPhase1)();
    };
});
parcelRegister("1MhR0", function(module, exports) {
    $parcel$export(module.exports, "getMetaBoolean", ()=>$039259847fa24143$export$9683360b0ae70629);
    $parcel$export(module.exports, "getIsNav4UserOptOut", ()=>$039259847fa24143$export$3fbfe0fdf05e0f9f);
    var $gJBT6 = parcelRequire("gJBT6");
    var $j8DrX;
    var $7qZOo;
    const $039259847fa24143$export$9683360b0ae70629 = (0, ($parcel$interopDefault($gJBT6)))((name)=>(0, (0, parcelRequire("j8DrX")).default)(`ajs-${name}`) === 'true');
    const $039259847fa24143$export$7d046765d192af80 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_ADMIN));
    const $039259847fa24143$export$ba89637357392be6 = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_IN));
    const $039259847fa24143$export$3fbfe0fdf05e0f9f = ()=>$039259847fa24143$export$9683360b0ae70629((0, (0, parcelRequire("7qZOo")).IS_NAV4_USER_OPT_OUT));
});
parcelRegister("7qZOo", function(module, exports) {
    $parcel$export(module.exports, "IS_ADMIN", ()=>$92928f70e02753a5$export$4261d5d429e288ec);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", ()=>$92928f70e02753a5$export$153ded4d539b820d);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", ()=>$92928f70e02753a5$export$9c962957701a4fe8);
    $parcel$export(module.exports, "NAV4_ROLLOUT_NONE", ()=>$92928f70e02753a5$export$3b602cac1f385c06);
    $parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", ()=>$92928f70e02753a5$export$e748a16828d2f61f);
    const $92928f70e02753a5$export$4261d5d429e288ec = 'is-admin';
    const $92928f70e02753a5$export$153ded4d539b820d = 'is-nav4-user-opt-in';
    const $92928f70e02753a5$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
    const $92928f70e02753a5$export$3b602cac1f385c06 = {
        stage: 'none'
    };
    const $92928f70e02753a5$export$e748a16828d2f61f = {
        stage: 'mobile'
    };
    const $92928f70e02753a5$export$9cd4b8dc5f7153b8 = {
        NONE: 'none',
        DOGFOODING: 'dogfooding',
        EAP: 'eap',
        BETA: 'beta',
        GA: 'ga'
    };
});
parcelRegister("8MTso", function(module, exports) {
    $parcel$export(module.exports, "getIsRouteExcludedForDogfoodingPhase1", ()=>$5866baf2a5010361$export$f0abfe25b95778e3);
    var $4R6GH;
    const $5866baf2a5010361$var$JPD_COLLECTIONS_OVERVIEW_REGEX = new RegExp('^/jira/polaris/roadmaps(/)*$');
    const $5866baf2a5010361$export$f0abfe25b95778e3 = ()=>{
        if (false) return false;
        const pathname = $5866baf2a5010361$var$getPathname();
        if (pathname.includes('/jira/polaris/roadmaps')) {
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jpd-sidebar-v4-for-roadmaps')) {
                const isJpdCollectionsOverview = $5866baf2a5010361$var$JPD_COLLECTIONS_OVERVIEW_REGEX.test(pathname);
                if (isJpdCollectionsOverview && (0, (0, parcelRequire("4R6GH")).fg)('jpd-sidebar-v4-for-roadmaps-overview')) return false;
                return true;
            }
        }
        return false;
    };
    const $5866baf2a5010361$var$getPathname = ()=>window.location.pathname;
});
parcelRegister("9qXgw", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForEap", ()=>$77cd593041adc2b6$export$393f53ae320de085);
    var $4R6GH;
    var $1MhR0;
    const $77cd593041adc2b6$export$393f53ae320de085 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
});
parcelRegister("eM91u", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", ()=>$8ade7fd740dbd607$export$4653cda61a4943d6);
    $parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", ()=>$8ade7fd740dbd607$export$d1b9ea3245b6a5de);
    $parcel$export(module.exports, "TAB_HEIGHT", ()=>$8ade7fd740dbd607$export$d07bba395c9390f1);
    $parcel$export(module.exports, "TAB_HEIGHT_REFRESH", ()=>$8ade7fd740dbd607$export$7795e1ec8bf78852);
    $parcel$export(module.exports, "TAB_GAP", ()=>$8ade7fd740dbd607$export$b61e6f89a9db76de);
    const $8ade7fd740dbd607$export$4653cda61a4943d6 = 75;
    const $8ade7fd740dbd607$export$d1b9ea3245b6a5de = 2;
    const $8ade7fd740dbd607$export$d07bba395c9390f1 = 36;
    const $8ade7fd740dbd607$export$7795e1ec8bf78852 = 56;
    const $8ade7fd740dbd607$export$29911ec08ab2ca2d = 5;
    const $8ade7fd740dbd607$export$b61e6f89a9db76de = 12;
    const $8ade7fd740dbd607$export$7fd2e391116c6ef5 = 9;
    const $8ade7fd740dbd607$export$e1633e494d305bfb = 'MORE';
});
parcelRegister("ao2h1", function(module, exports) {
    $parcel$export(module.exports, "RELAY_RESOURCE_TYPE", ()=>$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54);
    $parcel$export(module.exports, "createRelayResource", ()=>$5f6ac21695ec30bb$export$1cc887c62079ea32);
    $parcel$export(module.exports, "useRelayResource", ()=>$5f6ac21695ec30bb$export$42ca7b248c7aaee);
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $x9xyg;
    var $4R6GH;
    var $5yJb9;
    var $5a0Nh;
    var $kipqU;
    var $dIdda = parcelRequire("dIdda");
    var $5Wobd;
    const $5f6ac21695ec30bb$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $5f6ac21695ec30bb$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const query = parameters ?? await loadParameters?.();
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables || {}, options));
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, (0, parcelRequire("x9xyg")).setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const queryReference = (0, (0, parcelRequire("x9xyg")).measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), parameters, variables || {}, options));
        if (false && queryReference.id != null) {
            const promise = (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            if (promise) return promise.then(()=>{
                (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
                (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
                if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
                return queryReference;
            });
        }
        if (queryReference.id != null) (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, (0, parcelRequire("x9xyg")).setMark)(endMark);
            (0, (0, parcelRequire("x9xyg")).setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $5f6ac21695ec30bb$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $dIdda.createResource)({
            type: `${$5f6ac21695ec30bb$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: (routerContext, customContext)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('blu-3813-improve-ssr-hydration-of-relay')) return $5f6ac21695ec30bb$var$getDataNew({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
                return $5f6ac21695ec30bb$var$getDataOld({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    loadParameters: loadParameters,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $5f6ac21695ec30bb$export$1cc887c62079ea32 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$bbe949b85c06f763 = $5f6ac21695ec30bb$var$createRelayResourceImpl;
    const $5f6ac21695ec30bb$export$42ca7b248c7aaee = (resource, options)=>{
        const { data: queryReference, loading: loading, promise: promise } = (0, $dIdda.useResource)(resource);
        if (options?.suspendWhenLoading && loading) throw promise;
        return {
            queryReference: queryReference
        };
    };
});
parcelRegister("aqYy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1c475e7aa0ff0f$export$2e2bcd8739ae039);
    const $ea1c475e7aa0ff0f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hasBoardId"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isTmpRoute"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v8 = {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectAri"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v11 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
            }
        ], v12 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v13 = {
            "kind": "ScalarField",
            "name": "scopeId"
        }, v14 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            }
        ], v15 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v16 = [
            v15,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v17 = {
            "kind": "ScalarField",
            "name": "name"
        }, v18 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "projectType"
        }, v20 = {
            "kind": "ScalarField",
            "name": "projectStyle"
        }, v21 = {
            "kind": "ScalarField",
            "name": "key"
        }, v22 = {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }, v23 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v24 = {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v23,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }, v25 = {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v23,
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        }, v26 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v27 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v28 = [
            {
                "kind": "FragmentSpread",
                "name": "extraComponentsFar_horizontalNavHeader"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isTmpRoute",
                        "variableName": "isTmpRoute"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "boardHeader_horizontalNavHeader_projectFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "projectHeader_horizontalNavHeader_projectFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_navigationKitTabList_TabList_projectFragment"
            },
            v17,
            v18,
            v19,
            v20,
            v21,
            v22,
            v24,
            v25,
            v26,
            v27
        ], v29 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v30 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v31 = {
            "kind": "ScalarField",
            "name": "id"
        }, v32 = {
            "kind": "ScalarField",
            "name": "label"
        }, v33 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v34 = {
            "kind": "ScalarField",
            "name": "url"
        }, v35 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v36 = {
            "kind": "InlineFragment",
            "selections": [
                v31
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v37 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v38 = {
            "kind": "ScalarField",
            "name": "boardType"
        }, v39 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v40 = [
            v30,
            {
                "kind": "InlineFragment",
                "selections": [
                    v37,
                    v17,
                    v12,
                    v38,
                    {
                        "concreteType": "JiraFavouriteValue",
                        "kind": "LinkedField",
                        "name": "favouriteValue",
                        "plural": false,
                        "selections": [
                            v39,
                            v31
                        ]
                    },
                    v27
                ],
                "type": "JiraBoard"
            },
            v36
        ], v41 = [
            {
                "kind": "LinkedField",
                "name": "mostRecentlyViewedBoard",
                "plural": false,
                "selections": v40
            },
            v31
        ], v42 = [
            {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
            },
            v17,
            v18,
            v20,
            v19,
            v26,
            v24,
            v25,
            v21,
            v31,
            v39,
            {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            v22,
            v27,
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v30,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v37,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v31
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v30,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v37,
                                    v38
                                ],
                                "type": "JiraBoard"
                            },
                            v36
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10
                ],
                "kind": "Fragment",
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v11,
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitTabList_TabList_containerFragment"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitAddTab_AddTab"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v12,
                                                    v13,
                                                    {
                                                        "args": v14,
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "ui_navigationKitTabList_TabList_tabsFragment"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.containerNavigation"
                                },
                                {
                                    "condition": "isTmpRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                },
                                                v15,
                                                {
                                                    "kind": "Variable",
                                                    "name": "hasBoardId",
                                                    "variableName": "hasBoardId"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "projectAri",
                                                    "variableName": "projectAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "projectKey",
                                                    "variableName": "projectKey"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "useProjectAri",
                                                    "variableName": "useProjectAri"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "useProjectKey",
                                                    "variableName": "useProjectKey"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "boardHeader_horizontalNavHeader_boardFragment"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "projectDataByKey",
                                                "args": v16,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProjectByKey",
                                                "plural": false,
                                                "selections": v28
                                            },
                                            "action": "THROW",
                                            "path": "jira.projectDataByKey"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "useProjectAri",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "alias": "projectDataById",
                                                        "args": v29,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProject",
                                                        "plural": false,
                                                        "selections": v28
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0,
                    v7,
                    v6,
                    v3,
                    v2,
                    v10,
                    v9,
                    v4,
                    v5,
                    v8
                ],
                "kind": "Operation",
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v11,
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    v30,
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraContainerNavigationResult"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v31,
                                            v12,
                                            v13,
                                            {
                                                "args": v14,
                                                "concreteType": "JiraNavigationItemConnection",
                                                "kind": "LinkedField",
                                                "name": "navigationItems",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraNavigationItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v30,
                                                                    v31,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "isDefault"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "typeKey"
                                                                    },
                                                                    {
                                                                        "kind": "TypeDiscriminator",
                                                                        "abstractKey": "__isJiraNavigationItem"
                                                                    },
                                                                    v32,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canRemove"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canSetAsDefault"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "appId"
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraAppSection",
                                                                                "kind": "LinkedField",
                                                                                "name": "sections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v32,
                                                                                    {
                                                                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "links",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v32,
                                                                                            v33,
                                                                                            v34,
                                                                                            v35
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v34,
                                                                            v33,
                                                                            v35,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "appType"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "envLabel"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v27
                                                                                ],
                                                                                "type": "JiraNavigationItem",
                                                                                "abstractKey": "__isJiraNavigationItem"
                                                                            }
                                                                        ],
                                                                        "type": "JiraAppNavigationItem"
                                                                    },
                                                                    v27
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    v36
                                ]
                            },
                            {
                                "condition": "isTmpRoute",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "hasBoardId",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "boardId"
                                                    }
                                                ],
                                                "kind": "LinkedField",
                                                "name": "jiraBoard",
                                                "plural": false,
                                                "selections": v40
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "useProjectKey",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "condition": "hasBoardId",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "alias": "projectDataByKey",
                                                        "args": v16,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProjectByKey",
                                                        "plural": false,
                                                        "selections": v41
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "condition": "hasBoardId",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "alias": "projectDataById",
                                                        "args": v29,
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "jiraProject",
                                                        "plural": false,
                                                        "selections": v41
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v16,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v42
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "alias": "projectDataById",
                                                "args": v29,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProject",
                                                "plural": false,
                                                "selections": v42
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "def638e25db2f065a6ceadbb38f6d4bc613cca840e95dc29820c6275054f606e",
                "metadata": {},
                "name": "uiHorizontalSoftwareProjectNavQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ea1c475e7aa0ff0f$var$node.hash = "ef8c67db61c955d779206c3b78af3d1e";
    var $ea1c475e7aa0ff0f$export$2e2bcd8739ae039 = $ea1c475e7aa0ff0f$var$node;
});
parcelRegister("8YTna", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$f7f12dfb24bc320d$export$557c2f222778cea6);
    const $f7f12dfb24bc320d$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];
});
parcelRegister("7xTO3", function(module, exports) {
    $parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", ()=>$7371ef5d04dd1248$export$5839dd8142de842e);
    var $dJl1T;
    var $8YTna;
    var $dIdda = parcelRequire("dIdda");
    var $55UpE;
    const $7371ef5d04dd1248$export$5839dd8142de842e = (0, $dIdda.createResource)({
        type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            try {
                const response = await (0, (0, parcelRequire("55UpE")).fetchUserBoardNavigationData)(boardId);
                return response;
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
                return null;
            }
        },
        maxAge: 300000
    });
});
parcelRegister("55UpE", function(module, exports) {
    $parcel$export(module.exports, "fetchUserBoardNavigationData", ()=>$e577b36e40c022cb$export$306fb49fca60b34);
    var $eusud;
    const $e577b36e40c022cb$export$306fb49fca60b34 = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
    };
});
parcelRegister("c1N9v", function(module, exports) {
    $parcel$export(module.exports, "staticPlanSidebarNavigationResource", ()=>$4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7);
    var $dIdda = parcelRequire("dIdda");
    var $ijN6s;
    const $4a8a43738dc54d5c$var$getRouterKey = (match)=>{
        if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
        return 'none';
    };
    const $4a8a43738dc54d5c$export$e7e6c1b9d8d5ea7 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
        getKey: ({ match: match })=>$4a8a43738dc54d5c$var$getRouterKey(match),
        getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
            if (planId == null || scenarioId == null) return null;
            return (0, (0, parcelRequire("ijN6s")).fetchPlanSidebarNavInfo)(planId, scenarioId);
        },
        maxAge: 300000
    });
});
parcelRegister("ijN6s", function(module, exports) {
    $parcel$export(module.exports, "fetchPlanSidebarNavInfo", ()=>$b2d0559c1bc2bb35$export$a49729698cfc5310);
    var $eusud;
    const $b2d0559c1bc2bb35$var$requestSideBarInfo = (planId, scenarioId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
    const $b2d0559c1bc2bb35$export$a49729698cfc5310 = (planId, scenarioId)=>{
        if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
        if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
        return $b2d0559c1bc2bb35$var$requestSideBarInfo(planId, scenarioId);
    };
});
parcelRegister("6zFAI", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", ()=>$ee61b377cbb3343f$export$b8c6e2666f12f4bb);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $ee61b377cbb3343f$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $ee61b377cbb3343f$export$b8c6e2666f12f4bb = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$ee61b377cbb3343f$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $ee61b377cbb3343f$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const projectHomeAddonNavInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
            return projectHomeAddonNavInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("jAGOQ", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", ()=>$45e9310ad65e3e88$export$b15f9f5cf6db359e);
    var $eusud;
    const $45e9310ad65e3e88$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
        if (projectKeyOrId == null) throw new Error('invalid identifier specified');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
    };
});
parcelRegister("loy04", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$e4bf33528101348c);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$c5a0b9808c0c3182$export$2d5a704ae6f6b050);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $c5a0b9808c0c3182$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $c5a0b9808c0c3182$export$e4bf33528101348c = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$c5a0b9808c0c3182$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $c5a0b9808c0c3182$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
            return navInfo;
        },
        maxAge: 300000
    });
    const $c5a0b9808c0c3182$export$2d5a704ae6f6b050 = ()=>(0, $dIdda.useResource)($c5a0b9808c0c3182$export$e4bf33528101348c);
});
parcelRegister("ggg5j", function(module, exports) {
    $parcel$export(module.exports, "getIdentifier", ()=>$3ec7290d9b237c27$export$adb27ddab077e944);
    $parcel$export(module.exports, "staticProjectSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$f2dfc0f7b2d92691);
    $parcel$export(module.exports, "useSidebarNavigationResource", ()=>$3ec7290d9b237c27$export$b692cfadccf4e047);
    var $65Ltd;
    var $95bh0;
    var $8YTna;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $gDyED;
    const $3ec7290d9b237c27$export$adb27ddab077e944 = (routeName, match, query)=>{
        if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
        }
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
        return (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
    };
    const $3ec7290d9b237c27$var$getRouterKey = (routeName, match, query)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = $3ec7290d9b237c27$export$adb27ddab077e944(routeName, match, query);
        if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
        return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
    };
    const $3ec7290d9b237c27$export$f2dfc0f7b2d92691 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
        getKey: ({ match: match, query: query, route: { name: name } })=>$3ec7290d9b237c27$var$getRouterKey(name, match, query),
        getData: async ({ match: match, query: query, route: { name: name } })=>{
            const scopeIdentifier = $3ec7290d9b237c27$export$adb27ddab077e944(name, match, query);
            if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
            const navInfo = await (0, (0, parcelRequire("gDyED")).fetchProjectSidebarNavInfo)(scopeIdentifier);
            return navInfo;
        },
        maxAge: 300000
    });
    const $3ec7290d9b237c27$export$b692cfadccf4e047 = ()=>(0, $dIdda.useResource)($3ec7290d9b237c27$export$f2dfc0f7b2d92691);
});
parcelRegister("gDyED", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarNavInfo", ()=>$b6d61a4c2e3b518c$export$8a51470472777e11);
    var $eusud;
    const $b6d61a4c2e3b518c$export$8a51470472777e11 = (scopeIdentifier)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
        if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
        let queryParam = '';
        switch(identifierType){
            case 'boardId':
                queryParam = `boardId=${identifierValue}`;
                break;
            case 'projectKey':
            case 'projectId':
                queryParam = `projectIdOrKey=${identifierValue}`;
                break;
            default:
                break;
        }
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
    };
});
parcelRegister("iEUaw", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarShortcutsResource", ()=>$681ca3c44ff39b04$export$4847c29b4786b3b4);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $bskkv;
    const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
        getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const shortcuts = await (0, (0, parcelRequire("bskkv")).fetchShortcuts)(projectKeyOrId);
            return shortcuts;
        },
        maxAge: 300000
    });
});
parcelRegister("bskkv", function(module, exports) {
    $parcel$export(module.exports, "fetchShortcuts", ()=>$b1e90e13aab5fe84$export$49d696bf2525d700);
    var $jcw0u;
    var $7f4tk;
    const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
        try {
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchProjectShortcuts',
                packageName: 'jiraNavigationAppsResources'
            });
            throw error;
        }
    };
});
parcelRegister("2fwuR", function(module, exports) {
    $parcel$export(module.exports, "sidebarNav4Resource", ()=>$692dbcae1edae2a1$export$7648dc6f76f4f83d);
    $parcel$export(module.exports, "sidebarNav4UiStateResource", ()=>$692dbcae1edae2a1$export$a46129bd512544d7);
    var $jhS4y;
    var $3Jbkp;
    var $fMcVX;
    var $ao2h1;
    var $2OeZv;
    var $fZBia;
    const $692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
    const $692dbcae1edae2a1$export$7648dc6f76f4f83d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$692dbcae1edae2a1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const initialSelectedPath = (0, (0, parcelRequire("3Jbkp")).getInitialSelectedPath)(routerContext);
            return {
                parameters: (0, (0, parcelRequire("2OeZv")).default),
                variables: {
                    cloudId: cloudId,
                    isAppsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)),
                    isDashboardsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)),
                    isFiltersExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)),
                    isPlansExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)),
                    isProjectsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)),
                    isOperationsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)),
                    isOverviewsExpanded: (0, (0, parcelRequire("fMcVX")).isSelectedPath)(initialSelectedPath, (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS))
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $692dbcae1edae2a1$export$a46129bd512544d7 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, (0, parcelRequire("fZBia")).default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("jhS4y", function(module, exports) {
    $parcel$export(module.exports, "CONFIGURABLE_MENU_ID", ()=>$d66e3a3484b422c6$export$7838b734e4cd5e8d);
    $parcel$export(module.exports, "ENTITY_ID", ()=>$d66e3a3484b422c6$export$103ff18fe29ee1b);
    $parcel$export(module.exports, "MENU_ID_APPS", ()=>$d66e3a3484b422c6$export$441cd608ea3204f4);
    $parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", ()=>$d66e3a3484b422c6$export$5baa9c2e3c3931c5);
    $parcel$export(module.exports, "MENU_ID_ASSETS", ()=>$d66e3a3484b422c6$export$75c65bfc98b3a6e1);
    $parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", ()=>$d66e3a3484b422c6$export$8a0af92d49f1d13d);
    $parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", ()=>$d66e3a3484b422c6$export$a09300d15acc958a);
    $parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$4d718fbd418eef5c);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS", ()=>$d66e3a3484b422c6$export$dd009509c2dabb5e);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$d3da0455b4200fb2);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$b9dd2b5309d19763);
    $parcel$export(module.exports, "MENU_ID_FILTERS", ()=>$d66e3a3484b422c6$export$3d81af172a8e3c57);
    $parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", ()=>$d66e3a3484b422c6$export$1e2599eaf0039a97);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$53d274d993c9d5b5);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$7661ea763be69cfa);
    $parcel$export(module.exports, "MENU_ID_GOALS", ()=>$d66e3a3484b422c6$export$47c6ce6a83a59eab);
    $parcel$export(module.exports, "MENU_ID_OPERATIONS", ()=>$d66e3a3484b422c6$export$ef89639b7d9c162a);
    $parcel$export(module.exports, "MENU_ID_OPS_ALERTS", ()=>$d66e3a3484b422c6$export$af4ab6d4e920522a);
    $parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", ()=>$d66e3a3484b422c6$export$25c40acb2c53a294);
    $parcel$export(module.exports, "MENU_ID_OPS_REPORTS", ()=>$d66e3a3484b422c6$export$c7d8892f1628b844);
    $parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", ()=>$d66e3a3484b422c6$export$bb19a52e3df99541);
    $parcel$export(module.exports, "MENU_ID_OVERVIEWS", ()=>$d66e3a3484b422c6$export$3bd12c092f8db11b);
    $parcel$export(module.exports, "MENU_ID_PLANS", ()=>$d66e3a3484b422c6$export$f2533da33c749933);
    $parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$8468c5b6648f4f1f);
    $parcel$export(module.exports, "MENU_ID_PROJECT_APPS", ()=>$d66e3a3484b422c6$export$fed17b4c0866b97d);
    $parcel$export(module.exports, "MENU_ID_PROJECTS", ()=>$d66e3a3484b422c6$export$9c5278bd360a285);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$85389c606bb641dd);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", ()=>$d66e3a3484b422c6$export$4a1974b63c858e9c);
    $parcel$export(module.exports, "MENU_ID_RECENT", ()=>$d66e3a3484b422c6$export$692b796030a796f3);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS", ()=>$d66e3a3484b422c6$export$cdc80d4b5ce0c6a);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", ()=>$d66e3a3484b422c6$export$7606c0134aabf3d7);
    $parcel$export(module.exports, "MENU_ID_STARRED", ()=>$d66e3a3484b422c6$export$5637ca42a4d77f32);
    $parcel$export(module.exports, "MENU_ID_TEAMS", ()=>$d66e3a3484b422c6$export$d4f6fcf571f9c50);
    $parcel$export(module.exports, "MENU_ID_YOUR_WORK", ()=>$d66e3a3484b422c6$export$80dc576e446bdb6b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", ()=>$d66e3a3484b422c6$export$79c15668ed799a1b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", ()=>$d66e3a3484b422c6$export$e299bb06c4370c0d);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", ()=>$d66e3a3484b422c6$export$713b9b0a69a79cf9);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", ()=>$d66e3a3484b422c6$export$f1d9c0f27216aa1c);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", ()=>$d66e3a3484b422c6$export$45763fa331781074);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", ()=>$d66e3a3484b422c6$export$6ee20c845dbab3e3);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", ()=>$d66e3a3484b422c6$export$b3815dd180ce5e61);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", ()=>$d66e3a3484b422c6$export$100a1a639a0db980);
    const $d66e3a3484b422c6$export$7838b734e4cd5e8d = {
        APPS: 'jira.sidebar.apps',
        ASSETS: 'jira.sidebar.assets',
        DASHBOARDS: 'jira.sidebar.dashboards',
        FILTERS: 'jira.sidebar.filters',
        GOALS: 'jira.sidebar.goals',
        OPERATIONS: 'jira.sidebar.operations',
        OVERVIEWS: 'jira.sidebar.overviews',
        PLANS: 'jira.sidebar.plans',
        PROJECTS: 'jira.sidebar.projects',
        RECENT: 'jira.sidebar.recent',
        STARRED: 'jira.sidebar.starred',
        TEAMS: 'jira.sidebar.teams',
        ROADMAPS: 'jira.sidebar.roadmaps'
    };
    const $d66e3a3484b422c6$export$103ff18fe29ee1b = {
        ALARM_QUEUE: (id)=>`alrm_${id}`,
        APP: (id)=>`app_${id}`,
        BOARD: (id)=>`boar_${id}`,
        DASHBOARD: (id)=>`dash_${id}`,
        FILTER: (id)=>`filt_${id}`,
        FORM: (id)=>`form_${id}`,
        OVERVIEW: (id)=>`over_${id}`,
        PLAN: (id)=>`plan_${id}`,
        PROJECT: (id)=>`proj_${id}`,
        PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
        PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
        PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
        PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
        PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
        PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
        PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
        PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
        PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
        PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
        PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
        PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
        PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
        PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
        PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
        PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
        ROADMAP: (id)=>`roadmap_${id}`,
        QUEUE: (id)=>`queu_${id}`
    };
    const $d66e3a3484b422c6$export$441cd608ea3204f4 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.APPS;
    const $d66e3a3484b422c6$export$5baa9c2e3c3931c5 = 'app_mrkt';
    const $d66e3a3484b422c6$export$75c65bfc98b3a6e1 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ASSETS;
    const $d66e3a3484b422c6$export$8a0af92d49f1d13d = 'asst_schm';
    const $d66e3a3484b422c6$export$a09300d15acc958a = 'asst_rprt';
    const $d66e3a3484b422c6$export$4d718fbd418eef5c = 'board-view-all';
    const $d66e3a3484b422c6$export$dd009509c2dabb5e = $d66e3a3484b422c6$export$7838b734e4cd5e8d.DASHBOARDS;
    const $d66e3a3484b422c6$export$d3da0455b4200fb2 = 'dash-view';
    const $d66e3a3484b422c6$export$b9dd2b5309d19763 = 'dash-view-starred';
    const $d66e3a3484b422c6$export$3d81af172a8e3c57 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.FILTERS;
    const $d66e3a3484b422c6$export$1e2599eaf0039a97 = 'filt-search';
    const $d66e3a3484b422c6$export$53d274d993c9d5b5 = 'filt-view-all';
    const $d66e3a3484b422c6$export$7661ea763be69cfa = 'filt-view-starred';
    const $d66e3a3484b422c6$export$47c6ce6a83a59eab = $d66e3a3484b422c6$export$7838b734e4cd5e8d.GOALS;
    const $d66e3a3484b422c6$export$ef89639b7d9c162a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OPERATIONS;
    const $d66e3a3484b422c6$export$af4ab6d4e920522a = 'ops-alrt';
    const $d66e3a3484b422c6$export$25c40acb2c53a294 = 'ops-over';
    const $d66e3a3484b422c6$export$c7d8892f1628b844 = 'ops-rprt';
    const $d66e3a3484b422c6$export$bb19a52e3df99541 = 'ops-oncl';
    const $d66e3a3484b422c6$export$3bd12c092f8db11b = $d66e3a3484b422c6$export$7838b734e4cd5e8d.OVERVIEWS;
    const $d66e3a3484b422c6$export$f2533da33c749933 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PLANS;
    const $d66e3a3484b422c6$export$8468c5b6648f4f1f = 'plan-view-all';
    const $d66e3a3484b422c6$export$fed17b4c0866b97d = 'proj-app';
    const $d66e3a3484b422c6$export$e682260eda678e61 = 'proj-dir';
    const $d66e3a3484b422c6$export$9c5278bd360a285 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.PROJECTS;
    const $d66e3a3484b422c6$export$85389c606bb641dd = 'proj-view-all';
    const $d66e3a3484b422c6$export$4a1974b63c858e9c = 'proj-view-starred';
    const $d66e3a3484b422c6$export$692b796030a796f3 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.RECENT;
    const $d66e3a3484b422c6$export$cdc80d4b5ce0c6a = $d66e3a3484b422c6$export$7838b734e4cd5e8d.ROADMAPS;
    const $d66e3a3484b422c6$export$7606c0134aabf3d7 = 'roadmaps-view-all';
    const $d66e3a3484b422c6$export$5637ca42a4d77f32 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.STARRED;
    const $d66e3a3484b422c6$export$d4f6fcf571f9c50 = $d66e3a3484b422c6$export$7838b734e4cd5e8d.TEAMS;
    const $d66e3a3484b422c6$export$80dc576e446bdb6b = 'yrwk';
    const $d66e3a3484b422c6$export$79c15668ed799a1b = 'sd-sett-acc';
    const $d66e3a3484b422c6$export$e299bb06c4370c0d = 'sd-sett-req-man';
    const $d66e3a3484b422c6$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
    const $d66e3a3484b422c6$export$f1d9c0f27216aa1c = 'sd-sett-aut';
    const $d66e3a3484b422c6$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
    const $d66e3a3484b422c6$export$6ee20c845dbab3e3 = 'sd-sett-not';
    const $d66e3a3484b422c6$export$b3815dd180ce5e61 = 'sd-sett-apps';
    const $d66e3a3484b422c6$export$100a1a639a0db980 = 'sd-sett-ops';
});
parcelRegister("3Jbkp", function(module, exports) {
    $parcel$export(module.exports, "getInitialSelectedPath", ()=>$e52131b0b61339d3$export$39f409bc5f59c5e);
    var $bxYf9 = parcelRequire("bxYf9");
    var $7Ckoi;
    const $e52131b0b61339d3$export$39f409bc5f59c5e = (0, ($parcel$interopDefault($bxYf9)))((0, (0, parcelRequire("7Ckoi")).routeToSelectedPath));
});
parcelRegister("7Ckoi", function(module, exports) {
    $parcel$export(module.exports, "routeToSelectedPath", ()=>$551cdf5d088747a1$export$a92474c098a1fd13);
    var $4R6GH;
    var $fBDpl;
    var $ezq2z;
    var $j3mSh;
    var $1RoZ2;
    var $hdJn1;
    var $2m3Yb;
    var $3weqe;
    var $c6hlO;
    var $3lNyZ;
    var $8bXrC;
    var $eReVn;
    function $551cdf5d088747a1$export$a92474c098a1fd13(routeContext) {
        const routeName = routeContext.route.name;
        if ((0, (0, parcelRequire("2m3Yb")).topLevelConverter).routes.has(routeName)) return (0, (0, parcelRequire("2m3Yb")).topLevelConverter).convert(routeContext);
        if ((0, (0, parcelRequire("fBDpl")).appsConverter).routes.has(routeName)) return (0, (0, parcelRequire("fBDpl")).appsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("ezq2z")).assetsConverter).routes.has(routeName)) return (0, (0, parcelRequire("ezq2z")).assetsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("j3mSh")).dashboardsConverter).routes.has(routeName)) return (0, (0, parcelRequire("j3mSh")).dashboardsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("1RoZ2")).filtersConverter).routes.has(routeName)) return (0, (0, parcelRequire("1RoZ2")).filtersConverter).convert(routeContext);
        if ((0, (0, parcelRequire("hdJn1")).operationsConverter).routes.has(routeName)) return (0, (0, parcelRequire("hdJn1")).operationsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3weqe")).overviewsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3weqe")).overviewsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("c6hlO")).plansConverter).routes.has(routeName)) return (0, (0, parcelRequire("c6hlO")).plansConverter).convert(routeContext);
        if ((0, (0, parcelRequire("3lNyZ")).projectsConverter).routes.has(routeName)) return (0, (0, parcelRequire("3lNyZ")).projectsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("8bXrC")).roadmapsConverter).routes.has(routeName)) return (0, (0, parcelRequire("8bXrC")).roadmapsConverter).convert(routeContext);
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_1')) {
            if ((0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, (0, parcelRequire("eReVn")).serviceManagementProjectSettingsConverter).convert(routeContext);
        }
        return [];
    }
});
parcelRegister("fBDpl", function(module, exports) {
    $parcel$export(module.exports, "appsConverter", ()=>$55a8ac7f9c56fb94$export$d017a63045c88c47);
    var $65Ltd;
    var $jhS4y;
    const $55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT)
    ];
    const $55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX)
    ];
    const $55a8ac7f9c56fb94$export$66b32f6f30eb4b4 = new Set([
        ...$55a8ac7f9c56fb94$var$UNCERTAIN_APPS_SECTION_ROUTES,
        ...$55a8ac7f9c56fb94$var$CERTAIN_APPS_SECTION_ROUTES
    ]);
    function $55a8ac7f9c56fb94$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_APPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_APP_MARKETPLACE_DISCOVER));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
                path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(match.url.replace(/\/$/, '')));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
                {
                    const { projectKey: projectKey } = match.params;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
                {
                    const { projectKey: projectKey } = query;
                    return [
                        (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                        (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            default:
                break;
        }
        return path;
    }
    const $55a8ac7f9c56fb94$export$d017a63045c88c47 = {
        routes: $55a8ac7f9c56fb94$export$66b32f6f30eb4b4,
        convert: $55a8ac7f9c56fb94$var$convert
    };
});
parcelRegister("ezq2z", function(module, exports) {
    $parcel$export(module.exports, "assetsConverter", ()=>$bdd6509d07f3cefb$export$6cfeba0849032a84);
    var $65Ltd;
    var $jhS4y;
    const $bdd6509d07f3cefb$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
    ]);
    function $bdd6509d07f3cefb$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ASSETS_REPORTS));
                break;
            default:
                break;
        }
        return path;
    }
    const $bdd6509d07f3cefb$export$6cfeba0849032a84 = {
        routes: $bdd6509d07f3cefb$var$routes,
        convert: $bdd6509d07f3cefb$var$convert
    };
});
parcelRegister("j3mSh", function(module, exports) {
    $parcel$export(module.exports, "dashboardsConverter", ()=>$257dabfdf8711aa2$export$6468819b4be328b1);
    var $65Ltd;
    var $jhS4y;
    const $257dabfdf8711aa2$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)
    ]);
    function $257dabfdf8711aa2$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD:
                query.dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(query.dashboardId));
                break;
            default:
                {
                    const dashboardId = match.params.dashboardId;
                    if (dashboardId === 'last-visited') path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_DASHBOARDS_VIEW_ALL));
                    else dashboardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).DASHBOARD(dashboardId));
                    break;
                }
        }
        return path;
    }
    const $257dabfdf8711aa2$export$6468819b4be328b1 = {
        routes: $257dabfdf8711aa2$var$routes,
        convert: $257dabfdf8711aa2$var$convert
    };
});
parcelRegister("1RoZ2", function(module, exports) {
    $parcel$export(module.exports, "filtersConverter", ()=>$c2ae3b230f933dc6$export$6e91331b5debb7c8);
    var $65Ltd;
    var $jhS4y;
    const $c2ae3b230f933dc6$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
    ]);
    function $c2ae3b230f933dc6$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query, match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    else if (match.params?.issueKey) {
                        const [projectKey] = (match.params?.issueKey || '').split('-');
                        return [
                            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS),
                            (0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey)
                        ];
                    }
                    break;
                }
            default:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId === undefined) path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_FILTERS_SEARCH));
                    else path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FILTER(filterId));
                    break;
                }
        }
        return path;
    }
    const $c2ae3b230f933dc6$export$6e91331b5debb7c8 = {
        routes: $c2ae3b230f933dc6$var$routes,
        convert: $c2ae3b230f933dc6$var$convert
    };
});
parcelRegister("hdJn1", function(module, exports) {
    $parcel$export(module.exports, "operationsConverter", ()=>$9b181cf5d70a46b3$export$7fc92455d5020e1);
    var $65Ltd;
    var $jhS4y;
    const $9b181cf5d70a46b3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL)
    ]);
    function $9b181cf5d70a46b3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OPERATIONS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ON_CALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
                {
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_ALERTS));
                    const { query: alarmQueue = '', view: view } = query;
                    view && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ALARM_QUEUE(alarmQueue));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_REPORTS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_OPS_OVERVIEW));
                break;
            default:
                break;
        }
        return path;
    }
    const $9b181cf5d70a46b3$export$7fc92455d5020e1 = {
        routes: $9b181cf5d70a46b3$var$routes,
        convert: $9b181cf5d70a46b3$var$convert
    };
});
parcelRegister("2m3Yb", function(module, exports) {
    $parcel$export(module.exports, "topLevelConverter", ()=>$c60c27b55fbcd9c5$export$a33f2d74a674bf8a);
    var $65Ltd;
    var $jhS4y;
    const $c60c27b55fbcd9c5$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX)
    ]);
    function $c60c27b55fbcd9c5$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_YOUR_WORK:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_YOUR_WORK));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_TEAMS));
                break;
            default:
        }
        return path;
    }
    const $c60c27b55fbcd9c5$export$a33f2d74a674bf8a = {
        routes: $c60c27b55fbcd9c5$var$routes,
        convert: $c60c27b55fbcd9c5$var$convert
    };
});
parcelRegister("3weqe", function(module, exports) {
    $parcel$export(module.exports, "overviewsConverter", ()=>$b8a10fc0a37e731b$export$5469f6c6536ca9c5);
    var $65Ltd;
    var $jhS4y;
    const $b8a10fc0a37e731b$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
    ]);
    function $b8a10fc0a37e731b$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_OVERVIEWS)
        ];
        routeName;
        {
            const { overviewId: overviewId } = match.params;
            overviewId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).OVERVIEW(overviewId));
        }
        return path;
    }
    const $b8a10fc0a37e731b$export$5469f6c6536ca9c5 = {
        routes: $b8a10fc0a37e731b$var$routes,
        convert: $b8a10fc0a37e731b$var$convert
    };
});
parcelRegister("c6hlO", function(module, exports) {
    $parcel$export(module.exports, "plansConverter", ()=>$a783e1b6f52291a3$export$3bde637b58016d1);
    var $65Ltd;
    var $jhS4y;
    const $a783e1b6f52291a3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
    ]);
    function $a783e1b6f52291a3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PLANS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
                break;
            default:
                {
                    const { planId: planId } = match.params;
                    planId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PLAN(planId));
                }
        }
        return path;
    }
    const $a783e1b6f52291a3$export$3bde637b58016d1 = {
        routes: $a783e1b6f52291a3$var$routes,
        convert: $a783e1b6f52291a3$var$convert
    };
});
parcelRegister("3lNyZ", function(module, exports) {
    $parcel$export(module.exports, "projectsConverter", ()=>$6eaade1a69d23d1d$export$c41b724886e5872b);
    var $65Ltd;
    var $jhS4y;
    const $6eaade1a69d23d1d$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
    ]);
    function $6eaade1a69d23d1d$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING:
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECTS_VIEW_ALL));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
                {
                    const { projectKey: projectKey, appId: appId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_PROJECT_APPS));
                    appId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).APP(appId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SUMMARY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS:
                {
                    const { projectKey: projectKey, boardId: boardId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_VIEWS(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_REPORTS(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                {
                    const { projectKey: projectKey } = match.params;
                    const filterId = query.filter || query.filterId;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    if (projectKey && filterId) {
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_FILTERS(projectKey));
                        path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                    }
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
                {
                    const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && practiceType && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
                {
                    const { projectKey: projectKey, queueId: queueId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_QUEUES(projectKey));
                    queueId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT_SERVICES(projectKey));
                    break;
                }
            default:
                {
                    const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                    projectKey && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).PROJECT(projectKey));
                    boardId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).BOARD(boardId));
                    formId && path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).FORM(formId));
                }
        }
        return path;
    }
    const $6eaade1a69d23d1d$export$c41b724886e5872b = {
        routes: $6eaade1a69d23d1d$var$routes,
        convert: $6eaade1a69d23d1d$var$convert
    };
});
parcelRegister("8bXrC", function(module, exports) {
    $parcel$export(module.exports, "roadmapsConverter", ()=>$8c39d6aa787bb969$export$5761942b1e0c2dd0);
    var $65Ltd;
    var $jhS4y;
    const $8c39d6aa787bb969$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS)
    ]);
    function $8c39d6aa787bb969$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS)
        ];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS:
                {
                    const collectionId = match.params.collectionUUID;
                    if (collectionId) path.push((0, (0, parcelRequire("jhS4y")).ENTITY_ID).ROADMAP(collectionId));
                    else path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_ROADMAPS_VIEW_ALL));
                    break;
                }
            default:
        }
        return path;
    }
    const $8c39d6aa787bb969$export$5761942b1e0c2dd0 = {
        routes: $8c39d6aa787bb969$var$routes,
        convert: $8c39d6aa787bb969$var$convert
    };
});
parcelRegister("eReVn", function(module, exports) {
    $parcel$export(module.exports, "serviceManagementProjectSettingsConverter", ()=>$59806d8088c642c3$export$dd307ede503fe0e);
    var $65Ltd;
    var $2VkCP;
    var $bOhA4;
    var $2nb5R;
    var $040pa;
    var $YXuQ6;
    var $iQZ89;
    var $jhS4y;
    const $59806d8088c642c3$var$routes = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsLegacyAutomationRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFieldsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChatRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskEmailRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskWidgetRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentConversationsRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentIntentsRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).virtualAgentStandardFlowsRoute).name,
        (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsEmailRoute).name,
        (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
        (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
        (0, (0, parcelRequire("2nb5R")).routeGroupsProjectSettingsServicedeskKbRoute).name,
        (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
        (0, (0, parcelRequire("iQZ89")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
        (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskAutomationRoute).name,
        (0, (0, parcelRequire("040pa")).servicedeskSlaSettingsRoute).name,
        (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
    ]);
    function $59806d8088c642c3$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_ACCESS));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name:
            case (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
                break;
            case (0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
            case (0, (0, parcelRequire("iQZ89")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
            case (0, (0, parcelRequire("040pa")).servicedeskSlaSettingsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFieldsRoute).name:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsLegacyAutomationRoute).name:
            case (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskAutomationRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_AUTOMATION));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskEmailRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChatRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskWidgetRoute).name:
            case (0, (0, parcelRequire("2nb5R")).routeGroupsProjectSettingsServicedeskKbRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentIntentsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentStandardFlowsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentConversationsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).virtualAgentSettingsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_OPERATIONS));
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
            case (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
            case (0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsEmailRoute).name:
            case (0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_NOTIFICATIONS));
                break;
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
            case (0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
                path.push((0, (0, parcelRequire("jhS4y")).MENU_ID_SD_SETTINGS_APPS));
                break;
            default:
                break;
        }
        return path;
    }
    const $59806d8088c642c3$export$dd307ede503fe0e = {
        routes: $59806d8088c642c3$var$routes,
        convert: $59806d8088c642c3$var$convert
    };
});
parcelRegister("2VkCP", function(module, exports) {
    $parcel$export(module.exports, "getJsmProjectSettingsUrl", ()=>$2a557627656b882a$export$b7cec47cdf9c76f1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", ()=>$2a557627656b882a$export$666cdeccf1f430a6);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute", ()=>$2a557627656b882a$export$5ed718db41f9c966);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory", ()=>$2a557627656b882a$export$60b14f135c03f9c7);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", ()=>$2a557627656b882a$export$87914ccacd42ab35);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", ()=>$2a557627656b882a$export$e382068c2b8a7b9f);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskApps1Route", ()=>$2a557627656b882a$export$7ae67c73ac5367a8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", ()=>$2a557627656b882a$export$b237f4f6820b26e9);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", ()=>$2a557627656b882a$export$f7e149bf217bbb2c);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRedirectRoute", ()=>$2a557627656b882a$export$eb1177fbc6c41b97);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", ()=>$2a557627656b882a$export$f919d82b98f9257a);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute", ()=>$2a557627656b882a$export$ce59d5cb98345f8e);
    $parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", ()=>$2a557627656b882a$export$1a2228d5e07202a0);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", ()=>$2a557627656b882a$export$1596046a0b047934);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", ()=>$2a557627656b882a$export$3ab501c22b91462b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", ()=>$2a557627656b882a$export$324e5a618f1ac5a1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", ()=>$2a557627656b882a$export$e6f711e47860f891);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", ()=>$2a557627656b882a$export$4ef3eecacde57780);
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", ()=>$2a557627656b882a$export$40539cb16771014e);
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", ()=>$2a557627656b882a$export$1f37a1aff4f594af);
    $parcel$export(module.exports, "projectSettingsServicedeskNotifications1Route", ()=>$2a557627656b882a$export$18c6f3890d9fd8b8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", ()=>$2a557627656b882a$export$d195c572a6155c05);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", ()=>$2a557627656b882a$export$8152b460f5961d94);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", ()=>$2a557627656b882a$export$e184fa302b6981b6);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", ()=>$2a557627656b882a$export$dd22cfc45fe86c35);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", ()=>$2a557627656b882a$export$b03f0a1a580a902f);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", ()=>$2a557627656b882a$export$d29fa1140db9296d);
    $parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", ()=>$2a557627656b882a$export$abc6508b4dce2d9b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", ()=>$2a557627656b882a$export$680ccfe6e5af63a8);
    $parcel$export(module.exports, "virtualAgentIntentsRoute", ()=>$2a557627656b882a$export$1e70273fc2a407f5);
    $parcel$export(module.exports, "virtualAgentStandardFlowsRoute", ()=>$2a557627656b882a$export$f45c942ecfcc5682);
    $parcel$export(module.exports, "virtualAgentConversationsRoute", ()=>$2a557627656b882a$export$837f003bb6f40f9);
    $parcel$export(module.exports, "virtualAgentSettingsRoute", ()=>$2a557627656b882a$export$80422a49e17dfd6b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", ()=>$2a557627656b882a$export$394d5ca6ce9e5949);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", ()=>$2a557627656b882a$export$e856498dc02e46e8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", ()=>$2a557627656b882a$export$d0198d2da30de212);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", ()=>$2a557627656b882a$export$fe54e02c94ff5613);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", ()=>$2a557627656b882a$export$164572fb58075291);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", ()=>$2a557627656b882a$export$10089d339d8e30d1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", ()=>$2a557627656b882a$export$ff20eaee6cf19401);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", ()=>$2a557627656b882a$export$8e2543080acfc7c2);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", ()=>$2a557627656b882a$export$3a3e70b8651d8d57);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannels5Route", ()=>$2a557627656b882a$export$77d19d35e71558b3);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", ()=>$2a557627656b882a$export$cd46cad965f517e2);
    $parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", ()=>$2a557627656b882a$export$10bafd1256118bb8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRedirectRoute", ()=>$2a557627656b882a$export$43b5b901d4988763);
    var $65Ltd;
    const $2a557627656b882a$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $2a557627656b882a$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$2a557627656b882a$var$SERVICE_DESK_PRODUCT}/projects/${projectKey || ':projectKey'}/settings`;
    const $2a557627656b882a$var$jsmProjectSettingsUrl = $2a557627656b882a$export$b7cec47cdf9c76f1();
    const $2a557627656b882a$export$666cdeccf1f430a6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId?`,
        exact: true
    };
    const $2a557627656b882a$export$5ed718db41f9c966 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes-workflow`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    const $2a557627656b882a$export$60b14f135c03f9c7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/request-types/category/:practice`,
        exact: true
    };
    const $2a557627656b882a$export$87914ccacd42ab35 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/fields`,
        exact: true
    };
    const $2a557627656b882a$export$e382068c2b8a7b9f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/app-fields`,
        exact: true
    };
    const $2a557627656b882a$export$7ae67c73ac5367a8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/:appId?`,
        exact: true
    };
    const $2a557627656b882a$export$b237f4f6820b26e9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/details`,
        exact: true
    };
    const $2a557627656b882a$export$f7e149bf217bbb2c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/access`,
        exact: true
    };
    const $2a557627656b882a$export$eb1177fbc6c41b97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access-redirect`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/people`,
        exact: true
    };
    const $2a557627656b882a$export$f919d82b98f9257a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/forms`,
        exact: true
    };
    const $2a557627656b882a$export$ce59d5cb98345f8e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-jira-form-builder`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/forms/form/:templateFormId/edit`,
        exact: true
    };
    const $2a557627656b882a$export$1a2228d5e07202a0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/automate`
    };
    const $2a557627656b882a$export$1596046a0b047934 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-data-classifications`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/data-classifications`,
        exact: true
    };
    const $2a557627656b882a$export$3ab501c22b91462b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps`,
        exact: true
    };
    const $2a557627656b882a$export$324e5a618f1ac5a1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-features`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/itsm-features`,
        exact: true
    };
    const $2a557627656b882a$export$e6f711e47860f891 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications/internal-notifications`
    };
    const $2a557627656b882a$export$4ef3eecacde57780 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/internal-notifications`
    };
    const $2a557627656b882a$export$40539cb16771014e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications/notification-email`,
        exact: true
    };
    const $2a557627656b882a$export$1f37a1aff4f594af = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notification-email`,
        exact: true
    };
    const $2a557627656b882a$export$18c6f3890d9fd8b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/notifications`,
        exact: true
    };
    const $2a557627656b882a$export$d195c572a6155c05 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language-key`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/language/:languageKey/:sidebarItemKey?`
    };
    const $2a557627656b882a$export$8152b460f5961d94 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/language`,
        exact: true
    };
    const $2a557627656b882a$export$e184fa302b6981b6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/customer-permissions`,
        exact: true
    };
    const $2a557627656b882a$export$dd22cfc45fe86c35 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/customer-permissions`,
        exact: true
    };
    const $2a557627656b882a$export$b03f0a1a580a902f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-email-next-gen`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/email`,
        exact: true
    };
    const $2a557627656b882a$export$d29fa1140db9296d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/email`,
        exact: true
    };
    const $2a557627656b882a$export$abc6508b4dce2d9b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/automation`,
        exact: true
    };
    const $2a557627656b882a$export$680ccfe6e5af63a8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent`,
        exact: true
    };
    const $2a557627656b882a$export$1e70273fc2a407f5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/intents`,
        exact: true
    };
    const $2a557627656b882a$export$f45c942ecfcc5682 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/standard-flows`,
        exact: true
    };
    const $2a557627656b882a$export$837f003bb6f40f9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/conversations`,
        exact: true
    };
    const $2a557627656b882a$export$80422a49e17dfd6b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/virtual-agent/settings`,
        exact: true
    };
    const $2a557627656b882a$export$394d5ca6ce9e5949 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/portal-settings`,
        exact: true
    };
    const $2a557627656b882a$export$e856498dc02e46e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/portal-settings/:subPath(portal-groups)?`,
        exact: true
    };
    const $2a557627656b882a$export$d0198d2da30de212 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/external-links`,
        exact: true
    };
    const $2a557627656b882a$export$fe54e02c94ff5613 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/widget`,
        exact: true
    };
    const $2a557627656b882a$export$164572fb58075291 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/widget`,
        exact: true
    };
    const $2a557627656b882a$export$10089d339d8e30d1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/change-management`,
        exact: true
    };
    const $2a557627656b882a$export$ff20eaee6cf19401 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/incident-management`,
        exact: true
    };
    const $2a557627656b882a$export$8e2543080acfc7c2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels/chat`,
        exact: true
    };
    const $2a557627656b882a$export$3a3e70b8651d8d57 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/chat`,
        exact: true
    };
    const $2a557627656b882a$export$77d19d35e71558b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/channels`,
        exact: true
    };
    const $2a557627656b882a$export$cd46cad965f517e2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/feedback-settings`
    };
    const $2a557627656b882a$export$10bafd1256118bb8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS),
        path: `${$2a557627656b882a$var$jsmProjectSettingsUrl}/apps/:appId/:envId/:route?`
    };
    const $2a557627656b882a$export$43b5b901d4988763 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-redirect`,
        path: $2a557627656b882a$var$jsmProjectSettingsUrl
    };
});
parcelRegister("bOhA4", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", ()=>$2d3fa729818e1379$export$7fc567ce6cdc6b52);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", ()=>$2d3fa729818e1379$export$688d2c8abd7b3661);
    var $65Ltd;
    const $2d3fa729818e1379$export$5575497f0592ee94 = 'servicedesk';
    const $2d3fa729818e1379$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $2d3fa729818e1379$export$7fc567ce6cdc6b52 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
        path: `${$2d3fa729818e1379$var$projectSettingsUrl($2d3fa729818e1379$export$5575497f0592ee94)}/customer-notifications`
    };
    const $2d3fa729818e1379$export$688d2c8abd7b3661 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
        path: `${$2d3fa729818e1379$var$projectSettingsUrl($2d3fa729818e1379$export$5575497f0592ee94)}/notifications/customer-notifications`
    };
});
parcelRegister("2nb5R", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", ()=>$787a3748538c85bb$export$8855316927afaed1);
    var $65Ltd;
    const $787a3748538c85bb$export$5575497f0592ee94 = 'servicedesk';
    const $787a3748538c85bb$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $787a3748538c85bb$export$8855316927afaed1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
        path: `${$787a3748538c85bb$var$projectSettingsUrl($787a3748538c85bb$export$5575497f0592ee94)}/confluence-kb`,
        exact: true
    };
});
parcelRegister("040pa", function(module, exports) {
    $parcel$export(module.exports, "servicedeskSlaSettingsRoute", ()=>$b24230704c8d21b6$export$bfbf66468910573e);
    var $65Ltd;
    const $b24230704c8d21b6$export$5575497f0592ee94 = 'servicedesk';
    const $b24230704c8d21b6$export$bfbf66468910573e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
    };
});
parcelRegister("YXuQ6", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", ()=>$810950199d0bd223$export$cd0f363eecbc2379);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute", ()=>$810950199d0bd223$export$96fd54e139924473);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", ()=>$810950199d0bd223$export$1eebd582a7db1c90);
    var $65Ltd;
    const $810950199d0bd223$export$5575497f0592ee94 = 'servicedesk';
    const $810950199d0bd223$export$cd0f363eecbc2379 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
        path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned`
    };
    const $810950199d0bd223$export$96fd54e139924473 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-types-config`,
        path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice`
    };
    const $810950199d0bd223$export$1eebd582a7db1c90 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
        path: `/jira/${$810950199d0bd223$export$5575497f0592ee94}/projects/:projectKey/settings/request-types`
    };
});
parcelRegister("iQZ89", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", ()=>$c6b26f9ea53dbefe$export$ad30542ae2fd7196);
    var $65Ltd;
    const $c6b26f9ea53dbefe$export$ad30542ae2fd7196 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
        path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
        exact: true
    };
});
parcelRegister("fMcVX", function(module, exports) {
    $parcel$export(module.exports, "isSelectedPath", ()=>$ad785f9726254880$export$cdcd6885320eec31);
    var $lhMtU;
    function $ad785f9726254880$export$cdcd6885320eec31(path, ...args) {
        const next = (menuId)=>{
            return (0, (0, parcelRequire("lhMtU")).isMenuIdList)(menuId) ? (0, (0, parcelRequire("lhMtU")).toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
        };
        if (args.length === 0) return next;
        return next(args[0]);
    }
});
parcelRegister("lhMtU", function(module, exports) {
    $parcel$export(module.exports, "toMenuIdFromMenuIdList", ()=>$dc9d941dfadd4b5a$export$253323efd0c41e72);
    $parcel$export(module.exports, "isMenuIdList", ()=>$dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed);
    $parcel$export(module.exports, "toMenuIdList", ()=>$dc9d941dfadd4b5a$export$d8e017f58178e379);
    const $dc9d941dfadd4b5a$var$MENU_ID_DELIM = '   ';
    function $dc9d941dfadd4b5a$export$253323efd0c41e72(menuIds) {
        return menuIds.join($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
    function $dc9d941dfadd4b5a$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
        return maybeMenuIdList.indexOf($dc9d941dfadd4b5a$var$MENU_ID_DELIM) !== -1;
    }
    function $dc9d941dfadd4b5a$export$d8e017f58178e379(menuIdList) {
        return menuIdList.split($dc9d941dfadd4b5a$var$MENU_ID_DELIM);
    }
});
parcelRegister("2OeZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70949048397986dd$export$2e2bcd8739ae039);
    const $70949048397986dd$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isAppsExpanded"
        }, v2 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDashboardsExpanded"
        }, v3 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isFiltersExpanded"
        }, v4 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOperationsExpanded"
        }, v5 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOverviewsExpanded"
        }, v6 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPlansExpanded"
        }, v7 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isProjectsExpanded"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v12 = {
            "kind": "ScalarField",
            "name": "label"
        }, v13 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v14 = {
            "kind": "ScalarField",
            "name": "url"
        }, v15 = {
            "order": "DESC"
        }, v16 = {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v20 = {
            "kind": "InlineFragment",
            "selections": [
                v8
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v21 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v22 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v23 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v24 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            v18,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            v19,
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v20
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v11,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v8
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v23,
                            {
                                "args": v21,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v22,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v20
                ]
            }
        ], v25 = {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }, v26 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v27 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v11,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v8
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v29 = {
            "kind": "ScalarField",
            "name": "title"
        }, v30 = {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                v19,
                v8
            ]
        }, v31 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            v29,
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            v30,
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v8
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    v20
                ]
            }
        ], v32 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v11,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            v29,
                            v30
                        ],
                        "type": "JiraDashboard"
                    },
                    v20
                ]
            }
        ], v33 = [
            v8,
            v18,
            {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ConfigurableMenuItems"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v6,
                    v7,
                    v4,
                    v5
                ],
                "kind": "Operation",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudID",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "navKey",
                                        "value": "NAV_SIDEBAR"
                                    }
                                ],
                                "concreteType": "JiraUserNavigationConfiguration",
                                "kind": "LinkedField",
                                "name": "userNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigurableNavigationItem",
                                        "kind": "LinkedField",
                                        "name": "navItems",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "menuId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isVisible"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v9,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "condition": "isAppsExpanded",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "globalAppNavigationItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v12,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "envLabel"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v13,
                                                                    {
                                                                        "concreteType": "JiraAppSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "sections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v12,
                                                                                    v14,
                                                                                    v13
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "settingsUrl"
                                                                    },
                                                                    v14
                                                                ],
                                                                "type": "JiraAppNavigationItem"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v10,
                                "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                "kind": "LinkedField",
                                "name": "jwmOverviews",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v10,
                                "concreteType": "JiraAdvancedRoadmapsNavigation",
                                "kind": "LinkedField",
                                "name": "advancedRoadmapsNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasEditPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasCreateSamplePlanPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasGlobalPlansAdminPermissions"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentProjects",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PROJECT"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v24
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementLicensing",
                                        "kind": "LinkedField",
                                        "name": "jwmLicensing",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentUserSeatEdition"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isFiltersExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteFilters",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "FILTER"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    v18,
                                                                    v8,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentFilters",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "FILTER"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v26,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v18,
                                                                            v8,
                                                                            v19,
                                                                            v27,
                                                                            v28
                                                                        ],
                                                                        "type": "JiraFilter",
                                                                        "abstractKey": "__isJiraFilter"
                                                                    }
                                                                ],
                                                                "type": "JiraCustomFilter"
                                                            },
                                                            v20
                                                        ]
                                                    }
                                                ]
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "args": v10,
                                        "concreteType": "JiraSystemFilterConnection",
                                        "kind": "LinkedField",
                                        "name": "systemFilters",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilterEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraSystemFilter",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v26,
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v18,
                                                                    v11,
                                                                    v19,
                                                                    v27,
                                                                    v28
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isPlansExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouritePlans",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "PLAN"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "recentPlans",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PLAN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isDashboardsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "dashboardFavourites",
                                        "args": [
                                            v9,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v15,
                                                    "type": "DASHBOARD"
                                                }
                                            },
                                            v16
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    },
                                    {
                                        "alias": "dashboardRecents",
                                        "args": [
                                            v9,
                                            v25,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "DASHBOARD"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            v23
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOperationsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "OpsgenieQuery",
                                "kind": "LinkedField",
                                "name": "opsgenie",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "OpsgenieSavedSearches",
                                        "kind": "LinkedField",
                                        "name": "savedSearches",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "sharedWithMe",
                                                "plural": true,
                                                "selections": v33
                                            },
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "createdByMe",
                                                "plural": true,
                                                "selections": v33
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOverviewsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10,
                                        "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmOverviews",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraWorkManagementGiraOverview",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5ad34dbd3295f1e92b107036d33e96821560910a345245b86b33d7a7034dd31b",
                "metadata": {},
                "name": "L1MenuItemsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $70949048397986dd$var$node.hash = "3924b1f11b61ac6cf33dddcea40b965b";
    var $70949048397986dd$export$2e2bcd8739ae039 = $70949048397986dd$var$node;
});
parcelRegister("fZBia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c8513a288fea00$export$2e2bcd8739ae039);
    const $79c8513a288fea00$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "leftSidebarWidth"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.leftSidebarWidth"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
                "metadata": {},
                "name": "sidebarSelectorQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $79c8513a288fea00$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
    var $79c8513a288fea00$export$2e2bcd8739ae039 = $79c8513a288fea00$var$node;
});
parcelRegister("h9iZl", function(module, exports) {
    $parcel$export(module.exports, "navigationPlansVisibilityResource", ()=>$66eb980ebca35ddf$export$fa475a9581133779);
    $parcel$export(module.exports, "useNavigationPlansVisibility", ()=>$66eb980ebca35ddf$export$4524245d4e74edb2);
    $parcel$export(module.exports, "useNavigationViewPlansPermission", ()=>$66eb980ebca35ddf$export$98eef08fd4586a4);
    $parcel$export(module.exports, "useNavigationEditPlansPermission", ()=>$66eb980ebca35ddf$export$525db876ed776e0d);
    $parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", ()=>$66eb980ebca35ddf$export$54805a2120a31ad0);
    var $dJl1T;
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $66eb980ebca35ddf$export$fa475a9581133779 = (0, $dIdda.createResource)({
        type: (0, $94526093207618a3$export$9260ddb6dfeafd7b),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: tenantContext })=>{
            try {
                if (tenantContext.isAnonymous) return false;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
                return response;
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $94526093207618a3$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
            }
            return false;
        },
        maxAge: Infinity
    });
    const $66eb980ebca35ddf$export$4524245d4e74edb2 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isVisible = false;
        if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
        return [
            isVisible
        ];
    };
    const $66eb980ebca35ddf$export$98eef08fd4586a4 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let hasEditOrViewPermissions = false;
        if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
        return [
            hasEditOrViewPermissions
        ];
    };
    const $66eb980ebca35ddf$export$525db876ed776e0d = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let canEditPlans = false;
        if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
        return canEditPlans;
    };
    const $66eb980ebca35ddf$export$54805a2120a31ad0 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($66eb980ebca35ddf$export$fa475a9581133779);
        let isAdvancedRoadmapsTrial = false;
        if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
        return isAdvancedRoadmapsTrial;
    };
});
const $94526093207618a3$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $94526093207618a3$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';
parcelRegister("2eyDn", function(module, exports) {
    $parcel$export(module.exports, "consentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$785c22104b6f2285);
    $parcel$export(module.exports, "useConsentBannerUserPreferencesResource", ()=>$7912ae5bd04d670f$export$5bc7e83e85567fb4);
    var $e7OnS;
    var $3TzYp;
    var $4R6GH;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $7912ae5bd04d670f$export$785c22104b6f2285 = (0, $dIdda.createResource)({
        type: (0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b),
        getKey: ()=>(0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155),
        getData: async ()=>{
            const consentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_COOKIE_KEY));
            const fallbackConsentToken = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-browser-storage-bump-3')) {
                if (consentToken) return {
                    consentToken: consentToken,
                    fallbackConsentToken: fallbackConsentToken
                };
            } else {
                const currentLocale = (0, (0, parcelRequire("3TzYp")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
                if (consentToken && currentLocale) return {
                    consentToken: consentToken,
                    currentLocale: currentLocale,
                    fallbackConsentToken: fallbackConsentToken
                };
            }
            const data = await (0, (0, parcelRequire("eusud")).performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
            return data;
        },
        maxAge: 900000,
        isBrowserOnly: true
    });
    const $7912ae5bd04d670f$export$5bc7e83e85567fb4 = ()=>(0, $dIdda.useResource)($7912ae5bd04d670f$export$785c22104b6f2285);
});
parcelRegister("e7OnS", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>$a488cd5ca5197429$export$10d7db8e1a856fd8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>$a488cd5ca5197429$export$435de28e5b000487);
    $parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>$a488cd5ca5197429$export$4b17acc0e875ba2a);
    $parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>$a488cd5ca5197429$export$f57af01b64fc97b8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>$a488cd5ca5197429$export$23a1e02c3c0b0d08);
    $parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", ()=>$a488cd5ca5197429$export$37073d560ecebada);
    $parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", ()=>$a488cd5ca5197429$export$b28b5d760fe14a21);
    $parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", ()=>$a488cd5ca5197429$export$4a12f9e99971760a);
    $parcel$export(module.exports, "DEFAULT_PREFERENCES", ()=>$a488cd5ca5197429$export$f0fd1d13ec1d48f2);
    $parcel$export(module.exports, "V001_SCHEMA_KEY", ()=>$a488cd5ca5197429$export$f95182b7aa141c57);
    $parcel$export(module.exports, "V002_SCHEMA_KEY", ()=>$a488cd5ca5197429$export$1f25427b34f9c405);
    $parcel$export(module.exports, "V003_SCHEMA_KEY", ()=>$a488cd5ca5197429$export$31deaeaebce525bb);
    var $iG1qD;
    const $a488cd5ca5197429$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
    const $a488cd5ca5197429$export$435de28e5b000487 = 'atl-bsc-consent-token';
    const $a488cd5ca5197429$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
    const $a488cd5ca5197429$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
    const $a488cd5ca5197429$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
    const $a488cd5ca5197429$export$37073d560ecebada = 'atl-testing-consents';
    const $a488cd5ca5197429$export$b28b5d760fe14a21 = {
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: true
    };
    const $a488cd5ca5197429$export$4a12f9e99971760a = {
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary]: true,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional]: false,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing]: false,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics]: false,
        [(0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown]: false
    };
    const $a488cd5ca5197429$export$f0fd1d13ec1d48f2 = {
        ...$a488cd5ca5197429$export$4a12f9e99971760a,
        [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentsAreDefault]: true,
        [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).UserIsAuthenticated]: false,
        [(0, (0, parcelRequire("iG1qD")).ContextualConsentProperty).ConsentDataUnavailable]: true
    };
    const $a488cd5ca5197429$export$f95182b7aa141c57 = '001';
    const $a488cd5ca5197429$export$1f25427b34f9c405 = '002';
    const $a488cd5ca5197429$export$31deaeaebce525bb = '003';
});
parcelRegister("iG1qD", function(module, exports) {
    $parcel$export(module.exports, "PreferenceCategory", ()=>$d98d41ec52002465$export$ba064dbfe4bb66d7);
    $parcel$export(module.exports, "ConsentPreferenceV2", ()=>$d98d41ec52002465$export$cdef20bac194f235);
    $parcel$export(module.exports, "ContextualConsentProperty", ()=>$d98d41ec52002465$export$fac80ad19b60e313);
    $parcel$export(module.exports, "PrefetchedPreferenceState", ()=>$d98d41ec52002465$export$5d6594a0bba4ab8a);
    $parcel$export(module.exports, "CachedKeysDataProperty", ()=>$d98d41ec52002465$export$cd5dd043a4a3cfee);
    $parcel$export(module.exports, "Status", ()=>$d98d41ec52002465$export$96e9906d6d93a972);
    let $d98d41ec52002465$export$ba064dbfe4bb66d7 = function(PreferenceCategory) {
        PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
        PreferenceCategory["Functional"] = "FUNCTIONAL";
        PreferenceCategory["Marketing"] = "MARKETING";
        PreferenceCategory["Analytics"] = "ANALYTICS";
        PreferenceCategory["Unknown"] = "UNKNOWN";
        return PreferenceCategory;
    }({});
    let $d98d41ec52002465$export$cdef20bac194f235 = function(ConsentPreferenceV2) {
        ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
        ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
        ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
        ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
        return ConsentPreferenceV2;
    }({});
    let $d98d41ec52002465$export$fac80ad19b60e313 = function(ContextualConsentProperty) {
        ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
        ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
        ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        return ContextualConsentProperty;
    }({});
    let $d98d41ec52002465$export$5d6594a0bba4ab8a = function(PrefetchedPreferenceState) {
        PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
        return PrefetchedPreferenceState;
    }({});
    let $d98d41ec52002465$export$cd5dd043a4a3cfee = function(CachedKeysDataProperty) {
        CachedKeysDataProperty["LocalStorage"] = "localStorageKeys";
        CachedKeysDataProperty["SessionStorage"] = "sessionStorageKeys";
        CachedKeysDataProperty["Cookies"] = "keys";
        CachedKeysDataProperty["ThirdParty"] = "thirdPartyKeys";
        return CachedKeysDataProperty;
    }({});
    let $d98d41ec52002465$export$96e9906d6d93a972 = function(Status) {
        Status["SUCCESS"] = "SUCCESS";
        Status["BLOCKED"] = "BLOCKED";
        Status["FAILED"] = "FAILED";
        return Status;
    }({});
});
const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';
parcelRegister("drGWM", function(module, exports) {
    $parcel$export(module.exports, "checkApiKeyManagementKeysResource", ()=>$ea67ffb8a72e0299$export$b16eaa5246afc9b6);
    var $j74qU;
    var $3H5ry;
    var $dIdda = parcelRequire("dIdda");
    const $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
        if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
    };
    const $ea67ffb8a72e0299$export$b16eaa5246afc9b6 = ()=>(0, $dIdda.createResource)({
            type: (0, $9b8f6422d397a375$export$5879151f0d972f18),
            getKey: ()=>'check-api-key-management-keys',
            getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
                const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
                const isTransitioning = (0, (0, parcelRequire("3H5ry")).checkIsTransitioning)(tenantInfo);
                return $ea67ffb8a72e0299$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
            },
            maxAge: Infinity,
            isBrowserOnly: true,
            depends: [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]
        });
});
parcelRegister("j74qU", function(module, exports) {
    $parcel$export(module.exports, "eocFetch", ()=>$e038c50dbacfc9f4$export$212b9c60150b5a0a);
    var $bFU4G;
    var $aI12f;
    var $030R0;
    const $e038c50dbacfc9f4$export$212b9c60150b5a0a = (input, init)=>{
        let headers = init?.headers ?? {};
        let body = init?.body;
        if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
            body = JSON.stringify(body);
            headers['Content-Type'] = 'application/json';
        }
        if (typeof input === 'string') input = (0, (0, parcelRequire("030R0")).withPrefix)(input, init);
        else input = {
            ...input,
            url: (0, (0, parcelRequire("030R0")).withPrefix)(input.url, init)
        };
        const errorTransformer = init?.errorTransformer ?? (0, (0, parcelRequire("030R0")).defaultErrorTransformer);
        const startTime = performance.now();
        return fetch(input, {
            headers: headers,
            ...init,
            body: body
        }).catch((error)=>{
            throw new (0, (0, parcelRequire("aI12f")).NetworkError)(error.name, error);
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("aI12f")).HTTPError)(response);
            const sanitizedUrl = (0, (0, parcelRequire("030R0")).sanitizeUrlString)((0, (0, parcelRequire("030R0")).getRequestUrl)(input));
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now());
            switch(init?.responseType){
                case undefined:
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'headers':
                    return response;
            }
        }).catch((error)=>{
            if ((0, (0, parcelRequire("aI12f")).isNetworkError)(error)) {
                const transformerResult = errorTransformer(error);
                if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                    throw finalError;
                });
                else throw transformerResult;
            }
            throw error;
        });
    };
});
parcelRegister("aI12f", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$c2cf5dfa0e96b9de$export$bae979e68e4dc802);
    $parcel$export(module.exports, "HTTPError", ()=>$c2cf5dfa0e96b9de$export$aa9d629c530f62a7);
    $parcel$export(module.exports, "StreamedHTTPError", ()=>$c2cf5dfa0e96b9de$export$c30b5b02747d791c);
    $parcel$export(module.exports, "isHTTPError", ()=>$c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f);
    $parcel$export(module.exports, "isNetworkError", ()=>$c2cf5dfa0e96b9de$export$476aa014e2fd89d5);
    $parcel$export(module.exports, "isStreamedHTTPError", ()=>$c2cf5dfa0e96b9de$export$4f52fcea95c8f97d);
    var $60Rff;
    class $c2cf5dfa0e96b9de$export$bae979e68e4dc802 extends Error {
        constructor(name, cause){
            super('Network Error!');
            this.name = name;
            this.cause = cause;
        }
    }
    class $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 extends $c2cf5dfa0e96b9de$export$bae979e68e4dc802 {
        constructor(response){
            super((0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError);
            this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
            this.response = response;
        }
    }
    class $c2cf5dfa0e96b9de$export$c30b5b02747d791c extends $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 {
        constructor(cause, data, message){
            super(cause.response);
            this.cause = cause;
            this.data = data;
            this.message = message;
            this.message = message;
            this.name = (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError;
        }
    }
    const $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 || [
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $c2cf5dfa0e96b9de$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$bae979e68e4dc802 || [
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).NetworkError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).HTTPError,
            (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$c30b5b02747d791c || candidate?.name === (0, (0, parcelRequire("60Rff")).ERROR_NAMES).StreamedHTTPError;
});
parcelRegister("60Rff", function(module, exports) {
    $parcel$export(module.exports, "ERROR_NAMES", ()=>$3500a6ac498ab4f6$export$daceac3b97803ce1);
    var $3500a6ac498ab4f6$export$daceac3b97803ce1;
    (function(ERROR_NAMES) {
        ERROR_NAMES["HTTPError"] = "HTTPError";
        ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
        ERROR_NAMES["NetworkError"] = "NetworkError";
    })($3500a6ac498ab4f6$export$daceac3b97803ce1 || ($3500a6ac498ab4f6$export$daceac3b97803ce1 = {}));
});
parcelRegister("030R0", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$bc491f1610486b68$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "withPrefix", ()=>$bc491f1610486b68$export$44188c5f179c4553);
    $parcel$export(module.exports, "defaultErrorTransformer", ()=>$bc491f1610486b68$export$270fcc0e5df09fdd);
    $parcel$export(module.exports, "jsmErrorTransformer", ()=>$bc491f1610486b68$export$994cc82144d28ded);
    $parcel$export(module.exports, "getRequestUrl", ()=>$bc491f1610486b68$export$14619c0eed01a470);
    $parcel$export(module.exports, "sanitizeUrlString", ()=>$bc491f1610486b68$export$ceb09b958e605eff);
    var $gIuON;
    var $aI12f;
    let $bc491f1610486b68$var$metaCloudId;
    let $bc491f1610486b68$var$isJSMAvailable = true;
    function $bc491f1610486b68$export$c47913ca32a5c6f7(name) {
        const globalVariable = window ?? $parcel$global;
        if ((0, (0, parcelRequire("gIuON")).isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
        if ($bc491f1610486b68$var$metaCloudId) return $bc491f1610486b68$var$metaCloudId;
        if ($bc491f1610486b68$var$isJSMAvailable) {
            const element = document.querySelector(`meta[name="${name}"]`);
            $bc491f1610486b68$var$metaCloudId = element?.getAttribute('content') ?? undefined;
            $bc491f1610486b68$var$isJSMAvailable = !!$bc491f1610486b68$var$metaCloudId;
        }
        return $bc491f1610486b68$var$metaCloudId;
    }
    function $bc491f1610486b68$export$5a75f4aeb58ba80f(id) {
        $bc491f1610486b68$var$metaCloudId = id;
    }
    function $bc491f1610486b68$export$44188c5f179c4553(input, init) {
        if (init?.exactUrl) return input;
        if (window.__OG__) return '/webapi' + input;
        const cloudId = $bc491f1610486b68$export$c47913ca32a5c6f7('ajs-cloud-id');
        if (cloudId) return (0, $2021409bef50eca5$export$3414665826fa030e) + cloudId + input;
        return input;
    }
    const $bc491f1610486b68$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
    const $bc491f1610486b68$export$270fcc0e5df09fdd = (e)=>{
        if (e instanceof (0, (0, parcelRequire("aI12f")).HTTPError)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
            return e.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(e, message, message));
        }
        return e;
    };
    const $bc491f1610486b68$export$994cc82144d28ded = (error)=>{
        if (error instanceof (0, (0, parcelRequire("aI12f")).HTTPError)) {
            const contentType = error.response.headers.get('Content-Type');
            if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(error, data, data.errorMessages.join(',')));
            return error.response.text().then((message)=>new (0, (0, parcelRequire("aI12f")).StreamedHTTPError)(error, message, message));
        }
        return error;
    };
    const $bc491f1610486b68$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
    const $bc491f1610486b68$export$ceb09b958e605eff = (url)=>{
        const urlWithoutQueryParams = url.replace(/\?.*$/, '');
        const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
        return urlWithoutUUIDs;
    };
});
parcelRegister("gIuON", function(module, exports) {
    $parcel$export(module.exports, "isServer", ()=>$a110d4649f6250fb$export$6acf61af03e62db);
    const $a110d4649f6250fb$export$6acf61af03e62db = ()=>{
        try {
            return false;
        } catch (error) {
            return globalThis.false ?? false;
        }
    };
});
const $2021409bef50eca5$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';
parcelRegister("3H5ry", function(module, exports) {
    $parcel$export(module.exports, "checkShouldUseJSM", ()=>$bc03080c674ccba2$export$5e0f3a0d8463fa21);
    $parcel$export(module.exports, "checkIsTransitioning", ()=>$bc03080c674ccba2$export$d2f281fd4bf10855);
    $parcel$export(module.exports, "checkIsConsolidated", ()=>$bc03080c674ccba2$export$57f75aebff17dd1e);
    $parcel$export(module.exports, "checkIsTransitioned", ()=>$bc03080c674ccba2$export$b6461b23ee0e1471);
    $parcel$export(module.exports, "checkIsTransitionEligible", ()=>$bc03080c674ccba2$export$24040115cac5fdc3);
    $parcel$export(module.exports, "checkShouldAccessUnlockOperations", ()=>$bc03080c674ccba2$export$cd227238525e8d57);
    var $bgC2H;
    const $bc03080c674ccba2$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$d2f281fd4bf10855 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONING;
    };
    const $bc03080c674ccba2$export$57f75aebff17dd1e = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED;
    };
    const $bc03080c674ccba2$export$b6461b23ee0e1471 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).TRANSITIONED;
    };
    const $bc03080c674ccba2$export$24040115cac5fdc3 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1);
    };
    const $bc03080c674ccba2$export$cd227238525e8d57 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, (0, parcelRequire("bgC2H")).ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $47a35bf911de1c9b$export$a101f3562b5f0742));
    };
});
parcelRegister("bgC2H", function(module, exports) {
    $parcel$export(module.exports, "ConsolidationState", ()=>$927cd31b0e0ee4e8$export$9ef498b0a11fd37d);
    const $927cd31b0e0ee4e8$export$9ef498b0a11fd37d = {
        NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
        TRANSITIONING: 'TRANSITIONING',
        TRANSITIONED: 'TRANSITIONED',
        CONSOLIDATED: 'CONSOLIDATED'
    };
});
const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';
const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';
const $9b8f6422d397a375$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';
parcelRegister("kMiZJ", function(module, exports) {
    $parcel$export(module.exports, "consolidationUserStateResource", ()=>$1e0457dbe68ab17d$export$4b870505c49999ef);
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    var $9QTNT;
    const $1e0457dbe68ab17d$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
    const $1e0457dbe68ab17d$export$4b870505c49999ef = (0, $dIdda.createResource)({
        type: $1e0457dbe68ab17d$var$RESOURCE_KEY,
        getKey: ()=>$1e0457dbe68ab17d$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, (0, parcelRequire("9QTNT")).getOgConsolidationUserState)(accountId).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'consolidationUserStateResource',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }),
        maxAge: Infinity
    });
});
parcelRegister("9QTNT", function(module, exports) {
    $parcel$export(module.exports, "getOgConsolidationUserState", ()=>$1a9945d1ee35f024$export$df7594d56c9ebe57);
    var $89SaW;
    var $jcw0u;
    var $jJZqs;
    var $iXaZ3;
    const $1a9945d1ee35f024$export$df7594d56c9ebe57 = (accountId)=>{
        if (!accountId) return Promise.resolve((0, (0, parcelRequire("iXaZ3")).ERROR_CONSOLIDATION_USER_STATE));
        return (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, (0, parcelRequire("iXaZ3")).OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
            if (!val || typeof val !== 'object') {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getUserProperty',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: new (0, (0, parcelRequire("jJZqs")).ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            }
            if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE), key)))
            };
            if (!Object.keys((0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) return {
                ...(0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE),
                ...val
            };
            return val;
        }).catch((error)=>{
            if (error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.statusCode === 404) return 0, (0, parcelRequire("iXaZ3")).DEFAULT_CONSOLIDATION_USER_STATE;
            throw error;
        });
    };
});
parcelRegister("iXaZ3", function(module, exports) {
    $parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", ()=>$58f10b27bad0d860$export$1980758e2622af02);
    $parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$51d9907e9d716d);
    $parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", ()=>$58f10b27bad0d860$export$23da4710c3a29eae);
    const $58f10b27bad0d860$export$1980758e2622af02 = 'eoc_consolidation_user_state';
    const $58f10b27bad0d860$export$51d9907e9d716d = {
        isPromotionBannerDismissed: false,
        isWelcomeModalDisplayed: false,
        isTransitionHomeHidden: false,
        isTransitionBannerDismissed: false,
        isBroadcastWidgetDismissed: false,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: false
    };
    const $58f10b27bad0d860$export$23da4710c3a29eae = {
        isPromotionBannerDismissed: true,
        isWelcomeModalDisplayed: true,
        isTransitionHomeHidden: true,
        isTransitionBannerDismissed: true,
        isBroadcastWidgetDismissed: true,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: true
    };
});
parcelRegister("bHhiy", function(module, exports) {
    $parcel$export(module.exports, "getConsolidationStateResource", ()=>$cd33a435a46904ef$export$a6cf5054d4f9f5dd);
    var $j74qU;
    var $co1wz;
    var $4R6GH;
    var $dIdda = parcelRequire("dIdda");
    var $bgC2H;
    const $cd33a435a46904ef$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
        let url = '/internal/v1/customers/tenant-info';
        if (cloudId) url = `${url}/${cloudId}`;
        else throw new Error('No tenant info exists.');
        let promise;
        if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
            promise = new Promise((resolve)=>{
                resolve({
                    consolidationState: (0, (0, parcelRequire("bgC2H")).ConsolidationState).NOT_CONSOLIDATED
                });
            });
            return promise;
        }
        if (false) promise = (0, (0, parcelRequire("j74qU")).eocFetch)(url, {
            exactUrl: true,
            headers: {
                'x-ssr-service-name': (0, (0, parcelRequire("4R6GH")).fg)('tenant-info-issuer-change') ? 'og-customer-int-api' : 'og-apigw-atlassian-gw'
            }
        });
        else promise = (0, (0, parcelRequire("j74qU")).eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
        if ((0, (0, parcelRequire("co1wz")).ff)('eoc-tenant-info-hook_dq6ke')) return promise;
        return promise.then((response)=>response.consolidationState);
    };
    const $cd33a435a46904ef$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $dIdda.createResource)({
            type: (0, $5a94e356f9d5e220$export$25ee35b01de9d734),
            getKey: ()=>'tenantInformation',
            getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$cd33a435a46904ef$export$de6c19ae237c1eb9(cloudId, appPermissions),
            maxAge: Infinity,
            isBrowserOnly: forceBrowser
        });
});
parcelRegister("aA974", function(module, exports) {
    $parcel$export(module.exports, "gicSmartFieldsFeatureResource", ()=>$d18db694553f5610$export$ee94bb1f59b07e35);
    $parcel$export(module.exports, "useIsSmartFieldsOptIn", ()=>$d18db694553f5610$export$3870b1ff1b155c73);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $aHuqL;
    var $dIdda = parcelRequire("dIdda");
    const $d18db694553f5610$export$ee94bb1f59b07e35 = (0, $dIdda.createResource)({
        type: (0, $814b0a0376a60368$export$6f0555de4f60e84e),
        getKey: ()=>(0, $814b0a0376a60368$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                const data = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $814b0a0376a60368$export$b94951a11282ae6a));
                if (!data) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                return data;
            } catch (error) {
                if (error.statusCode === 404) return {
                    hasUserOptedOut: false,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'gicSmartFieldsFeatureResource',
                        packageName: (0, $814b0a0376a60368$export$b8b9d90f9e5bd72b),
                        teamName: 'deliveroo'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? false : undefined
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $d18db694553f5610$export$3870b1ff1b155c73 = ()=>{
        const { data: data, update: update, loading: loading } = (0, $dIdda.useResource)($d18db694553f5610$export$ee94bb1f59b07e35);
        const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
        const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
        const currentDismissedGicOnboarding = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false : undefined;
        const dismissReadMore = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    hasUserDismissedReadMore: true,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? previousData?.hasUserDismissedGicOnboarding ? {
                        hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                    } : {
                        hasUserDismissedGicOnboarding: false
                    } : {}
                }));
        }, [
            update
        ]);
        const dismissGicOnboarding = (0, $5uXOq.useCallback)(()=>{
            update((previousData)=>({
                    ...previousData?.hasUserOptedOut ? {
                        hasUserOptedOut: previousData.hasUserOptedOut
                    } : {
                        hasUserOptedOut: false
                    },
                    ...previousData?.hasUserDismissedReadMore ? {
                        hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                    } : {
                        hasUserDismissedReadMore: false
                    },
                    hasUserDismissedGicOnboarding: true
                }));
        }, [
            update
        ]);
        return {
            isSmartFieldsOptIn: loading ? null : currentOptInStatus,
            isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
            isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
            dismissReadMore: dismissReadMore,
            dismissGicOnboarding: dismissGicOnboarding,
            loading: loading
        };
    };
});
parcelRegister("aHuqL", function(module, exports) {
    $parcel$export(module.exports, "userPreferenceAPI", ()=>$0f87ed1c6d708024$export$4f7929ca6b50a436);
    var $eusud;
    const $0f87ed1c6d708024$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
    const $0f87ed1c6d708024$var$get = async (key)=>{
        try {
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)($0f87ed1c6d708024$var$url(key));
            return result?.value;
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            throw error;
        }
    };
    const $0f87ed1c6d708024$var$set = (key, value)=>(0, (0, parcelRequire("eusud")).performPutRequest)($0f87ed1c6d708024$var$url(key), {
            body: JSON.stringify({
                value: value
            })
        });
    const $0f87ed1c6d708024$var$remove = (key)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)($0f87ed1c6d708024$var$url(key));
    const $0f87ed1c6d708024$export$4f7929ca6b50a436 = {
        get: $0f87ed1c6d708024$var$get,
        set: $0f87ed1c6d708024$var$set,
        remove: $0f87ed1c6d708024$var$remove
    };
});
const $814b0a0376a60368$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $814b0a0376a60368$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key';
const $814b0a0376a60368$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $814b0a0376a60368$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';
parcelRegister("f5nIZ", function(module, exports) {
    $parcel$export(module.exports, "gicOptInStatusResources", ()=>$1dd3138bca6cac05$export$14c89b6b6a261524);
    var $dJl1T;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $1dd3138bca6cac05$export$14c89b6b6a261524 = (0, $dIdda.createResource)({
        type: (0, $8e5bc4e5db4905c7$export$fe522736b61f6709),
        getKey: ()=>'gic_optin_status',
        getData: async ()=>{
            let gicOptInStatus = null;
            try {
                gicOptInStatus = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
            } catch (e) {
                if (e.statusCode !== 404) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
            }
            return {
                gicOptInStatus: gicOptInStatus ?? {
                    isEnabled: false
                }
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';
parcelRegister("hZhhj", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RESPONSE", ()=>$0f1ada479bbc578a$export$32d9db53927095d3);
    $parcel$export(module.exports, "incomingMailServerExpiryStatusResource", ()=>$0f1ada479bbc578a$export$369caf52ed1ad2b1);
    $parcel$export(module.exports, "useIncomingMailExpiryStatus", ()=>$0f1ada479bbc578a$export$283aa034b7d4e2a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $b9c933d7a799fa71$export$5bf8eb915287f5f4));
    const $0f1ada479bbc578a$export$32d9db53927095d3 = {
        isAdmin: false,
        showBanner: true,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $0f1ada479bbc578a$export$369caf52ed1ad2b1 = (0, $dIdda.createResource)({
        type: (0, $b9c933d7a799fa71$export$3b9494e0dfc4de09),
        getKey: ()=>(0, $b9c933d7a799fa71$export$f2f2f265ccc09f82),
        getData: async ()=>{
            let incomingMailServerExpiryStatus = null;
            try {
                incomingMailServerExpiryStatus = await $0f1ada479bbc578a$var$fetchGetIncomingMailServerExpiryStatus();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'incomingMailServerExpiryStatus',
                        packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                        teamName: 'maverick'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0f1ada479bbc578a$export$32d9db53927095d3
            };
        },
        maxAge: 3600000
    });
    const $0f1ada479bbc578a$export$283aa034b7d4e2a0 = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $dIdda.useResource)($0f1ada479bbc578a$export$369caf52ed1ad2b1);
        const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $5uXOq.useState)(()=>{
            if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
            return $0f1ada479bbc578a$export$32d9db53927095d3;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.incomingMailServerExpiryStatus) {
                setResponseStatusGet('success');
                setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.incomingMailServerExpiryStatus
        ]);
        return {
            responseStatus: responseStatusGet,
            state: incomingMailServerExpiryStatus
        };
    };
});
const $b9c933d7a799fa71$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $b9c933d7a799fa71$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $b9c933d7a799fa71$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';
parcelRegister("9MiT2", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", ()=>$2d6f7831c4394a60$export$1b6468a6eb7d9b09);
    $parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", ()=>$2d6f7831c4394a60$export$e21c345b2538e96e);
    var $5uXOq = parcelRequire("5uXOq");
    var $561FV = parcelRequire("561FV");
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    var $erLlC;
    const $2d6f7831c4394a60$export$1b6468a6eb7d9b09 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("erLlC")).RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
        getKey: ()=>(0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
        getData: async ()=>{
            let modalViewCount = 0;
            try {
                const apiResult = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    if (!(0, ($parcel$interopDefault($561FV)))(apiResult, 'value') || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'benefitsModalValue')) {
                        const error = new Error('Invalid preference value');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'issueTransitionChangeboardingPreferencesResource',
                                packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                    return {
                        numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                        benefitsModal: {
                            isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                            nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                        }
                    };
                }
                if (typeof apiResult !== 'object' || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } else {
                    modalViewCount = Number(apiResult.value);
                    return {
                        numberOfTimesUserHasSeenChangeboarding: modalViewCount
                    };
                }
            } catch (error) {
                if (error.statusCode === 404) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                        numberOfTimesUserHasSeenChangeboarding: 0,
                        benefitsModal: {
                            isDisabled: false,
                            nextDateToShowBenefitsModal: null
                        }
                    };
                    return {
                        numberOfTimesUserHasSeenChangeboarding: 0
                    };
                }
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                numberOfTimesUserHasSeenChangeboarding: modalViewCount,
                benefitsModal: {
                    isDisabled: true,
                    nextDateToShowBenefitsModal: null
                }
            };
        }
    });
    const $2d6f7831c4394a60$export$e21c345b2538e96e = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $dIdda.useResource)($2d6f7831c4394a60$export$1b6468a6eb7d9b09);
        const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $5uXOq.useState)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) return {
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
            return 0, (0, parcelRequire("erLlC")).USER_SEEN_CARDINALITY_UNKNOWN;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTranstitionChangeboardingPreferences = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            const body = typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal') ? {
                value: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled,
                    nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
                }
            } : {
                value: updates
            };
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)((0, (0, parcelRequire("erLlC")).ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                    body: JSON.stringify(body)
                });
                setResponseStatusPut('success');
                let updateData;
                if (typeof updates !== 'number' && (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                    benefitsModal: {
                        isDisabled: updates?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                };
                if (typeof updates === 'number') updateData = {
                    numberOfTimesUserHasSeenChangeboarding: updates
                };
                update(()=>updateData);
                response = 'success';
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference({
                    numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                    benefitsModal: {
                        isDisabled: data?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                    }
                });
                return;
            }
            if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
                setResponseStatusGet('success');
                setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.numberOfTimesUserHasSeenChangeboarding,
            data?.benefitsModal?.isDisabled,
            data?.benefitsModal?.nextDateToShowBenefitsModal
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionChangeboardingPreference
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTranstitionChangeboardingPreferences
            }
        };
    };
});
parcelRegister("erLlC", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", ()=>$ca7314633d486db1$export$d66d4b761db3d20f);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", ()=>$ca7314633d486db1$export$79fd70b908f71ddd);
    $parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", ()=>$ca7314633d486db1$export$e5007258addba8aa);
    $parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", ()=>$ca7314633d486db1$export$91880069e7e73b18);
    $parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", ()=>$ca7314633d486db1$export$9ccdfd91f2512a27);
    const $ca7314633d486db1$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
    const $ca7314633d486db1$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
    const $ca7314633d486db1$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
    const $ca7314633d486db1$export$91880069e7e73b18 = -1;
    const $ca7314633d486db1$export$9ccdfd91f2512a27 = 14;
});
parcelRegister("fNOVA", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionOptInStatusResource", ()=>$cf959888902c771b$export$5fbcf4d7a6d9c477);
    $parcel$export(module.exports, "useIssueTransitionLabsOptIn", ()=>$cf959888902c771b$export$bc11d4816053db5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $aIZdc;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    var $dO2g2;
    const $cf959888902c771b$var$fetchGetIssueTransitionOptInState = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca));
    const $cf959888902c771b$export$5fbcf4d7a6d9c477 = (0, $dIdda.createResource)({
        type: (0, $267ed65766cf1bd0$export$eb01e12fc3db65c0),
        getKey: ()=>(0, $267ed65766cf1bd0$export$a964df7bc15d81e),
        getData: async ()=>{
            let issueTransitionOptInStatus = null;
            const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
            const isModernITSRenderEnabled = (0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
            if (!isModernITSRenderEnabled) return {
                issueTransitionOptInStatus: {
                    isEnabled: false,
                    expiryTime: -1
                }
            };
            if (isModernIssueTransitionSRBCohort) return {
                issueTransitionOptInStatus: {
                    isEnabled: true
                }
            };
            try {
                issueTransitionOptInStatus = await $cf959888902c771b$var$fetchGetIssueTransitionOptInState();
            } catch (error) {
                if (error.statusCode === 404) (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'issueTransitionOptInStatusResource',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, (0, parcelRequire("dO2g2")).default)()
            };
        },
        maxAge: Number.MAX_VALUE
    });
    const $cf959888902c771b$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, (0, parcelRequire("eusud")).performPutRequest)((0, $267ed65766cf1bd0$export$466b1c60da56c8ca), {
            body: JSON.stringify(payload)
        });
    const $cf959888902c771b$export$bc11d4816053db5c = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $dIdda.useResource)($cf959888902c771b$export$5fbcf4d7a6d9c477);
        const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $5uXOq.useState)(()=>{
            if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
            return (0, (0, parcelRequire("dO2g2")).default)();
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $5uXOq.useState)('not started');
        const [responseStatusPut, setResponseStatusPut] = (0, $5uXOq.useState)('not started');
        const updateIssueTransitionOptInStatus = (0, $5uXOq.useCallback)(async (updates)=>{
            let response = 'loading';
            setResponseStatusPut('loading');
            try {
                const updatedPreferences = await $cf959888902c771b$var$fetchModifyIssueTransitionOptInState(updates);
                setResponseStatusPut('success');
                update(()=>({
                        issueTransitionOptInStatus: updatedPreferences
                    }));
                response = 'success';
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err,
                    meta: {
                        id: 'issueTransitionOptInStatusUpdate',
                        packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setResponseStatusPut('error');
                response = 'error';
            }
            return response;
        }, [
            update
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.issueTransitionOptInStatus) {
                setResponseStatusGet('success');
                setIssueTransitionOptInState(data.issueTransitionOptInStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.issueTransitionOptInStatus
        ]);
        return {
            stateGet: {
                responseStatus: responseStatusGet,
                state: issueTransitionLabsOptInState
            },
            stateUpdate: {
                responseStatus: responseStatusPut,
                setState: updateIssueTransitionOptInStatus
            }
        };
    };
});
const $267ed65766cf1bd0$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $267ed65766cf1bd0$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $267ed65766cf1bd0$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $267ed65766cf1bd0$export$880a78695d76498e = 8;
parcelRegister("dO2g2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa107364a5021d3$export$2e2bcd8739ae039);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    const $8fa107364a5021d3$var$FF_POSSIBLE_VALUES = [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ];
    const $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState = ()=>{
        const isModernITSRenderEnabled = (0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            isEnabled: false,
            expiryTime: -1
        };
        const isModernIssueTransitionSRBCohort = (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb') || (0, (0, parcelRequire("aIZdc")).isFedRamp)();
        if (isModernIssueTransitionSRBCohort) return {
            isEnabled: true
        };
        const isExplicitlyUseTurnedOff = (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $8fa107364a5021d3$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
        return isExplicitlyUseTurnedOff ? {
            isEnabled: false,
            expiryTime: -1
        } : {
            isEnabled: true
        };
    };
    var $8fa107364a5021d3$export$2e2bcd8739ae039 = $8fa107364a5021d3$var$getDefaultIssueTransitionLabsOptInState;
});
parcelRegister("kJQXA", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", ()=>$273ba0463e1e3cac$export$fa191d7d71460a98);
    var $4Pf62;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $273ba0463e1e3cac$export$fa191d7d71460a98 = (0, $dIdda.createResource)({
        type: (0, $b830026e722fc8e6$export$fd4fc70ec71927d1),
        getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
        getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
            const defaultValue = {
                enabled: true
            };
            if (!licensedProducts || !licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
            const { enabled: enabled } = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
            return {
                enabled: enabled
            };
        },
        maxAge: Infinity
    });
});
const $b830026e722fc8e6$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';
parcelRegister("atU1t", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarGlobalResource", ()=>$587727b78e9bd173$export$44e7ad3c66a3f25f);
    var $3NIpU;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $587727b78e9bd173$export$44e7ad3c66a3f25f = (0, $dIdda.createResource)({
        type: (0, $f9d36ddc532997a4$export$fa5743fc6a1da5d8),
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || projectId || '__state';
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { baseUrl: baseUrl } = tenantContext;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const scope = {
                projectKey: projectKey,
                projectId: projectId
            };
            const response = await (0, (0, parcelRequire("3NIpU")).fetchSidebarConfig)(baseUrl, scope, false);
            return {
                response: response,
                scope: scope
            };
        },
        maxAge: 300000
    });
});
parcelRegister("3NIpU", function(module, exports) {
    $parcel$export(module.exports, "fetchSidebarConfig", ()=>$8ba40d865239bafe$export$d1d13c4b972a22f1);
    var $dJl1T;
    var $7f4tk;
    const $8ba40d865239bafe$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';
    const $8ba40d865239bafe$var$fetchUsingProtobuf = async (url)=>{
        try {
            const fetchProtobuf = await (parcelRequire("aOyKS"));
            if (!fetchProtobuf) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
            return fetchProtobuf.default(url);
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($8ba40d865239bafe$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
            throw err;
        }
    };
    const $8ba40d865239bafe$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
        const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
        const params = {
            exclude: [
                'webItems.reports',
                'webItems.home',
                'webItems.gin',
                exclude
            ].filter(Boolean).join(',')
        };
        let path = '';
        if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
        else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
        else if (identifierValue != null) path = `project/${identifierValue}`;
        else {
            path = 'product';
            const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
            const projectIdOrKey = projectId || projectKey;
            if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
        }
        const queryString = [
            new URLSearchParams(params).toString(),
            queryParams
        ].filter(Boolean).join('&');
        return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
    };
    const $8ba40d865239bafe$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
        if (isServer) {
            const protoUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
            return $8ba40d865239bafe$var$fetchUsingProtobuf(protoUrl);
        }
        const sidebarUrl = $8ba40d865239bafe$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
        return (0, (0, parcelRequire("7f4tk")).default)(sidebarUrl);
    };
});
parcelRegister("aOyKS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7erVk").then(()=>parcelRequire('g4I8Z'));
});
const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';
parcelRegister("c34Wf", function(module, exports) {
    $parcel$export(module.exports, "navigationUiStateResource", ()=>$976a0f933d5d0ba8$export$14c178691841b423);
    var $8QpSo;
    var $dIdda = parcelRequire("dIdda");
    var $kJPyG;
    const $976a0f933d5d0ba8$var$getNavigationUiStateMemoized = (0, (0, parcelRequire("8QpSo")).default)((atlassianAccountId)=>(0, (0, parcelRequire("kJPyG")).getNavigationUiState)({
            tenantContext: {
                atlassianAccountId: atlassianAccountId
            }
        }));
    const $976a0f933d5d0ba8$export$14c178691841b423 = (0, $dIdda.createResource)({
        type: 'RESOURCE_TYPE_NAVIGATION_UI',
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$976a0f933d5d0ba8$var$getNavigationUiStateMemoized(atlassianAccountId),
        maxAge: Infinity
    });
});
parcelRegister("kJPyG", function(module, exports) {
    $parcel$export(module.exports, "getNavigationUiState", ()=>$a5efaf793a61ef5e$export$29999268b070c9bd);
    var $89SaW;
    var $1yqku;
    const $a5efaf793a61ef5e$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
        const { atlassianAccountId: accountId } = tenantContext;
        let uiState = await (0, (0, parcelRequire("1yqku")).queryLocalStorage)();
        if (uiState || !accountId) return uiState;
        try {
            uiState = await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
            (0, (0, parcelRequire("1yqku")).updateLocalStorageData)(uiState);
        } catch (e) {}
        return uiState;
    };
});
const $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $2ed2f0cf8ecb933e$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';
parcelRegister("1yqku", function(module, exports) {
    $parcel$export(module.exports, "queryLocalStorage", ()=>$fa4273588466a1c1$export$e192dcb908272d5);
    $parcel$export(module.exports, "updateLocalStorageData", ()=>$fa4273588466a1c1$export$ec13c725e067146a);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    const $fa4273588466a1c1$export$e7db3fa51c63bc5c = ()=>{
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
        return {
            setItem: (0, ($parcel$interopDefault($8Rkzz))),
            getItem: (0, ($parcel$interopDefault($8Rkzz)))
        };
    };
    const $fa4273588466a1c1$var$queryLocalStorageSync = ()=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        const item = localStorage.getItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8));
        if (!false && item) try {
            return JSON.parse(item);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $2ed2f0cf8ecb933e$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
        }
    };
    const $fa4273588466a1c1$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
            const item = $fa4273588466a1c1$var$queryLocalStorageSync();
            resolve(item);
        });
    const $fa4273588466a1c1$export$ec13c725e067146a = (data)=>{
        const localStorage = $fa4273588466a1c1$export$e7db3fa51c63bc5c();
        localStorage.setItem((0, $2ed2f0cf8ecb933e$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    };
});
parcelRegister("eOlBz", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", ()=>$4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
    $parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", ()=>$4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2);
    $parcel$export(module.exports, "useNewIssueViewLockedInStatus", ()=>$4e2e5fcdbf62dfaf$export$3b09097f2a423abd);
    var $dIdda = parcelRequire("dIdda");
    const $4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c = (0, $dIdda.createResource)({
        type: (0, $103a13dfd187b85c$export$fdb92aeacda42553),
        getKey: ()=>'newIssueViewTransitionLockingStatus',
        getDataLoader: ()=>(parcelRequire("l81Mv")),
        maxAge: Number.MAX_VALUE
    });
    const $4e2e5fcdbf62dfaf$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
    const $4e2e5fcdbf62dfaf$export$3b09097f2a423abd = ()=>(0, $dIdda.useResource)($4e2e5fcdbf62dfaf$export$babbf5bfbc4d268c);
});
const $103a13dfd187b85c$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';
parcelRegister("l81Mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bDo1N").then(()=>parcelRequire('2RVA3'));
});
parcelRegister("3X1Xr", function(module, exports) {
    $parcel$export(module.exports, "persistentIssueCreateModalViewResource", ()=>$950f2f2a5a65ba3f$export$266a039a005e8314);
    var $dIdda = parcelRequire("dIdda");
    const $950f2f2a5a65ba3f$export$266a039a005e8314 = (0, $dIdda.createResource)({
        type: (0, $fa76c7a777da2375$export$f658cfd591eb583e),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("cptV5")),
        maxAge: Number.MAX_VALUE
    });
});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';
parcelRegister("cptV5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Kt13").then(()=>parcelRequire('8FYIq'));
});
parcelRegister("dxCvy", function(module, exports) {
    $parcel$export(module.exports, "projectContextResource", ()=>$fb0493b5a465ed74$export$27ad0d75c619be68);
    $parcel$export(module.exports, "projectContextResourceWithCache", ()=>$fb0493b5a465ed74$export$d75816e37af81473);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $fb0493b5a465ed74$var$getDataLoader = ()=>(parcelRequire("2VAeN"));
    const $fb0493b5a465ed74$export$27ad0d75c619be68 = (0, $dIdda.createResource)({
        type: (0, $0f463a88567f1621$export$80a60a092d9ab81),
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return projectKey || projectId;
        },
        getDataLoader: $fb0493b5a465ed74$var$getDataLoader,
        maxAge: 1800000
    });
    const $fb0493b5a465ed74$export$d75816e37af81473 = $fb0493b5a465ed74$export$27ad0d75c619be68;
});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';
parcelRegister("2VAeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7UkBG").then(()=>parcelRequire('fsLhR'));
});
parcelRegister("kkNtb", function(module, exports) {
    $parcel$export(module.exports, "rovoEntitlementResource", ()=>$10274390833bf523$export$a0974cf24d16bc5d);
    $parcel$export(module.exports, "useRovoEntitlementResource", ()=>$10274390833bf523$export$b9cee3799212b85a);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
    const $10274390833bf523$var$fetchRovoEntitlement = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $34f68d752b7fdd6c$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesRovoEntitlement',
                    teamName: 'ai-mate'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            isRovoEnabled: null
        };
    };
    const $10274390833bf523$export$a0974cf24d16bc5d = (0, $dIdda.createResource)({
        type: $10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getKey: ()=>$10274390833bf523$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>$10274390833bf523$var$fetchRovoEntitlement(cloudId),
        maxAge: Infinity
    });
    const $10274390833bf523$export$b9cee3799212b85a = ()=>(0, $dIdda.useResource)($10274390833bf523$export$a0974cf24d16bc5d);
});
const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;
parcelRegister("7GnDe", function(module, exports) {
    $parcel$export(module.exports, "incidentsInitialPageChecksResource", ()=>$08a008dcde68e650$export$b2b94ce8ba590cc8);
    $parcel$export(module.exports, "incidentsCustomFieldIdResource", ()=>$08a008dcde68e650$export$e81d7afef87ae597);
    $parcel$export(module.exports, "incidentExperimentTraitResource", ()=>$08a008dcde68e650$export$31c6945718067be3);
    var $dIdda = parcelRequire("dIdda");
    const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, $dIdda.createResource)({
        type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("1Y6Un"))
    });
    const $08a008dcde68e650$export$e81d7afef87ae597 = (0, $dIdda.createResource)({
        type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("7F1l2"))
    });
    const $08a008dcde68e650$export$31c6945718067be3 = (0, $dIdda.createResource)({
        type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
        getKey: ()=>'incident_experiment_traits',
        getDataLoader: ()=>(parcelRequire("7I42N")),
        maxAge: Number.MAX_SAFE_INTEGER
    });
});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';
parcelRegister("1Y6Un", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jEfvB").then(()=>parcelRequire('8lQN4'));
});
parcelRegister("7F1l2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8rk6s").then(()=>parcelRequire('i0mY9'));
});
parcelRegister("7I42N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ajWVH").then(()=>parcelRequire('iwLnj'));
});
parcelRegister("2Ql51", function(module, exports) {
    $parcel$export(module.exports, "themePreferenceResource", ()=>$14feb59df5995657$export$e5a423d1eb1cf1d0);
    $parcel$export(module.exports, "useThemePreference", ()=>$14feb59df5995657$export$3416635c8aeb5bab);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $dIdda = parcelRequire("dIdda");
    var $Y0b1l;
    const $14feb59df5995657$var$getDataLoader = ()=>(parcelRequire("7QoEx"));
    const $14feb59df5995657$export$e5a423d1eb1cf1d0 = (0, $dIdda.createResource)({
        type: 'RESOURCE_THEME_PREFERENCE',
        getKey: ()=>'state',
        getDataLoader: $14feb59df5995657$var$getDataLoader,
        maxAge: 300000
    });
    const $14feb59df5995657$export$3416635c8aeb5bab = ()=>{
        const { data: data, update: updateThemePreferenceResource } = (0, $dIdda.useResource)($14feb59df5995657$export$e5a423d1eb1cf1d0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireThemeAnalytics = (0, $5uXOq.useCallback)((current, next)=>{
            const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            const analyticsEvent = createAnalyticsEvent({
                action: (0, $d0956fbcd917153f$export$89c5cf64ad15c3ea),
                actionSubject: (0, $d0956fbcd917153f$export$9e2cc65718a61846)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                newPreference: next,
                oldPreference: current,
                OStheme: OStheme
            });
        }, [
            createAnalyticsEvent
        ]);
        const setTheme = (0, $5uXOq.useCallback)(async (theme)=>{
            updateThemePreferenceResource(()=>({
                    theme: theme
                }));
            if (data?.theme !== theme) {
                fireThemeAnalytics(data?.theme, theme);
                await (0, (0, parcelRequire("Y0b1l")).setThemePreference)(theme);
            }
        }, [
            data?.theme,
            updateThemePreferenceResource,
            fireThemeAnalytics
        ]);
        return {
            theme: data?.theme,
            setTheme: setTheme
        };
    };
});
const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';
parcelRegister("Y0b1l", function(module, exports) {
    $parcel$export(module.exports, "setThemePreference", ()=>$fb319b2ef1da4e47$export$a6b84eebd33787e2);
    $parcel$export(module.exports, "getThemePreference", ()=>$fb319b2ef1da4e47$export$2f7a12048d96237);
    var $b9op4;
    var $jcw0u;
    var $aHuqL;
    const $fb319b2ef1da4e47$export$a6b84eebd33787e2 = (theme)=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $d0956fbcd917153f$export$40bd77e1c9f49c27), theme);
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'put',
                    errName: String(error.name),
                    statusCode: error.statusCode,
                    param: `to:${theme}`
                }
            });
        });
        return promise;
    };
    const $fb319b2ef1da4e47$export$2f7a12048d96237 = async ()=>{
        const promise = (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $d0956fbcd917153f$export$40bd77e1c9f49c27));
        promise.catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'get',
                    errName: String(error.name),
                    statusCode: error.statusCode
                }
            });
        });
        promise.then((theme)=>{
            if (theme && !(0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme)) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: new Error('Unrecognized theme!'),
                attributes: {
                    op: 'get',
                    theme: theme,
                    errName: 'unrecognized value!'
                }
            });
        });
        const theme = await promise;
        return theme && (0, (0, parcelRequire("b9op4")).ThemeOptions).includes(theme) ? theme : undefined;
    };
});
parcelRegister("b9op4", function(module, exports) {
    $parcel$export(module.exports, "ThemeOptions", ()=>$a1d11c8212b90b3e$export$abe7936539cefefe);
    $parcel$export(module.exports, "DEFAULT_THEME", ()=>$a1d11c8212b90b3e$export$2faeed762aac6741);
    const $a1d11c8212b90b3e$export$abe7936539cefefe = [
        'light',
        'dark',
        'auto'
    ];
    const $a1d11c8212b90b3e$export$2faeed762aac6741 = 'light';
});
parcelRegister("7QoEx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5DvFw")
    ]).then(()=>parcelRequire('jyeNt'));
});
parcelRegister("9vlEn", function(module, exports) {
    $parcel$export(module.exports, "userHomepageResource", ()=>$ea929e6a42e03883$export$16320dd0d1e6c145);
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $ea929e6a42e03883$export$16320dd0d1e6c145 = (0, $dIdda.createResource)({
        type: (0, $a4d0f361741078de$export$2026a6db44b15de7),
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
            const { homepagePreference: homepagePreference } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
            return {
                homepagePreference: homepagePreference
            };
        },
        maxAge: Infinity
    });
});
const $a4d0f361741078de$export$2026a6db44b15de7 = 'USER_HOMEPAGE';
parcelRegister("6QKrH", function(module, exports) {
    $parcel$export(module.exports, "LegacyPage", ()=>$fbde0cafbe117684$export$273311ee2c946a58);
    var $5uXOq = parcelRequire("5uXOq");
    var $gdB0k;
    const $fbde0cafbe117684$export$273311ee2c946a58 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdB0k")).default), {
            match: props.match,
            action: props.action,
            route: props.route,
            isSpa: false
        }));
    var $fbde0cafbe117684$export$2e2bcd8739ae039 = $fbde0cafbe117684$export$273311ee2c946a58;
});
parcelRegister("gdB0k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bb8150642d26f84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $65Ltd;
    var $4oDnX;
    var $vrkiK;
    var $fJ1Pn;
    class $3bb8150642d26f84$var$SpaStateResetPage extends (0, $5uXOq.Component) {
        shouldComponentUpdate(nextProps) {
            const cleanMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(this.props.match, this.props.route);
            const cleanNextMatch = (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(nextProps.match, nextProps.route);
            return !(0, ($parcel$interopDefault($ajpes)))(cleanMatch, cleanNextMatch);
        }
        render() {
            const { action: action, match: match, route: route, isSpa: isSpa } = this.props;
            const shouldNotUpdate = action === 'REPLACE' && (!isSpa || route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { resetCurrentPage: resetCurrentPage })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fJ1Pn")).default), {
                    resetCurrentPage: shouldNotUpdate ? (0, ($parcel$interopDefault($8Rkzz))) : resetCurrentPage,
                    match: (0, (0, parcelRequire("vrkiK")).getApdexMatchObject)(match, route),
                    route: route
                }));
        }
    }
    var $3bb8150642d26f84$export$2e2bcd8739ae039 = $3bb8150642d26f84$var$SpaStateResetPage;
});
parcelRegister("4oDnX", function(module, exports) {
    $parcel$export(module.exports, "SpaStateSubscriber", ()=>$363cd3235a9267e4$export$fd52daf2a3c1ec68);
    $parcel$export(module.exports, "SpaStateActionsSubscriber", ()=>$363cd3235a9267e4$export$3dfa91988c213fbc);
    $parcel$export(module.exports, "useSpaState", ()=>$363cd3235a9267e4$export$a57865516f6345d1);
    $parcel$export(module.exports, "useSpaStateActions", ()=>$363cd3235a9267e4$export$b134752525935b78);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $363cd3235a9267e4$export$fd52daf2a3c1ec68 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$3dfa91988c213fbc = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
    const $363cd3235a9267e4$export$a57865516f6345d1 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default));
    const $363cd3235a9267e4$export$b134752525935b78 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: null
    });
});
parcelRegister("7w9eZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85db42238a8acf29$export$2e2bcd8739ae039);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $7JoAD = parcelRequire("7JoAD");
    var $6Bj8c;
    const $85db42238a8acf29$export$d4c72bab9d6cc13a = {
        transitionCheckTimestamp: -1,
        currentPage: {
            uuid: false ? '' : (0, ($parcel$interopDefault($7Jxgt))).v4(),
            startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
            apps: {},
            userLocation: ''
        },
        visitedPages: [],
        navigation: {
            isCollapsed: false,
            viewId: 'noView',
            viewType: '',
            projectType: null,
            isInitialEventSent: false,
            pageId: null,
            nextViewId: ''
        }
    };
    const $85db42238a8acf29$var$store = (0, $7JoAD.createStore)({
        name: 'spa-state',
        initialState: $85db42238a8acf29$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("6Bj8c"))
    });
    var $85db42238a8acf29$export$2e2bcd8739ae039 = $85db42238a8acf29$var$store;
});
parcelRegister("6Bj8c", function(module, exports) {
    $parcel$export(module.exports, "setAppStart", ()=>(parcelRequire("fI6Pg")).setAppStart);
    $parcel$export(module.exports, "setAppReady", ()=>(parcelRequire("fI6Pg")).setAppReady);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>(parcelRequire("fI6Pg")).setAppStartWithAppId);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setAppReadyWithAppId);
    $parcel$export(module.exports, "setAppErrorReady", ()=>(parcelRequire("fI6Pg")).setAppErrorReady);
    $parcel$export(module.exports, "setTimeoutReady", ()=>(parcelRequire("fI6Pg")).setTimeoutReady);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>(parcelRequire("fI6Pg")).setTimeoutReadyWithAppId);
    $parcel$export(module.exports, "resetCurrentPage", ()=>(parcelRequire("fI6Pg")).resetCurrentPage);
    $parcel$export(module.exports, "setResourceMetrics", ()=>(parcelRequire("fI6Pg")).setResourceMetrics);
    var $fI6Pg;
});
parcelRegister("fI6Pg", function(module, exports) {
    $parcel$export(module.exports, "resetCurrentPage", ()=>$4a986cd3487bf863$export$5639685a1fb81722);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>$4a986cd3487bf863$export$8a98548dad2fa97b);
    $parcel$export(module.exports, "setTimeoutReady", ()=>$4a986cd3487bf863$export$b9cc4378ea785421);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>$4a986cd3487bf863$export$9d528722f2ff2999);
    $parcel$export(module.exports, "setAppStart", ()=>$4a986cd3487bf863$export$71192061050856ad);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>$4a986cd3487bf863$export$6a25429a42d30f9a);
    $parcel$export(module.exports, "setAppReady", ()=>$4a986cd3487bf863$export$fc59cc4ed9bba7cd);
    $parcel$export(module.exports, "setAppErrorReady", ()=>$4a986cd3487bf863$export$aff63c1e41443b6a);
    $parcel$export(module.exports, "setResourceMetrics", ()=>$4a986cd3487bf863$export$8ad155d489dcf34d);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1ciso;
    var $21pfT;
    var $co1wz;
    var $cfDZ3;
    var $1AZST;
    const $4a986cd3487bf863$export$7bd623b29ec8e1eb = 10000;
    const $4a986cd3487bf863$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            performance.mark('resetCurrentPage');
            (0, (0, parcelRequire("21pfT")).browserMetrics).startPageLoad({
                isInitial: false
            });
            (0, (0, parcelRequire("1ciso")).default)(nextRouteUfoName, nextRouteName);
            if ((0, (0, parcelRequire("co1wz")).ff)('uip.ufo')) {
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).abort({
                    force: true
                });
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
            }
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
                currentPage: {
                    uuid: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                    apps: {},
                    startTime: Date.now(),
                    userLocation: ''
                },
                visitedPages: [
                    ...currentState.visitedPages,
                    {
                        ...currentState.currentPage
                    }
                ],
                transitionCheckTimestamp: 0
            });
        };
    const $4a986cd3487bf863$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
                const apps = {
                    ...currentPage.apps
                };
                if (apps[appId] && apps[appId].expectingTimeout) {
                    const updatedPage = {
                        ...currentPage,
                        apps: {
                            ...apps,
                            [appId]: {
                                ...apps[appId],
                                timeoutTime: timeoutTime,
                                expectingTimeout: 0
                            }
                        }
                    };
                    setState({
                        currentPage: updatedPage
                    });
                }
            }
        };
    const $4a986cd3487bf863$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId, timeoutTime));
        };
    const $4a986cd3487bf863$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
                const timeoutId = setTimeout(()=>{
                    dispatch($4a986cd3487bf863$export$8a98548dad2fa97b(appId));
                }, $4a986cd3487bf863$export$7bd623b29ec8e1eb);
                const updatedPage = {
                    ...currentPage,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)(),
                    apps: {
                        ...currentPage.apps,
                        [appId]: {
                            startTime: startTime,
                            expectingTimeout: timeoutId
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$9d528722f2ff2999(appId, startTime));
        };
    const $4a986cd3487bf863$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
                const apps = {
                    ...currentPage.apps
                };
                clearTimeout(currentPage.apps[appId].expectingTimeout);
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            endTime: endTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($4a986cd3487bf863$export$6a25429a42d30f9a(appId, endTime));
        };
    const $4a986cd3487bf863$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        'error-page': {
                            endTime: Date.now()
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $4a986cd3487bf863$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                currentPage: {
                    ...currentState.currentPage,
                    resources: [
                        ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                        resourceMetrics
                    ]
                }
            });
        };
});
parcelRegister("vrkiK", function(module, exports) {
    $parcel$export(module.exports, "calcRapidBoardResetState", ()=>$fd0af9cf1691807e$export$2350ed3ff6c1a082);
    $parcel$export(module.exports, "getApdexMatchObject", ()=>$fd0af9cf1691807e$export$47e434f08768932b);
    $parcel$export(module.exports, "calcRapidBoardResetStateV2", ()=>$fd0af9cf1691807e$export$dbd9185166d0d04c);
    $parcel$export(module.exports, "isValidRoute", ()=>$fd0af9cf1691807e$export$9f3e656a7f6a3adc);
    var $65Ltd;
    const $fd0af9cf1691807e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [
                    (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
                ];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    resetDone = false;
                    break;
                }
                if (!useStoredSettings && rapidBoardPaths.indexOf((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
                rapidBoardPaths = [];
                break;
            default:
                resetDone = false;
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$47e434f08768932b = (match, route)=>{
        let cleanMatch = {
            ...match,
            params: {
                ...match.params
            },
            query: {
                ...match.query
            }
        };
        if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
            const { params: params, query: query } = match;
            const paramKeys = params && Object.keys(params);
            const queryKeys = query && Object.keys(query);
            const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
            const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
            if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
            if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
        });
        if (match.query && match.query.view && match.query.view === 'detail') cleanMatch.query.view = undefined;
        if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
        cleanMatch = {
            ...cleanMatch,
            url: ''
        };
        return cleanMatch;
    };
    const $fd0af9cf1691807e$export$dbd9185166d0d04c = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [];
                resetDone = true;
                break;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                    resetDone = true;
                    rapidBoardPaths = [];
                    break;
                } else if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    break;
                } else {
                    rapidBoardPaths = [];
                    break;
                }
            default:
                if (rapidBoardPaths.includes((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                    resetDone = true;
                    rapidBoardPaths = [];
                }
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $fd0af9cf1691807e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
        if (state) {
            const { currentPage: currentPage, visitedPages: visitedPages } = state;
            const visitedPageLength = visitedPages.length;
            if (currentPage && currentPage.apps[appId]) return true;
            if (visitedPageLength === 0 || searchDepth <= 0) return false;
            for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
                if (visitedPages[visitedPageLength - i].apps[appId]) return true;
            }
        }
        return false;
    };
    const $fd0af9cf1691807e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
        switch(routeToCheck.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_EMBED:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES:
                return true;
            default:
                return false;
        }
    };
});
parcelRegister("fJ1Pn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df3649b3ebec92f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $vrkiK;
    class $df3649b3ebec92f5$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.resetDone = true;
            this.rapidBoardPaths = [];
            const [paths] = (0, (0, parcelRequire("vrkiK")).calcRapidBoardResetState)(this.rapidBoardPaths, this.props.route.name, !!this.props.match.query.useStoredSettings);
            this.rapidBoardPaths = paths;
        }
        shouldComponentUpdate(nextProps) {
            if (!(0, ($parcel$interopDefault($ajpes)))(this.props.match, nextProps.match)) {
                const [paths, resetBoolean] = (0, (0, parcelRequire("vrkiK")).calcRapidBoardResetState)(this.rapidBoardPaths, nextProps.route.name, !!nextProps.match.query.useStoredSettings);
                this.rapidBoardPaths = paths;
                this.resetDone = resetBoolean;
            }
            return true;
        }
        componentDidUpdate() {
            if (!this.resetDone) {
                if (!__SPA__) {
                    this.resetDone = true;
                    return;
                }
                this.props.resetCurrentPage();
                this.resetDone = true;
            }
        }
        render() {
            return null;
        }
    }
});
parcelRegister("51f7x", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", ()=>$9651cb580c71c297$export$5519b86c9ea602e1);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $1RJbT;
    var $aYyVm;
    const $9651cb580c71c297$export$5519b86c9ea602e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1RJbT")).globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            component: (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPage),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPromise)
            ]
        }));
});
parcelRegister("ffza4", function(module, exports) {
    $parcel$export(module.exports, "LazyAtlassianNavigation", ()=>$772c987a24839dcf$export$4caed23aa0274abb);
    var $fDtbf;
    var $2SVPM;
    var $kxZPA;
    const $772c987a24839dcf$export$4caed23aa0274abb = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        const bundleReady = (parcelRequire("2KdiI"));
        if (!false) bundleReady.then(()=>{
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, (0, parcelRequire("fDtbf")).JS_EVAL_START))) {
                (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return bundleReady;
    }, {
        moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
    });
});
parcelRegister("2SVPM", function(module, exports) {
    $parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", ()=>$b3ae4dfcfbbe07cd$export$15ca6669ae356831);
    $parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", ()=>$b3ae4dfcfbbe07cd$export$ab75d59423c060f4);
    $parcel$export(module.exports, "measureInitialPageLoadTiming", ()=>$b3ae4dfcfbbe07cd$export$e18462760bac553c);
    $parcel$export(module.exports, "setProductBundleReadyForInitialRender", ()=>$b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65);
    var $jI6pi;
    var $21pfT;
    const $b3ae4dfcfbbe07cd$var$safeMeasure = (name, start, stop)=>{
        try {
            performance.measure(name, start, stop);
        } catch (_err) {}
    };
    const $b3ae4dfcfbbe07cd$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
        if (false) return;
        $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stop);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
    };
    const $b3ae4dfcfbbe07cd$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
        if (false) return;
        const stopMark = `${name}__stop_mark$`;
        performance.mark(stopMark);
        $b3ae4dfcfbbe07cd$var$safeMeasure(name, start, stopMark);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
    };
    const $b3ae4dfcfbbe07cd$export$e18462760bac553c = (name, fn)=>{
        if (false) return fn();
        const startMark = `${name}__start_mark$`;
        const stopMark = `${name}__stop_mark$`;
        performance.mark(startMark);
        const result = fn();
        performance.mark(stopMark);
        $b3ae4dfcfbbe07cd$var$safeMeasure(name, startMark, stopMark);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
        return result;
    };
    const $b3ae4dfcfbbe07cd$export$53038a2e9d597818 = async (name, fn)=>{
        if (false) return fn();
        const startMark = `${name}__start_mark$`;
        const stopMark = `${name}__stop_mark$`;
        performance.mark(startMark);
        const result = await fn();
        performance.mark(stopMark);
        (0, (0, parcelRequire("21pfT")).browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
        (0, (0, parcelRequire("jI6pi")).addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
        return result;
    };
    const $b3ae4dfcfbbe07cd$export$de1b4cf109d9ab65 = ()=>{
        if (false) return;
        $b3ae4dfcfbbe07cd$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
    };
});
parcelRegister("jI6pi", function(module, exports) {
    $parcel$export(module.exports, "addTimingFromPerformanceMark", ()=>$0d5c580691017430$export$758b9a33800fa436);
    $parcel$export(module.exports, "getTimings", ()=>$0d5c580691017430$export$6d488733a547304);
    const $0d5c580691017430$var$timings = [];
    function $0d5c580691017430$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
        $0d5c580691017430$var$timings.push({
            name: name,
            startMark: startMark,
            stopMark: stopMark,
            cleanStart: cleanStart,
            cleanStop: cleanStop
        });
    }
    function $0d5c580691017430$export$6d488733a547304() {
        const reportedTimingsObj = {};
        $0d5c580691017430$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
            const startEntryList = performance.getEntriesByName(startMark);
            const stopEntryList = performance.getEntriesByName(stopMark);
            if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
                const startEntry = startEntryList[startEntryList.length - 1];
                const stopEntry = stopEntryList[stopEntryList.length - 1];
                const { startTime: startTime } = startEntry;
                const duration = stopEntry.startTime - startTime;
                const timing = {
                    startTime: Math.round(startTime),
                    duration: Math.round(duration)
                };
                reportedTimingsObj[name] = timing;
            }
            if (cleanStart) performance.clearMarks(startMark);
            if (cleanStop) performance.clearMarks(stopMark);
        });
        return reportedTimingsObj;
    }
});
parcelRegister("2KdiI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kV4Fy")
    ]).then(()=>parcelRequire('jC2al'));
});
parcelRegister("ibkIl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsLayout", ()=>$3eb51436f6201a33$export$e6aef6083548e882);
    var $2BrOV;
    var $1XrjK;
    const $3eb51436f6201a33$export$e6aef6083548e882 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout));
});
parcelRegister("2BrOV", function(module, exports) {
    $parcel$export(module.exports, "globalLayout", ()=>$6d4ecb0834e594e8$export$929cb72e7acb7fd9);
    var $1XrjK;
    const $6d4ecb0834e594e8$var$rightSidebars = ()=>[];
    const $6d4ecb0834e594e8$export$929cb72e7acb7fd9 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        rightSidebars: $6d4ecb0834e594e8$var$rightSidebars()
    });
});
parcelRegister("1XrjK", function(module, exports) {
    $parcel$export(module.exports, "coalesce", ()=>$3b8b9d6fe762babb$export$6e5538615c060df7);
    $parcel$export(module.exports, "renderGlobalComponents", ()=>$3b8b9d6fe762babb$export$fc28c9563350e5b8);
    $parcel$export(module.exports, "createLayout", ()=>$3b8b9d6fe762babb$export$3dd437ade36ede40);
    $parcel$export(module.exports, "composeLayouts", ()=>$3b8b9d6fe762babb$export$6c041b39c370853f);
    $parcel$export(module.exports, "withProjectContext", ()=>$3b8b9d6fe762babb$export$e97a7da67a5b8ce4);
    var $5uXOq = parcelRequire("5uXOq");
    var $lpwtK;
    var $lfTZh;
    const $3b8b9d6fe762babb$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
    const $3b8b9d6fe762babb$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
            const { displayName: displayName, name: name } = Component;
            const key = $3b8b9d6fe762babb$export$6e5538615c060df7(displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(name) ?? i;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: key?.toString(),
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                key: key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null)));
        });
    const $3b8b9d6fe762babb$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
            isChromeless: isChromeless,
            globalComponents: Array.from(new Set(globalComponents)),
            rightSidebars: Array.from(new Set(rightSidebars))
        });
    const $3b8b9d6fe762babb$export$6c041b39c370853f = (...layouts)=>{
        if (layouts.length === 1) return $3b8b9d6fe762babb$export$3dd437ade36ede40(layouts[0]);
        const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
                isChromeless: isChromeless,
                globalComponents: [
                    ...l.globalComponents,
                    ...globalComponents
                ],
                rightSidebars: [
                    ...l.rightSidebars,
                    ...rightSidebars
                ]
            }), {
            globalComponents: [],
            rightSidebars: [],
            isChromeless: false
        });
        return $3b8b9d6fe762babb$export$3dd437ade36ede40(layout);
    };
    const $3b8b9d6fe762babb$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    const $3b8b9d6fe762babb$var$formatPrefix = (style, type)=>{
        if (!style && !type) return 'Empty';
        if (style === 'any' && type === 'any') return 'Any';
        const formattedStyle = $3b8b9d6fe762babb$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
        if (type === 'any') return formattedStyle;
        const formattedType = $3b8b9d6fe762babb$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
        if (style === 'any') return formattedType;
        return `${formattedStyle}${formattedType}`;
    };
    const $3b8b9d6fe762babb$export$e97a7da67a5b8ce4 = (Component, options)=>{
        const { project: expectedProject } = options;
        const ScopedComponent = ()=>{
            const { data: project, loading: loading } = (0, (0, parcelRequire("lpwtK")).useProject)();
            if (loading) return null;
            if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
        };
        const name = $3b8b9d6fe762babb$export$6e5538615c060df7(Component.displayName) ?? $3b8b9d6fe762babb$export$6e5538615c060df7(Component.name) ?? 'Component';
        const prefix = $3b8b9d6fe762babb$var$formatPrefix(expectedProject?.style, expectedProject?.type);
        ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
        return ScopedComponent;
    };
});
parcelRegister("lpwtK", function(module, exports) {
    $parcel$export(module.exports, "useProject", ()=>$f3d7644b5666677d$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bsuuc;
    var $1J3t1;
    const $f3d7644b5666677d$export$51b1383ef8844a7 = (customContext)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)(customContext);
        const project = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("bsuuc")).extractData)(data), [
            data
        ]);
        return {
            data: project,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("bsuuc", function(module, exports) {
    $parcel$export(module.exports, "getStyle", ()=>$36c780ae7e3dc8c8$export$3d2f074408bd1b82);
    $parcel$export(module.exports, "extractData", ()=>$36c780ae7e3dc8c8$export$9df5fa0a366163d2);
    var $2vSU6;
    const $36c780ae7e3dc8c8$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC;
    const $36c780ae7e3dc8c8$var$getProject = (project)=>({
            avatarUrl: project.avatarUrls['48x48'],
            id: Number(project.id),
            isSimplified: project.simplified,
            key: project.key,
            name: project.name,
            style: $36c780ae7e3dc8c8$export$3d2f074408bd1b82(project.simplified),
            type: project.projectTypeKey
        });
    const $36c780ae7e3dc8c8$export$9df5fa0a366163d2 = (data)=>{
        const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
        switch(projectType){
            case 'jira_work_management':
                return jiraWorkManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraWorkManagementNavData.project) : null;
            case 'jira_software':
                return jiraSoftwareNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraSoftwareNavData.project) : null;
            case 'jira_service_management':
            case 'jira_customer_service':
                return jiraServiceManagementNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraServiceManagementNavData.project) : null;
            case 'jira_product_discovery':
                return jiraProductDiscoveryNavData?.project ? $36c780ae7e3dc8c8$var$getProject(jiraProductDiscoveryNavData.project) : null;
            case null:
            default:
                return null;
        }
    };
});
parcelRegister("1J3t1", function(module, exports) {
    $parcel$export(module.exports, "useProjectSidebarNavigation", ()=>$bb292f58b8ec7804$export$5a85006c180fb373);
    $parcel$export(module.exports, "useProjectSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$2bed15cd7d167db5);
    $parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$a9d05fc2c1d94895);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", ()=>$bb292f58b8ec7804$export$d48e3c3556894533);
    $parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", ()=>$bb292f58b8ec7804$export$24a781cd863077aa);
    $parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", ()=>$bb292f58b8ec7804$export$e16ecd2512eb0dc7);
    $parcel$export(module.exports, "useJiraSoftwareProjectNavigation", ()=>$bb292f58b8ec7804$export$68dc0ecbea8211d2);
    $parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", ()=>$bb292f58b8ec7804$export$5cf90b625d0e1248);
    $parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", ()=>$bb292f58b8ec7804$export$d63d92edebe543d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $b2pl3;
    var $6zFAI;
    var $gcI3W;
    var $loy04;
    var $ggg5j;
    var $324W5;
    var $dIdda = parcelRequire("dIdda");
    var $727Q1;
    const $bb292f58b8ec7804$export$5a85006c180fb373 = (customContext)=>{
        const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), customContext);
        const memoizedResponse = (0, $5uXOq.useMemo)(()=>navResponse, [
            navResponse
        ]);
        (0, (0, parcelRequire("727Q1")).useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
        return {
            data: memoizedResponse,
            loading: memoizedResponse != null ? false : loading,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$2bed15cd7d167db5 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$a9d05fc2c1d94895 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$d48e3c3556894533 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$24a781cd863077aa = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource));
    const $bb292f58b8ec7804$export$e16ecd2512eb0dc7 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraWorkManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$68dc0ecbea8211d2 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraSoftwareNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$5cf90b625d0e1248 = (customContext)=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373(customContext);
        const response = data?.jiraServiceManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $bb292f58b8ec7804$export$d63d92edebe543d9 = ()=>{
        const { data: data, ...rest } = $bb292f58b8ec7804$export$5a85006c180fb373();
        const response = data?.jiraProductDiscoveryNavData || null;
        return {
            data: response,
            ...rest
        };
    };
});
parcelRegister("b2pl3", function(module, exports) {
    $parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", ()=>$565682b770797f58$export$fab84295e18e9246);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $565682b770797f58$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $565682b770797f58$export$fab84295e18e9246 = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
        getKey: ({ match: match, query: query })=>$565682b770797f58$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $565682b770797f58$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("gcI3W", function(module, exports) {
    $parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", ()=>$e60f9280597d4f0e$export$b662f3f877add30d);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $jAGOQ;
    const $e60f9280597d4f0e$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e60f9280597d4f0e$export$b662f3f877add30d = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$e60f9280597d4f0e$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e60f9280597d4f0e$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, (0, parcelRequire("jAGOQ")).fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("324W5", function(module, exports) {
    $parcel$export(module.exports, "useResourceWithCustomRouterContext", ()=>$0c2698427b7aacc1$export$61dad767cf446185);
    var $e5wyW;
    var $4R6GH;
    var $dIdda = parcelRequire("dIdda");
    var $geWXd;
    const $0c2698427b7aacc1$var$DUMMY_ROUTE = {
        name: 'DUMMY_ROUTE_NAME',
        path: '/projects/:projectKey/dummyroute'
    };
    const $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
        let useResourceArgCustomContext;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
                routerContext: (0, $dIdda.createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const resourceResponse = (0, $dIdda.useResource)(resource, useResourceArgCustomContext);
        (0, (0, parcelRequire("geWXd")).useInitFetchResource)(resourceResponse, !customRouterContext);
        return resourceResponse;
    };
    function $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
        let resourceOptions;
        if (customRouterContext) {
            const { route: route = $0c2698427b7aacc1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
                routerContext: (0, $dIdda.createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const { shouldPrefetch: shouldPrefetch } = options;
        const resourceResponse = (0, $dIdda.useResource)(resource, resourceOptions);
        (0, (0, parcelRequire("geWXd")).usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
        return resourceResponse;
    }
    const $0c2698427b7aacc1$export$61dad767cf446185 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_useinitresource_data_bug'), $0c2698427b7aacc1$var$useResourceWithCustomRouterContextWithOptions, $0c2698427b7aacc1$var$useResourceWithCustomRouterContextOld);
});
parcelRegister("e5wyW", function(module, exports) {
    $parcel$export(module.exports, "functionWithCondition", ()=>$12199147dc0ae1fa$export$af3c0e82a18fc057);
    $parcel$export(module.exports, "functionUnionWithCondition", ()=>$12199147dc0ae1fa$export$c41c28c1d883fcd5);
    function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
        const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
        return fnWithCondition;
    }
    function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
        return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
    }
});
parcelRegister("geWXd", function(module, exports) {
    $parcel$export(module.exports, "useInitFetchResource", ()=>$b632b0c18495344b$export$5b98692301d8680);
    $parcel$export(module.exports, "usePrefetchableResource", ()=>$b632b0c18495344b$export$99f17ace416cfe75);
    var $5uXOq = parcelRequire("5uXOq");
    const $b632b0c18495344b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
        (0, $5uXOq.useEffect)(()=>{
            if (skipInitFetch) return;
            if (!data && !loading && !error && refresh) refresh();
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            refresh: refresh,
            ...rest
        };
    };
    function $b632b0c18495344b$export$99f17ace416cfe75(resource, shouldPrefetch) {
        (0, $5uXOq.useEffect)(()=>{
            if (!shouldPrefetch) return;
            if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
        }, []);
    }
});
parcelRegister("727Q1", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", ()=>$5300bc04c6e3c00f$export$780174995da89d60);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    const $5300bc04c6e3c00f$export$90dbde7e33e6e21 = ()=>null;
    const $5300bc04c6e3c00f$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $dIdda.createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/:projectKey/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                projectKey: projectKey
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$19001bab9e4b7f8f = (projectKey)=>{
        const { data: data, update: update } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$d647718555c2fdd8(projectKey)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $dIdda.createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
            component: $5300bc04c6e3c00f$export$90dbde7e33e6e21
        }, {
            params: {
                boardId: `${boardId}`
            }
        }) : undefined;
    const $5300bc04c6e3c00f$export$e2bb7877e6cec3eb = (boardId)=>{
        const { data: data, update: update } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource), {
            routerContext: $5300bc04c6e3c00f$export$23dc6491016cabdc(boardId)
        });
        return {
            data: data,
            update: update
        };
    };
    const $5300bc04c6e3c00f$export$780174995da89d60 = (latestNavInfo)=>{
        const [{ match: match, query: query, route: { name: name } }] = (0, $dIdda.useRouter)();
        const isOnBoardBasedRoute = (0, (0, parcelRequire("ggg5j")).getIdentifier)(name, match, query)?.identifierType === 'boardId';
        const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
        const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
        const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
        const { data: projectRouteNavInfo, update: updateProjectRoute } = $5300bc04c6e3c00f$export$19001bab9e4b7f8f(pKey);
        const { data: boardRouteNavInfo, update: updateBoardRoute } = $5300bc04c6e3c00f$export$e2bb7877e6cec3eb(boardId);
        (0, $5uXOq.useEffect)(()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, ($parcel$interopDefault($ajpes)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        }, [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ]);
    };
});
parcelRegister("lmyls", function(module, exports) {
    $parcel$export(module.exports, "ADDON_ID", ()=>$ee51d260cb059727$export$6c4866a933650d1d);
    $parcel$export(module.exports, "MENU_ID", ()=>$ee51d260cb059727$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$ee51d260cb059727$export$adf978edbdfaf080);
    const $ee51d260cb059727$export$6c4866a933650d1d = {
        DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
    };
    const $ee51d260cb059727$export$d4cd258d01c03112 = {
        ADDONS: 'ADDONS',
        APP_SWITCHER: 'APP_SWITCHER',
        DASHBOARDS: 'DASHBOARDS',
        FILTERS: 'FILTERS',
        HELP: 'HELP',
        HOME: 'HOME',
        INSIGHT: 'INSIGHT',
        NOTIFICATIONS: 'NOTIFICATIONS',
        PEOPLE: 'PEOPLE',
        PLANS: 'PLANS',
        PROFILE: 'PROFILE',
        PROJECTS: 'PROJECTS',
        ROADMAPS: 'ROADMAPS',
        SEARCH: 'SEARCH',
        SERVICE_HUB: 'SERVICE_HUB',
        SETTINGS: 'SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
    const $ee51d260cb059727$export$adf978edbdfaf080 = {
        BOARD_SETTINGS: 'BOARD_SETTINGS',
        GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
        GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
        GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
        GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
        GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        PLAN_SETTINGS: 'PLAN_SETTINGS',
        PROJECT_SETTINGS: 'PROJECT_SETTINGS'
    };
});
parcelRegister("78U7j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f593a4193eb44f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("jCoeB")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
    });
    const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
    var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;
});
parcelRegister("dZQxE", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$e39fc1e1d73100a0$export$1edc778464f08256);
    var $5uXOq = parcelRequire("5uXOq");
    var $azzrO;
    var $5e7oM;
    var $lfTZh;
    var $5Hj3V;
    var $acDan;
    var $lGo7j;
    const $e39fc1e1d73100a0$export$1edc778464f08256 = ({ children: children, id: id })=>{
        const onFail = (0, (0, parcelRequire("acDan")).useSidebarFail)();
        const onSuccess = (0, (0, parcelRequire("acDan")).useSidebarSuccess)();
        const onError = (0, $5uXOq.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
            else onFail(location, error);
        }, [
            onFail,
            onSuccess
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
            id: id,
            packageName: "jiraSpaAppsSidebarCommon",
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarSSRPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "nav-sidebar",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), {
                isFull: true
            })
        }, children));
    };
});
parcelRegister("azzrO", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", ()=>$4d07bc740e316cc0$export$8df02628d98cae7e);
    $parcel$export(module.exports, "pageSegmentStore", ()=>$4d07bc740e316cc0$export$26cadbe0bcaabcde);
    $parcel$export(module.exports, "useNavPerformanceMetrics", ()=>$4d07bc740e316cc0$export$906025848d54198d);
    $parcel$export(module.exports, "NavTopPerformanceMark", ()=>$4d07bc740e316cc0$export$b7f4caa65b0906fc);
    $parcel$export(module.exports, "NavTopSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$2c4a101f2cde4fc2);
    $parcel$export(module.exports, "NavTopPerformanceReport", ()=>$4d07bc740e316cc0$export$c64b31449a6177d);
    $parcel$export(module.exports, "NavSidebarPerformanceMark", ()=>$4d07bc740e316cc0$export$35b2aeea5cbc963e);
    $parcel$export(module.exports, "NavSidebarSSRPerformanceMark", ()=>$4d07bc740e316cc0$export$14f711a2cb6a655a);
    $parcel$export(module.exports, "NavSidebarPerformanceReport", ()=>$4d07bc740e316cc0$export$a018e347341b3640);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $dGrdR;
    var $cfDZ3;
    var $5M3R9;
    var $5e7oM;
    const $4d07bc740e316cc0$var$createTopNavPageSegment = ()=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME),
            timings: [
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'bundle-load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).bundleLoadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_MARKS).renderStart
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$8df02628d98cae7e = {
        ADDONS: (0, (0, parcelRequire("dGrdR")).metrics).interaction({
            key: 'navigation-top.addons-dropdown-opened'
        })
    };
    const $4d07bc740e316cc0$var$createSidebarPageSegment = ()=>(0, (0, parcelRequire("dGrdR")).metrics).pageSegmentLoad({
            key: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME),
            timings: [
                {
                    key: 'renderAttempt',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderAttempt
                },
                {
                    key: 'ttic',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'load',
                    startMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart,
                    endMark: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $4d07bc740e316cc0$export$26cadbe0bcaabcde = (()=>{
        const segmentConstructors = {
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createTopNavPageSegment,
            [(0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $4d07bc740e316cc0$var$createSidebarPageSegment
        };
        const segments = {};
        return {
            getSegment: (key)=>{
                if (!segments[key]) {
                    if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                    segments[key] = segmentConstructors[key]();
                }
                return segments[key];
            }
        };
    })();
    const $4d07bc740e316cc0$export$906025848d54198d = (segmentKey = (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME))=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        const segment = (0, $5uXOq.useRef)($4d07bc740e316cc0$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
        if (!false && !startedRef.current) {
            segment && segment.startFromPageLoad();
            startedRef.current = true;
        }
        return (0, $5uXOq.useMemo)(()=>Object.assign(segment, {
                markSSR: (metricKey)=>{
                    const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                    if (window.SPA_STATE) {
                        const { startTime: startTime = 0, duration: duration = 0 } = (0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("5M3R9")).getRenderTraceFromSSRGlobal)(), [
                            'traces',
                            `render/${tmpSsrMetricKey}`
                        ]) || {};
                        const markTime = startTime + duration;
                        markTime && markTime > 0 && segment.mark(metricKey, markTime);
                    }
                }
            }), [
            segment
        ]);
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.mark(metricKey), []);
        return null;
    };
    const $4d07bc740e316cc0$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const tmpSsrMetricKey = `${(0, (0, parcelRequire("5e7oM")).NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>navSegment.markSSR(metricKey), []);
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5M3R9")).RenderTracerMark), {
            type: "end",
            traceKey: tmpSsrMetricKey
        }) : null;
    };
    const $4d07bc740e316cc0$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
        const navSegment = $4d07bc740e316cc0$export$906025848d54198d(segmentKey);
        (0, $5uXOq.useEffect)(()=>{
            navSegment.stop({
                customData: {
                    ...customData,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                }
            });
            navSegment.clear();
        }, []);
        return null;
    };
    const $4d07bc740e316cc0$export$b7f4caa65b0906fc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$2c4a101f2cde4fc2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$c64b31449a6177d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$35b2aeea5cbc963e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$14f711a2cb6a655a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $4d07bc740e316cc0$export$a018e347341b3640 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4d07bc740e316cc0$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
});
parcelRegister("5M3R9", function(module, exports) {
    $parcel$export(module.exports, "RenderTracerMark", ()=>$ca67b9a5090b457c$export$54c89059bb435049);
    $parcel$export(module.exports, "getRenderTraceFromSSRGlobal", ()=>$ca67b9a5090b457c$export$345f21b0287f67e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Csk1 = parcelRequire("6Csk1");
    var $9XE6b = parcelRequire("9XE6b");
    var $jR67t;
    var $7JoAD = parcelRequire("7JoAD");
    const $ca67b9a5090b457c$var$initialState = {
        start: undefined,
        traces: {}
    };
    let $ca67b9a5090b457c$var$currentTraces = {};
    const $ca67b9a5090b457c$export$2365ecd8218e21c7 = ()=>$ca67b9a5090b457c$var$currentTraces;
    const $ca67b9a5090b457c$export$5c757eaa1990d0d7 = (key)=>{
        if ($ca67b9a5090b457c$var$currentTraces[key]) return;
        $ca67b9a5090b457c$var$currentTraces[key] = {
            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
        };
    };
    const $ca67b9a5090b457c$export$16854dc18f8d976 = (key)=>{
        if (!$ca67b9a5090b457c$var$currentTraces[key] || $ca67b9a5090b457c$var$currentTraces[key].duration != null) return;
        $ca67b9a5090b457c$var$currentTraces[key].duration = (0, (0, parcelRequire("jR67t")).performance).now() - $ca67b9a5090b457c$var$currentTraces[key].startTime;
    };
    const $ca67b9a5090b457c$var$actions = {
        startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                if (traces[key]) return;
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            startTime: time
                        }
                    })
                });
            },
        endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                const trace = traces[key] || {
                    startTime: 0
                };
                setState({
                    traces: (0, ($parcel$interopDefault($6Csk1)))({}, traces, {
                        [key]: {
                            ...trace,
                            duration: time - trace.startTime
                        }
                    })
                });
                $ca67b9a5090b457c$var$currentTraces = Object.assign($ca67b9a5090b457c$var$currentTraces, getState().traces);
            }
    };
    const $ca67b9a5090b457c$var$Store = (0, $7JoAD.createStore)({
        name: 'jira-render-tracer',
        initialState: $ca67b9a5090b457c$var$initialState,
        actions: $ca67b9a5090b457c$var$actions
    });
    const $ca67b9a5090b457c$var$RenderTracerActions = (0, $7JoAD.createSubscriber)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$export$719a95758870be58 = (0, $7JoAD.createHook)($ca67b9a5090b457c$var$Store, {
        selector: null
    });
    const $ca67b9a5090b457c$var$RenderTracerContainerBase = (0, $7JoAD.createContainer)($ca67b9a5090b457c$var$Store, {
        onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
                setState({
                    start: startTime,
                    traces: {
                        [startKey]: {
                            startTime: (0, (0, parcelRequire("jR67t")).performance).now()
                        }
                    }
                });
            }
    });
    const $ca67b9a5090b457c$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerContainerBase, {
            startKey: startKey,
            startTime: startTime
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$export$54c89059bb435049, {
            traceKey: startKey,
            type: "end"
        }));
    const $ca67b9a5090b457c$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ca67b9a5090b457c$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
            if (type === 'start') startTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            else if (type === 'end') endTrace(traceKey, (0, (0, parcelRequire("jR67t")).performance).now());
            return null;
        });
    const $ca67b9a5090b457c$export$cba8addc8743389c = (appName = 'unknown', traces = $ca67b9a5090b457c$var$currentTraces)=>({
            [(0, $eb0760a6ada94ab6$export$3c96fa14fb694e11)]: {
                data: {
                    traces: traces,
                    routeName: appName
                }
            }
        });
    const $ca67b9a5090b457c$export$345f21b0287f67e5 = ()=>(0, ($parcel$interopDefault($9XE6b)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
            (0, $eb0760a6ada94ab6$export$3c96fa14fb694e11),
            'data'
        ], {});
});
parcelRegister("jR67t", function(module, exports) {
    $parcel$export(module.exports, "performance", ()=>$c026bc7061377d6e$export$f2d2284f5fec51f8);
    const $c026bc7061377d6e$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
    class $c026bc7061377d6e$export$9a0dbed22cbf63be {
        start() {
            if (false) this.startAt = $c026bc7061377d6e$var$now();
        }
        now() {
            if (false) return $c026bc7061377d6e$var$now() - this.startAt;
            return $c026bc7061377d6e$var$now();
        }
        constructor(){
            this.startAt = $c026bc7061377d6e$var$now();
        }
    }
    const $c026bc7061377d6e$export$f2d2284f5fec51f8 = new $c026bc7061377d6e$export$9a0dbed22cbf63be();
});
const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';
parcelRegister("5e7oM", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", ()=>$83022b592d1d8567$export$6635720e40ea7a7a);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", ()=>$83022b592d1d8567$export$1d3c3cb357af0e86);
    $parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", ()=>$83022b592d1d8567$export$e7a14fa81b3c6488);
    $parcel$export(module.exports, "NAVIGATION_TOP_MARKS", ()=>$83022b592d1d8567$export$ad760bb9734bf93f);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", ()=>$83022b592d1d8567$export$1d10ee0c85c3cb21);
    const $83022b592d1d8567$export$6635720e40ea7a7a = 'navigation.top';
    const $83022b592d1d8567$export$1d3c3cb357af0e86 = 'navigation.sidebar';
    const $83022b592d1d8567$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
    const $83022b592d1d8567$export$ad760bb9734bf93f = {
        renderStart: 'navigation-top.render.start',
        renderEnd: 'navigation-top.render.end',
        renderSsrStart: 'navigation-top.render.ssr.start',
        renderSsrEnd: 'navigation-top.render.ssr.end',
        bundleLoadStart: 'navigation-top.bundle-load.start'
    };
    const $83022b592d1d8567$export$1d10ee0c85c3cb21 = {
        renderAttempt: 'navigation-sidebar.render.attempt',
        renderStart: 'navigation-sidebar.render.start',
        renderEnd: 'navigation-sidebar.render.end',
        renderSsrStart: 'navigation-sidebar.render.ssr.start',
        renderSsrEnd: 'navigation-sidebar.render.ssr.end',
        loadStart: 'navigation-sidebar.load.start',
        loadEnd: 'navigation-sidebar.load.end'
    };
});
parcelRegister("5Hj3V", function(module, exports) {
    $parcel$export(module.exports, "SidebarErrorBoundary", ()=>$c3958cf153a091e2$export$62853c5766dad0c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $cfDZ3;
    var $kqzba;
    const $c3958cf153a091e2$export$62853c5766dad0c4 = (props)=>{
        const userLocation = (0, (0, parcelRequire("cfDZ3")).getUserLocation)();
        const extraEventData = (0, $5uXOq.useMemo)(()=>({
                ...props.extraEventData,
                userLocation: userLocation
            }), [
            props.extraEventData,
            userLocation
        ]);
        const fallback = (0, $5uXOq.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kqzba")).Fallback), {
                error: error
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            ...props,
            extraEventData: extraEventData,
            fallback: fallback
        });
    };
});
parcelRegister("kqzba", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$790c5d1c3d335eca$export$fb8d7f40caaeea67);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kobfu;
    var $koVbs;
    var $evbHg = parcelRequire("evbHg");
    var $h8OaL;
    const $790c5d1c3d335eca$var$styles = {
        wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
        error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
        image: "_4t3i12am"
    };
    const $790c5d1c3d335eca$export$fb8d7f40caaeea67 = (props)=>{
        const { error: error } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.wrapper
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            alt: "",
            src: (0, ($parcel$interopDefault($evbHg))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.image
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("h8OaL")).default).errorBody)), (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $790c5d1c3d335eca$var$styles.error
            ])
        }, "ERROR: ", (0, (0, parcelRequire("kobfu")).getErrorHash)(error)));
    };
});
parcelRegister("evbHg", function(module, exports) {
    module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();
});
parcelRegister("h8OaL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7c8a71ff5065c1e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7c8a71ff5065c1e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorHeading: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("acDan", function(module, exports) {
    $parcel$export(module.exports, "SidebarStart", ()=>$b5a3a4467dac2130$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarRenderStart", ()=>$b5a3a4467dac2130$export$ba19e3624956e66);
    $parcel$export(module.exports, "SidebarReady", ()=>$b5a3a4467dac2130$export$a06ecbbe5820282);
    $parcel$export(module.exports, "useSidebarFail", ()=>$b5a3a4467dac2130$export$661ed14c8f75da9f);
    $parcel$export(module.exports, "useSidebarSuccess", ()=>$b5a3a4467dac2130$export$ddb17534fdfb7dc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $azzrO;
    var $5e7oM;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $4QcD9;
    var $6jY6G;
    var $8zOmE;
    var $2NMNM;
    var $6IzHB;
    var $dIdda = parcelRequire("dIdda");
    var $kvHKs;
    const { useValue: $b5a3a4467dac2130$var$useSidebarId } = (0, (0, parcelRequire("4QcD9")).createValueController)('sidebar-id');
    const $b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
        experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
        attributes: {
            sidebar: 'v3'
        }
    };
    const $b5a3a4467dac2130$export$6738d1299dc79710 = ()=>{
        const [{ route: route, match: match }] = (0, $dIdda.useRouter)();
        const pageId = (0, (0, parcelRequire("6IzHB")).usePageId)();
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const onStartExperience = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experienceId: pageId,
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE),
            analyticsSource: 'Sidebar'
        });
        (0, $5uXOq.useMemo)(()=>{
            if (route.isRedirect ?? false) return;
            onStartExperience();
            startRef.current = Date.now();
        }, [
            route,
            match
        ]);
        return null;
    };
    const $b5a3a4467dac2130$export$ba19e3624956e66 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderStart
        });
    const $b5a3a4467dac2130$export$a06ecbbe5820282 = ({ id: id })=>{
        const [, setSidebarId] = $b5a3a4467dac2130$var$useSidebarId();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const onSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
        (0, $5uXOq.useEffect)(()=>{
            setSidebarId(id);
            return ()=>setSidebarId();
        }, [
            setSidebarId,
            id
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (route.isRedirect ?? false) return;
            onSuccess();
        }, [
            onSuccess,
            route
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            window.__POLLINATOR__ = {
                ...window.__POLLINATOR__,
                routeName: routeName
            };
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            routeName
        ]);
        const customData = (0, $5uXOq.useMemo)(()=>({
                route: routeName,
                sidebarId: id
            }), [
            routeName,
            id
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceMark), {
            metricKey: (0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).renderEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azzrO")).NavSidebarPerformanceReport), {
            customData: customData
        }));
    };
    const $b5a3a4467dac2130$export$661ed14c8f75da9f = ()=>{
        const onFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, (0, parcelRequire("kvHKs")).SIDEBAR_EXPERIENCE)
        });
        return (0, $5uXOq.useCallback)((location, error)=>{
            onFail(location, error);
        }, [
            onFail
        ]);
    };
    const $b5a3a4467dac2130$export$ddb17534fdfb7dc6 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)($b5a3a4467dac2130$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
});
parcelRegister("93jKl", function(module, exports) {
    $parcel$export(module.exports, "useExperienceFail", ()=>$e2626e1ab0692489$export$606da7704d8eaf06);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZneA;
    var $bCf8q;
    var $l9g16;
    const $e2626e1ab0692489$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((location, error, extraAttributes = {})=>{
            const { current: current } = self;
            if ((0, (0, parcelRequire("bCf8q")).isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)) return;
            current.experienceTracker.fail({
                name: current.name,
                error: error,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes,
                    location: location
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("l9g16", function(module, exports) {
    $parcel$export(module.exports, "useExperienceContext", ()=>$79f23c22d88dd8d5$export$be8ec22ac9208049);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSOOm;
    const $79f23c22d88dd8d5$export$be8ec22ac9208049 = ()=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext));
        return context;
    };
});
parcelRegister("kaHBi", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$e1187df33c58b997$export$675e0d25df38d426);
    $parcel$export(module.exports, "ExperienceStart", ()=>$e1187df33c58b997$export$f20b867e738a222c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $e1187df33c58b997$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
        const self = (0, $5uXOq.useRef)({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            experienceTracker: experienceTracker,
            disableSli: disableSli,
            userLocation: userLocation,
            collect: collect
        });
        self.current.experienceId = experienceId;
        self.current.experience = experience;
        self.current.timeout = timeout;
        self.current.analyticsSource = analyticsSource;
        self.current.application = application;
        self.current.edition = edition;
        self.current.experienceTracker = experienceTracker;
        self.current.userLocation = userLocation;
        self.current.collect = collect;
        return (0, $5uXOq.useCallback)(()=>{
            const { current: current } = self;
            current.experienceTracker.start({
                id: current.experienceId,
                name: current.experience,
                timeout: current.timeout,
                attributes: {
                    analyticsSource: current.analyticsSource,
                    experience: current.experience,
                    experienceId: current.experienceId,
                    application: current.application,
                    edition: current.edition,
                    disableSli: current.disableSli,
                    userLocation: current.userLocation
                },
                collect: current.collect,
                onSuccess: ()=>undefined
            });
        }, [
            self
        ]);
    };
    const $e1187df33c58b997$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
        const onStart = $e1187df33c58b997$export$675e0d25df38d426({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            disableSli: disableSli,
            collect: collect
        });
        (0, $5uXOq.useMemo)(()=>{
            onStart();
        }, [
            onStart,
            experienceId,
            experience,
            timeout,
            analyticsSource,
            application,
            edition,
            disableSli,
            collect
        ]);
        return null;
    };
});
parcelRegister("6jY6G", function(module, exports) {
    $parcel$export(module.exports, "useCurrentRoute", ()=>$dda4cada2257eb1d$export$c4b7ea2942f2d0e);
    $parcel$export(module.exports, "useRouteByName", ()=>$dda4cada2257eb1d$export$d69a946e2d0a1c12);
    $parcel$export(module.exports, "usePreviousRouterState", ()=>$dda4cada2257eb1d$export$1e5fb68306bd0b92);
    var $dIdda = parcelRequire("dIdda");
    var $cfDZ3;
    const $dda4cada2257eb1d$export$c4b7ea2942f2d0e = (0, $dIdda.createRouterSelector)((state)=>state.route);
    const $dda4cada2257eb1d$export$d69a946e2d0a1c12 = (0, $dIdda.createRouterSelector)((state, routeName)=>state.routes.find(({ name: name })=>name === routeName) ?? null);
    const $dda4cada2257eb1d$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
            name: name,
            path: path,
            query: query,
            exact: exact
        });
    const $dda4cada2257eb1d$export$1e5fb68306bd0b92 = ()=>{
        (0, $dIdda.useRouter)();
        return (0, (0, parcelRequire("cfDZ3")).getPreviousRouterState)();
    };
});
parcelRegister("3bQtK", function(module, exports) {
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$f46ca4b214d7cdb6$export$4962f3898bd5c829);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $l9g16;
    const $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT = {};
    const $f46ca4b214d7cdb6$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const self = (0, $5uXOq.useRef)({
            experience: experience,
            attributes: attributes,
            experienceTracker: experienceTracker,
            route: route
        });
        self.current.route = route;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        self.current.experience = experience;
        return (0, $5uXOq.useCallback)((extraAttributes = {})=>{
            const { current: current } = self;
            if (current.route && current.route.isRedirect === true) return;
            current.experienceTracker.succeed({
                name: current.experience,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
    const $f46ca4b214d7cdb6$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $f46ca4b214d7cdb6$var$STABLE_EMPTY_OBJECT })=>{
        const onExperienceSuccess = $f46ca4b214d7cdb6$export$e94f0da4fc0603c6({
            experience: experience,
            attributes: attributes
        });
        (0, $5uXOq.useEffect)(()=>{
            onExperienceSuccess();
        }, [
            attributes,
            onExperienceSuccess
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (false) onExperienceSuccess();
        }, [
            onExperienceSuccess
        ]);
        return null;
    };
});
parcelRegister("4QcD9", function(module, exports) {
    $parcel$export(module.exports, "createValueController", ()=>$3f293f209341d999$export$ff0ab9dd4ceb4a93);
    var $7JoAD = parcelRequire("7JoAD");
    const $3f293f209341d999$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
        const actions = {
            setValue: (value)=>({ setState: setState })=>setState({
                        value: value
                    })
        };
        const initialState = {
            value: defaultValue
        };
        const store = (0, $7JoAD.createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const ValueContainer = (0, $7JoAD.createContainer)(store);
        const selector = (state)=>state.value;
        const useValueInternal = (0, $7JoAD.createHook)(store, {
            selector: selector
        });
        const useValue = ()=>{
            const [value, { setValue: setValue }] = useValueInternal();
            return [
                value,
                setValue
            ];
        };
        return {
            ValueContainer: ValueContainer,
            useValue: useValue
        };
    };
});
parcelRegister("6IzHB", function(module, exports) {
    $parcel$export(module.exports, "usePageId", ()=>$57184c749af08735$export$3434ba5eadb360dc);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $57184c749af08735$var$useSweetStatePageId = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: (state)=>state.currentPage.uuid
    });
    const $57184c749af08735$export$3434ba5eadb360dc = ()=>{
        const [pageId] = $57184c749af08735$var$useSweetStatePageId();
        return pageId;
    };
});
parcelRegister("kvHKs", function(module, exports) {
    $parcel$export(module.exports, "REPO_TYPE", ()=>$f1419662a60c783a$export$399c7e6858236b4);
    $parcel$export(module.exports, "LINK_TYPE", ()=>$f1419662a60c783a$export$58125ce2bb1c3378);
    $parcel$export(module.exports, "EMOJI_REGEX", ()=>$f1419662a60c783a$export$c79ed2783644934c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", ()=>$f1419662a60c783a$export$25ae65041c800c9);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", ()=>$f1419662a60c783a$export$e03c9beea817d44b);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", ()=>$f1419662a60c783a$export$3d575bdf28c0d17c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", ()=>$f1419662a60c783a$export$af84baced6970a17);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", ()=>$f1419662a60c783a$export$c767f253046b1ea7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", ()=>$f1419662a60c783a$export$265b9384cc2dfbd4);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$2de77b357e71c7a7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$7de7abb92169d6c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", ()=>$f1419662a60c783a$export$fd7df8bd7600c65c);
    $parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", ()=>$f1419662a60c783a$export$dde074e512e80dff);
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$f1419662a60c783a$export$1f70a76cb421b107);
    $parcel$export(module.exports, "SIDEBAR_EXPERIENCE", ()=>$f1419662a60c783a$export$71aaf2625ee54d10);
    $parcel$export(module.exports, "staticLegacyIds", ()=>$f1419662a60c783a$export$f57650e6e7be03dc);
    const $f1419662a60c783a$export$399c7e6858236b4 = 'source.code.link';
    const $f1419662a60c783a$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
    const $f1419662a60c783a$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
    const $f1419662a60c783a$export$25ae65041c800c9 = 'pin-filter-myopenissues';
    const $f1419662a60c783a$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
    const $f1419662a60c783a$export$3d575bdf28c0d17c = 'pin-filter-allissues';
    const $f1419662a60c783a$export$af84baced6970a17 = 'pin-filter-allopenissues';
    const $f1419662a60c783a$export$c767f253046b1ea7 = 'pin-filter-doneissues';
    const $f1419662a60c783a$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
    const $f1419662a60c783a$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
    const $f1419662a60c783a$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
    const $f1419662a60c783a$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
    const $f1419662a60c783a$export$dde074e512e80dff = 'global-create-spotlight';
    const $f1419662a60c783a$export$1f70a76cb421b107 = {
        REPORTS_ADDONS: 'sd-reports-addons'
    };
    const $f1419662a60c783a$export$83016cff6318a5dd = Object.freeze({
        CODE_TAB: 'CODE_TAB',
        ONCALL_TAB: 'ONCALL_TAB',
        PAGES_TAB: 'PAGES_TAB'
    });
    const $f1419662a60c783a$export$f371b4c263b142af = {
        [$f1419662a60c783a$export$83016cff6318a5dd.CODE_TAB]: 'code',
        [$f1419662a60c783a$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
        [$f1419662a60c783a$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
    };
    const $f1419662a60c783a$export$b66c40cadee12a0b = 'project/agility/index';
    const $f1419662a60c783a$export$6f454e69bce3a691 = 'project/business/index';
    const $f1419662a60c783a$export$3a0f7f7a8a0b306b = 'project/ops/index';
    const $f1419662a60c783a$export$1346c9aa3cbb477d = 'project/software/index';
    const $f1419662a60c783a$export$4598dd67943205cf = 'project/software/issues';
    const $f1419662a60c783a$export$8f36e85c5afae5 = 'project/software/reports';
    const $f1419662a60c783a$export$8151e5564c0016a1 = 'attachments';
    const $f1419662a60c783a$export$4acd0d06a25e56b5 = 'eventtypes';
    const $f1419662a60c783a$export$211ab01804585e09 = 'webhooks-admin';
    const $f1419662a60c783a$export$294b9ab8545a9f36 = 'services';
    const $f1419662a60c783a$export$665efe695022359b = 'greenhopper-lexorank-manage';
    const $f1419662a60c783a$export$47fbefc73055eb9d = 'admin-helper-admin-section';
    const $f1419662a60c783a$export$76e6bd729450de52 = 'advanced_section';
    const $f1419662a60c783a$export$ac928a90c0d3daa8 = 'collectors';
    const $f1419662a60c783a$export$309ac0136b7d5dfa = 'dark_features';
    const $f1419662a60c783a$export$998f1706a6ca29b = 'general_configuration';
    const $f1419662a60c783a$export$e9af81a594543847 = 'import_export_section';
    const $f1419662a60c783a$export$bbf19cc23216c6b = 'mail_section';
    const $f1419662a60c783a$export$693dd06b18660b78 = 'security_section';
    const $f1419662a60c783a$export$c6d1221ea0bce75e = 'shared_section';
    const $f1419662a60c783a$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
    const $f1419662a60c783a$export$af156d8e27fc5458 = 'user_interface';
    const $f1419662a60c783a$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
    const $f1419662a60c783a$export$f57650e6e7be03dc = [
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ];
});
parcelRegister("lGo7j", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$0c703bf4651638aa$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $gjTBi;
    var $bWqXX;
    const $0c703bf4651638aa$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "sidebar-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$BackgroundedWrapper, null, isFull && (0, ($parcel$interopDefault($5uXOq))).createElement($0c703bf4651638aa$var$HeadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWqXX")).default), {
            hasIcon: isFull
        }))));
    const $0c703bf4651638aa$var$BackgroundedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tem _1yt4s5g3",
                __cmplp.className
            ])
        });
    });
    const $0c703bf4651638aa$var$HeadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41k9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gjTBi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab78cae21894a64c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9UCCQ;
    var $jsTfk;
    var $j9VTE;
    const $ab78cae21894a64c$var$Section = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return props.children;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            ...props,
            ref: ref,
            overrides: {
                HeadingItem: {
                    cssFn: (0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles)
                }
            }
        });
    });
    var $ab78cae21894a64c$export$2e2bcd8739ae039 = $ab78cae21894a64c$var$Section;
});
parcelRegister("jsTfk", function(module, exports) {
    $parcel$export(module.exports, "overrideStyleFunction", ()=>$0d8b3d5d608d86de$export$505cedac1a39aacf);
    $parcel$export(module.exports, "baseSideNavItemStyle", ()=>$0d8b3d5d608d86de$export$aed216a85ec468ac);
    $parcel$export(module.exports, "sectionHeaderSpacingStyles", ()=>$0d8b3d5d608d86de$export$a5c27bed78cfecb9);
    const $0d8b3d5d608d86de$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
        return (state)=>{
            return [
                baseStyle(state),
                newStyle(state)
            ];
        };
    };
    const $0d8b3d5d608d86de$var$defaultStyles = {
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:active': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
        }
    };
    const $0d8b3d5d608d86de$var$selectedStyles = {
        backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        ':visited': {
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }
    };
    const $0d8b3d5d608d86de$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
        return {
            paddingBlock: "var(--ds-space-100, 8px)",
            paddingInline: "var(--ds-space-100, 8px)",
            borderRadius: "var(--ds-border-radius, 3px)",
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            ...!isDisabled && !isSelected && $0d8b3d5d608d86de$var$defaultStyles,
            ...!isDisabled && isSelected && $0d8b3d5d608d86de$var$selectedStyles,
            ['& [data-item-elem-before]']: {
                height: '1.5rem',
                width: '1.5rem'
            }
        };
    };
    const $0d8b3d5d608d86de$export$a5c27bed78cfecb9 = ()=>{
        return {
            paddingInline: "var(--ds-space-100, 8px)"
        };
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("bWqXX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c4e822429ecf69c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwwXK;
    var $jsTfk;
    var $j9VTE;
    const $9c4e822429ecf69c$var$SkeletonItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("j9VTE")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
            cssFn: ()=>({
                    ...(0, (0, parcelRequire("jsTfk")).sectionHeaderSpacingStyles)(),
                    '&&::before': {
                        height: '1.5rem',
                        marginRight: "var(--ds-space-200, 16px)",
                        width: '1.5rem'
                    }
                }),
            ...props
        });
    };
    var $9c4e822429ecf69c$export$2e2bcd8739ae039 = $9c4e822429ecf69c$var$SkeletonItem;
});
parcelRegister("gbGmI", function(module, exports) {
    $parcel$export(module.exports, "setPerformanceMarkLoadStart", ()=>$46c186c6902de7dc$export$4166241bf9111f66);
    $parcel$export(module.exports, "setPerformanceMarkLoadEnd", ()=>$46c186c6902de7dc$export$edbd543f308bbef5);
    var $azzrO;
    var $5e7oM;
    const $46c186c6902de7dc$export$4166241bf9111f66 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadStart);
    };
    const $46c186c6902de7dc$export$edbd543f308bbef5 = ()=>{
        const sideBarSegment = (0, (0, parcelRequire("azzrO")).pageSegmentStore).getSegment((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, (0, parcelRequire("5e7oM")).NAVIGATION_SIDEBAR_MARKS).loadEnd);
    };
});
parcelRegister("jCoeB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkFzD").then(()=>parcelRequire('dZptX'));
});
parcelRegister("2G9Bk", function(module, exports) {
    $parcel$export(module.exports, "createEntry", ()=>$2b838b47862d019e$export$344b9c9ab5e66c9a);
    const $2b838b47862d019e$export$344b9c9ab5e66c9a = (baseRoute, opts)=>{
        baseRoute.lazyOpts = opts;
        return baseRoute;
    };
});
parcelRegister("1RJbT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", ()=>$e49bb87876b98a92$export$4f2c2d125c2b811a);
    var $65Ltd;
    const $e49bb87876b98a92$export$4f2c2d125c2b811a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST),
        path: '/jira/settings/issues/explicit-field-association'
    };
});
parcelRegister("aYyVm", function(module, exports) {
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", ()=>$95736e1c9d4aba6e$export$7b11685155ada84d);
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", ()=>$95736e1c9d4aba6e$export$e81c180c4f4833e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $kxZPA;
    const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        return (0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7wmre")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
    }, {
        moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
    });
    const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
            pageId: "jira-admin-pages-explicit-field-association-project-list",
            shouldShowSpinner: true
        });
});
parcelRegister("7yO8g", function(module, exports) {
    $parcel$export(module.exports, "markAsProductBundleReady", ()=>$beda9c6123873bbb$export$ff83c57004505abd);
    var $2SVPM;
    const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            (0, (0, parcelRequire("2SVPM")).setProductBundleReadyForInitialRender)();
        });
        return importedBundle;
    };
});
parcelRegister("5j7Th", function(module, exports) {
    $parcel$export(module.exports, "LazyPage", ()=>$63937a96c08aaddb$export$a18c9c3dd309b8e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $lfTZh;
    var $6jY6G;
    var $7LpuY;
    var $dZw8H;
    const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
    const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
    const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const Skeleton = route.skeleton || (shouldShowSpinner ? (0, (0, parcelRequire("kb4zh")).default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
        (0, $5uXOq.useEffect)(()=>{
            if (route.isRedirect) (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        return route.isRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page_redirect",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7LpuY")).default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "lazy_page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null))));
    };
});
parcelRegister("kb4zh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26967b2e10d397c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fNobW;
    var $eZJjh;
    function $c26967b2e10d397c$export$2e2bcd8739ae039({ testId: testId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "legacy-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c26967b2e10d397c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            testId: testId
        }))));
    }
    const $c26967b2e10d397c$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $c26967b2e10d397c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wpz1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7LpuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c62dfc18679e80c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $bNvU3;
    var $7N30e;
    var $6b6Tk;
    var $8Qrwl;
    var $hXKq5;
    class $6c62dfc18679e80c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { children: children, pageId: pageId } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Qrwl")).default).Provider, {
                value: {
                    pageId: pageId,
                    onReady: this.onReady,
                    onCustomMark: this.onCustomMark
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: this.onStart,
                args: [
                    pageId
                ]
            }), children));
        }
        constructor(...args){
            super(...args);
            this.customMarks = [];
            this.onStart = ()=>{
                (0, (0, parcelRequire("kUU4G")).default)((0, $ce556f125dee8174$export$56940a9488e85199));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$45c4b6bf7935c69a));
            };
            this.onCustomMark = (markName)=>{
                (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)(markName));
                this.customMarks.push(markName);
            };
            this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
                metric.stop({
                    customData: extra
                });
                if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
            };
        }
    }
});
parcelRegister("kUU4G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb4d2f8b5a69f79$export$2e2bcd8739ae039);
    var $6RCeq;
    var $6cb4d2f8b5a69f79$export$2e2bcd8739ae039 = (prefix)=>{
        if ((0, (0, parcelRequire("6RCeq")).default) && (0, (0, parcelRequire("6RCeq")).default).getEntries && (0, (0, parcelRequire("6RCeq")).default).clearMarks) return (0, (0, parcelRequire("6RCeq")).default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
            (0, (0, parcelRequire("6RCeq")).default).clearMarks(mark.name);
            return mark;
        });
        return [];
    };
});
parcelRegister("bNvU3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c14e3adf575574$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    class $96c14e3adf575574$var$OpTrigger extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        shouldComponentUpdate(nextProps) {
            return !(0, ($parcel$interopDefault($ajpes)))(this.props.args, nextProps.args);
        }
        componentDidUpdate() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $96c14e3adf575574$export$2e2bcd8739ae039 = $96c14e3adf575574$var$OpTrigger;
});
parcelRegister("7N30e", function(module, exports) {
    $parcel$export(module.exports, "stopLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$a928755af449867);
    $parcel$export(module.exports, "startLowPriorityEventDelay", ()=>$5d68e3874efadecb$export$8bb8df5a93e9525);
    $parcel$export(module.exports, "default", ()=>$5d68e3874efadecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kUU4G;
    var $x9xyg;
    var $3vBBc;
    var $fjcgS;
    var $lsa9q;
    var $6b6Tk;
    const $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT = 10000;
    let $5d68e3874efadecb$var$stopDelayTimeout;
    let $5d68e3874efadecb$var$lastDelayActionPromise = (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
    const $5d68e3874efadecb$export$a928755af449867 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) return client;
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$2d91d3eed1108e72));
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(false);
            client.stopLowPriorityEventDelay();
            return client;
        });
    };
    const $5d68e3874efadecb$export$8bb8df5a93e9525 = ()=>{
        $5d68e3874efadecb$var$lastDelayActionPromise = $5d68e3874efadecb$var$lastDelayActionPromise.then((client)=>{
            if (!(0, (0, parcelRequire("3vBBc")).isEventDelayActive)()) {
                (0, (0, parcelRequire("kUU4G")).default)((0, $2eb1df3f82c48b0d$export$358721a9d6125914));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $2eb1df3f82c48b0d$export$b2122dce85a27912));
            }
            client.startLowPriorityEventDelay();
            (0, (0, parcelRequire("3vBBc")).setEventDelayActive)(true);
            clearTimeout($5d68e3874efadecb$var$stopDelayTimeout);
            $5d68e3874efadecb$var$stopDelayTimeout = setTimeout($5d68e3874efadecb$export$a928755af449867, $5d68e3874efadecb$var$STOP_DELAY_TIMEOUT);
            return client;
        });
    };
    const $5d68e3874efadecb$export$778ebe2a4fab1ba7 = ()=>$5d68e3874efadecb$var$lastDelayActionPromise;
    const $5d68e3874efadecb$var$EventDelayController = ()=>{
        const [loadedState] = (0, (0, parcelRequire("lsa9q")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!loadedState.hasLoaded && (0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) $5d68e3874efadecb$export$8bb8df5a93e9525();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    var $5d68e3874efadecb$export$2e2bcd8739ae039 = $5d68e3874efadecb$var$EventDelayController;
});
parcelRegister("3vBBc", function(module, exports) {
    $parcel$export(module.exports, "setEventDelayActive", ()=>$63f3b8c0745d0500$export$9a4add6d6ddcc1a);
    $parcel$export(module.exports, "isEventDelayActive", ()=>$63f3b8c0745d0500$export$3536b0184fa98d19);
    let $63f3b8c0745d0500$var$eventDelayActive = false;
    const $63f3b8c0745d0500$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
        $63f3b8c0745d0500$var$eventDelayActive = isEventDelayActive;
    };
    const $63f3b8c0745d0500$export$3536b0184fa98d19 = ()=>$63f3b8c0745d0500$var$eventDelayActive;
});
parcelRegister("lsa9q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f20cb56a66aca22$export$2e2bcd8739ae039);
    var $7JoAD = parcelRequire("7JoAD");
    var $7w9eZ;
    const $4f20cb56a66aca22$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        const determineHasLoaded = ()=>{
            if (appIds.length === 1 && appIds[0] === (0, $146ecce9d079a34d$export$3a54edb6ba4daa82)) return !__SPA__;
            return appIds.length ? appIds.filter((id)=>id !== (0, $146ecce9d079a34d$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
        };
        const hasLoaded = determineHasLoaded();
        return {
            hasLoaded: hasLoaded
        };
    };
    const $4f20cb56a66aca22$var$usePageLoadedSubscriber = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: $4f20cb56a66aca22$export$4a361c7505f72f5c
    });
    var $4f20cb56a66aca22$export$2e2bcd8739ae039 = $4f20cb56a66aca22$var$usePageLoadedSubscriber;
});
const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';
const $2eb1df3f82c48b0d$export$358721a9d6125914 = 'event-delay-controller.';
const $2eb1df3f82c48b0d$export$b2122dce85a27912 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}start`;
const $2eb1df3f82c48b0d$export$2d91d3eed1108e72 = `${$2eb1df3f82c48b0d$export$358721a9d6125914}end`;
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("8Qrwl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87d05828c384551$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d87d05828c384551$var$contextName = 'SpaApdexAnalytics';
    var $d87d05828c384551$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)($d87d05828c384551$var$contextName);
});
parcelRegister("hXKq5", function(module, exports) {
    $parcel$export(module.exports, "getPrefixedMarkName", ()=>$f6cddc52a08e036c$export$c8f0e9837e7e9425);
    const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;
});
parcelRegister("dZw8H", function(module, exports) {
    $parcel$export(module.exports, "SpaStateContainer", ()=>$b1cd152eb196251c$export$e9a92b877fe80e80);
    $parcel$export(module.exports, "SpaStateAppStart", ()=>$b1cd152eb196251c$export$d18dd27183a635c);
    $parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", ()=>$b1cd152eb196251c$export$95a2912d76fb5433);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$b1cd152eb196251c$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$b1cd152eb196251c$export$41e70078eeddaddc);
    $parcel$export(module.exports, "SpaStatePageErrorReady", ()=>$b1cd152eb196251c$export$2583aa269898885c);
    $parcel$export(module.exports, "getSpaStateLastUserLocation", ()=>$b1cd152eb196251c$export$6e9ab893e97cccef);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $dIdda = parcelRequire("dIdda");
    var $7JoAD = parcelRequire("7JoAD");
    var $4oDnX;
    var $7w9eZ;
    const $b1cd152eb196251c$export$e9a92b877fe80e80 = (0, $7JoAD.createContainer)((0, (0, parcelRequire("7w9eZ")).default));
    const $b1cd152eb196251c$export$d18dd27183a635c = ()=>{
        const startRef = (0, $5uXOq.useRef)(Date.now());
        const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, (0, parcelRequire("4oDnX")).useSpaState)();
        (0, $5uXOq.useMemo)(()=>{
            startRef.current = Date.now();
        }, [
            visitedPages
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setAppStart(startRef.current);
        }, [
            setAppStart,
            visitedPages
        ]);
        return null;
    };
    const $b1cd152eb196251c$var$useRouterMatchSelector = (0, $dIdda.createRouterSelector)((state)=>state.match);
    const $b1cd152eb196251c$var$useSpaStatePagesCount = (0, $7JoAD.createHook)((0, (0, parcelRequire("7w9eZ")).default), {
        selector: ({ visitedPages: visitedPages })=>visitedPages.length
    });
    const $b1cd152eb196251c$export$95a2912d76fb5433 = ()=>{
        const match = $b1cd152eb196251c$var$useRouterMatchSelector();
        const [count, { setAppStart: setAppStart }] = $b1cd152eb196251c$var$useSpaStatePagesCount();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b1cd152eb196251c$export$ada7e0ec445851a2, {
            visitedPagesLength: count,
            onSetAppStart: setAppStart,
            match: match
        });
    };
    const $b1cd152eb196251c$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady
            }));
    const $b1cd152eb196251c$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppReady,
                args: comparer
            }));
    const $b1cd152eb196251c$export$2583aa269898885c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oDnX")).SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
                op: setAppErrorReady
            }));
    class $b1cd152eb196251c$export$ada7e0ec445851a2 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
            const matchHasChanged = props.match !== state.match;
            const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
            if (setAppStart) props.onSetAppStart(Date.now());
            if (setAppStart || !visitedPageLengthHasChanged) return {
                started: true,
                visitedPagesLength: props.visitedPagesLength,
                match: props.match
            };
            return state;
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args);
            this.state = {
                visitedPagesLength: 0,
                started: false,
                match: null
            };
        }
    }
    const $b1cd152eb196251c$export$6e9ab893e97cccef = ()=>{
        const { visitedPages: visitedPages } = (0, $7JoAD.defaultRegistry).getStore((0, (0, parcelRequire("7w9eZ")).default)).storeState.getState();
        return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
    };
});
parcelRegister("7wmre", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3r4bl")
    ]).then(()=>parcelRequire('61Yus'));
});
parcelRegister("2rSKc", function(module, exports) {
    $parcel$export(module.exports, "addonsEmceePublicRouteEntry", ()=>$b25930f37fa52697$export$7922e0b87a833c8e);
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $atU1t;
    var $lTc8d;
    const $b25930f37fa52697$export$7922e0b87a833c8e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lTc8d")).addonsEmceePublicRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)()
            ]
        }));
});
parcelRegister("iHiHz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$883820dc444dc59c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("6xFyF")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
    });
    const $883820dc444dc59c$var$GlobalAppsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalAppsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($883820dc444dc59c$var$LazyGlobalAppsSettingsSidebar, null)));
    $883820dc444dc59c$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
    var $883820dc444dc59c$export$2e2bcd8739ae039 = $883820dc444dc59c$var$GlobalAppsSettingsSidebar;
});
parcelRegister("6xFyF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3EO4A")
    ]).then(()=>parcelRequire('kO26e'));
});
parcelRegister("lTc8d", function(module, exports) {
    $parcel$export(module.exports, "addonsEmceePublicRoute", ()=>$23bd026a293e27ee$export$9f7bcf70c66ebed0);
    var $65Ltd;
    const $23bd026a293e27ee$export$9f7bcf70c66ebed0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC),
        path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover'
    };
});
parcelRegister("etW4g", function(module, exports) {
    $parcel$export(module.exports, "legacyAllReportsRouteEntry", ()=>$3fdcf7e7a972597d$export$b8ab848c3f170ed4);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $dxCvy;
    var $7GnDe;
    var $9T7gB;
    var $9dKjw;
    const $3fdcf7e7a972597d$export$b8ab848c3f170ed4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9T7gB")).legacyAllReportsRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("9dKjw")).getReportsCommonResource)()
            ]
        }));
});
parcelRegister("gyYxw", function(module, exports) {
    $parcel$export(module.exports, "genericProjectLayout", ()=>$177735c975452188$export$85dad8e9886563f6);
    var $18N1t;
    var $1XrjK;
    var $6Z2mh;
    var $e7bC3;
    var $9Y3Lc;
    const $177735c975452188$export$85dad8e9886563f6 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("18N1t")).coreProjectLayout), (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("9Y3Lc")).userBoardLayout));
});
parcelRegister("18N1t", function(module, exports) {
    $parcel$export(module.exports, "coreProjectLayout", ()=>$32b20434a17da609$export$3c06ced9943ca671);
    var $1Du13;
    var $1XrjK;
    const $32b20434a17da609$export$3c06ced9943ca671 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
});
parcelRegister("1Du13", function(module, exports) {
    $parcel$export(module.exports, "projectLayout", ()=>$08491b76212b7395$export$204149bac601d20c);
    var $fpzhz;
    var $1XrjK;
    var $kxZPA;
    var $hMrxB;
    const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: 'any'
            }
        });
    const $08491b76212b7395$var$ProjectTrackers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8RliR")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
    });
    const $08491b76212b7395$var$ProjectFavicon = ()=>{
        (0, (0, parcelRequire("hMrxB")).useProjectFavicon)();
        return null;
    };
    const $08491b76212b7395$var$rightSidebars = ()=>[];
    const $08491b76212b7395$var$globalComponents = [
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
        $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
        $08491b76212b7395$var$withAnyProjectContext((0, (0, parcelRequire("fpzhz")).ProjectRouteListener))
    ];
    const $08491b76212b7395$export$204149bac601d20c = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: $08491b76212b7395$var$globalComponents,
        rightSidebars: $08491b76212b7395$var$rightSidebars()
    });
});
parcelRegister("fpzhz", function(module, exports) {
    $parcel$export(module.exports, "ProjectRouteListener", ()=>$a96b9050ddfb05f9$export$159f09d701320911);
    var $5uXOq = parcelRequire("5uXOq");
    var $dxCvy;
    var $itmJb;
    var $dIdda = parcelRequire("dIdda");
    var $hVf1M;
    const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
        const isSiteAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (isSiteAdmin) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: true
            });
            else if (data != null) (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: data.isProjectAdmin
            });
            else (0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                loading: loading,
                isProjectAdmin: null
            });
        }, [
            data,
            loading,
            isSiteAdmin
        ]);
        (0, $5uXOq.useEffect)(()=>()=>(0, (0, parcelRequire("hVf1M")).setIsProjectAdmin)({
                    loading: false,
                    isProjectAdmin: null
                }), []);
        return null;
    };
});
parcelRegister("itmJb", function(module, exports) {
    $parcel$export(module.exports, "useIsAdmin", ()=>$dfb6d33a8a8c98ed$export$99a5e4bc80d231ca);
    var $9OXo1;
    const $dfb6d33a8a8c98ed$export$99a5e4bc80d231ca = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAdmin || false;
    };
});
parcelRegister("hMrxB", function(module, exports) {
    $parcel$export(module.exports, "useProjectFavicon", ()=>$6ee68e956a566e2d$export$32abcb1f939de016);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $lpwtK;
    const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const iconEle = document.querySelector("link[rel='shortcut icon']");
        const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
            iconEle
        ]);
        const enabled = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-favicon-use-projecticon') === 'true', []);
        (0, $5uXOq.useEffect)(()=>{
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }, [
            project,
            iconEle,
            defaultFavicon,
            enabled
        ]);
    };
});
parcelRegister("8RliR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("gw9ua")
    ]).then(()=>parcelRequire('8DuT4'));
});
parcelRegister("6Z2mh", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectLayout", ()=>$0836cf39cca1e468$export$e321cb31c875d1ba);
    $parcel$export(module.exports, "rightSidebarsLayout", ()=>$0836cf39cca1e468$export$820f9bb834280408);
    var $2vSU6;
    var $2BrOV;
    var $i90UH;
    var $1Du13;
    var $1XrjK;
    var $ln7rs;
    var $kxZPA;
    const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $0836cf39cca1e468$var$ProjectBuilder = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9p3bS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/index.tsx"
    });
    const $0836cf39cca1e468$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hqzS2")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
    });
    const $0836cf39cca1e468$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("dyNBT")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {
        globalComponents: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
            $0836cf39cca1e468$var$withServiceProjectContext((0, (0, parcelRequire("i90UH")).AsyncJsmCustomDomainChangeBoardingFlag)),
            $0836cf39cca1e468$var$ProjectBuilder
        ],
        rightSidebars: [
            $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
            ...(0, (0, parcelRequire("ln7rs")).serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
        ]
    });
    const $0836cf39cca1e468$export$820f9bb834280408 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        rightSidebars: [
            $0836cf39cca1e468$var$RightSidebars
        ]
    });
});
parcelRegister("i90UH", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", ()=>$3ba5f01428db990d$export$b1ef5e3da6e1959d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fPVwK")), {
        moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
    });
    const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-jsm-custom-domain-change-boarding-flag",
            packageName: "jira-help-center-custom-domain-change-boarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-custom-domain-change-boarding-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));
});
parcelRegister("fPVwK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("fgCot")
    ]).then(()=>parcelRequire('9d42Z'));
});
parcelRegister("ln7rs", function(module, exports) {
    $parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", ()=>$f6f2168537ade4c7$export$2562b2d784eadc10);
    var $5uXOq = parcelRequire("5uXOq");
    var $4YIAU;
    var $1XrjK;
    var $kxZPA;
    const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
        const ScopedComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YIAU")).default), {
                hasServiceDeskAccess: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null));
        const name = (0, (0, parcelRequire("1XrjK")).coalesce)(Component.displayName) ?? (0, (0, parcelRequire("1XrjK")).coalesce)(Component.name) ?? 'Component';
        ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
        return ScopedComponent;
    };
    const $f6f2168537ade4c7$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("4IHta")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
    });
    const $f6f2168537ade4c7$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("hfniT")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/index.tsx"
    });
    const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
        ],
        rightSidebars: [
            $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
        ]
    });
});
parcelRegister("4YIAU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d82237ab91dce08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $1Yett;
    const $8d82237ab91dce08$var$AppPermissionsCheck = (props)=>{
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
            if ((0, (0, parcelRequire("1Yett")).isDevelopmentEnv)()) console.warn('AppPermissionsCheck should have defined at least one of access prop');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        }
        return null;
    };
    $8d82237ab91dce08$var$AppPermissionsCheck.defaultProps = {
        hasCoreAccess: undefined,
        hasSoftwareAccess: undefined,
        hasServiceDeskAccess: undefined
    };
    var $8d82237ab91dce08$export$2e2bcd8739ae039 = $8d82237ab91dce08$var$AppPermissionsCheck;
});
parcelRegister("1Yett", function(module, exports) {
    $parcel$export(module.exports, "isDevelopmentEnv", ()=>$7b47955f7b675219$export$48e5fb80244b95c5);
    const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;
});
parcelRegister("4IHta", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lBhEF")
    ]).then(()=>parcelRequire('fY1ne'));
});
parcelRegister("hfniT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("jlA2G")
    ]).then(()=>parcelRequire('lBfZ6'));
});
parcelRegister("9p3bS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b77bX").then(()=>parcelRequire('fT1Vy'));
});
parcelRegister("hqzS2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eZivQ")
    ]).then(()=>parcelRequire('dOvA3'));
});
parcelRegister("dyNBT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8Ww2s")
    ]).then(()=>parcelRequire('4D7Qi'));
});
parcelRegister("e7bC3", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareProjectLayout", ()=>$43d4c7537a1fee65$export$3791efdd32024063);
    $parcel$export(module.exports, "softwareProjectLayout", ()=>$43d4c7537a1fee65$export$9a918616afa3328c);
    $parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$ada52b1309832862);
    $parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", ()=>$43d4c7537a1fee65$export$6c1958653c44ba37);
    $parcel$export(module.exports, "softwareProjectLayoutCode", ()=>$43d4c7537a1fee65$export$ab7e607e8441dc61);
    var $2vSU6;
    var $1Du13;
    var $1XrjK;
    var $kxZPA;
    const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)
            }
        });
    const $43d4c7537a1fee65$var$Onboarding = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("8vADS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
    });
    const $43d4c7537a1fee65$var$OnboardingCode = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("nvZ7o")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/index.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebars = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("9Md0O")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $43d4c7537a1fee65$var$RightSidebarsCode = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("eDMeh")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/index.tsx"
    });
    const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
    const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
    const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
    ];
    const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
        $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
    ];
    const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout), {});
    const $43d4c7537a1fee65$export$3791efdd32024063 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$9a918616afa3328c = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboarding
        ]
    });
    const $43d4c7537a1fee65$export$ada52b1309832862 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
    const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
        rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
        globalComponents: [
            $43d4c7537a1fee65$var$SoftWareOnboardingCode
        ]
    });
});
parcelRegister("8vADS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5zn1B")
    ]).then(()=>parcelRequire('67mQl'));
});
parcelRegister("nvZ7o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9CFKR")
    ]).then(()=>parcelRequire('c0mAV'));
});
parcelRegister("9Md0O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("29qdR")
    ]).then(()=>parcelRequire('fHATI'));
});
parcelRegister("eDMeh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8pyxb")
    ]).then(()=>parcelRequire('3YyXe'));
});
parcelRegister("9Y3Lc", function(module, exports) {
    $parcel$export(module.exports, "userBoardLayout", ()=>$1760a1663e36faa5$export$7092b4ee86ae0b71);
    var $1XrjK;
    const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, (0, parcelRequire("1XrjK")).createLayout)();
});
const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';
parcelRegister("hBv66", function(module, exports) {
    $parcel$export(module.exports, "genericProjectSidebars", ()=>$0b920001492d0ef4$export$d88d2d25355bc89a);
    $parcel$export(module.exports, "classicBoardSidebars", ()=>$0b920001492d0ef4$export$c04daf123cec1f1e);
    $parcel$export(module.exports, "genericConnectSidebars", ()=>$0b920001492d0ef4$export$844d342b575ead35);
    var $cin8p;
    var $dmKXV;
    var $iHiHz;
    var $cOg46;
    var $koWFd;
    var $h0bZU;
    var $9s3j1;
    var $2IHt2;
    const $0b920001492d0ef4$export$d88d2d25355bc89a = [
        (0, (0, parcelRequire("dmKXV")).default),
        (0, (0, parcelRequire("koWFd")).default),
        (0, (0, parcelRequire("h0bZU")).default),
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$c04daf123cec1f1e = [
        (0, (0, parcelRequire("9s3j1")).default),
        (0, (0, parcelRequire("2IHt2")).default)
    ];
    const $0b920001492d0ef4$export$844d342b575ead35 = [
        ...$0b920001492d0ef4$export$d88d2d25355bc89a,
        (0, (0, parcelRequire("cin8p")).default),
        (0, (0, parcelRequire("iHiHz")).default),
        (0, (0, parcelRequire("cOg46")).default)
    ];
});
parcelRegister("cin8p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$760a63d3e4200cc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $760a63d3e4200cc2$var$LazyConnectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("bxwfY")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
    });
    const $760a63d3e4200cc2$var$ConnectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "connect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($760a63d3e4200cc2$var$LazyConnectSidebar, null)));
    $760a63d3e4200cc2$var$ConnectSidebar.displayName = 'ConnectSidebar';
    var $760a63d3e4200cc2$export$2e2bcd8739ae039 = $760a63d3e4200cc2$var$ConnectSidebar;
});
parcelRegister("bxwfY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("a8u2l")
    ]).then(()=>parcelRequire('caET0'));
});
parcelRegister("dmKXV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac63d95d52d9688b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ac63d95d52d9688b$var$LazyCoreProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("6RP79")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
    });
    const $ac63d95d52d9688b$var$CoreProjectSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "coreProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ac63d95d52d9688b$var$LazyCoreProjectSidebar, null));
    var $ac63d95d52d9688b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($ac63d95d52d9688b$var$CoreProjectSidebar);
});
parcelRegister("6RP79", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bpTJC")
    ]).then(()=>parcelRequire('8rIQt'));
});
parcelRegister("cOg46", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18dc7dd640caeb91$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("2YlLB")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
    });
    const $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalSystemSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($18dc7dd640caeb91$var$LazyGlobalSystemSettingsSidebar, null)));
    $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
    var $18dc7dd640caeb91$export$2e2bcd8739ae039 = $18dc7dd640caeb91$var$GlobalSystemSettingsSidebar;
});
parcelRegister("2YlLB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("gQZpl")
    ]).then(()=>parcelRequire('6Pefo'));
});
parcelRegister("koWFd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73e9a7a50d60fc40$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("ioGL3")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
    });
    const $73e9a7a50d60fc40$var$SoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "softwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($73e9a7a50d60fc40$var$LazyClassicSoftwareProjectSidebar, null)));
    $73e9a7a50d60fc40$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
    var $73e9a7a50d60fc40$export$2e2bcd8739ae039 = $73e9a7a50d60fc40$var$SoftwareProjectSidebar;
});
parcelRegister("ioGL3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4OI1j")
    ]).then(()=>parcelRequire('4WgKv'));
});
parcelRegister("h0bZU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca3f1b5dd616f02b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ca3f1b5dd616f02b$export$5b9febabdab63fba = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("in19N")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
    });
    const $ca3f1b5dd616f02b$var$ServicedeskSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ca3f1b5dd616f02b$export$5b9febabdab63fba, null)));
    $ca3f1b5dd616f02b$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
    var $ca3f1b5dd616f02b$export$2e2bcd8739ae039 = $ca3f1b5dd616f02b$var$ServicedeskSidebar;
});
parcelRegister("in19N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aOxtZ")
    ]).then(()=>parcelRequire('eufGV'));
});
parcelRegister("9s3j1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed71aad279526f75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("fXenH")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
    });
    const $ed71aad279526f75$var$ClassicSoftwareProjectSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "classicSoftwareProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed71aad279526f75$var$LazyClassicSoftwareProjectSidebar, null)));
    $ed71aad279526f75$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
    var $ed71aad279526f75$export$2e2bcd8739ae039 = $ed71aad279526f75$var$ClassicSoftwareProjectSidebar;
});
parcelRegister("fXenH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXBFn")
    ]).then(()=>parcelRequire('dydBa'));
});
parcelRegister("2IHt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8627747b0236ab96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $8627747b0236ab96$var$LazyUserSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("j9Afm")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
    });
    const $8627747b0236ab96$var$UserSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "user"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8627747b0236ab96$var$LazyUserSidebar, null)));
    $8627747b0236ab96$var$UserSidebar.displayName = 'UserSidebar';
    var $8627747b0236ab96$export$2e2bcd8739ae039 = $8627747b0236ab96$var$UserSidebar;
});
parcelRegister("j9Afm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("36IoX")
    ]).then(()=>parcelRequire('3AQ56'));
});
parcelRegister("lNicp", function(module, exports) {
    $parcel$export(module.exports, "getBusinessProjectResources", ()=>$492115de1a4c9f28$export$20e8c2951e444b08);
    $parcel$export(module.exports, "getProjectViewResources", ()=>$492115de1a4c9f28$export$fcbe882e18ee4a35);
    $parcel$export(module.exports, "getOverviewViewResources", ()=>$492115de1a4c9f28$export$21c5527b459d56fe);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $1E3vT;
    var $jrO9m;
    var $l2N2a;
    var $9yEpR;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    const $492115de1a4c9f28$var$commonResources = [
        (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
        (0, (0, parcelRequire("iNzEe")).navigationResource)
    ];
    const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
            (0, (0, parcelRequire("1E3vT")).navigationItemsResource)
        ];
    const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
            ...$492115de1a4c9f28$var$commonResources,
            (0, (0, parcelRequire("jrO9m")).overviewDetailsResource)
        ];
    const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
            ...$492115de1a4c9f28$export$20e8c2951e444b08(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
            ...$492115de1a4c9f28$export$46471673e66df5c1(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
});
parcelRegister("dAmbh", function(module, exports) {
    $parcel$export(module.exports, "configurationResource", ()=>$43ad736dfc62d10f$export$5c4ad441346dc154);
    $parcel$export(module.exports, "useRankField", ()=>$43ad736dfc62d10f$export$fffa1172af8de100);
    $parcel$export(module.exports, "useStartDateField", ()=>$43ad736dfc62d10f$export$bf78b0881400efef);
    $parcel$export(module.exports, "useIsLinkingEnabled", ()=>$43ad736dfc62d10f$export$76fc5a1eecec5a35);
    $parcel$export(module.exports, "useIsSubtasksEnabled", ()=>$43ad736dfc62d10f$export$dca58a051cb58f03);
    var $dIdda = parcelRequire("dIdda");
    var $58BMJ;
    const $43ad736dfc62d10f$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
    const $43ad736dfc62d10f$export$5c4ad441346dc154 = (0, $dIdda.createResource)({
        type: $43ad736dfc62d10f$var$RESOURCE_KEY,
        getKey: ()=>$43ad736dfc62d10f$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, (0, parcelRequire("58BMJ")).fetchConfiguration)(cloudId),
        maxAge: Infinity
    });
    const $43ad736dfc62d10f$export$b629b793d58e3884 = ()=>(0, $dIdda.useResource)($43ad736dfc62d10f$export$5c4ad441346dc154);
    const $43ad736dfc62d10f$export$fffa1172af8de100 = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.rankField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$bf78b0881400efef = ()=>{
        const { data: data, loading: loading, error: error } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return {
            data: data?.startDateField ?? null,
            loading: loading,
            error: error
        };
    };
    const $43ad736dfc62d10f$export$76fc5a1eecec5a35 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isLinkingEnabled ?? false;
    };
    const $43ad736dfc62d10f$export$dca58a051cb58f03 = ()=>{
        const { data: data } = $43ad736dfc62d10f$export$b629b793d58e3884();
        return data?.isSubtasksEnabled ?? false;
    };
});
parcelRegister("58BMJ", function(module, exports) {
    $parcel$export(module.exports, "fetchConfiguration", ()=>$1cb1e84b048c3101$export$9911e92fcb5c83c0);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $lKH3S;
    const $1cb1e84b048c3101$export$9911e92fcb5c83c0 = async (cloudId)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
                body: JSON.stringify({
                    query: (0, $5c0554031841947d$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            if (response.data == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return (0, (0, parcelRequire("lKH3S")).transformData)(response);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'configurationResource',
                    packageName: 'jiraRouterResourcesBusinessConfiguration',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
parcelRegister("jlq4V", function(module, exports) {
    $parcel$export(module.exports, "GraphQLErrors", ()=>$503bc83696833cc0$export$89c202e66b2de2b6);
    var $7hpBk = parcelRequire("7hpBk");
    var $8LQ84 = parcelRequire("8LQ84");
    const $503bc83696833cc0$var$generateErrorMessage = (err)=>{
        let message = '';
        if ((0, ($parcel$interopDefault($8LQ84)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
            const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += `${errorMessage}\n`;
        });
        message = message.replace(/\n$/, '');
        return message;
    };
    class $503bc83696833cc0$export$89c202e66b2de2b6 extends Error {
        constructor(graphQLErrors){
            super();
            this.graphQLErrors = graphQLErrors != null ? (0, ($parcel$interopDefault($7hpBk)))(graphQLErrors) : [];
            this.message = $503bc83696833cc0$var$generateErrorMessage(this);
            this.cause = this.graphQLErrors?.[0];
            this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
            this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
        }
    }
});
parcelRegister("7hpBk", function(module, exports) {
    var $8LQ84 = parcelRequire("8LQ84");
    function $54cdfac2bc83c2a9$var$castArray() {
        if (!arguments.length) return [];
        var value = arguments[0];
        return $8LQ84(value) ? value : [
            value
        ];
    }
    module.exports = $54cdfac2bc83c2a9$var$castArray;
});
const $5c0554031841947d$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
  }
}
`;
parcelRegister("lKH3S", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$0ad069c9956cd674$export$3ceb62baab058c6b);
    const $0ad069c9956cd674$export$3ceb62baab058c6b = (response)=>{
        let rankField = null;
        const rankFieldNode = response.data?.jira?.rankField;
        if (rankFieldNode != null) rankField = {
            id: rankFieldNode.fieldId,
            name: rankFieldNode.name
        };
        let startDateField = null;
        const startDateFieldNode = response.data?.jira?.startDateField;
        if (startDateFieldNode != null) startDateField = {
            id: startDateFieldNode.fieldId,
            name: startDateFieldNode.name
        };
        const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
        const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
        return {
            rankField: rankField,
            startDateField: startDateField,
            isLinkingEnabled: isLinkingEnabled,
            isSubtasksEnabled: isSubtasksEnabled
        };
    };
});
parcelRegister("g4ZHz", function(module, exports) {
    $parcel$export(module.exports, "fieldsResource", ()=>$410efef54f79d33f$export$8bca6c1954ae9308);
    $parcel$export(module.exports, "useFieldsResource", ()=>$410efef54f79d33f$export$c0cd85886917fe89);
    var $jlq4V;
    var $dXq4S;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $ljySl;
    var $kig09;
    const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
    const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
    };
    const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
        const response = await promise;
        if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        return (0, (0, parcelRequire("kig09")).transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
    };
    const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, $dIdda.createResource)({
        type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
            if (match.params.overviewId) return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
                overviewAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'project-overview',
                    resourceId: match.params.overviewId,
                    activationId: activationId
                })
            });
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, (0, parcelRequire("ljySl")).fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
                cloudId: cloudId,
                jqlContext: `project = '${projectIdOrKey}'`
            });
        },
        maxAge: 3600000
    });
    const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, $dIdda.useResource)($410efef54f79d33f$export$8bca6c1954ae9308);
});
parcelRegister("dXq4S", function(module, exports) {
    $parcel$export(module.exports, "isAri", ()=>$5c4418bd595ae8cf$export$8e68286aef4c3a8b);
    $parcel$export(module.exports, "createAri", ()=>$5c4418bd595ae8cf$export$594d18a0ad2e0e57);
    $parcel$export(module.exports, "toAri", ()=>$5c4418bd595ae8cf$export$24b47820a324e614);
    $parcel$export(module.exports, "toAriOrDefault", ()=>$5c4418bd595ae8cf$export$e2789192113e8b07);
    $parcel$export(module.exports, "parseAri", ()=>$5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
    $parcel$export(module.exports, "getAriConfig", ()=>$5c4418bd595ae8cf$export$3d8d7031a11613fd);
    const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
    const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
    const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
    const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
        if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
        if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
        return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
    };
    const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
        return undefined;
    };
    const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
    const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
        if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
            const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
            if (parts?.groups) {
                const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
                return {
                    resourceOwner: resourceOwner,
                    cloudId: cloudId,
                    resourceType: resourceType,
                    workspaceId: workspaceId,
                    resourceId: resourceId,
                    activationId: activationId
                };
            }
        }
        return undefined;
    };
    const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
        const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
        if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
        return config;
    };
});
parcelRegister("ljySl", function(module, exports) {
    $parcel$export(module.exports, "fetchFields", ()=>$90e7c5e5920e8507$export$f3ddd735c360919);
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
    const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
        try {
            const promise = (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: $90e7c5e5920e8507$var$PAGE_SIZE,
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return await handler(promise);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fieldsResource',
                    packageName: 'jiraRouterResourcesBusinessFields',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return null;
    };
});
const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;
parcelRegister("kig09", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$3d209f684c72dca4$export$3ceb62baab058c6b);
    const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);
});
parcelRegister("iNzEe", function(module, exports) {
    $parcel$export(module.exports, "navigationResource", ()=>$6b942b0827824c4b$export$62940941ee574cdc);
    $parcel$export(module.exports, "useNavigationResource", ()=>$6b942b0827824c4b$export$c17011c09e042a31);
    $parcel$export(module.exports, "useIsPremiumUserSeat", ()=>$6b942b0827824c4b$export$90749419e9042370);
    $parcel$export(module.exports, "useTriggerOverviewChangeboarding", ()=>$6b942b0827824c4b$export$30f6f0b00bf4f2f8);
    var $gccSB = parcelRequire("gccSB");
    var $dXq4S;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $geiy6;
    const $6b942b0827824c4b$export$62940941ee574cdc = (0, $dIdda.createResource)({
        type: 'BUSINESS_NAVIGATION',
        getKey: ()=>'BUSINESS_NAVIGATION',
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return null;
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (!(0, ($parcel$interopDefault($gccSB)))(projectKey)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
                cloudId: cloudId,
                projectKey: projectKey
            });
            if (!(0, ($parcel$interopDefault($gccSB)))(projectId)) return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
                cloudId: cloudId,
                projectId: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'project',
                    resourceId: projectId
                })
            });
            return (0, (0, parcelRequire("geiy6")).fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
                cloudId: cloudId
            });
        },
        maxAge: Infinity
    });
    const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $dIdda.useResource)($6b942b0827824c4b$export$62940941ee574cdc);
    const $6b942b0827824c4b$export$90749419e9042370 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.isPremiumUserSeat);
    };
    const $6b942b0827824c4b$export$30f6f0b00bf4f2f8 = ()=>{
        const { data: data } = $6b942b0827824c4b$export$c17011c09e042a31();
        if (data === 'NOT_APPLICABLE') return false;
        return Boolean(data?.showPlansOnboarding);
    };
});
parcelRegister("geiy6", function(module, exports) {
    $parcel$export(module.exports, "fetchNavigation", ()=>$446f8b979bebb841$export$1fc5fff73d9a570c);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ifwpM;
    const $446f8b979bebb841$var$EMPTY_RESPONSE = {
        recents: [],
        favorites: [],
        hasMoreFavorite: false,
        overviews: [],
        overviewsError: null,
        isPremiumUserSeat: false,
        showPlansOnboarding: false,
        shouldHideOverviews: false
    };
    const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: {
                        first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                        ...params
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response.data?.jira?.navigation === undefined) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            let areOverviewsGone = false;
            if (Array.isArray(response.errors)) areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
            return (0, (0, parcelRequire("ifwpM")).transformData)(response.data.jira.navigation, areOverviewsGone);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'navigationResource',
                    packageName: 'jiraRouterResourcesBusinessNavigation',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $446f8b979bebb841$var$EMPTY_RESPONSE;
    };
});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';
parcelRegister("ifwpM", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$9031e5290b70d3d6$export$3ceb62baab058c6b);
    var $6cG4N;
    var $027FQ;
    const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
    const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite,
            permissions: {
                viewIssues: node.viewIssues.canPerform
            },
            defaultView: node.defaultView?.typeKey?.toLowerCase()
        });
    const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
            id: node.id,
            name: node.name,
            theme: node?.theme ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name
        });
    const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
        if (navigation == null) return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
        let overviews = [];
        let overviewsError = null;
        const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
        if (isPremiumUserSeat) {
            if (navigation.overviews?.__typename === (0, (0, parcelRequire("027FQ")).OVERVIEWS_SUCCESS_RESPONSE_TYPE)) overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
            else overviewsError = navigation.overviews ?? new Error('Unknown overviews error');
        }
        let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
        recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
        const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
        const shouldHideOverviews = areOverviewsGone && !showPlansOnboarding;
        return {
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
            overviews: overviews,
            overviewsError: overviewsError,
            isPremiumUserSeat: isPremiumUserSeat,
            showPlansOnboarding: showPlansOnboarding,
            shouldHideOverviews: shouldHideOverviews
        };
    };
});
parcelRegister("6cG4N", function(module, exports) {
    $parcel$export(module.exports, "STAR_ICON_COLOR", ()=>$cd302866fea6f361$export$9e0962e0cb41695d);
    $parcel$export(module.exports, "Variables", ()=>$cd302866fea6f361$export$8bb9d79ea938efc9);
    $parcel$export(module.exports, "Tokens", ()=>$cd302866fea6f361$export$8e1e81ac145e31be);
    $parcel$export(module.exports, "BASE_THEME", ()=>$cd302866fea6f361$export$8a6e9b3370a0f87a);
    $parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$f286efa6bd1e8f9d);
    $parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", ()=>$cd302866fea6f361$export$97cb21c6432e07e8);
    $parcel$export(module.exports, "GRADIENT_THEME", ()=>$cd302866fea6f361$export$b124f62a6aab972);
    $parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$9441e0d8f766c59a);
    $parcel$export(module.exports, "NO_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$4c351ec1dc290344);
    $parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", ()=>$cd302866fea6f361$export$34373eced7ee212e);
    $parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", ()=>$cd302866fea6f361$export$5ddfadab7b1e12c1);
    $parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$349e5dbeac874253);
    $parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", ()=>$cd302866fea6f361$export$242b2d2213fedf27);
    $parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", ()=>$cd302866fea6f361$export$fe05a238062e2c3d);
    $parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", ()=>$cd302866fea6f361$export$cab9d853866386f2);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$cd302866fea6f361$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", ()=>$cd302866fea6f361$export$8e357501548afe78);
    $parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$baaf8255c30ea280);
    $parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$d9035bc768f8226d);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$4810531e30462f89);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$1c0b806722927549);
    $parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$2af5673c2fa63c55);
    $parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$5771162cdeebfb85);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$a1626d6d785092a2);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$410e3d6221a052e);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_HORIZONTAL_NAV_HEIGHT", ()=>$cd302866fea6f361$export$8588194807a0ca4b);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT", ()=>$cd302866fea6f361$export$254a8b23553b7df3);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT", ()=>$cd302866fea6f361$export$41cffad47189e5bd);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$cd302866fea6f361$export$ef343e01db40c562);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", ()=>$cd302866fea6f361$export$77cdace62a821419);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", ()=>$cd302866fea6f361$export$3efe68325dd9dc02);
    var $22jFS;
    var $44v1T;
    const $cd302866fea6f361$export$9e0962e0cb41695d = '#FFAB00';
    const $cd302866fea6f361$export$8bb9d79ea938efc9 = {
        BACKDROP_FILTER: '--project-backdrop-filter',
        COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
        COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
        COLOR_BACKGROUND_INPUT: '--project-background-input',
        COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
        COLOR_BACKGROUND_SELECTED: '--project-background-selected',
        COLOR_BORDER: '--project-color-border',
        COLOR_BORDER_INPUT: '--project-color-border-input',
        COLOR_BORDER_INVERSE: '--project-color-border-inverse',
        COLOR_BORDER_SELECTED: '--project-color-border-selected',
        COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
        COLOR_ICON_DANGER: '--project-color-icon-danger',
        COLOR_ICON_INFORMATION: '--project-color-icon-information',
        COLOR_ICON_SUCCESS: '--project-color-icon-success',
        COLOR_ICON_WARNING: '--project-color-icon-warning',
        COLOR_LINK: '--project-color-link',
        COLOR_LINK_PRESSED: '--project-color-link-pressed',
        COLOR_SKELETON: '--project-skeleton',
        COLOR_TEXT: '--project-color-text',
        COLOR_TEXT_DISABLED: '--project-color-text-disabled',
        COLOR_TEXT_INVERSE: '--project-color-text-inverse',
        COLOR_TEXT_SELECTED: '--project-color-text-selected',
        COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
        COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
        CONTENT_HEIGHT: '--project-content-height',
        CONTENT_WIDTH: '--project-content-width',
        ELEVATION_SURFACE: '--project-elevation-surface',
        ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
        ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
        WRAPPER_BACKGROUND: '--project-wrapper-background',
        WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
        WRAPPER_HEIGHT: '--project-wrapper-height',
        WRAPPER_PADDING: '--project-wrapper-padding',
        WRAPPER_WIDTH: '--project-wrapper-width'
    };
    const $cd302866fea6f361$export$8e1e81ac145e31be = {
        BACKDROP_FILTER: 'var(--project-backdrop-filter)',
        COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
        COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
        COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
        COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
        COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
        COLOR_BORDER: 'var(--project-color-border)',
        COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
        COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
        COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
        COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
        COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
        COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
        COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
        COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
        COLOR_LINK: 'var(--project-color-link)',
        COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
        COLOR_SKELETON: 'var(--project-skeleton)',
        COLOR_TEXT: 'var(--project-color-text)',
        COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
        COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
        COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
        COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
        COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
        CONTENT_HEIGHT: 'var(--project-content-height)',
        CONTENT_WIDTH: 'var(--project-content-width)',
        ELEVATION_SURFACE: 'var(--project-elevation-surface)',
        ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
        ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
        WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
        WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
        WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
        WRAPPER_PADDING: 'var(--project-wrapper-padding)',
        WRAPPER_WIDTH: 'var(--project-wrapper-width)'
    };
    const $cd302866fea6f361$export$8a6e9b3370a0f87a = {
        'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
        'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
        'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
        'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
        'color.background.input': `var(--ds-background-input, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.background.neutral': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30A})`,
        'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$exports).N50A})`,
        'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).N50A})`,
        'color.background.selected': `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.elevation.surface': `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.border': `var(--ds-border, ${(0, $829f609a65d26a98$exports).N40A})`,
        'color.border.input': "var(--ds-border-input, #091E4224)",
        'color.border.inverse': `var(--ds-border-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.border.selected': `var(--ds-border-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.icon.danger': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R200})`,
        'color.icon.information': `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B200})`,
        'color.icon.success': `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G200})`,
        'color.icon.warning': `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y200})`,
        'color.link': "var(--ds-link, #0c66e4)",
        'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
        'color.skeleton': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`,
        'color.text': `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
        'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
        'color.text.inverse': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        'color.text.selected': `var(--ds-text-selected, ${(0, $829f609a65d26a98$exports).B400})`,
        'color.text.subtle': `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
        'elevation.surface.contrast': 'transparent',
        'elevation.surface.contrast.bolder': 'transparent'
    };
    const $cd302866fea6f361$export$f286efa6bd1e8f9d = {
        'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
        'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
        'color.background.input': 'rgba(255, 255, 255, 0.8)',
        'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.text.selected': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
    };
    const $cd302866fea6f361$export$97cb21c6432e07e8 = {
        'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
        'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
        'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
        'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
        'color.background.input': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
        'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
        'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
        'color.background.selected': 'rgba(255, 255, 255, 0.6)',
        'color.elevation.surface': '#172b4d',
        'color.border': 'rgba(255, 255, 255, 0.14)',
        'color.border.input': 'rgba(255, 255, 255, 0.3)',
        'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
        'color.border.selected': (0, $829f609a65d26a98$exports).N0,
        'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
        'color.icon.information': (0, $829f609a65d26a98$exports).N0,
        'color.icon.success': (0, $829f609a65d26a98$exports).N0,
        'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
        'color.skeleton': 'rgba(255,255,255,0.08)',
        'color.text': (0, $829f609a65d26a98$exports).N0,
        'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
        'color.text.inverse': '#172B4D',
        'color.text.selected': '#172B4D',
        'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
        'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
    };
    const $cd302866fea6f361$export$b124f62a6aab972 = {
        'color.link': '#CCE0FF',
        'color.link.pressed': '#E9F2FF'
    };
    const $cd302866fea6f361$export$9441e0d8f766c59a = {
        name: 'image',
        brightness: 'high',
        theme: {
            light: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
                'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
                'color.text.selected': `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
                'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`
            },
            dark: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.background.input': 'rgba(34, 39, 43, 0.8)',
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.elevation.surface': '#172b4d',
                'color.border': 'rgba(255, 255, 255, 0.14)',
                'color.border.input': 'rgba(255, 255, 255, 0.3)',
                'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
                'color.icon.danger': (0, $829f609a65d26a98$exports).N0,
                'color.icon.information': (0, $829f609a65d26a98$exports).N0,
                'color.icon.success': (0, $829f609a65d26a98$exports).N0,
                'color.icon.warning': (0, $829f609a65d26a98$exports).N0,
                'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
                'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
                'color.skeleton': 'rgba(255,255,255,0.8)',
                'color.text': (0, $829f609a65d26a98$exports).N0,
                'color.text.selected': "var(--ds-text-inverse, #1D2125)",
                'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
                'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
            }
        }
    };
    const $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG = {
        name: 'white'
    };
    const $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
        name: 'light-purple'
    };
    const $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
        name: 'light-blue'
    };
    const $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
        name: 'light-teal'
    };
    const $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
        name: 'light-green'
    };
    const $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
        name: 'light-yellow'
    };
    const $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG = {
        name: 'light-red'
    };
    const $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
        name: 'light-magenta'
    };
    const $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
        name: 'light-orange'
    };
    const $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG = {
        name: 'dark'
    };
    const $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG = {
        name: 'purple'
    };
    const $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG = {
        name: 'blue'
    };
    const $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG = {
        name: 'teal'
    };
    const $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG = {
        name: 'green'
    };
    const $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG = {
        name: 'yellow'
    };
    const $cd302866fea6f361$var$RED_BACKGROUND_CONFIG = {
        name: 'red'
    };
    const $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG = {
        name: 'magenta'
    };
    const $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG = {
        name: 'orange'
    };
    const $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG = {
        name: 'darker-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
        name: 'darker-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG = {
        name: 'darker-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG = {
        name: 'darker-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG = {
        name: 'darker-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG = {
        name: 'darker-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
        name: 'darker-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
        name: 'darker-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG = {
        name: 'darker-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darker-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
        name: 'darkest-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'darkest-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
        name: 'darkest-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
        name: 'darkest-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
        name: 'darkest-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG = {
        name: 'darkest-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'darkest-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'darkest-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG = {
        name: 'darkest-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darkest-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
        name: 'lightest-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F1F2F4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'lightest-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F3F0FF',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
        name: 'lightest-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E9F2FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
        name: 'lightest-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E7F9FF',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
        name: 'lightest-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCFFF1',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
        name: 'lightest-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#EFFFD6',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'lightest-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF7D6',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'lightest-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF3EB',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
        name: 'lightest-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECEB',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lightest-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECF8',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
        name: 'lighter-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCDFE4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
        name: 'lighter-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DFD8FD',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
        name: 'lighter-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#CCE0FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
        name: 'lighter-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#C6EDFB',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
        name: 'lighter-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#BAF3DB',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
        name: 'lighter-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#D3F1A7',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
        name: 'lighter-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F8E6A0',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
        name: 'lighter-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FEDEC8',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG = {
        name: 'lighter-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFD5D2',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lighter-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FDD0EC',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $cd302866fea6f361$export$4c351ec1dc290344 = {
        name: 'no-background',
        brightness: 'high',
        theme: {
            light: $cd302866fea6f361$export$8a6e9b3370a0f87a,
            dark: $cd302866fea6f361$export$8a6e9b3370a0f87a
        }
    };
    const $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META = {
        name: 'gradient-gray-to-black',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
        name: 'gradient-dark-to-medium-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
        name: 'gradient-light-to-dark-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META = {
        name: 'gradient-blue-to-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
        name: 'gradient-purple-to-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
        name: 'gradient-magenta-to-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
        name: 'gradient-dark-to-light-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
        name: 'gradient-dark-to-light-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
        name: 'gradient-dark-green-to-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            }
        }
    };
    const $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
        name: 'gradient-dark-to-medium-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            }
        }
    };
    const $cd302866fea6f361$export$34373eced7ee212e = [
        $cd302866fea6f361$var$WHITE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARK_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$5ddfadab7b1e12c1 = [
        $cd302866fea6f361$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_BLUE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_TEAL_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_GREEN_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_LIME_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_RED_BACKGROUND_CONFIG,
        $cd302866fea6f361$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
    ];
    const $cd302866fea6f361$export$349e5dbeac874253 = [
        ...$cd302866fea6f361$export$5ddfadab7b1e12c1,
        $cd302866fea6f361$export$4c351ec1dc290344
    ];
    const $cd302866fea6f361$export$242b2d2213fedf27 = [
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_RED_META,
        $cd302866fea6f361$var$GRADIENT_MAGENTA_TO_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_GREEN_TO_LIME_META,
        $cd302866fea6f361$var$GRADIENT_BLUE_TO_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
        $cd302866fea6f361$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
        $cd302866fea6f361$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
        $cd302866fea6f361$var$GRADIENT_PURPLE_TO_MAGENTA_META,
        $cd302866fea6f361$var$GRADIENT_GRAY_TO_BLACK_META
    ];
    const $cd302866fea6f361$export$8f118a95a310853a = [
        ...$cd302866fea6f361$export$242b2d2213fedf27,
        ...$cd302866fea6f361$export$349e5dbeac874253
    ];
    const $cd302866fea6f361$export$fe05a238062e2c3d = {
        white: $cd302866fea6f361$export$4c351ec1dc290344,
        'light-purple': $cd302866fea6f361$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        'light-blue': $cd302866fea6f361$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        'light-teal': $cd302866fea6f361$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        'light-green': $cd302866fea6f361$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        'light-yellow': $cd302866fea6f361$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        'light-orange': $cd302866fea6f361$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        'light-red': $cd302866fea6f361$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        'light-magenta': $cd302866fea6f361$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        dark: $cd302866fea6f361$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        purple: $cd302866fea6f361$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        blue: $cd302866fea6f361$var$DARKER_BLUE_BACKGROUND_CONFIG,
        teal: $cd302866fea6f361$var$DARKER_TEAL_BACKGROUND_CONFIG,
        green: $cd302866fea6f361$var$DARKER_GREEN_BACKGROUND_CONFIG,
        yellow: $cd302866fea6f361$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        orange: $cd302866fea6f361$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        red: $cd302866fea6f361$var$DARKER_RED_BACKGROUND_CONFIG,
        magenta: $cd302866fea6f361$var$DARKER_MAGENTA_BACKGROUND_CONFIG
    };
    const $cd302866fea6f361$export$cab9d853866386f2 = $cd302866fea6f361$export$4c351ec1dc290344;
    const $cd302866fea6f361$export$ed7cc0d417ee89e = '--jwm-banner-height';
    const $cd302866fea6f361$export$7009ab5fba189797 = `var(${$cd302866fea6f361$export$ed7cc0d417ee89e}, 0px)`;
    const $cd302866fea6f361$export$8e357501548afe78 = 24;
    const $cd302866fea6f361$export$baaf8255c30ea280 = 95;
    const $cd302866fea6f361$export$d9035bc768f8226d = `calc(${$cd302866fea6f361$export$baaf8255c30ea280}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$4810531e30462f89 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d})`;
    const $cd302866fea6f361$export$1c0b806722927549 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$d9035bc768f8226d} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$2af5673c2fa63c55 = 126;
    const $cd302866fea6f361$export$5771162cdeebfb85 = `calc(${$cd302866fea6f361$export$2af5673c2fa63c55}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$a1626d6d785092a2 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85})`;
    const $cd302866fea6f361$export$410e3d6221a052e = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$5771162cdeebfb85} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$8588194807a0ca4b = 146;
    const $cd302866fea6f361$export$254a8b23553b7df3 = `calc(${$cd302866fea6f361$export$8588194807a0ca4b}px + ${$cd302866fea6f361$export$7009ab5fba189797})`;
    const $cd302866fea6f361$export$41cffad47189e5bd = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3})`;
    const $cd302866fea6f361$export$ef343e01db40c562 = `calc(100vh - ${(0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)} - ${$cd302866fea6f361$export$254a8b23553b7df3} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px)`;
    const $cd302866fea6f361$export$77cdace62a821419 = `calc(100vw - ${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)}) !important`;
    const $cd302866fea6f361$export$3efe68325dd9dc02 = `calc(100vw - ${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)} - ${(0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)} - ${$cd302866fea6f361$export$8e357501548afe78 * 2}px) !important`;
});
parcelRegister("22jFS", function(module, exports) {
    $parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$cbfb0f5b2869b17b);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$a30f2e00489a8957);
    $parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$c103b605cd368aed);
    $parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$fa34f417972d6341);
    $parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$3a6a779d9181047c);
    $parcel$export(module.exports, "VAR_BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$bcd94a6a792e7f96);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", ()=>$565cb8192fc4e070$export$b6744d31294864fd);
    $parcel$export(module.exports, "DIMENSIONS", ()=>$565cb8192fc4e070$export$d67ac355184b7646);
    $parcel$export(module.exports, "LEFT_PANEL", ()=>$565cb8192fc4e070$export$344062f7cfc9528e);
    $parcel$export(module.exports, "RIGHT_PANEL", ()=>$565cb8192fc4e070$export$c7139cc2d6110b5f);
    $parcel$export(module.exports, "BANNER", ()=>$565cb8192fc4e070$export$238d30785c4bca84);
    $parcel$export(module.exports, "TOP_NAVIGATION", ()=>$565cb8192fc4e070$export$bec6dca2e63de4ae);
    $parcel$export(module.exports, "CONTENT", ()=>$565cb8192fc4e070$export$d1213e82613ff4df);
    $parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$be83e7118304b28e);
    $parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$4a98ee0bd1ae362);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$539e68c09584883a);
    $parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$b92df8810d2fcd01);
    $parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$c3e41153b9288bcf);
    $parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$c4d6152f86ea28f6);
    $parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$46acf8758e9e2636);
    $parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$70740f5ad8360a78);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$991d5285ad765a3d);
    $parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", ()=>$565cb8192fc4e070$export$6949d4f32b161684);
    $parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$d6e7e8af042815bb);
    $parcel$export(module.exports, "TRANSITION_DURATION", ()=>$565cb8192fc4e070$export$3749e1104328fde4);
    $parcel$export(module.exports, "FLYOUT_DELAY", ()=>$565cb8192fc4e070$export$1074d925b0b82be5);
    $parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", ()=>$565cb8192fc4e070$export$451e84a45a9e4a75);
    $parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", ()=>$565cb8192fc4e070$export$802bb2c050f3db5c);
    $parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", ()=>$565cb8192fc4e070$export$5e5e1875c3fd8f4f);
    $parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", ()=>$565cb8192fc4e070$export$70c702a8c5895f03);
    $parcel$export(module.exports, "GRAB_AREA_SELECTOR", ()=>$565cb8192fc4e070$export$48a43f91e4becf4e);
    $parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", ()=>$565cb8192fc4e070$export$dac2fb31a9f6844d);
    $parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", ()=>$565cb8192fc4e070$export$9ecd22db14e6c70e);
    $parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", ()=>$565cb8192fc4e070$export$5253dd9707b8c3ba);
    $parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", ()=>$565cb8192fc4e070$export$206a08f7f8beb554);
    $parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", ()=>$565cb8192fc4e070$export$659ee746b31b360d);
    $parcel$export(module.exports, "LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$f963aecf2d4465bd);
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$750459958906793);
    $parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$f897e1ed9f8ed251);
    $parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$b44ab66843c05a69);
    $parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$aeff86a16f13529);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$d2fa14f05b61e66);
    const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
    const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
    const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
    const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
    const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
    const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
    const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
    const $565cb8192fc4e070$export$d67ac355184b7646 = [
        $565cb8192fc4e070$export$cbfb0f5b2869b17b,
        $565cb8192fc4e070$export$fa34f417972d6341,
        $565cb8192fc4e070$export$bcd94a6a792e7f96,
        $565cb8192fc4e070$export$3a6a779d9181047c,
        $565cb8192fc4e070$export$a30f2e00489a8957,
        $565cb8192fc4e070$export$c103b605cd368aed
    ];
    const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
    const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
    const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
    const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
    const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
    const $565cb8192fc4e070$export$2d8180803f50fc5 = 'main';
    const $565cb8192fc4e070$export$50ea883ba6f28ff5 = 'left-sidebar';
    const $565cb8192fc4e070$export$7bf43119a6b49ddb = 'right-sidebar';
    const $565cb8192fc4e070$export$be83e7118304b28e = 56;
    const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
    const $565cb8192fc4e070$export$539e68c09584883a = 240;
    const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
    const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
    const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
    const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
    const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
    const $565cb8192fc4e070$export$f562af313cda0684 = 80;
    const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
    const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
    const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
    const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
    const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
    const $565cb8192fc4e070$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
    const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
    const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
    const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
    const $565cb8192fc4e070$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
    const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
    const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
    const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
    const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
    const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
    const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
    const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
    const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
    const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
    const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
    const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
    const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
    const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
    const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;
});
parcelRegister("44v1T", function(module, exports) {
    $parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", ()=>$81918a2ef6db1f93$export$d60454526e2281af);
    var $22jFS;
    const $81918a2ef6db1f93$export$d60454526e2281af = `(${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)})`;
});
parcelRegister("027FQ", function(module, exports) {
    $parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", ()=>$fd4c320fd9ec6c35$export$ddf2fc82885279d);
    const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
    const $fd4c320fd9ec6c35$export$39284f7325536558 = {
        ServiceDesk: 'SERVICE_DESK',
        Business: 'BUSINESS',
        Software: 'SOFTWARE'
    };
    const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
        TeamManagedProject: 'TEAM_MANAGED_PROJECT',
        CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
    };
});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
parcelRegister("1E3vT", function(module, exports) {
    $parcel$export(module.exports, "navigationItemsResource", ()=>$4f364072ed560b43$export$8446b129b5aba359);
    var $ljMDN;
    var $dJl1T;
    var $3HwlS;
    var $eM91u;
    var $ao2h1;
    var $6SGt4;
    var $1nb22;
    const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
    const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
        try {
            return projectId ? (0, (0, parcelRequire("ljMDN")).JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString() : '';
        } catch (err) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
            return '';
        }
    };
    const $4f364072ed560b43$export$8446b129b5aba359 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const { cloudId: cloudId } = tenantContext;
            const projectIdOrKey = projectKey || projectId;
            const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
            return {
                parameters: (0, (0, parcelRequire("6SGt4")).default),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    first: (0, (0, parcelRequire("eM91u")).NAVIGATION_ITEMS_PAGE_SIZE),
                    containerNavigationInput: scopeId ? {
                        scopeId: scopeId
                    } : {
                        projectKeyQuery: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    },
                    useContainerNavigation: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    useNewProjectHeader: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)(),
                    projectKey: projectKey,
                    projectAri: scopeId,
                    useProjectKey: Boolean(projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("6SGt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fed7f561d3a05da6$export$2e2bcd8739ae039);
    const $fed7f561d3a05da6$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useContainerNavigation"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useNewProjectHeader"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useProjectKey"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v11 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        }, v12 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v13 = {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        }, v14 = {
            "kind": "ScalarField",
            "name": "name"
        }, v15 = {
            "condition": "useNewProjectHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectBoardHeader_horizontalNavHeader_projectFragment"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "projectHeader_horizontalNavHeader_projectFragment"
                }
            ]
        }, v16 = {
            "kind": "FragmentSpread",
            "name": "tabs_businessHorizontalNav_TabsContent_projectFragment"
        }, v17 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v18 = {
            "args": [
                v9
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                }
            ]
        }, v19 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v20 = [
            v9,
            v19,
            {
                "kind": "Variable",
                "name": "projectIdOrKey",
                "variableName": "projectIdOrKey"
            }
        ], v21 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v22 = {
            "kind": "ScalarField",
            "name": "id"
        }, v23 = {
            "kind": "ScalarField",
            "name": "label"
        }, v24 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v25 = {
            "kind": "ScalarField",
            "name": "url"
        }, v26 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v27 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v28 = {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v21,
                v22,
                {
                    "kind": "ScalarField",
                    "name": "isDefault"
                },
                {
                    "kind": "ScalarField",
                    "name": "typeKey"
                },
                {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraNavigationItem"
                },
                v23,
                {
                    "kind": "ScalarField",
                    "name": "canRemove"
                },
                {
                    "kind": "ScalarField",
                    "name": "canSetAsDefault"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                                v23,
                                {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        v23,
                                        v24,
                                        v25,
                                        v26
                                    ]
                                }
                            ]
                        },
                        v25,
                        v24,
                        v26,
                        {
                            "kind": "ScalarField",
                            "name": "appType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "envLabel"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v27
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                        }
                    ],
                    "type": "JiraAppNavigationItem"
                },
                v27
            ]
        }, v29 = [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v21,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ], v30 = {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": v29
        }, v31 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v32 = {
            "kind": "InlineFragment",
            "selections": [
                v22
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v33 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v34 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v35 = {
            "kind": "ScalarField",
            "name": "boardId"
        }, v36 = [
            v11,
            v12,
            v13,
            v14,
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            v22,
            {
                "condition": "useNewProjectHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v33,
                    {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    {
                        "alias": "canEditProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v34,
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                    },
                    {
                        "alias": "canViewProjectConfig",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": v34,
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                    },
                    {
                        "concreteType": "JiraBoardConnection",
                        "kind": "LinkedField",
                        "name": "boards",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraBoardEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraBoard",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v35,
                                            {
                                                "concreteType": "JiraFavouriteValue",
                                                "kind": "LinkedField",
                                                "name": "favouriteValue",
                                                "plural": false,
                                                "selections": [
                                                    v33,
                                                    v22
                                                ]
                                            },
                                            v31,
                                            v22,
                                            v27
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v27
                ]
            },
            {
                "condition": "useContainerNavigation",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "navigationMetadata",
                        "plural": false,
                        "selections": [
                            v21,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v35,
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSimpleBoard"
                                    },
                                    v22
                                ],
                                "type": "JiraSoftwareProjectNavigationMetadata"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "mostRecentlyViewedBoard",
                        "plural": false,
                        "selections": [
                            v21,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v35,
                                    {
                                        "kind": "ScalarField",
                                        "name": "boardType"
                                    }
                                ],
                                "type": "JiraBoard"
                            },
                            v32
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8
                ],
                "kind": "Fragment",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "tabs_businessHorizontalNav_TabsContent_jiraQueryFragment"
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectDataByKey",
                                            "args": v10,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectByKey",
                                            "plural": false,
                                            "selections": [
                                                v11,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v12,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataByKey.projectId"
                                                },
                                                v13,
                                                v14,
                                                v15,
                                                v16
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useProjectKey",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectDataById",
                                            "args": v17,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProject",
                                            "plural": false,
                                            "selections": [
                                                v11,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v12,
                                                    "action": "THROW",
                                                    "path": "jira.projectDataById.projectId"
                                                },
                                                v13,
                                                v14,
                                                v15,
                                                v16
                                            ]
                                        }
                                    ]
                                },
                                v18
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v4,
                    v2,
                    v1,
                    v6,
                    v5,
                    v3,
                    v8,
                    v7
                ],
                "kind": "Operation",
                "name": "projectNavigation_horizontalNavigationQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v18,
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "navigationItems",
                                        "args": v20,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "jwmSavedViewsByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v28,
                                                    v21,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    }
                                                ]
                                            },
                                            v30,
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "alias": "navigationItems",
                                        "args": v20,
                                        "filters": [
                                            "cloudId",
                                            "projectIdOrKey"
                                        ],
                                        "handle": "connection",
                                        "key": "tabs_jiraNavigation__navigationItems",
                                        "kind": "LinkedHandle",
                                        "name": "jwmSavedViewsByProject"
                                    }
                                ]
                            },
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "input",
                                                "variableName": "containerNavigationInput"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraContainerNavigationResult"
                                            },
                                            v21,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v22,
                                                    v31,
                                                    {
                                                        "args": [
                                                            v19
                                                        ],
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    v28,
                                                                    v21
                                                                ]
                                                            },
                                                            v30
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v29,
                                                "type": "QueryError"
                                            },
                                            v32
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v10,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v36
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v17,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": v36
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "cb36e10a41a601f964c936292686a838726dc5b8430eb652166a8c310914baac",
                "metadata": {},
                "name": "projectNavigation_horizontalNavigationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $fed7f561d3a05da6$var$node.hash = "6bc22acbcf8f31d68defc8a8e42e4678";
    var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;
});
parcelRegister("jrO9m", function(module, exports) {
    $parcel$export(module.exports, "overviewDetailsResource", ()=>$e1715b61e2fa96e9$export$cd57aa046b167312);
    $parcel$export(module.exports, "useOverview", ()=>$e1715b61e2fa96e9$export$626541a5c6f2cfa1);
    var $dIdda = parcelRequire("dIdda");
    var $hFi7P;
    const $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
    const $e1715b61e2fa96e9$export$cd57aa046b167312 = (0, $dIdda.createResource)({
        type: $e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY,
        getKey: ({ match: match })=>`${$e1715b61e2fa96e9$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
        getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, (0, parcelRequire("hFi7P")).fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
        maxAge: 3600000
    });
    const $e1715b61e2fa96e9$export$626541a5c6f2cfa1 = ()=>(0, $dIdda.useResource)($e1715b61e2fa96e9$export$cd57aa046b167312);
});
parcelRegister("hFi7P", function(module, exports) {
    $parcel$export(module.exports, "fetchOverviewDetails", ()=>$692d3aa28ecf0a74$export$f0395142dbdd6c61);
    var $63wRx;
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $dXq4S;
    var $dpLxG;
    const $692d3aa28ecf0a74$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
        if (!overviewId) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("dpLxG")).QUERY),
                    variables: {
                        id: (0, (0, parcelRequire("dXq4S")).createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'project-overview',
                            resourceId: overviewId,
                            activationId: activationId
                        })
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response?.data?.jira?.overview?.__typename === (0, $4bd5c695609ae115$export$62a5da7e3fa5ff88)) return (0, (0, parcelRequire("63wRx")).mapOverviewFragment)(response.data.jira.overview);
            throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response?.data?.jira?.overview ?? response.errors);
        } catch (error) {
            if (error?.statusCode === 410) throw error;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'overviewDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return null;
    };
});
parcelRegister("63wRx", function(module, exports) {
    $parcel$export(module.exports, "mapOverviewFragment", ()=>$bc1a4d4cd369fa52$export$e79bf238de33eabb);
    const $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $bc1a4d4cd369fa52$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
            const { node: node } = edge || {};
            if (node == null) return null;
            return {
                key: node.key,
                id: Number(node.projectId),
                avatarUrl: node.avatar?.large ?? '',
                name: node.name,
                type: node.projectType.toLowerCase(),
                isSimplified: node.projectStyle === $bc1a4d4cd369fa52$var$SIMPLIFIED_PROJECT_STYLE,
                isFavorite: node.isFavourite === true,
                permissions: {
                    administerProject: node.administerProject.canPerform,
                    createIssues: node.createIssues.canPerform,
                    deleteIssues: node.deleteIssues.canPerform,
                    editIssues: node.editIssues.canPerform,
                    linkIssues: node.linkIssues.canPerform,
                    scheduleIssues: node.scheduleIssues.canPerform,
                    transitionIssues: node.transitionIssues?.canPerform === true,
                    viewIssues: node.viewIssues.canPerform
                }
            };
        }).filter((project)=>project);
    const $bc1a4d4cd369fa52$export$e79bf238de33eabb = (overview)=>{
        const { id: id, name: name, theme: theme, projects: projectsData } = overview;
        const projects = $bc1a4d4cd369fa52$var$mapProjectsNode(projectsData.edges);
        const unreachableProjectsCount = projectsData.edges.length - projects.length;
        return {
            id: id,
            name: name,
            theme: theme,
            projects: projects,
            unreachableProjectsCount: unreachableProjectsCount
        };
    };
});
parcelRegister("dpLxG", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$42259e945f9fd88b$export$2b91517d6d5b4365);
    const $42259e945f9fd88b$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892)}
`;
});
const $71cc1a0cc3cc977d$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;
const $4bd5c695609ae115$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';
parcelRegister("l2N2a", function(module, exports) {
    $parcel$export(module.exports, "projectDetailsResource", ()=>$a72df1053ff3c9a0$export$e541d9eb202b4972);
    $parcel$export(module.exports, "useProject", ()=>$a72df1053ff3c9a0$export$51b1383ef8844a7);
    $parcel$export(module.exports, "useMediaConfiguration", ()=>$a72df1053ff3c9a0$export$ab5cf8327e07f046);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $8s4PA;
    const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
    const $a72df1053ff3c9a0$export$e541d9eb202b4972 = (0, $dIdda.createResource)({
        type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("8s4PA")).fetchProjectDetails)(cloudId, projectKey, projectId);
        },
        maxAge: 3600000
    });
    const $a72df1053ff3c9a0$export$51b1383ef8844a7 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return {
            data: data?.currentProject ?? null,
            loading: loading,
            error: error
        };
    };
    const $a72df1053ff3c9a0$export$ab5cf8327e07f046 = ()=>{
        const { data: data } = (0, $dIdda.useResource)($a72df1053ff3c9a0$export$e541d9eb202b4972);
        return data?.media ?? null;
    };
});
parcelRegister("8s4PA", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectDetails", ()=>$3400333a67b09775$export$78aa221476efa1c6);
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $dXq4S;
    var $2D9kr;
    const $3400333a67b09775$var$EMPTY_VALUE = {
        themeSetting: null,
        media: null
    };
    const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
        const projectIdOrKey = projectId || projectKey;
        if (!projectIdOrKey) return null;
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
                body: JSON.stringify({
                    query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        usingProjectKey: projectId == null,
                        projectId: projectId != null ? (0, (0, parcelRequire("dXq4S")).createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'project',
                            resourceId: projectId
                        }) : ''
                    }
                })
            });
            return (0, (0, parcelRequire("2D9kr")).transformData)(response.data, projectIdOrKey);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'projectDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessProjectDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return $3400333a67b09775$var$EMPTY_VALUE;
    };
});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;
parcelRegister("2D9kr", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$a9016a2d391e1663$export$3ceb62baab058c6b);
    const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            status: node.status,
            isSimplified: node.simplified,
            isFavorite: node.favorite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                transitionIssues: node.transitionIssues.canPerform,
                viewIssues: node.viewIssues.canPerform
            }
        };
    };
    const $a9016a2d391e1663$var$parseThemeSetting = (data)=>{
        const theme = data?.jwmSidebar?.theme;
        if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
            type: 'color',
            value: theme.colorValue
        };
        if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
            type: 'color',
            value: theme.gradientValue
        };
        if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
            const { customBackground: customBackground } = theme;
            const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
            return {
                type: 'image',
                value: 'image',
                id: id,
                mediaApiFileId: mediaApiFileId,
                mediaReadToken: mediaReadToken,
                sourceType: sourceType,
                sourceIdentifier: sourceIdentifier,
                altText: altText
            };
        }
        return null;
    };
    const $a9016a2d391e1663$var$parseMediaConfiguration = (data)=>{
        const clientId = data?.jira?.mediaClientId;
        const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
        if (clientId == null || externalEndpointUrl == null) return null;
        return {
            clientId: clientId,
            externalEndpointUrl: externalEndpointUrl
        };
    };
    const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
            themeSetting: $a9016a2d391e1663$var$parseThemeSetting(data),
            currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
            projectIdOrKey: projectIdOrKey,
            media: $a9016a2d391e1663$var$parseMediaConfiguration(data)
        });
});
parcelRegister("9yEpR", function(module, exports) {
    $parcel$export(module.exports, "storageDetailsResource", ()=>$920f9d6e578a6c36$export$76c871115d0c70a1);
    $parcel$export(module.exports, "useStorageDetails", ()=>$920f9d6e578a6c36$export$8c295c187914aac1);
    var $dIdda = parcelRequire("dIdda");
    var $6Z2DE;
    const $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
    const $920f9d6e578a6c36$export$76c871115d0c70a1 = (0, $dIdda.createResource)({
        type: $920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getKey: ()=>$920f9d6e578a6c36$var$RESOURCE_TYPE_KEY,
        getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, (0, parcelRequire("6Z2DE")).fetchStorageDetails)(appEditions),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $920f9d6e578a6c36$export$8c295c187914aac1 = ()=>(0, $dIdda.useResource)($920f9d6e578a6c36$export$76c871115d0c70a1);
});
parcelRegister("6Z2DE", function(module, exports) {
    $parcel$export(module.exports, "fetchStorageDetails", ()=>$6e4752d8c4202fab$export$576d1c3de6af9760);
    var $jlq4V;
    var $dJl1T;
    var $jcw0u;
    var $eusud;
    var $ldyPw;
    const $6e4752d8c4202fab$export$576d1c3de6af9760 = async (appEditions)=>{
        try {
            if (appEditions?.core !== (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) return null;
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/latest?query', {
                body: JSON.stringify({
                    query: (0, $3d489d21cba189e7$export$2b91517d6d5b4365),
                    variables: {
                        productKey: 'jira-core'
                    }
                }),
                headers: {
                    'content-type': 'application/json'
                }
            });
            if (response.errors != null) {
                const error = response.errors?.[0];
                const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
                if (!isClientError) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            }
            const usageLimit = response?.data?.attachmentStorage;
            if (usageLimit && usageLimit?.allowed) {
                const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
                return percentageUsed;
            }
            return null;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getStorageAmountService',
                    packageName: 'jiraRouterResourcesBusinessStorageDetails',
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $3d489d21cba189e7$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;
parcelRegister("aFVvc", function(module, exports) {
    $parcel$export(module.exports, "projectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$f6c05eaea53ab4ae);
    $parcel$export(module.exports, "useProjectCreatePermissionsResource", ()=>$9880b75bed11d4d0$export$2bd0d3b374549a68);
    var $dIdda = parcelRequire("dIdda");
    const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("axsKz"));
    const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $dIdda.createResource)({
        type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
        getKey: ()=>'state',
        getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
        maxAge: Infinity
    });
    const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $dIdda.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);
});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';
parcelRegister("axsKz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bqWWL").then(()=>parcelRequire('5Yzmr'));
});
parcelRegister("9T7gB", function(module, exports) {
    $parcel$export(module.exports, "legacyAllReportsRoute", ()=>$dc48f6dcc6c9e25a$export$549d32fceee24980);
    var $65Ltd;
    const $dc48f6dcc6c9e25a$export$549d32fceee24980 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        path: '/projects/:projectKey',
        query: [
            'selectedItem=(.*report-page.*)'
        ]
    };
});
parcelRegister("9dKjw", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$a33e8671883cd449$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $a33e8671883cd449$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $a33e8671883cd449$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("48Ij3", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJSWReportsResource", ()=>$d94d5098764be5f8$export$5910307042ab3f6f);
    var $8YTna;
    var $dIdda = parcelRequire("dIdda");
    var $7xeIG;
    const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $dIdda.createResource)({
        type: 'JIRA_SOFTWARE_REPORTS',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            const response = await (0, (0, parcelRequire("7xeIG")).fetchJSWReports)(boardId);
            return response?.reports;
        },
        maxAge: 300000
    });
});
parcelRegister("7xeIG", function(module, exports) {
    $parcel$export(module.exports, "fetchJSWReports", ()=>$61400f9195fc4c28$export$a93a577d6971da2c);
    var $eusud;
    const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
    };
});
parcelRegister("4Bwc0", function(module, exports) {
    $parcel$export(module.exports, "devOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$96cb0eae1b3413f4);
    $parcel$export(module.exports, "useDevOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$e9adc6103e9ed514);
    var $dIdda = parcelRequire("dIdda");
    const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $dIdda.createResource)({
        type: (0, $16165c7eb855363c$export$14c5ce449424c281),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("fUjXk")),
        maxAge: 60000
    });
    const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $dIdda.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);
});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';
parcelRegister("fUjXk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("goFaC").then(()=>parcelRequire('5aldt'));
});
parcelRegister("cww4s", function(module, exports) {
    $parcel$export(module.exports, "legacyBacklogRouteEntry", ()=>$76169c5e62307112$export$e64dbc2432a0bfba);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $dxCvy;
    var $7GnDe;
    var $6QKrH;
    var $84Hdw;
    var $5PD5h;
    const $76169c5e62307112$export$e64dbc2432a0bfba = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("84Hdw")).legacyBacklogRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ]
        }));
});
parcelRegister("84Hdw", function(module, exports) {
    $parcel$export(module.exports, "legacyBacklogRoute", ()=>$375efe0f51eefa82$export$c51fda014ab27b5d);
    var $65Ltd;
    const $375efe0f51eefa82$export$c51fda014ab27b5d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_BACKLOG),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=(.*planning.*)'
        ]
    };
});
parcelRegister("5PD5h", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", ()=>$a816ddf70513a004$export$128d5d79815580ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("gMULe")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
    });
    const $a816ddf70513a004$export$128d5d79815580ca = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-software-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a816ddf70513a004$var$LazyHorizontalSoftwareProjectNav, null));
});
parcelRegister("gMULe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("djQ7G")
    ]).then(()=>parcelRequire('1f09g'));
});
parcelRegister("bNq9X", function(module, exports) {
    $parcel$export(module.exports, "legacyBoardRouteEntry", ()=>$c5b9873c9f8a1258$export$e3d172b0d9fd0d47);
    $parcel$export(module.exports, "legacyBoard1RouteEntry", ()=>$c5b9873c9f8a1258$export$fa18d34686878114);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $dxCvy;
    var $7GnDe;
    var $6QKrH;
    var $cLiUn;
    var $5PD5h;
    const $c5b9873c9f8a1258$export$e3d172b0d9fd0d47 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cLiUn")).legacyBoardRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ]
        }));
    const $c5b9873c9f8a1258$export$fa18d34686878114 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cLiUn")).legacyBoard1Route), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ]
        }));
});
parcelRegister("cLiUn", function(module, exports) {
    $parcel$export(module.exports, "legacyBoardRoute", ()=>$fdb6ff8bec92a4ae$export$9259d0f05fc27139);
    $parcel$export(module.exports, "legacyBoard1Route", ()=>$fdb6ff8bec92a4ae$export$be72991932610f35);
    var $65Ltd;
    const $fdb6ff8bec92a4ae$export$9259d0f05fc27139 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_BOARD),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView'
        ]
    };
    const $fdb6ff8bec92a4ae$export$be72991932610f35 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_BOARD),
        path: '/secure/RapidBoard.jspa'
    };
});
parcelRegister("eThIt", function(module, exports) {
    $parcel$export(module.exports, "legacyConnectGeneralRouteEntry", ()=>$3845c947bf9a95f3$export$5f816cf76ff922b8);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $hz6Yb;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $dxCvy;
    var $7GnDe;
    var $hPgV1;
    const $3845c947bf9a95f3$export$5f816cf76ff922b8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hPgV1")).legacyConnectGeneralRoute), ()=>({
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)(),
            navigation: {
                sidebar: (0, (0, parcelRequire("hBv66")).genericConnectSidebars)
            },
            resources: [
                (0, (0, parcelRequire("hz6Yb")).connectGeneralResources),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("hz6Yb", function(module, exports) {
    $parcel$export(module.exports, "connectGeneralResources", ()=>$07e636c36bc19b52$export$f34ab0d904621847);
    $parcel$export(module.exports, "useConnectGeneralResource", ()=>$07e636c36bc19b52$export$53479840ec6d4024);
    var $dIdda = parcelRequire("dIdda");
    const $07e636c36bc19b52$export$f34ab0d904621847 = (0, $dIdda.createResource)({
        type: (0, $1130bd470474fe6f$export$d5eed449bb62d4c1),
        getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
            if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        getDataLoader: ()=>(parcelRequire("bBygl"))
    });
    const $07e636c36bc19b52$export$53479840ec6d4024 = ()=>(0, $dIdda.useResource)($07e636c36bc19b52$export$f34ab0d904621847);
});
const $1130bd470474fe6f$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';
parcelRegister("bBygl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("W2aDd").then(()=>parcelRequire('6LiLg'));
});
parcelRegister("hPgV1", function(module, exports) {
    $parcel$export(module.exports, "legacyConnectGeneralRoute", ()=>$87cd34a23c2a9b8f$export$837edad42702a8e5);
    var $65Ltd;
    const $87cd34a23c2a9b8f$export$837edad42702a8e5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey'
    };
});
parcelRegister("cpQ1x", function(module, exports) {
    $parcel$export(module.exports, "legacyConnectProjectRouteEntry", ()=>$2a105fd0abb69c29$export$c7f411b1904e5c2a);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $9UABi;
    var $bHhiy;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $d61u6;
    const $2a105fd0abb69c29$export$c7f411b1904e5c2a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d61u6")).legacyConnectProjectRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                (0, (0, parcelRequire("9UABi")).connectProjectResources),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("9UABi", function(module, exports) {
    $parcel$export(module.exports, "connectProjectResources", ()=>$fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
    var $8Vh1q;
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $dIdda.createResource)({
        type: (0, $35b0c7feb103121f$export$da32d27651782c3),
        getKey: ({ query: query })=>{
            const { addonKey: addonKey, moduleKey: moduleKey } = (0, (0, parcelRequire("8Vh1q")).transformUrlToAddonAndModuleKeys)(query);
            if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        depends: [
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource).type
        ],
        getDataLoader: ()=>(parcelRequire("actZ1"))
    });
});
parcelRegister("8Vh1q", function(module, exports) {
    $parcel$export(module.exports, "transformResponse", ()=>$beff5be7f4728df2$export$3361e9be8093ddcc);
    $parcel$export(module.exports, "extractContext", ()=>$beff5be7f4728df2$export$efdbd45f3e77a161);
    $parcel$export(module.exports, "transformQueryParams", ()=>$beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
    $parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", ()=>$beff5be7f4728df2$export$752ef5ab3d7ab15f);
    var $dJl1T;
    var $6VnTH;
    var $bsuuc;
    const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
        try {
            const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
            const structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
            const context = {
                productContext: productContext,
                structuredContext: structuredContext,
                productCtx: productContext
            };
            return {
                ...response,
                ...context,
                isFullPage: response.general === '1',
                user: {
                    timeZone: response.timeZone,
                    uid: response.uid || undefined,
                    ukey: response.ukey || undefined,
                    fullName: response.fullName || undefined
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                },
                history: {
                    state: ''
                },
                autoresize: true,
                ns: response.uniqueKey,
                containerId: `embedded-${response.uniqueKey}`,
                contextPath: response.cp,
                width: response.w || response.width,
                height: response.h || response.height
            };
        } catch (error) {
            const location = 'connect-iframe.transformer';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
            return {
                autoresize: true,
                productCtx: undefined,
                structuredContext: undefined,
                isFullPage: true,
                history: {
                    state: ''
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                }
            };
        }
    };
    const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
        const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
        return newValue !== null ? {
            [newName]: newValue
        } : null;
    };
    const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
        const scope = contextData && contextData.scope || null;
        const project = contextData && contextData.project || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
        const project = projectSidebarNavInfo && (0, (0, parcelRequire("bsuuc")).extractData)(projectSidebarNavInfo) || null;
        const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, (0, parcelRequire("6VnTH")).extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
        const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
        return {
            ...query,
            ...context
        };
    };
    const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
        const { selectedItem: selectedItem } = query;
        let addonKey = '';
        let moduleKey = '';
        if (selectedItem) {
            const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
            [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
        }
        return {
            addonKey: addonKey,
            moduleKey: moduleKey
        };
    };
});
parcelRegister("6VnTH", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$4d73b10ca351bbb3$export$9df5fa0a366163d2);
    $parcel$export(module.exports, "extractUserBoard", ()=>$4d73b10ca351bbb3$export$67db9e2d1b6ed865);
    const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
        if (jiraSoftwareNavData.boardInfo == null) return null;
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: true
        };
    };
    const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: false
        };
    };
});
const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';
parcelRegister("actZ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g7yss").then(()=>parcelRequire('4ECv0'));
});
parcelRegister("fpjJX", function(module, exports) {
    $parcel$export(module.exports, "getServiceDeskNavigationResources", ()=>$491f4fde535ee8ab$export$bc0bd65e6da57c1f);
    $parcel$export(module.exports, "getServiceDeskNavigationSingleResources", ()=>$491f4fde535ee8ab$export$41a9145ddbba28e5);
    $parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", ()=>$491f4fde535ee8ab$export$2c543d6accc1eb9b);
    $parcel$export(module.exports, "getServiceDeskSettingsResources", ()=>$491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
    $parcel$export(module.exports, "getServicedeskPageContextResources", ()=>$491f4fde535ee8ab$export$a8b852f03a310dc0);
    $parcel$export(module.exports, "getQueuesResources", ()=>$491f4fde535ee8ab$export$70b97995f4d5ef9f);
    $parcel$export(module.exports, "getIssueListSsrResource", ()=>$491f4fde535ee8ab$export$e1016cce62543991);
    $parcel$export(module.exports, "getKnowledgeBaseResources", ()=>$491f4fde535ee8ab$export$ed87d3b71544c4ef);
    $parcel$export(module.exports, "getInsightResources", ()=>$491f4fde535ee8ab$export$9e0cf1fab0581096);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $b2pl3;
    var $gS5PF;
    var $6zFAI;
    var $gcI3W;
    var $ggg5j;
    var $iEUaw;
    var $bjZiV;
    var $3RJkv;
    var $dxCvy;
    var $8H3A4;
    var $cAofY;
    var $eUvlM;
    var $lbaDt;
    var $1WlLE;
    var $2cxgG;
    var $6sNnq;
    var $7GnDe;
    var $gNStA;
    var $gRzZD;
    const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
        ];
    const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
            ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
            ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
        ];
    const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
            (0, (0, parcelRequire("1WlLE")).priorityGroupResource),
            (0, (0, parcelRequire("6sNnq")).featuresResource),
            (0, (0, parcelRequire("gS5PF")).staticSidebarJsmReportsResource)
        ];
    const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
            (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredProjectProperties)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredFrontendProperties)),
            (0, (0, parcelRequire("5bkvv")).forgeServiceDeskQueueModuleResource),
            (0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)(), (0, (0, parcelRequire("2cxgG")).virtualAgentOnboardingResource))
        ];
    const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource)
        ];
    const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
            ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
            ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource))
        ];
    const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_view_queues_issuelist'), (0, (0, parcelRequire("1WlLE")).issueListSsrResource))
        ];
    const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
});
parcelRegister("gS5PF", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJsmReportsResource", ()=>$e7e607725980fdf6$export$ec28065a31cce4ce);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $cQGRH;
    const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
        getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            return (0, (0, parcelRequire("cQGRH")).fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
        },
        maxAge: 300000
    });
});
parcelRegister("cQGRH", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", ()=>$ed2ba0d649a8d8eb$export$c1dd51127051647d);
    var $eusud;
    const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
        if (projectIdOrKey == null) throw new Error('invalid project id or key');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
    };
});
parcelRegister("bjZiV", function(module, exports) {
    $parcel$export(module.exports, "kbConfluenceContextResource", ()=>$450040dc63d5cc0e$export$8b58be1423986d17);
    var $dIdda = parcelRequire("dIdda");
    const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("f43qF"));
    const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $dIdda.createResource)({
        type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
        maxAge: Infinity
    });
});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';
parcelRegister("f43qF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2CTCs").then(()=>parcelRequire('2SeLy'));
});
parcelRegister("8H3A4", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAnalyticsContextResource", ()=>$4d76b3bac8f2b7c8$export$d6f4f0483916919f);
    $parcel$export(module.exports, "useServiceDeskAnalyticsContext", ()=>$4d76b3bac8f2b7c8$export$bc2de1c42df30b10);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $4d76b3bac8f2b7c8$var$getDataLoader = ()=>(parcelRequire("9YBmF"));
    const $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS = 86400000;
    const $4d76b3bac8f2b7c8$export$d6f4f0483916919f = (0, $dIdda.createResource)({
        type: (0, $3b4b6bf0bbdfa955$export$285b47583a5bdd0f),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $4d76b3bac8f2b7c8$var$getDataLoader,
        maxAge: $4d76b3bac8f2b7c8$var$ONE_DAY_IN_MILLIS
    });
    const $4d76b3bac8f2b7c8$export$bc2de1c42df30b10 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($4d76b3bac8f2b7c8$export$d6f4f0483916919f);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
});
const $3b4b6bf0bbdfa955$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';
parcelRegister("9YBmF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3rvO2").then(()=>parcelRequire('btHFe'));
});
parcelRegister("cAofY", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskContextResource", ()=>$9c517de0cdc23225$export$5eaaf465969a9171);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("jxdf6"));
    const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $dIdda.createResource)({
        type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrIdFromMatchAndQuery)({
                match: match,
                query: query
            }),
        getDataLoader: $9c517de0cdc23225$var$getDataLoader,
        maxAge: Infinity
    });
});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';
parcelRegister("jxdf6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iNITq").then(()=>parcelRequire('g4PUK'));
});
parcelRegister("eUvlM", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPracticesResource", ()=>$9479f477b801290f$export$2ae319305481e7de);
    $parcel$export(module.exports, "useWorkCategoriesQueueSupported", ()=>$9479f477b801290f$export$a86ac771006f14b3);
    $parcel$export(module.exports, "useWorkCategoriesAllSupported", ()=>$9479f477b801290f$export$fe081b1a59d3c818);
    $parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", ()=>$9479f477b801290f$export$4d46346ef0bdc6b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $oCMSG;
    var $dIdda = parcelRequire("dIdda");
    const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("bvW9G"));
    const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $9479f477b801290f$export$2ae319305481e7de = (0, $dIdda.createResource)({
        type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $9479f477b801290f$var$getDataLoader,
        maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
    });
    const $9479f477b801290f$var$queuesOrder = [
        ...(0, (0, parcelRequire("oCMSG")).WORK_CATEGORIES_QUEUE_SUPPORTED)
    ];
    const $9479f477b801290f$var$workCategoryOrder = [
        ...$9479f477b801290f$var$queuesOrder,
        (0, (0, parcelRequire("oCMSG")).DEVELOPER_ESCALATION)
    ];
    const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformItsmPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
        const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !data && !error) refreshPractices();
        }, [
            data,
            error,
            loading,
            refreshPractices
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
});
parcelRegister("oCMSG", function(module, exports) {
    $parcel$export(module.exports, "CHANGES", ()=>$4f9c4406e75c8aa5$export$8598196f74460271);
    $parcel$export(module.exports, "INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
    $parcel$export(module.exports, "PROBLEMS", ()=>$4f9c4406e75c8aa5$export$ceba70db1edb1def);
    $parcel$export(module.exports, "SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
    $parcel$export(module.exports, "POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$81e62964cc725098);
    $parcel$export(module.exports, "NO_CATEGORY", ()=>$4f9c4406e75c8aa5$export$485b1216c42d8d4);
    $parcel$export(module.exports, "NO_PRACTICE", ()=>$4f9c4406e75c8aa5$export$52bf3f16b7812704);
    $parcel$export(module.exports, "SHORT_FORM_CHANGES", ()=>$4f9c4406e75c8aa5$export$a50185c8e9fb007e);
    $parcel$export(module.exports, "SHORT_FORM_INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a54a30a3c3cce634);
    $parcel$export(module.exports, "SHORT_FORM_PROBLEMS", ()=>$4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
    $parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$335d3ac0c367f03f);
    $parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
    $parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", ()=>$4f9c4406e75c8aa5$export$a2b1f8f055150f02);
    $parcel$export(module.exports, "ItsmPracticeToShortForm", ()=>$4f9c4406e75c8aa5$export$56c57f7ad650c45c);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP", ()=>$4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", ()=>$4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", ()=>$4f9c4406e75c8aa5$export$45952424a7f29b99);
    $parcel$export(module.exports, "CHANGES_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$6c24c440228eac9c);
    $parcel$export(module.exports, "INCIDENTS_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$5b65d27ec2d28d18);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$3f757c5e00588ffd);
    $parcel$export(module.exports, "practiceKeyJqlNameMapping", ()=>$4f9c4406e75c8aa5$export$b78213db77524b5b);
    var $7c0in;
    var $kVZSN;
    const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
    const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
    const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
    const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
    const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
    const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
    const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
    const $4f9c4406e75c8aa5$export$f929a394dd190451 = 'no-category-new';
    const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice';
    const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
    const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
    const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
    const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
    const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
    const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
    const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
        $4f9c4406e75c8aa5$export$81e62964cc725098
    ];
    const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
    ];
    const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
        ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
        $4f9c4406e75c8aa5$export$485b1216c42d8d4
    ];
    const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
        $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
    ];
    const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$export$f929a394dd190451
    };
    const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changes,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequests,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problems,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidents,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviews,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queues,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalation,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategory
    };
    const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changesLower,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequestsLower,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problemsLower,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidentsLower,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviewsLower,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queuesLower,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalationLower,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategoryLower
    };
    const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, (0, parcelRequire("7c0in")).getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
        const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
        if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
        return acc;
    }, {});
    const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
    const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
    const $4f9c4406e75c8aa5$export$51618dc8334072b = 'Problems';
    const $4f9c4406e75c8aa5$export$a34586940ac9c374 = 'Service requests';
    const $4f9c4406e75c8aa5$export$5497b62b513b7853 = 'Post-incident reviews';
    const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
    const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$51618dc8334072b,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$a34586940ac9c374,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$5497b62b513b7853,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
    };
});
parcelRegister("7c0in", function(module, exports) {
    $parcel$export(module.exports, "hasProp", ()=>$2dc9189f096b533d$export$dd642ef726dcde21);
    $parcel$export(module.exports, "getTypedKeys", ()=>$2dc9189f096b533d$export$5206d47972fefe20);
    const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
    const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
        return Object.keys(obj);
    };
});
parcelRegister("kVZSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d218b9a030da8fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        queues: {
            "id": "work-category.common.queues",
            "defaultMessage": "Queues"
        },
        serviceRequests: {
            "id": "work-category.common.service-requests",
            "defaultMessage": "Service requests"
        },
        incidents: {
            "id": "work-category.common.incidents",
            "defaultMessage": "Incidents"
        },
        changes: {
            "id": "work-category.common.changes",
            "defaultMessage": "Changes"
        },
        problems: {
            "id": "work-category.common.problems",
            "defaultMessage": "Problems"
        },
        postIncidentReviews: {
            "id": "work-category.common.post-incident-reviews",
            "defaultMessage": "Post-incident reviews"
        },
        noCategory: {
            "id": "work-category.common.no-category",
            "defaultMessage": "General"
        },
        queuesLower: {
            "id": "work-category.common.queues-lower",
            "defaultMessage": "queues"
        },
        serviceRequestsLower: {
            "id": "work-category.common.service-requests-lower",
            "defaultMessage": "service requests"
        },
        incidentsLower: {
            "id": "work-category.common.incidents-lower",
            "defaultMessage": "incidents"
        },
        changesLower: {
            "id": "work-category.common.changes-lower",
            "defaultMessage": "changes"
        },
        problemsLower: {
            "id": "work-category.common.problems-lower",
            "defaultMessage": "problems"
        },
        postIncidentReviewsLower: {
            "id": "work-category.common.post-incident-reviews-lower",
            "defaultMessage": "post-incident reviews"
        },
        noCategoryLower: {
            "id": "work-category.common.no-category-lower",
            "defaultMessage": "general"
        },
        developerEscalation: {
            "id": "work-category.common.developer-escalation",
            "defaultMessage": "Developer escalations"
        },
        developerEscalationLower: {
            "id": "work-category.common.developer-escalation-lower",
            "defaultMessage": "developer escalations"
        }
    });
});
const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';
parcelRegister("bvW9G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jhLKO").then(()=>parcelRequire('8khb6'));
});
parcelRegister("lbaDt", function(module, exports) {
    $parcel$export(module.exports, "requiredProjectProperties", ()=>$3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
    $parcel$export(module.exports, "requiredFrontendProperties", ()=>$3477ceb4f9b98b2e$export$47241956725e3029);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $13HHi;
    const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("gssgh"));
    const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];
    const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader
    });
    const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("fTSMy"));
    const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
        maxAge: (0, (0, parcelRequire("13HHi")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("13HHi", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES", ()=>$e7877c2ea997c7d8$export$54b53cba12671494);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES", ()=>$e7877c2ea997c7d8$export$7d9318d6cfb0a4df);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$e7877c2ea997c7d8$export$5a00268156ea5027);
    const $e7877c2ea997c7d8$export$54b53cba12671494 = 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';
    const $e7877c2ea997c7d8$export$7d9318d6cfb0a4df = 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES';
    const $e7877c2ea997c7d8$export$5a00268156ea5027 = 86400000;
});
parcelRegister("gssgh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7aPU6").then(()=>parcelRequire('d4USv'));
});
parcelRegister("fTSMy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Lrpj").then(()=>parcelRequire('7UDgf'));
});
parcelRegister("1WlLE", function(module, exports) {
    $parcel$export(module.exports, "queuesNavigationItems", ()=>$c68314f43531feff$export$4fed8be571897bef);
    $parcel$export(module.exports, "priorityGroupResource", ()=>$c68314f43531feff$export$1f9ab301771fe42e);
    $parcel$export(module.exports, "issueListSsrResource", ()=>$c68314f43531feff$export$3d03cbaac8581e65);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $8w6CZ;
    const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("kuvqU"));
    const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("jyy5p"));
    const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("9mhm7"));
    const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, ($parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
    const $c68314f43531feff$export$4fed8be571897bef = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS)
    });
    const $c68314f43531feff$export$1f9ab301771fe42e = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
        maxAge: (0, (0, parcelRequire("8w6CZ")).ONE_DAY_IN_MILLIS),
        isBrowserOnly: true
    });
    const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8w6CZ")).RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
        getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
        getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
        maxAge: 0,
        skipBrowser: true
    });
});
parcelRegister("8w6CZ", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", ()=>$a4c66eaf20e13a4d$export$a401e6d6b205c72b);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", ()=>$a4c66eaf20e13a4d$export$2064262c540606ba);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", ()=>$a4c66eaf20e13a4d$export$2733615da5b906f0);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$a4c66eaf20e13a4d$export$5a00268156ea5027);
    const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
    const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
    const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
    const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;
});
parcelRegister("kuvqU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fYHqp").then(()=>parcelRequire('lini2'));
});
parcelRegister("jyy5p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2mLKW").then(()=>parcelRequire('etJR3'));
});
parcelRegister("9mhm7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jmkWj").then(()=>parcelRequire('bmzqI'));
});
parcelRegister("2cxgG", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentOnboardingResource", ()=>$e9d51fb7135f5412$export$d39827c053fda3aa);
    var $ao2h1;
    var $2j6fy;
    const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
        isBrowserOnly: true,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("2j6fy")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    key: match.params.projectKey || ''
                }
            })
    });
});
parcelRegister("2j6fy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45b605658e5ce20d$export$2e2bcd8739ae039);
    var $7oHmH;
    const $45b605658e5ce20d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "f9088e152f36ba09b78f1e067be176d1d2e7e1bab920efd3620300fc8bf9722e",
            "metadata": {},
            "name": "mainVirtualAgentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;
});
parcelRegister("7oHmH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f0ef421b1798a33$export$2e2bcd8739ae039);
    var $4R6GH;
    var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('require_ai_enabled_for_jsm_virtual_agent');
        }
    };
});
parcelRegister("6sNnq", function(module, exports) {
    $parcel$export(module.exports, "featuresResource", ()=>$d0a02e466fb63798$export$16f81cc9da2c6c47);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("8wbKs"));
    const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
    const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $dIdda.createResource)({
        type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $d0a02e466fb63798$var$getDataLoader,
        maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
    });
});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';
parcelRegister("8wbKs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aOISr").then(()=>parcelRequire('frQmB'));
});
parcelRegister("gRzZD", function(module, exports) {
    $parcel$export(module.exports, "workspaceResource", ()=>$d68afc54033ea939$export$2f02c3f971168d17);
    var $dIdda = parcelRequire("dIdda");
    var $ahEft;
    const $d68afc54033ea939$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
    const $d68afc54033ea939$export$2f02c3f971168d17 = (0, $dIdda.createResource)({
        type: $d68afc54033ea939$export$9b3a4d71d46e5ee7,
        getKey: ()=>'state',
        getData: async (_, routerContext)=>{
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(_, routerContext);
            return workspaceId;
        },
        maxAge: Infinity
    });
});
parcelRegister("ahEft", function(module, exports) {
    $parcel$export(module.exports, "isPremiumInstance", ()=>$b8bed038f2dce149$export$abb609d3bcbb74f6);
    $parcel$export(module.exports, "isLicensedPremiumUser", ()=>$b8bed038f2dce149$export$d7b4c32773b1c643);
    $parcel$export(module.exports, "default", ()=>$b8bed038f2dce149$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $ktP1V;
    var $5Ny9E;
    var $ldyPw;
    const $b8bed038f2dce149$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
    const $b8bed038f2dce149$export$abb609d3bcbb74f6 = (tenantContext)=>{
        const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
        const isPremium = serviceDeskAppEdition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
        return isPremium;
    };
    const $b8bed038f2dce149$export$d7b4c32773b1c643 = (tenantContext)=>{
        const { appPermissions: appPermissions } = tenantContext;
        const isPremium = $b8bed038f2dce149$export$abb609d3bcbb74f6(tenantContext);
        const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
        return isPremium && isLicensedUser;
    };
    const $b8bed038f2dce149$var$transformResponse = (response)=>{
        const ids = response.results ?? [];
        return ids.length ? (0, (0, parcelRequire("5Ny9E")).toWorkspaceId)(ids[0].id) : null;
    };
    const $b8bed038f2dce149$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        if ($b8bed038f2dce149$export$d7b4c32773b1c643(tenantContext) === false || !(0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)()) return null;
        return (0, (0, parcelRequire("eusud")).performGetRequest)($b8bed038f2dce149$export$530f260cc76f04ff(baseUrl)).then($b8bed038f2dce149$var$transformResponse).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
            return null;
        });
    };
    var $b8bed038f2dce149$export$2e2bcd8739ae039 = $b8bed038f2dce149$export$e1d718dfe6dad973;
});
parcelRegister("ktP1V", function(module, exports) {
    $parcel$export(module.exports, "isCMDBEnabledInEnvironment", ()=>$84a32a7226f836c4$export$6dbfb62369f79a64);
    var $aIZdc;
    const $84a32a7226f836c4$export$6dbfb62369f79a64 = ()=>!(0, (0, parcelRequire("aIZdc")).isFedRamp)();
});
parcelRegister("5Ny9E", function(module, exports) {
    $parcel$export(module.exports, "toSchemaId", ()=>$a330a4171d28d64c$export$d577b7f3b832f656);
    $parcel$export(module.exports, "toCmdbObjectId", ()=>$a330a4171d28d64c$export$1ba342595bc7be13);
    $parcel$export(module.exports, "toCmdbObjectTypeId", ()=>$a330a4171d28d64c$export$b46e25afa2bab6a);
    $parcel$export(module.exports, "toObjectCommentId", ()=>$a330a4171d28d64c$export$ece2917434bb0a8c);
    $parcel$export(module.exports, "toWorkspaceId", ()=>$a330a4171d28d64c$export$d002b8d7821b6b59);
    $parcel$export(module.exports, "toObjectTypeAttributeId", ()=>$a330a4171d28d64c$export$cfd92c18cee8add7);
    const $a330a4171d28d64c$export$d577b7f3b832f656 = (id)=>id;
    const $a330a4171d28d64c$export$1ba342595bc7be13 = (id)=>id;
    const $a330a4171d28d64c$export$b46e25afa2bab6a = (id)=>id;
    const $a330a4171d28d64c$export$ece2917434bb0a8c = (id)=>id;
    const $a330a4171d28d64c$export$d002b8d7821b6b59 = (id)=>id;
    const $a330a4171d28d64c$export$cfd92c18cee8add7 = (id)=>id;
});
parcelRegister("d61u6", function(module, exports) {
    $parcel$export(module.exports, "legacyConnectProjectRoute", ()=>$0991eddac05e9f26$export$dfdf98c5b58cfa04);
    var $65Ltd;
    const $0991eddac05e9f26$export$dfdf98c5b58cfa04 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        path: '/projects/:projectKey',
        query: [
            'selectedItem'
        ]
    };
});
parcelRegister("lT1ZM", function(module, exports) {
    $parcel$export(module.exports, "legacyCustomReportRouteEntry", ()=>$4366c5931d4f1202$export$12938ba85bf5fe54);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $dxCvy;
    var $7GnDe;
    var $kxEJS;
    var $g2CTo;
    const $4366c5931d4f1202$export$12938ba85bf5fe54 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kxEJS")).legacyCustomReportRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("g2CTo")).getReportsCommonResource)()
            ]
        }));
});
parcelRegister("kxEJS", function(module, exports) {
    $parcel$export(module.exports, "legacyCustomReportRoute", ()=>$4ea0bfbf05a2851b$export$6f4b8901e7772b05);
    var $65Ltd;
    const $4ea0bfbf05a2851b$export$6f4b8901e7772b05 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CUSTOM_REPORT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=reporting',
            'chart'
        ]
    };
});
parcelRegister("g2CTo", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$8bbca6d516ecad1e$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $8bbca6d516ecad1e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $8bbca6d516ecad1e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("8Pux3", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsAddRouteEntry", ()=>$712b0b110e9bcba3$export$6cc9527a3f96c0a5);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $2BoUK;
    const $712b0b110e9bcba3$export$6cc9527a3f96c0a5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2BoUK")).legacyDashboardsAddRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            }
        }));
});
parcelRegister("2BoUK", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsAddRoute", ()=>$25b4661c0e1b8c4e$export$1e88394d2d12a4bc);
    const $25b4661c0e1b8c4e$var$secure = '(/secure/|/)';
    const $25b4661c0e1b8c4e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $25b4661c0e1b8c4e$export$1e88394d2d12a4bc = {
        name: 'legacy-dashboards-add',
        path: `${$25b4661c0e1b8c4e$var$secure}AddPortalPage${$25b4661c0e1b8c4e$var$defaultSuffix}.jspa`
    };
});
parcelRegister("4RrJu", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsConfigureRouteEntry", ()=>$1157fbb6db8b819a$export$18ff609f147595cc);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $26Dvy;
    const $1157fbb6db8b819a$export$18ff609f147595cc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("26Dvy")).legacyDashboardsConfigureRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            }
        }));
});
parcelRegister("26Dvy", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsConfigureRoute", ()=>$1e72889165d9e62c$export$549a0bcc3a0017a7);
    const $1e72889165d9e62c$var$secure = '(/secure/|/)';
    const $1e72889165d9e62c$var$defaultSuffix = '([!%]?[\\w]*)';
    const $1e72889165d9e62c$export$549a0bcc3a0017a7 = {
        name: 'legacy-dashboards-configure',
        path: `${$1e72889165d9e62c$var$secure}ConfigurePortalPages${$1e72889165d9e62c$var$defaultSuffix}.jspa`
    };
});
parcelRegister("l87wS", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsDeleteRouteEntry", ()=>$2100bb58ad21af7d$export$4f59d0a9276c0c9b);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $8dwJn;
    const $2100bb58ad21af7d$export$4f59d0a9276c0c9b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8dwJn")).legacyDashboardsDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            }
        }));
});
parcelRegister("8dwJn", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsDeleteRoute", ()=>$899113184cd34907$export$dfa5dcc35e497330);
    const $899113184cd34907$var$secure = '(/secure/|/)';
    const $899113184cd34907$var$defaultSuffix = '([!%]?[\\w]*)';
    const $899113184cd34907$export$dfa5dcc35e497330 = {
        name: 'legacy-dashboards-delete',
        path: `${$899113184cd34907$var$secure}DeletePortalPage${$899113184cd34907$var$defaultSuffix}.jspa`
    };
});
parcelRegister("ixNqV", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRouteEntry", ()=>$ccf7bc76ce394bf0$export$748e329bd0c282a);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $dcTTb;
    const $ccf7bc76ce394bf0$export$748e329bd0c282a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dcTTb")).dashboardsDirectoryRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            }
        }));
});
parcelRegister("dcTTb", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRoute", ()=>$63d809c97ace4d23$export$41bba408475cab16);
    var $65Ltd;
    const $63d809c97ace4d23$export$41bba408475cab16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        path: '/jira/dashboards'
    };
});
parcelRegister("8D07Q", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsEditRouteEntry", ()=>$f1e2cb2a12c1537e$export$60414c63c9cd3646);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $hXTLW;
    const $f1e2cb2a12c1537e$export$60414c63c9cd3646 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hXTLW")).legacyDashboardsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            }
        }));
});
parcelRegister("hXTLW", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsEditRoute", ()=>$1527816712bae435$export$4f028eb17334a195);
    const $1527816712bae435$var$secure = '(/secure/|/)';
    const $1527816712bae435$var$defaultSuffix = '([!%]?[\\w]*)';
    const $1527816712bae435$export$4f028eb17334a195 = {
        name: 'legacy-dashboards-edit',
        path: `${$1527816712bae435$var$secure}EditPortalPage${$1527816712bae435$var$defaultSuffix}.jspa`
    };
});
parcelRegister("kyH4Y", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsRestoreRouteEntry", ()=>$08846320a8231a0b$export$4bf748e39cc28644);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $kSO7A;
    const $08846320a8231a0b$export$4bf748e39cc28644 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kSO7A")).legacyDashboardsRestoreRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            }
        }));
});
parcelRegister("kSO7A", function(module, exports) {
    $parcel$export(module.exports, "legacyDashboardsRestoreRoute", ()=>$b92c802b5c118566$export$110af57b4332630d);
    const $b92c802b5c118566$var$defaultSuffix = '([!%]?[\\w]*)';
    const $b92c802b5c118566$export$110af57b4332630d = {
        name: 'legacy-dashboards-restore',
        path: `/secure/RestoreDefaultDashboard${$b92c802b5c118566$var$defaultSuffix}.jspa`
    };
});
parcelRegister("lwy1a", function(module, exports) {
    $parcel$export(module.exports, "legacyFallbackRouteEntry", ()=>$19b0f48843145a31$export$1af0a6dff57e40e7);
    var $2BrOV;
    var $2G9Bk;
    var $6de9w;
    const $19b0f48843145a31$export$1af0a6dff57e40e7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6de9w")).legacyFallbackRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("6de9w", function(module, exports) {
    $parcel$export(module.exports, "legacyFallbackRoute", ()=>$332ff227d04e39b3$export$27cd5ba2ad569682);
    var $65Ltd;
    const $332ff227d04e39b3$export$27cd5ba2ad569682 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_FALLBACK),
        path: '/:any'
    };
});
parcelRegister("iBTsr", function(module, exports) {
    $parcel$export(module.exports, "legacyGinActionRouteEntry", ()=>$98945718480286ca$export$8d542f975e38405d);
    var $2BrOV;
    var $lmyls;
    var $8Wi6S;
    var $2G9Bk;
    var $atU1t;
    var $iQm7Z;
    const $98945718480286ca$export$8d542f975e38405d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iQm7Z")).legacyGinActionRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("8Wi6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9fa7b304f828b3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "AsyncSidebarFiltersGlobal", ()=>$7c9fa7b304f828b3$export$1af88ebe65f50e73);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("d3UTn")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
    });
    const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
    var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersGlobal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8GB8S")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle.SidebarFiltersGlobal;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
    });
    const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters-global"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersGlobal, null)));
});
parcelRegister("d3UTn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iTs3w")
    ]).then(()=>parcelRequire('7T8w9'));
});
parcelRegister("8GB8S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2dpYI")
    ]).then(()=>parcelRequire('hcPI1'));
});
parcelRegister("iQm7Z", function(module, exports) {
    $parcel$export(module.exports, "legacyGinActionRoute", ()=>$d4421269f043e3c0$export$796a8e79b017f80d);
    const $d4421269f043e3c0$export$796a8e79b017f80d = {
        name: 'legacy-gin-action',
        path: '/secure/IssueNavAction!default.jspa',
        query: [
            'filter|jql|issueKey'
        ]
    };
});
parcelRegister("foqfA", function(module, exports) {
    $parcel$export(module.exports, "legacyGinBulkRouteEntry", ()=>$9988e1448681851e$export$fa36e59125fc7266);
    var $2BrOV;
    var $2G9Bk;
    var $lpiWM;
    const $9988e1448681851e$export$fa36e59125fc7266 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lpiWM")).legacyGinBulkRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("lpiWM", function(module, exports) {
    $parcel$export(module.exports, "legacyGinBulkRoute", ()=>$ec22656239f10871$export$73e4833202a78627);
    const $ec22656239f10871$var$defaultSuffix = '([!%]?[\\w]*)';
    const $ec22656239f10871$export$73e4833202a78627 = {
        name: 'legacy-gin-bulk',
        path: `/secure/Bulk(\\w+)${$ec22656239f10871$var$defaultSuffix}.jspa`
    };
});
parcelRegister("9yX2q", function(module, exports) {
    $parcel$export(module.exports, "legacyGinBulkeditRouteEntry", ()=>$91eb149bc7b15a60$export$f591688aa6cd2d3);
    var $2BrOV;
    var $2G9Bk;
    var $2iDIk;
    const $91eb149bc7b15a60$export$f591688aa6cd2d3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2iDIk")).legacyGinBulkeditRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("2iDIk", function(module, exports) {
    $parcel$export(module.exports, "legacyGinBulkeditRoute", ()=>$27e239c7c75eb736$export$7c8f48fad7f31e42);
    const $27e239c7c75eb736$var$defaultSuffix = '([!%]?[\\w]*)';
    const $27e239c7c75eb736$export$7c8f48fad7f31e42 = {
        name: 'legacy-gin-bulkedit',
        path: `/(secure/views|issue)/bulkedit/Bulk(\\w+)${$27e239c7c75eb736$var$defaultSuffix}.jspa`
    };
});
parcelRegister("afkjn", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueAssignRouteEntry", ()=>$f666aad870816318$export$b7bc71c8e27d96);
    var $2BrOV;
    var $2G9Bk;
    var $3U0Ok;
    const $f666aad870816318$export$b7bc71c8e27d96 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3U0Ok")).legacyGinIssueAssignRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("3U0Ok", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueAssignRoute", ()=>$40d51106cc8ccba6$export$6cc1fcd71b2e06ad);
    const $40d51106cc8ccba6$var$defaultSuffix = '([!%]?[\\w]*)';
    const $40d51106cc8ccba6$export$6cc1fcd71b2e06ad = {
        name: 'legacy-gin-issue-assign',
        path: `/secure/(\\w*)AssignIssue${$40d51106cc8ccba6$var$defaultSuffix}.jspa`
    };
});
parcelRegister("j8gaF", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueCloneRouteEntry", ()=>$901d248b6fd91f31$export$b54f23b666808992);
    var $2BrOV;
    var $2G9Bk;
    var $f83Yg;
    const $901d248b6fd91f31$export$b54f23b666808992 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("f83Yg")).legacyGinIssueCloneRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("f83Yg", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueCloneRoute", ()=>$84b7bc9ea3213d13$export$55ba9c8834c09ade);
    const $84b7bc9ea3213d13$var$defaultSuffix = '([!%]?[\\w]*)';
    const $84b7bc9ea3213d13$export$55ba9c8834c09ade = {
        name: 'legacy-gin-issue-clone',
        path: `/(secure|issue)/CloneIssue(\\w*)${$84b7bc9ea3213d13$var$defaultSuffix}.jspa`
    };
});
parcelRegister("g0GVs", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueConvertRouteEntry", ()=>$a6bae721fe931045$export$45f0108fe367a800);
    var $2BrOV;
    var $2G9Bk;
    var $es1jN;
    const $a6bae721fe931045$export$45f0108fe367a800 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("es1jN")).legacyGinIssueConvertRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("es1jN", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueConvertRoute", ()=>$a4c60c0095b850d0$export$338f229cb5c21a79);
    const $a4c60c0095b850d0$var$defaultSuffix = '([!%]?[\\w]*)';
    const $a4c60c0095b850d0$export$338f229cb5c21a79 = {
        name: 'legacy-gin-issue-convert',
        path: `/secure/ConvertIssue(\\w*)${$a4c60c0095b850d0$var$defaultSuffix}.jspa`
    };
});
parcelRegister("a2seC", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueCreateRouteEntry", ()=>$a3142227b9e71a89$export$86ab2339e662875a);
    var $2BrOV;
    var $2G9Bk;
    var $jnvec;
    const $a3142227b9e71a89$export$86ab2339e662875a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jnvec")).legacyGinIssueCreateRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("jnvec", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueCreateRoute", ()=>$a554b3c2ab2556d3$export$f27db894d3724085);
    const $a554b3c2ab2556d3$var$secure = '(/secure/|/)';
    const $a554b3c2ab2556d3$var$defaultSuffix = '([!%]?[\\w]*)';
    const $a554b3c2ab2556d3$export$f27db894d3724085 = {
        name: 'legacy-gin-issue-create',
        path: `${$a554b3c2ab2556d3$var$secure}CreateIssue(\\w*)${$a554b3c2ab2556d3$var$defaultSuffix}.jspa`
    };
});
parcelRegister("hGmIt", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueEditRouteEntry", ()=>$202f7f8672ff8ecc$export$944b36cf4b5cef62);
    var $2BrOV;
    var $2G9Bk;
    var $5TEd9;
    const $202f7f8672ff8ecc$export$944b36cf4b5cef62 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5TEd9")).legacyGinIssueEditRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("5TEd9", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueEditRoute", ()=>$082295f49edecb63$export$5286735392e527fb);
    const $082295f49edecb63$var$defaultSuffix = '([!%]?[\\w]*)';
    const $082295f49edecb63$export$5286735392e527fb = {
        name: 'legacy-gin-issue-edit',
        path: `/secure/EditIssue${$082295f49edecb63$var$defaultSuffix}.jspaa`
    };
});
parcelRegister("fN1YT", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueMoveRouteEntry", ()=>$c938db5750620997$export$9c2ab973bb46413b);
    var $2BrOV;
    var $2G9Bk;
    var $5CsJ0;
    const $c938db5750620997$export$9c2ab973bb46413b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5CsJ0")).legacyGinIssueMoveRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("5CsJ0", function(module, exports) {
    $parcel$export(module.exports, "legacyGinIssueMoveRoute", ()=>$873078f4dc3303c2$export$338e257c93d678f9);
    const $873078f4dc3303c2$var$defaultSuffix = '([!%]?[\\w]*)';
    const $873078f4dc3303c2$export$338e257c93d678f9 = {
        name: 'legacy-gin-issue-move',
        path: `/secure/MoveIssue(\\w*)${$873078f4dc3303c2$var$defaultSuffix}.jspa`
    };
});
parcelRegister("glG2a", function(module, exports) {
    $parcel$export(module.exports, "legacyGinManageRouteEntry", ()=>$084c8dfa8792c077$export$2b56a5623615dd47);
    var $2BrOV;
    var $lmyls;
    var $8Wi6S;
    var $2G9Bk;
    var $atU1t;
    var $9di5H;
    const $084c8dfa8792c077$export$2b56a5623615dd47 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9di5H")).legacyGinManageRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("9di5H", function(module, exports) {
    $parcel$export(module.exports, "legacyGinManageRoute", ()=>$c5a70fed24808617$export$e6c509778313a0c1);
    const $c5a70fed24808617$var$secure = '(/secure/|/)';
    const $c5a70fed24808617$export$e6c509778313a0c1 = {
        name: 'legacy-gin-manage',
        path: `${$c5a70fed24808617$var$secure}ManageFilters.jspa`
    };
});
parcelRegister("cYSpk", function(module, exports) {
    $parcel$export(module.exports, "legacyGinSubscriptionEditRouteEntry", ()=>$61ddc87b6e819ac7$export$5255243cc56f26c3);
    var $2BrOV;
    var $lmyls;
    var $8Wi6S;
    var $2G9Bk;
    var $atU1t;
    var $kbL3F;
    const $61ddc87b6e819ac7$export$5255243cc56f26c3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kbL3F")).legacyGinSubscriptionEditRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("kbL3F", function(module, exports) {
    $parcel$export(module.exports, "legacyGinSubscriptionEditRoute", ()=>$91807c070d48d7f2$export$20e6c550a55cf8f4);
    const $91807c070d48d7f2$var$secure = '(/secure/|/)';
    const $91807c070d48d7f2$var$defaultSuffix = '([!%]?[\\w]*)';
    const $91807c070d48d7f2$export$20e6c550a55cf8f4 = {
        name: 'legacy-gin-subscription-edit',
        path: `${$91807c070d48d7f2$var$secure}EditSubscription${$91807c070d48d7f2$var$defaultSuffix}.jspa`
    };
});
parcelRegister("3WQFs", function(module, exports) {
    $parcel$export(module.exports, "legacyGinSubscriptionsRouteEntry", ()=>$e62ae20ec9e1532a$export$e739dd8af3aee54a);
    var $2BrOV;
    var $lmyls;
    var $8Wi6S;
    var $2G9Bk;
    var $atU1t;
    var $jwyeT;
    const $e62ae20ec9e1532a$export$e739dd8af3aee54a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jwyeT")).legacyGinSubscriptionsRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("jwyeT", function(module, exports) {
    $parcel$export(module.exports, "legacyGinSubscriptionsRoute", ()=>$e717cc444930f12f$export$cbcaf00bd4f92b0);
    var $65Ltd;
    const $e717cc444930f12f$var$secure = '(/secure/|/)';
    const $e717cc444930f12f$var$defaultSuffix = '([!%]?[\\w]*)';
    const $e717cc444930f12f$export$cbcaf00bd4f92b0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS),
        path: `${$e717cc444930f12f$var$secure}ViewSubscriptions${$e717cc444930f12f$var$defaultSuffix}.jspa`
    };
});
parcelRegister("67rDY", function(module, exports) {
    $parcel$export(module.exports, "legacyGinSubtaskActionRouteEntry", ()=>$99d6231e936d31ff$export$31f29cb95c5903fc);
    var $2BrOV;
    var $2G9Bk;
    var $jnBTB;
    const $99d6231e936d31ff$export$31f29cb95c5903fc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jnBTB")).legacyGinSubtaskActionRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("jnBTB", function(module, exports) {
    $parcel$export(module.exports, "legacyGinSubtaskActionRoute", ()=>$32432db66031457d$export$d9c87b9b27d73f7c);
    const $32432db66031457d$var$defaultSuffix = '([!%]?[\\w]*)';
    const $32432db66031457d$export$d9c87b9b27d73f7c = {
        name: 'legacy-gin-subtask-action',
        path: `/secure/(Move|Convert)SubTask(\\w*)${$32432db66031457d$var$defaultSuffix}.jspa`
    };
});
parcelRegister("dRlY8", function(module, exports) {
    $parcel$export(module.exports, "legacyGinWatchersIssueRouteEntry", ()=>$1ac259c0aebda8f6$export$97a124d7b834ca82);
    var $2BrOV;
    var $2G9Bk;
    var $1VsxU;
    const $1ac259c0aebda8f6$export$97a124d7b834ca82 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1VsxU")).legacyGinWatchersIssueRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("1VsxU", function(module, exports) {
    $parcel$export(module.exports, "legacyGinWatchersIssueRoute", ()=>$b0a47cbb8c35b786$export$b3198e66bf5d49ae);
    const $b0a47cbb8c35b786$export$b3198e66bf5d49ae = {
        name: 'legacy-gin-watchers-issue',
        path: '/secure/ManageWatchers!default.jspa'
    };
});
parcelRegister("4GwLj", function(module, exports) {
    $parcel$export(module.exports, "globalAutomationRouteEntry", ()=>$20ad3d7fdff60220$export$652cb0c5f80823c0);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $eZnWX;
    const $20ad3d7fdff60220$export$652cb0c5f80823c0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eZnWX")).globalAutomationRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("eZnWX", function(module, exports) {
    $parcel$export(module.exports, "globalAutomationRoute", ()=>$5545f719441de9a9$export$5276d514cac1db59);
    const $5545f719441de9a9$var$defaultSuffix = '([!%]?[\\w]*)';
    const $5545f719441de9a9$export$5276d514cac1db59 = {
        name: 'global-automation',
        path: `/secure/Automation${$5545f719441de9a9$var$defaultSuffix}.jspa`
    };
});
parcelRegister("fS7Zg", function(module, exports) {
    $parcel$export(module.exports, "globalIssueNavigatorRouteEntry", ()=>$5a68ace5eda087ee$export$690b5fd7062ce607);
    $parcel$export(module.exports, "globalIssueNavigatorBrowseRouteEntry", ()=>$5a68ace5eda087ee$export$b1b791616cdb9491);
    $parcel$export(module.exports, "globalIssueNavigatorRedirectRouteEntry", ()=>$5a68ace5eda087ee$export$8cbe781346b8b4a2);
    var $2BrOV;
    var $lmyls;
    var $8Wi6S;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $6QKrH;
    var $71Gk7;
    var $7Ec5O;
    const $5a68ace5eda087ee$export$690b5fd7062ce607 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("71Gk7")).globalIssueNavigatorRoute), ()=>({
            canTransitionIn: ()=>false,
            component: (0, (0, parcelRequire("7Ec5O")).LegacyPageWithTeamProfileCardView),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
    const $5a68ace5eda087ee$export$b1b791616cdb9491 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("71Gk7")).globalIssueNavigatorBrowseRoute), ()=>({
            canTransitionIn: ()=>false,
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
    const $5a68ace5eda087ee$export$8cbe781346b8b4a2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("71Gk7")).globalIssueNavigatorRedirectRoute), ()=>({
            canTransitionIn: ()=>false,
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
                sidebar: (0, (0, parcelRequire("8Wi6S")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("71Gk7", function(module, exports) {
    $parcel$export(module.exports, "globalIssueNavigatorRoute", ()=>$7087c0d72ce043a7$export$f4c8e8bc55cd2008);
    $parcel$export(module.exports, "globalIssueNavigatorBrowseRoute", ()=>$7087c0d72ce043a7$export$c1b37e392499fccf);
    $parcel$export(module.exports, "globalIssueNavigatorRedirectRoute", ()=>$7087c0d72ce043a7$export$b2cd2888fd62d62e);
    var $65Ltd;
    const $7087c0d72ce043a7$export$f4c8e8bc55cd2008 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN),
        path: '/issues/:issueKey(.*)?',
        apdexIgnoreParams: [
            'issueKey'
        ]
    };
    const $7087c0d72ce043a7$export$c1b37e392499fccf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_ISSUE),
        path: '/browse/:issueKey?',
        query: [
            'jql|filter'
        ]
    };
    const $7087c0d72ce043a7$export$b2cd2888fd62d62e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH),
        path: '/secure/QuickSearch.jspa',
        query: [
            'searchString'
        ]
    };
});
parcelRegister("7Ec5O", function(module, exports) {
    $parcel$export(module.exports, "LegacyPageWithTeamProfileCardView", ()=>$9442fba15e52fbb6$export$bc3f01ea4ac19d59);
    var $5uXOq = parcelRequire("5uXOq");
    var $9FUIO;
    var $1ukJn;
    var $6QKrH;
    var $9OXo1;
    const $9442fba15e52fbb6$export$bc3f01ea4ac19d59 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6QKrH")).LegacyPage), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9FUIO")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ukJn")).default), {
            TenantContextSubscriber: (0, (0, parcelRequire("9OXo1")).TenantContextSubscriber)
        }));
});
parcelRegister("9FUIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1259b4dcb355d8f8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("2ixZF")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
    });
    const $1259b4dcb355d8f8$export$9b28d5c0f56030a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "open-help-panel-link-through-event-listener",
            packageName: "jira-help-panel-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-open-help-panel-link-through-event-listener",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener, null)));
    var $1259b4dcb355d8f8$export$2e2bcd8739ae039 = $1259b4dcb355d8f8$export$9b28d5c0f56030a7;
});
parcelRegister("2ixZF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("li0NF")
    ]).then(()=>parcelRequire('LS48m'));
});
parcelRegister("1ukJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c755f0a1cb7bd3d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $3c755f0a1cb7bd3d$var$LegacyTeamProfileCard = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jyqRi")), {
        moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard-legacy/index.tsx"
    });
    const $3c755f0a1cb7bd3d$export$c8a3662e461b7707 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "legacy-team-profile-card",
            packageName: "profilecard-next"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-legacy-team-profile-card",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3c755f0a1cb7bd3d$var$LegacyTeamProfileCard, props)));
    var $3c755f0a1cb7bd3d$export$2e2bcd8739ae039 = $3c755f0a1cb7bd3d$export$c8a3662e461b7707;
});
parcelRegister("jyqRi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7JCRv")
    ]).then(()=>parcelRequire('bLirh'));
});
parcelRegister("2B1hR", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsAddonsOauthRouteEntry", ()=>$71347aef3c88b5bb$export$b674e2feb3ded4d1);
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $atU1t;
    var $hYLy4;
    const $71347aef3c88b5bb$export$b674e2feb3ded4d1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hYLy4")).globalSettingsAddonsOauthRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)()
            ]
        }));
});
parcelRegister("hYLy4", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsAddonsOauthRoute", ()=>$cbcd453c58502a54$export$13884c00b567e541);
    const $cbcd453c58502a54$export$13884c00b567e541 = {
        name: 'global-settings-addons-oauth',
        path: '/secure/oauth-credentials'
    };
});
parcelRegister("9jvhK", function(module, exports) {
    $parcel$export(module.exports, "emceeAppRouteEntry", ()=>$c6988ca74fac58d2$export$881c7d683ab02802);
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $6QKrH;
    var $9Y7t8;
    const $c6988ca74fac58d2$export$881c7d683ab02802 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9Y7t8")).emceeAppRoute), ()=>({
            canTransitionIn: ()=>false,
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)()
            ]
        }));
});
parcelRegister("9Y7t8", function(module, exports) {
    $parcel$export(module.exports, "emceeAppRoute", ()=>$18ac51784a86a796$export$5149e7851c6c4f53);
    $parcel$export(module.exports, "manageAppsRoute", ()=>$18ac51784a86a796$export$d5409be3b4016aab);
    var $65Ltd;
    const $18ac51784a86a796$export$5149e7851c6c4f53 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE),
        path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
    };
    const $18ac51784a86a796$export$d5409be3b4016aab = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_MANAGE_APPS),
        path: '/plugins/servlet/upm'
    };
});
parcelRegister("hMwq2", function(module, exports) {
    $parcel$export(module.exports, "manageAppsRouteEntry", ()=>$7bdeeeedda0af7c0$export$4ce557e11b5e9d68);
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $6QKrH;
    var $9Y7t8;
    const $7bdeeeedda0af7c0$export$4ce557e11b5e9d68 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9Y7t8")).manageAppsRoute), ()=>({
            canTransitionIn: ()=>false,
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)()
            ]
        }));
});
parcelRegister("iwi8A", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", ()=>$c56141b51871f3bd$export$d83c2e469d070766);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $aAwBP;
    const $c56141b51871f3bd$export$d83c2e469d070766 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aAwBP")).globalSettingsCustomFieldsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("aAwBP", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsCustomFieldsRoute", ()=>$71f95f4b5460e0a0$export$45e7d93edcc9507f);
    var $65Ltd;
    const $71f95f4b5460e0a0$export$45e7d93edcc9507f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
        path: '/secure/admin/ViewCustomFields.jspa'
    };
});
parcelRegister("12CWk", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRouteEntry", ()=>$9318f1e50bb7ea88$export$c493b601f2512cdb);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $i4RLt;
    const $9318f1e50bb7ea88$export$c493b601f2512cdb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("i4RLt")).globalSettingsFieldLayoutSchemesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("i4RLt", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRoute", ()=>$2b9d8c5c4c47bf1b$export$6e04f01d8f54ad08);
    var $65Ltd;
    const $2b9d8c5c4c47bf1b$export$6e04f01d8f54ad08 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES),
        path: '/secure/admin/ViewFieldLayoutSchemes.jspa'
    };
});
parcelRegister("g33xc", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsFieldLayoutsRouteEntry", ()=>$9bba431bd87c0411$export$9988358457e7d230);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $6oQfi;
    const $9bba431bd87c0411$export$9988358457e7d230 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6oQfi")).globalSettingsFieldLayoutsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("6oQfi", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsFieldLayoutsRoute", ()=>$32a3fac98b367822$export$ead41dd3ea1da5b3);
    var $65Ltd;
    const $32a3fac98b367822$export$ead41dd3ea1da5b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS),
        path: '/secure/admin/ViewFieldLayouts.jspa'
    };
});
parcelRegister("b5v7R", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueSubtasksRouteEntry", ()=>$132164ca7c108b53$export$625e23490e28fdb5);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $j91OJ;
    const $132164ca7c108b53$export$625e23490e28fdb5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("j91OJ")).globalSettingsIssueSubtasksRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("j91OJ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueSubtasksRoute", ()=>$694f373d91f3d6c8$export$1327adfb7eea6607);
    var $65Ltd;
    const $694f373d91f3d6c8$export$1327adfb7eea6607 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS),
        path: '/secure/admin/subtasks/ManageSubTasks.jspa'
    };
});
parcelRegister("eODBO", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueTimeTrackingRouteEntry", ()=>$cf57c2708f930de3$export$ad6c1602c9fe5020);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $d8Ety;
    const $cf57c2708f930de3$export$ad6c1602c9fe5020 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d8Ety")).globalSettingsIssueTimeTrackingRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("d8Ety", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueTimeTrackingRoute", ()=>$b69629952d2773c2$export$8596beec8543d958);
    var $65Ltd;
    const $b69629952d2773c2$var$defaultSuffix = '([!%]?[\\w]*)';
    const $b69629952d2773c2$export$8596beec8543d958 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING),
        path: `/secure/admin/TimeTrackingAdmin${$b69629952d2773c2$var$defaultSuffix}.jspa`
    };
});
parcelRegister("hlfSP", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueWorkflowRouteEntry", ()=>$679eceb9d6313b14$export$460b4d1709d73a2e);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $5Jl6N;
    const $679eceb9d6313b14$export$460b4d1709d73a2e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Jl6N")).globalSettingsIssueWorkflowRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("5Jl6N", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueWorkflowRoute", ()=>$00ad70e0b98fd3be$export$83c76a9f38e044d2);
    var $65Ltd;
    const $00ad70e0b98fd3be$export$83c76a9f38e044d2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
        path: '/secure/admin/workflows/:page'
    };
});
parcelRegister("5z6KH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRouteEntry", ()=>$7ca2ba45926a1f01$export$cfc4572fe7838d46);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $eNARC;
    const $7ca2ba45926a1f01$export$cfc4572fe7838d46 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eNARC")).globalSettingsIssueWorkflowSchemesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("eNARC", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRoute", ()=>$26d470a82646376b$export$fabaf6e717c3f1b6);
    var $65Ltd;
    const $26d470a82646376b$export$fabaf6e717c3f1b6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES),
        path: '/secure/admin/ViewWorkflowSchemes.jspa'
    };
});
parcelRegister("eLVEp", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRouteEntry", ()=>$92e4aeb4167f8b40$export$580990afd7fb8505);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $g91R3;
    const $92e4aeb4167f8b40$export$580990afd7fb8505 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("g91R3")).globalSettingsIssuesCustomFieldsAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("g91R3", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRoute", ()=>$166bda4cd3d3dc6a$export$4e17e29838928fe7);
    var $65Ltd;
    const $166bda4cd3d3dc6a$export$4e17e29838928fe7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE),
        path: '/secure/admin/AssociateFieldToScreens!default.jspa'
    };
});
parcelRegister("lagzw", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRouteEntry", ()=>$391c084c32e25f69$export$f2078b26bfdef553);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $8vXH1;
    const $391c084c32e25f69$export$f2078b26bfdef553 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8vXH1")).globalSettingsIssuesCustomFieldsConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("8vXH1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRoute", ()=>$395563dc02e7f119$export$db330236178a2eb2);
    var $65Ltd;
    const $395563dc02e7f119$export$db330236178a2eb2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE),
        path: '/secure/admin/ConfigureCustomField!default.jspa'
    };
});
parcelRegister("3latU", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRouteEntry", ()=>$e3da21f0d916313d$export$504c6fb2862492a1);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $fDmAy;
    const $e3da21f0d916313d$export$504c6fb2862492a1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fDmAy")).globalSettingsIssuesCustomFieldsDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("fDmAy", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRoute", ()=>$ea98d8035c54e56c$export$36f7f639e35c6980);
    var $65Ltd;
    const $ea98d8035c54e56c$export$36f7f639e35c6980 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE),
        path: '/secure/admin/DeleteCustomField!default.jspa'
    };
});
parcelRegister("5Nnqm", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRouteEntry", ()=>$096ba3b979d51d93$export$68ff9a44323b27ca);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $hj1NH;
    const $096ba3b979d51d93$export$68ff9a44323b27ca = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hj1NH")).globalSettingsIssuesCustomFieldsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hj1NH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRoute", ()=>$f8de3f2267eda090$export$ca7a3fa1760c59bf);
    var $65Ltd;
    const $f8de3f2267eda090$export$ca7a3fa1760c59bf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT),
        path: '/secure/admin/EditCustomField(\\w*)!default.jspa'
    };
});
parcelRegister("d6dRh", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRouteEntry", ()=>$a219492dda0ab7d4$export$12970e70b4c77f98);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $89yvr;
    const $a219492dda0ab7d4$export$12970e70b4c77f98 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("89yvr")).globalSettingsIssuesCustomFieldsManageRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("89yvr", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRoute", ()=>$acc8a910f3a006fc$export$441ab7e26eb9710);
    var $65Ltd;
    const $acc8a910f3a006fc$export$441ab7e26eb9710 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE),
        path: '/secure/admin/ManageConfigurationScheme!default.jspa'
    };
});
parcelRegister("4VzuS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRouteEntry", ()=>$bb7cd7d96e806d13$export$df186d4a4dcc70d6);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $gWmPH;
    const $bb7cd7d96e806d13$export$df186d4a4dcc70d6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gWmPH")).globalSettingsIssuesCustomFieldsTranslateRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("gWmPH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRoute", ()=>$e4c22088074b305e$export$13f985d12cff8c13);
    var $65Ltd;
    const $e4c22088074b305e$export$13f985d12cff8c13 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE),
        path: '/secure/admin/TranslateCustomField!default.jspa'
    };
});
parcelRegister("cMeMl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldAddRouteEntry", ()=>$f751fa71d039e77a$export$a0f9d2aa72494978);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $9YS7E;
    const $f751fa71d039e77a$export$a0f9d2aa72494978 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9YS7E")).globalSettingsIssuesFieldAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("9YS7E", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldAddRoute", ()=>$f7e663ec08c10900$export$7bb3a869061a8016);
    const $f7e663ec08c10900$export$7bb3a869061a8016 = {
        name: 'global-settings-issues-field-add',
        path: '/secure/admin/AddNewFieldScreen.jspa'
    };
});
parcelRegister("uTJdq", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRouteEntry", ()=>$3ee2f12aecbd03ba$export$26b162cdb704f0a0);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $7ezC5;
    const $3ee2f12aecbd03ba$export$26b162cdb704f0a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ezC5")).globalSettingsIssuesFieldConfigureEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("7ezC5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRoute", ()=>$85cb40b67c564024$export$37908ebd0fc6f94c);
    var $65Ltd;
    const $85cb40b67c564024$export$37908ebd0fc6f94c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT),
        path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa'
    };
});
parcelRegister("gQaJ7", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRouteEntry", ()=>$d0200038ce9e8c62$export$ce20a01bf6cc22e8);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $lYecC;
    const $d0200038ce9e8c62$export$ce20a01bf6cc22e8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lYecC")).globalSettingsIssuesFieldConfigureRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("lYecC", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRoute", ()=>$b3a70e3301cd8cbe$export$47585e3c198123be);
    var $65Ltd;
    const $b3a70e3301cd8cbe$export$47585e3c198123be = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE),
        path: '/secure/admin/ConfigureFieldScreen.jspa'
    };
});
parcelRegister("fGB22", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldCopyRouteEntry", ()=>$20b99e61d1b66b6c$export$4d899a20474ade0);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $iohzn;
    const $20b99e61d1b66b6c$export$4d899a20474ade0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iohzn")).globalSettingsIssuesFieldCopyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("iohzn", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldCopyRoute", ()=>$1f3084aed9f5a0d8$export$ec5bbfc3593b01b7);
    var $65Ltd;
    const $1f3084aed9f5a0d8$export$ec5bbfc3593b01b7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY),
        path: '/secure/admin/ViewCopyFieldScreen.jspa'
    };
});
parcelRegister("6R0vY", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRouteEntry", ()=>$10f86fb5a7f42609$export$9170e2ce6999793e);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $d2gU3;
    const $10f86fb5a7f42609$export$9170e2ce6999793e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d2gU3")).globalSettingsIssuesFieldDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("d2gU3", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRoute", ()=>$42a9148863ae279b$export$9a0bc2a1c24ad312);
    var $65Ltd;
    const $42a9148863ae279b$export$9a0bc2a1c24ad312 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE),
        path: '/secure/admin/ViewDeleteFieldScreen.jspa'
    };
});
parcelRegister("9VVuX", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldEditRouteEntry", ()=>$bbc10b5e52bd01da$export$4f6f7197ee5fbd88);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $kF2qF;
    const $bbc10b5e52bd01da$export$4f6f7197ee5fbd88 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kF2qF")).globalSettingsIssuesFieldEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("kF2qF", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldEditRoute", ()=>$a7162ce5a1fbab4f$export$e41329d1f04b5b51);
    var $65Ltd;
    const $a7162ce5a1fbab4f$export$e41329d1f04b5b51 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT),
        path: '/secure/admin/EditFieldScreen!default.jspa'
    };
});
parcelRegister("iwnR1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRouteEntry", ()=>$f09820585c4677c6$export$3a842eb59e795637);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $kKOCc;
    const $f09820585c4677c6$export$3a842eb59e795637 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kKOCc")).globalSettingsIssuesFieldSchemesAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("kKOCc", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRoute", ()=>$42ea523e85708e54$export$8b20e975ade5b676);
    var $65Ltd;
    const $42ea523e85708e54$export$8b20e975ade5b676 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD),
        path: '/secure/admin/AddFieldConfigurationScheme!default.jspa'
    };
});
parcelRegister("1JdXH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRouteEntry", ()=>$85c25b04008d1ebc$export$5f5a8b65a56acfea);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $71073;
    const $85c25b04008d1ebc$export$5f5a8b65a56acfea = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("71073")).globalSettingsIssuesFieldSchemesConfigureRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("71073", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRoute", ()=>$476082e8fe0c052c$export$6401bf37dfa17226);
    var $65Ltd;
    const $476082e8fe0c052c$export$6401bf37dfa17226 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE),
        path: '/secure/admin/ConfigureFieldScreenScheme.jspa'
    };
});
parcelRegister("clrfj", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRouteEntry", ()=>$663e770ccc9eed72$export$4c126f203951bdce);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $83hGf;
    const $663e770ccc9eed72$export$4c126f203951bdce = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("83hGf")).globalSettingsIssuesFieldSchemesCopyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("83hGf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRoute", ()=>$f8ec12054088dffc$export$195423dd1ef4cf0a);
    var $65Ltd;
    const $f8ec12054088dffc$export$195423dd1ef4cf0a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY),
        path: '/secure/admin/ViewCopyFieldScreenScheme.jspa'
    };
});
parcelRegister("1yWGC", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRouteEntry", ()=>$4a578aa8b985c7d9$export$a4609f789aeed81f);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $66nN1;
    const $4a578aa8b985c7d9$export$a4609f789aeed81f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("66nN1")).globalSettingsIssuesFieldSchemesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("66nN1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRoute", ()=>$b8aa715e03055a92$export$998546ee0d8d0995);
    var $65Ltd;
    const $b8aa715e03055a92$export$998546ee0d8d0995 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE),
        path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa'
    };
});
parcelRegister("9CQ2b", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRouteEntry", ()=>$526d463e71dfdc2d$export$aabed4f53fb4f921);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $9mkiv;
    const $526d463e71dfdc2d$export$aabed4f53fb4f921 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9mkiv")).globalSettingsIssuesFieldSchemesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("9mkiv", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRoute", ()=>$4e7dbb459c0cc017$export$c7b713e1fe2e026f);
    var $65Ltd;
    const $4e7dbb459c0cc017$var$defaultSuffix = '([!%]?[\\w]*)';
    const $4e7dbb459c0cc017$export$c7b713e1fe2e026f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT),
        path: `/secure/admin/EditFieldScreenScheme${$4e7dbb459c0cc017$var$defaultSuffix}.jspa`
    };
});
parcelRegister("62QWI", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRouteEntry", ()=>$665993951e27fd93$export$e38b78ff4a960db6);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $bkXpi;
    const $665993951e27fd93$export$e38b78ff4a960db6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bkXpi")).globalSettingsIssuesFieldSchemesEditItemRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("bkXpi", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRoute", ()=>$a609ded1b158b73c$export$4606c3f78e4ec3db);
    var $65Ltd;
    const $a609ded1b158b73c$var$defaultSuffix = '([!%]?[\\w]*)';
    const $a609ded1b158b73c$export$4606c3f78e4ec3db = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM),
        path: `/secure/admin/EditFieldScreenSchemeItem${$a609ded1b158b73c$var$defaultSuffix}.jspa`
    };
});
parcelRegister("nNkX7", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldViewRouteEntry", ()=>$c3f1b862e1846a57$export$25331ec7b1b8ebfb);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $7ry23;
    const $c3f1b862e1846a57$export$25331ec7b1b8ebfb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ry23")).globalSettingsIssuesFieldViewRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7ry23", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldViewRoute", ()=>$4aa28beacef2bc4e$export$1a32944e52a128e5);
    const $4aa28beacef2bc4e$export$1a32944e52a128e5 = {
        name: 'global-settings-issues-field-view',
        path: '/secure/admin/ViewFieldsScreen.jspa'
    };
});
parcelRegister("j6X8z", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRouteEntry", ()=>$59fd1757d87c2812$export$8946e190202a15c7);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $ee5xA;
    const $59fd1757d87c2812$export$8946e190202a15c7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ee5xA")).globalSettingsIssuesFieldlayoutsConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ee5xA", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRoute", ()=>$2ee830cfa0d4bd40$export$b469488e0c133a32);
    var $65Ltd;
    const $2ee830cfa0d4bd40$var$defaultSuffix = '([!%]?[\\w]*)';
    const $2ee830cfa0d4bd40$export$b469488e0c133a32 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW),
        path: `/secure/admin/ConfigureFieldLayout${$2ee830cfa0d4bd40$var$defaultSuffix}.jspa`
    };
});
parcelRegister("dSPOH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRouteEntry", ()=>$585e9bd258b16f31$export$c4d25de70db36bde);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $jzLn1;
    const $585e9bd258b16f31$export$c4d25de70db36bde = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jzLn1")).globalSettingsIssuesFieldlayoutsCopyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("jzLn1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRoute", ()=>$bf500c96b4352eb4$export$3a9552d4b0f71408);
    var $65Ltd;
    const $bf500c96b4352eb4$export$3a9552d4b0f71408 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY),
        path: '/secure/admin/CopyFieldLayout!default.jspa'
    };
});
parcelRegister("7PWgz", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRouteEntry", ()=>$e9af9356ad6c27c7$export$f2dfb8808ab4e2f2);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $6356h;
    const $e9af9356ad6c27c7$export$f2dfb8808ab4e2f2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6356h")).globalSettingsIssuesFieldlayoutsDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("6356h", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRoute", ()=>$4a32933e735a37c5$export$3ef4c145c5aa96b6);
    const $4a32933e735a37c5$export$3ef4c145c5aa96b6 = {
        name: 'global-settings-issues-fieldlayouts-delete',
        path: '/secure/admin/DeleteFieldLayout!default.jspa'
    };
});
parcelRegister("ekikx", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRouteEntry", ()=>$0785c087bbd95dbb$export$10710e2f7971e271);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $6Quk3;
    const $0785c087bbd95dbb$export$10710e2f7971e271 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6Quk3")).globalSettingsIssuesFieldlayoutsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("6Quk3", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRoute", ()=>$13917a9b4c805121$export$3a0534b35ee08e33);
    const $13917a9b4c805121$export$3a0534b35ee08e33 = {
        name: 'global-settings-issues-fieldlayouts-edit',
        path: '/secure/admin/EditFieldLayout!default.jspa'
    };
});
parcelRegister("dVehM", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry", ()=>$237f735d002f44b6$export$5b791b0a90dab069);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $1bSzQ;
    const $237f735d002f44b6$export$5b791b0a90dab069 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1bSzQ")).globalSettingsIssuesFieldlayoutsSchemesConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("1bSzQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRoute", ()=>$63b52301c41728d6$export$97921be5feed3adf);
    var $65Ltd;
    const $63b52301c41728d6$var$defaultSuffix = '([!%]?[\\w]*)';
    const $63b52301c41728d6$export$97921be5feed3adf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE),
        path: `/secure/admin/ConfigureFieldLayoutScheme${$63b52301c41728d6$var$defaultSuffix}.jspa`
    };
});
parcelRegister("jr2Mg", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry", ()=>$49e593f5f6e54db2$export$e5d2e7b8b7eb3bf5);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $admGG;
    const $49e593f5f6e54db2$export$e5d2e7b8b7eb3bf5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("admGG")).globalSettingsIssuesFieldlayoutsSchemesCopyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("admGG", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRoute", ()=>$fdc8902a3331e8a7$export$71563f57601b0e2);
    var $65Ltd;
    const $fdc8902a3331e8a7$var$defaultSuffix = '([!%]?[\\w]*)';
    const $fdc8902a3331e8a7$export$71563f57601b0e2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY),
        path: `/secure/admin/CopyFieldLayoutScheme${$fdc8902a3331e8a7$var$defaultSuffix}.jspa`
    };
});
parcelRegister("8aJ2b", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry", ()=>$f0805091f460730b$export$c1e57f90dca7eb4c);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $1cpd7;
    const $f0805091f460730b$export$c1e57f90dca7eb4c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1cpd7")).globalSettingsIssuesFieldlayoutsSchemesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("1cpd7", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRoute", ()=>$aff8b8ad7b30671e$export$e1a49cd1071690c4);
    var $65Ltd;
    const $aff8b8ad7b30671e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $aff8b8ad7b30671e$export$e1a49cd1071690c4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE),
        path: `/secure/admin/DeleteFieldLayoutScheme${$aff8b8ad7b30671e$var$defaultSuffix}.jspa`
    };
});
parcelRegister("43Uc9", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry", ()=>$aa8cb2019b8c54b1$export$99138c4ced2f05f7);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $4kLZE;
    const $aa8cb2019b8c54b1$export$99138c4ced2f05f7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4kLZE")).globalSettingsIssuesFieldlayoutsSchemesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("4kLZE", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRoute", ()=>$8664b1c2fed47dfa$export$a14fc516b4846e63);
    var $65Ltd;
    const $8664b1c2fed47dfa$var$defaultSuffix = '([!%]?[\\w]*)';
    const $8664b1c2fed47dfa$export$a14fc516b4846e63 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT),
        path: `/secure/admin/EditFieldLayoutScheme${$8664b1c2fed47dfa$var$defaultSuffix}.jspa`
    };
});
parcelRegister("kHniB", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry", ()=>$1f2b40f7b56e4c81$export$a860d5fef4b2c724);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $4kZl1;
    const $1f2b40f7b56e4c81$export$a860d5fef4b2c724 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4kZl1")).globalSettingsIssuesFieldlayoutsSchemesEntityRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("4kZl1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRoute", ()=>$b1b34cf7c0745ef5$export$54dfcbcea4cc773c);
    var $65Ltd;
    const $b1b34cf7c0745ef5$var$defaultSuffix = '([!%]?[\\w]*)';
    const $b1b34cf7c0745ef5$export$54dfcbcea4cc773c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY),
        path: `/secure/admin/ViewEditFieldLayoutSchemeEntity${$b1b34cf7c0745ef5$var$defaultSuffix}.jspa`
    };
});
parcelRegister("i9iZS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldviewRouteEntry", ()=>$f16f47b965fa6b50$export$1258f6b3b3168b6a);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $hN2kb;
    const $f16f47b965fa6b50$export$1258f6b3b3168b6a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hN2kb")).globalSettingsIssuesFieldviewRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hN2kb", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesFieldviewRoute", ()=>$c0f98aa36dfaf3fa$export$4e15d6f42067a40d);
    var $65Ltd;
    const $c0f98aa36dfaf3fa$export$4e15d6f42067a40d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE),
        path: '/secure/admin/ViewIssueFields.jspa'
    };
});
parcelRegister("hvbGw", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRouteEntry", ()=>$d78d81dac7e5c9bf$export$611de8afc4baaba5);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $iHkHA;
    const $d78d81dac7e5c9bf$export$611de8afc4baaba5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iHkHA")).globalSettingsIssuesGeneralTranslationsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("iHkHA", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRoute", ()=>$16ef055c96b1c7e3$export$82d4e60692b6b82);
    const $16ef055c96b1c7e3$export$82d4e60692b6b82 = {
        name: 'global-settings-issues-general-translations',
        path: '/secure/admin/ViewTranslations!default.jspa'
    };
});
parcelRegister("aiZ7o", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesLinkTypesRouteEntry", ()=>$0ff84cb6465dd59e$export$a96d582e6ce3db7f);
    $parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRouteEntry", ()=>$0ff84cb6465dd59e$export$a7de28edcb387644);
    $parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRouteEntry", ()=>$0ff84cb6465dd59e$export$bcae6091ca248a97);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3tVIo;
    const $0ff84cb6465dd59e$export$a96d582e6ce3db7f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3tVIo")).globalSettingsIssuesLinkTypesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
    const $0ff84cb6465dd59e$export$a7de28edcb387644 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3tVIo")).globalSettingsIssuesLinkTypesActivateRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
    const $0ff84cb6465dd59e$export$bcae6091ca248a97 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3tVIo")).globalSettingsIssuesLinkTypesDeactivateRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("3tVIo", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesLinkTypesRoute", ()=>$c8edb7a429a14292$export$ee4b5d966d77c912);
    $parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRoute", ()=>$c8edb7a429a14292$export$3669b743a852443d);
    $parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRoute", ()=>$c8edb7a429a14292$export$3b168b9635205cc2);
    var $65Ltd;
    const $c8edb7a429a14292$export$ee4b5d966d77c912 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES),
        path: '/secure/admin/ViewLinkTypes!default.jspa'
    };
    const $c8edb7a429a14292$export$3669b743a852443d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE),
        path: '/secure/admin/IssueLinkingActivate.jspa'
    };
    const $c8edb7a429a14292$export$3b168b9635205cc2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE),
        path: '/secure/admin/IssueLinkingDeActivate.jspa'
    };
});
parcelRegister("apLiY", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRouteEntry", ()=>$15ef848672bcffe5$export$5fed41168399db0a);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $lsNF3;
    const $15ef848672bcffe5$export$5fed41168399db0a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lsNF3")).globalSettingsIssuesLinktypesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("lsNF3", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRoute", ()=>$fe8a30a9c2217aac$export$da95e063618de37b);
    var $65Ltd;
    const $fe8a30a9c2217aac$export$da95e063618de37b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE),
        path: '/secure/admin/DeleteLinkType!default.jspa'
    };
});
parcelRegister("5Wx3t", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRouteEntry", ()=>$262e324389e7d7bd$export$58d36c7fbe66c9af);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $lbYLs;
    const $262e324389e7d7bd$export$58d36c7fbe66c9af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lbYLs")).globalSettingsIssuesLinktypesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("lbYLs", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRoute", ()=>$4e371a6e5f644193$export$670f7372491286fd);
    var $65Ltd;
    const $4e371a6e5f644193$export$670f7372491286fd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT),
        path: '/secure/admin/EditLinkType!default.jspa'
    };
});
parcelRegister("42kD1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationAddRouteEntry", ()=>$49debf6018dd8cad$export$d52d95e2669ccb14);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $cPaCU;
    const $49debf6018dd8cad$export$d52d95e2669ccb14 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cPaCU")).globalSettingsIssuesNotificationAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cPaCU", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationAddRoute", ()=>$e480e790d8abbfba$export$493378d37b4f830);
    var $65Ltd;
    const $e480e790d8abbfba$var$defaultSuffix = '([!%]?[\\w]*)';
    const $e480e790d8abbfba$export$493378d37b4f830 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD),
        path: `/secure/admin/AddNotification${$e480e790d8abbfba$var$defaultSuffix}.jspa`
    };
});
parcelRegister("9Ahl6", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRouteEntry", ()=>$221195b88aa8d002$export$e3ff68e9ac0a92e2);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $9AedH;
    const $221195b88aa8d002$export$e3ff68e9ac0a92e2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9AedH")).globalSettingsIssuesNotificationDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("9AedH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRoute", ()=>$f3963a49e610d300$export$7497920ead69d08f);
    var $65Ltd;
    const $f3963a49e610d300$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f3963a49e610d300$export$7497920ead69d08f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE),
        path: `/secure/admin/DeleteNotification${$f3963a49e610d300$var$defaultSuffix}.jspa`
    };
});
parcelRegister("6bzuG", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationEditRouteEntry", ()=>$3b94a2b00faf201d$export$256c34b63a2221ee);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $kMKtC;
    const $3b94a2b00faf201d$export$256c34b63a2221ee = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kMKtC")).globalSettingsIssuesNotificationEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("kMKtC", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationEditRoute", ()=>$f8c9cc6f731c3b79$export$715522cf2d547eaf);
    var $65Ltd;
    const $f8c9cc6f731c3b79$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f8c9cc6f731c3b79$export$715522cf2d547eaf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT),
        path: `/secure/admin/EditNotifications${$f8c9cc6f731c3b79$var$defaultSuffix}.jspa`
    };
});
parcelRegister("iSsNS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRouteEntry", ()=>$34b2e368144e52c7$export$f1f02571fc623886);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $kTUEB;
    const $34b2e368144e52c7$export$f1f02571fc623886 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kTUEB")).globalSettingsIssuesNotificationSchemeAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("kTUEB", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRoute", ()=>$0d4e1b79db1268a6$export$629ba048f31d2c0f);
    var $65Ltd;
    const $0d4e1b79db1268a6$var$defaultSuffix = '([!%]?[\\w]*)';
    const $0d4e1b79db1268a6$export$629ba048f31d2c0f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD),
        path: `/secure/admin/AddNotificationScheme${$0d4e1b79db1268a6$var$defaultSuffix}.jspa`
    };
});
parcelRegister("jJpgV", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRouteEntry", ()=>$80d07feecc77c4d3$export$40145c5de888865f);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $lIGfQ;
    const $80d07feecc77c4d3$export$40145c5de888865f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lIGfQ")).globalSettingsIssuesNotificationSchemeDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("lIGfQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRoute", ()=>$45e76c9be1ef5eb7$export$64a190266a30ffd6);
    var $65Ltd;
    const $45e76c9be1ef5eb7$var$defaultSuffix = '([!%]?[\\w]*)';
    const $45e76c9be1ef5eb7$export$64a190266a30ffd6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE),
        path: `/secure/admin/DeleteNotificationScheme${$45e76c9be1ef5eb7$var$defaultSuffix}.jspa`
    };
});
parcelRegister("eWkcy", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRouteEntry", ()=>$a24e45b3e17b9acb$export$856d15be55b1a791);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $du9pH;
    const $a24e45b3e17b9acb$export$856d15be55b1a791 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("du9pH")).globalSettingsIssuesNotificationSchemeEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("du9pH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRoute", ()=>$7e811b5776243e6e$export$a7f8c6170a6db933);
    var $65Ltd;
    const $7e811b5776243e6e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $7e811b5776243e6e$export$a7f8c6170a6db933 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT),
        path: `/secure/admin/EditNotificationScheme${$7e811b5776243e6e$var$defaultSuffix}.jspa`
    };
});
parcelRegister("2QaYg", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationViewRouteEntry", ()=>$ace82dca63d7ee80$export$45dd8c9548b0054e);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $9tOwY;
    const $ace82dca63d7ee80$export$45dd8c9548b0054e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tOwY")).globalSettingsIssuesNotificationViewRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("9tOwY", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNotificationViewRoute", ()=>$2d65dc805730306a$export$bc2109e7325d1a16);
    var $65Ltd;
    const $2d65dc805730306a$var$defaultSuffix = '([!%]?[\\w]*)';
    const $2d65dc805730306a$export$bc2109e7325d1a16 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW),
        path: `/secure/admin/ViewNotificationSchemes${$2d65dc805730306a$var$defaultSuffix}.jspa`
    };
});
parcelRegister("8kL76", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRouteEntry", ()=>$e338e61ccf0d14b6$export$f49580b73c3ba83);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $lexNA;
    var $1szwt;
    const $e338e61ccf0d14b6$export$f49580b73c3ba83 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lexNA")).globalSettingsIssuesPermissionsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            component: (0, (0, parcelRequire("1szwt")).LegacyEditPermissionsPage),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("lexNA", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRoute", ()=>$7b8092c7ecd3bd46$export$c7d87b3baf9e9a67);
    const $7b8092c7ecd3bd46$var$defaultSuffix = '([!%]?[\\w]*)';
    const $7b8092c7ecd3bd46$export$c7d87b3baf9e9a67 = {
        name: 'global-settings-issues-permissions-edit',
        path: `/secure/admin/EditPermissions${$7b8092c7ecd3bd46$var$defaultSuffix}.jspa`
    };
});
parcelRegister("1szwt", function(module, exports) {
    $parcel$export(module.exports, "LegacyEditPermissionsPage", ()=>$fd77ea98c0506931$export$fb0bf0e5f8e439b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QKrH;
    const $fd77ea98c0506931$export$fb0bf0e5f8e439b9 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6QKrH")).LegacyPage), props));
    var $fd77ea98c0506931$export$2e2bcd8739ae039 = $fd77ea98c0506931$export$fb0bf0e5f8e439b9;
});
parcelRegister("c2Cpo", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRouteEntry", ()=>$79eabf465a9cde01$export$d475751e96368b33);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $fV8AR;
    const $79eabf465a9cde01$export$d475751e96368b33 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fV8AR")).globalSettingsIssuesPermissionsSchemesAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("fV8AR", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRoute", ()=>$916f7c85cf620fdf$export$f9c900df1268958);
    var $65Ltd;
    const $916f7c85cf620fdf$export$f9c900df1268958 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD),
        path: '/secure/admin/AddPermissionScheme!default.jspa'
    };
});
parcelRegister("jolwb", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRouteEntry", ()=>$d41c8c4bc42ad32c$export$af3ca420f50b74f8);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $11Hor;
    const $d41c8c4bc42ad32c$export$af3ca420f50b74f8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("11Hor")).globalSettingsIssuesPermissionsSchemesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("11Hor", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRoute", ()=>$19abf2c50a23c0a2$export$9cbf97d551da6de6);
    var $65Ltd;
    const $19abf2c50a23c0a2$export$9cbf97d551da6de6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE),
        path: '/secure/admin/DeletePermissionScheme!default.jspa'
    };
});
parcelRegister("3EIJ8", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRouteEntry", ()=>$0012290be0d11afb$export$a1aace45fc58c0c0);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $cFjKq;
    const $0012290be0d11afb$export$a1aace45fc58c0c0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cFjKq")).globalSettingsIssuesPermissionsSchemesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cFjKq", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRoute", ()=>$ce029b6ad797f825$export$baed669ce740350d);
    var $65Ltd;
    const $ce029b6ad797f825$export$baed669ce740350d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT),
        path: '/secure/admin/EditPermissionScheme!default.jspa'
    };
});
parcelRegister("kPDwm", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRouteEntry", ()=>$69d28986f20d0262$export$92306855354418dd);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $4IA3r;
    const $69d28986f20d0262$export$92306855354418dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4IA3r")).globalSettingsIssuesPermissionsSchemesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("4IA3r", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRoute", ()=>$d67b3b0fbd8e2d43$export$152abbb6f806c87);
    var $65Ltd;
    const $d67b3b0fbd8e2d43$var$defaultSuffix = '([!%]?[\\w]*)';
    const $d67b3b0fbd8e2d43$export$152abbb6f806c87 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES),
        path: `/secure/admin/ViewPermissionSchemes${$d67b3b0fbd8e2d43$var$defaultSuffix}.jspa`
    };
});
parcelRegister("cfZHb", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRouteEntry", ()=>$ea1deab9c94c52ef$export$79f7bd4999f40475);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $9E8cx;
    const $ea1deab9c94c52ef$export$79f7bd4999f40475 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9E8cx")).globalSettingsIssuesPermissionsSchemesProjectRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("9E8cx", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRoute", ()=>$a144141d861c7fad$export$c29ffdea8ba3226d);
    var $65Ltd;
    const $a144141d861c7fad$export$c29ffdea8ba3226d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE),
        path: '/secure/project/SelectProjectPermissionScheme!default.jspa'
    };
});
parcelRegister("3zySp", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRouteEntry", ()=>$fe089c1049ff7161$export$88a39202914c5905);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $iBinq;
    const $fe089c1049ff7161$export$88a39202914c5905 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iBinq")).globalSettingsIssuesPrioritiesDefaultRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("iBinq", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRoute", ()=>$0f1d72226cb0e16c$export$83a29d1cc0270f5a);
    const $0f1d72226cb0e16c$var$defaultSuffix = '([!%]?[\\w]*)';
    const $0f1d72226cb0e16c$export$83a29d1cc0270f5a = {
        name: 'global-settings-issues-priorities-default',
        path: `/secure/admin/MakeDefaultPriority${$0f1d72226cb0e16c$var$defaultSuffix}.jspa`
    };
});
parcelRegister("drG3A", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRouteEntry", ()=>$12c3dc4d5da21152$export$e13fff0f49e2648b);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $7eVGG;
    const $12c3dc4d5da21152$export$e13fff0f49e2648b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7eVGG")).globalSettingsIssuesPrioritiesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7eVGG", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRoute", ()=>$7f74699fd46dea4c$export$1092268c69e42aa4);
    var $65Ltd;
    const $7f74699fd46dea4c$export$1092268c69e42aa4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE),
        path: '/secure/admin/DeletePriority!default.jspa'
    };
});
parcelRegister("hQSWw", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRouteEntry", ()=>$92c63ca32b9904b7$export$cd447ff81bd82138);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $cDac5;
    const $92c63ca32b9904b7$export$cd447ff81bd82138 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cDac5")).globalSettingsIssuesPrioritiesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cDac5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRoute", ()=>$add7a7d5a3682b48$export$c0f633caf37ba40d);
    var $65Ltd;
    const $add7a7d5a3682b48$export$c0f633caf37ba40d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT),
        path: '/secure/admin/EditPriority!default.jspa'
    };
});
parcelRegister("7t6RT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", ()=>$50f4c5ec28a82889$export$63a56a096ab0d260);
    var $lmyls;
    var $78U7j;
    var $Bodkp;
    var $2G9Bk;
    var $atU1t;
    var $f7bpL;
    const $50f4c5ec28a82889$export$63a56a096ab0d260 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("f7bpL")).globalSettingsIssuesPrioritiesRoute), ()=>({
            layout: (0, (0, parcelRequire("Bodkp")).priorityMappingGlobalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("Bodkp", function(module, exports) {
    $parcel$export(module.exports, "priorityMappingGlobalSettingsLayout", ()=>$65268f1a363ddd1a$export$233c4c28b2b79294);
    var $ibkIl;
    var $1XrjK;
    var $kxZPA;
    const $65268f1a363ddd1a$var$LegacyAsyncModals = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("aLPUy")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-priorities-mapping-global-settings-layout/src/ui/legacy-async-modals/index.tsx"
    });
    const $65268f1a363ddd1a$export$4219cc7dcaa1716c = [
        $65268f1a363ddd1a$var$LegacyAsyncModals
    ];
    const $65268f1a363ddd1a$export$233c4c28b2b79294 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("ibkIl")).globalSettingsLayout), {
        globalComponents: $65268f1a363ddd1a$export$4219cc7dcaa1716c
    });
});
parcelRegister("aLPUy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("zydG7")
    ]).then(()=>parcelRequire('1oQ9c'));
});
parcelRegister("f7bpL", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", ()=>$9706842c5d060d06$export$518516cdf6b7cd83);
    var $65Ltd;
    const $9706842c5d060d06$export$518516cdf6b7cd83 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
        path: '/secure/admin/ViewPriorities.jspa'
    };
});
parcelRegister("1NqcA", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRouteEntry", ()=>$2eb9623714b3ae27$export$3dd9e223f9189ad8);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $7Xrmp;
    const $2eb9623714b3ae27$export$3dd9e223f9189ad8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7Xrmp")).globalSettingsIssuesPrioritiesTranslationsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7Xrmp", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRoute", ()=>$ac9038f13bdcbed0$export$ac50c32d38c2abe0);
    var $65Ltd;
    const $ac9038f13bdcbed0$export$ac50c32d38c2abe0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE),
        path: '/secure/admin/ViewTranslations!default.jspa',
        query: [
            'issueConstantType=priority'
        ]
    };
});
parcelRegister("iEOv0", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRouteEntry", ()=>$034c0ba00d12f32a$export$48a6536027e4aff8);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $cknqk;
    const $034c0ba00d12f32a$export$48a6536027e4aff8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cknqk")).globalSettingsIssuesResolutionsDefaultRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cknqk", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRoute", ()=>$56109ab8d9bb9161$export$3069447d64064849);
    var $65Ltd;
    const $56109ab8d9bb9161$var$defaultSuffix = '([!%]?[\\w]*)';
    const $56109ab8d9bb9161$export$3069447d64064849 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT),
        path: `/secure/admin/MakeDefaultResolution${$56109ab8d9bb9161$var$defaultSuffix}.jspa`
    };
});
parcelRegister("eoQjS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRouteEntry", ()=>$a1cc42b7414d15d3$export$e4f8ecf8d9862ad4);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $f1hfs;
    const $a1cc42b7414d15d3$export$e4f8ecf8d9862ad4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("f1hfs")).globalSettingsIssuesResolutionsDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("f1hfs", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRoute", ()=>$188172177a2aa96f$export$cef4d5289f287690);
    var $65Ltd;
    const $188172177a2aa96f$export$cef4d5289f287690 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE),
        path: '/secure/admin/DeleteResolution!default.jspa'
    };
});
parcelRegister("gZV6Y", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRouteEntry", ()=>$99c52e6ff7e1529b$export$abc7d0979f67b53f);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $cEtNR;
    const $99c52e6ff7e1529b$export$abc7d0979f67b53f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cEtNR")).globalSettingsIssuesResolutionsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cEtNR", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRoute", ()=>$e5d918501f284f82$export$92b7f2cef28676);
    var $65Ltd;
    const $e5d918501f284f82$export$92b7f2cef28676 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT),
        path: '/secure/admin/EditResolution!default.jspa'
    };
});
parcelRegister("17yPk", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsRouteEntry", ()=>$6efd6aec2cc94a57$export$2fc29b05ae7ea40);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $ddLKM;
    const $6efd6aec2cc94a57$export$2fc29b05ae7ea40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ddLKM")).globalSettingsIssuesResolutionsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ddLKM", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsRoute", ()=>$eef96f68f09f1470$export$7ad0e4697ed2a3ec);
    var $65Ltd;
    const $eef96f68f09f1470$export$7ad0e4697ed2a3ec = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS),
        path: '/secure/admin/ViewResolutions.jspa'
    };
});
parcelRegister("cLAit", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRouteEntry", ()=>$645893b38a5e9c5a$export$93bb5b2fc4a9a739);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $2DQDV;
    const $645893b38a5e9c5a$export$93bb5b2fc4a9a739 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2DQDV")).globalSettingsIssuesResolutionsTranslationsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("2DQDV", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRoute", ()=>$a2d09b05d684a162$export$c84118fcbe41734c);
    var $65Ltd;
    const $a2d09b05d684a162$export$c84118fcbe41734c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE),
        path: '/secure/admin/ViewTranslations!default.jspa',
        query: [
            'issueConstantType=resolution'
        ]
    };
});
parcelRegister("Th6e7", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityEditRouteEntry", ()=>$2fdbe6f7cf0bdfd3$export$fe5197eff63a479c);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $dD5m1;
    const $2fdbe6f7cf0bdfd3$export$fe5197eff63a479c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dD5m1")).globalSettingsIssuesSecurityEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("dD5m1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityEditRoute", ()=>$ad376225c8b6b797$export$5f1d8fd298c25945);
    var $65Ltd;
    const $ad376225c8b6b797$var$defaultSuffix = '([!%]?[\\w]*)';
    const $ad376225c8b6b797$export$5f1d8fd298c25945 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT),
        path: `/secure/admin/EditIssueSecurities${$ad376225c8b6b797$var$defaultSuffix}.jspa`
    };
});
parcelRegister("cJLbl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRouteEntry", ()=>$4eac55fe7343f01d$export$32a0f47c80094c8a);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $hL3z5;
    const $4eac55fe7343f01d$export$32a0f47c80094c8a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hL3z5")).globalSettingsIssuesSecurityLevelAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("hL3z5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRoute", ()=>$a9182b136519f6a4$export$27fd05d5eac2b88);
    var $65Ltd;
    const $a9182b136519f6a4$export$27fd05d5eac2b88 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD),
        path: '/secure/admin/AddIssueSecurity!default.jspa'
    };
});
parcelRegister("1eB7K", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRouteEntry", ()=>$c1013f3849b620d6$export$566f3107971a2203);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $gGAWq;
    const $c1013f3849b620d6$export$566f3107971a2203 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gGAWq")).globalSettingsIssuesSecurityLevelDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("gGAWq", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRoute", ()=>$10dbcbf18f054a2c$export$9d60d6418ce002aa);
    var $65Ltd;
    const $10dbcbf18f054a2c$export$9d60d6418ce002aa = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE),
        path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa'
    };
});
parcelRegister("l9OjQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRouteEntry", ()=>$6222c72e06be483e$export$d5da255e04fa662f);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $hS4HB;
    const $6222c72e06be483e$export$d5da255e04fa662f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hS4HB")).globalSettingsIssuesSecurityLevelEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("hS4HB", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRoute", ()=>$69c45f3a29fdf25b$export$882588e58b7b7aa4);
    var $65Ltd;
    const $69c45f3a29fdf25b$export$882588e58b7b7aa4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT),
        path: '/secure/admin/EditSecurityLevel!default.jspa'
    };
});
parcelRegister("1i9Xk", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRouteEntry", ()=>$80f5f0c2c4b9343d$export$a0157f60ff5930b1);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $7ATLB;
    const $80f5f0c2c4b9343d$export$a0157f60ff5930b1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ATLB")).globalSettingsIssuesSecuritySchemesAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7ATLB", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRoute", ()=>$a47e3161e51ab004$export$1f38848b5541a84a);
    var $65Ltd;
    const $a47e3161e51ab004$var$defaultSuffix = '([!%]?[\\w]*)';
    const $a47e3161e51ab004$export$1f38848b5541a84a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD),
        path: `/secure/admin/AddIssueSecurityScheme${$a47e3161e51ab004$var$defaultSuffix}.jspa`
    };
});
parcelRegister("egtWh", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRouteEntry", ()=>$6f3058b056857c88$export$9a262260e12c79c8);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $4amSR;
    const $6f3058b056857c88$export$9a262260e12c79c8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4amSR")).globalSettingsIssuesSecuritySchemesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("4amSR", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRoute", ()=>$a70f984c7193ddd5$export$c653091a64df0f25);
    var $65Ltd;
    const $a70f984c7193ddd5$var$defaultSuffix = '([!%]?[\\w]*)';
    const $a70f984c7193ddd5$export$c653091a64df0f25 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE),
        path: `/secure/admin/DeleteIssueSecurityScheme${$a70f984c7193ddd5$var$defaultSuffix}.jspa`
    };
});
parcelRegister("eidif", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRouteEntry", ()=>$39faabc3f9e65c26$export$fd9e3acdd660a584);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $iirqk;
    const $39faabc3f9e65c26$export$fd9e3acdd660a584 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iirqk")).globalSettingsIssuesSecuritySchemesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("iirqk", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRoute", ()=>$523838bf7ed89953$export$bea68ab25bef976c);
    var $65Ltd;
    const $523838bf7ed89953$var$defaultSuffix = '([!%]?[\\w]*)';
    const $523838bf7ed89953$export$bea68ab25bef976c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT),
        path: `/secure/admin/EditIssueSecurityScheme${$523838bf7ed89953$var$defaultSuffix}.jspa`
    };
});
parcelRegister("fy4Yg", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRouteEntry", ()=>$84f486a83c49bd24$export$97cc0de5c7b8411a);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $76mTm;
    const $84f486a83c49bd24$export$97cc0de5c7b8411a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("76mTm")).globalSettingsIssuesSecuritySchemesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("76mTm", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRoute", ()=>$44fa52c43d3b401e$export$35f866ec59eb6111);
    var $65Ltd;
    const $44fa52c43d3b401e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $44fa52c43d3b401e$export$35f866ec59eb6111 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES),
        path: `/secure/admin/ViewIssueSecuritySchemes${$44fa52c43d3b401e$var$defaultSuffix}.jspa`
    };
});
parcelRegister("aQQaa", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesStatusesRouteEntry", ()=>$d9d51110f534fd84$export$f736a667e7868236);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $kOPen;
    const $d9d51110f534fd84$export$f736a667e7868236 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kOPen")).globalSettingsIssuesStatusesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("kOPen", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesStatusesRoute", ()=>$a1d2bf81fd6caa5e$export$4f249f1de6014aa8);
    var $65Ltd;
    const $a1d2bf81fd6caa5e$export$4f249f1de6014aa8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES),
        path: '/secure/admin/ViewStatuses.jspa'
    };
});
parcelRegister("eBuTH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRouteEntry", ()=>$495096d2467808ca$export$6ae705ef4b0a0174);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $a4z7X;
    const $495096d2467808ca$export$6ae705ef4b0a0174 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("a4z7X")).globalSettingsIssuesStatusesTranslationsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("a4z7X", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRoute", ()=>$5f6614f0a0af0366$export$1766642f43dd1413);
    var $65Ltd;
    const $5f6614f0a0af0366$export$1766642f43dd1413 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE),
        path: '/secure/admin/ViewTranslations!default.jspa',
        query: [
            'issueConstantType=status'
        ]
    };
});
parcelRegister("4nY0z", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRouteEntry", ()=>$f0922ba53d1c3dd7$export$62334310a9f11802);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $h9GC9;
    const $f0922ba53d1c3dd7$export$62334310a9f11802 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("h9GC9")).globalSettingsIssuesSubtasksDisableRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("h9GC9", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRoute", ()=>$aa1e3b01ca31657a$export$d2a6ab37bbab7a2d);
    var $65Ltd;
    const $aa1e3b01ca31657a$export$d2a6ab37bbab7a2d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE),
        path: '/secure/admin/subtasks/DisableSubTasks!default.jspa'
    };
});
parcelRegister("itMEc", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRouteEntry", ()=>$d5c0a26b2c1cc658$export$ffc845bbb3fd5a36);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $3NQda;
    const $d5c0a26b2c1cc658$export$ffc845bbb3fd5a36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3NQda")).globalSettingsIssuesSubtasksEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("3NQda", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRoute", ()=>$2a7c1f5cf6839f93$export$6ab3581cc7d5f524);
    var $65Ltd;
    const $2a7c1f5cf6839f93$export$6ab3581cc7d5f524 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT),
        path: '/secure/admin/subtasks/EditSubTaskIssueTypes!default.jspa'
    };
});
parcelRegister("38epV", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRouteEntry", ()=>$b03aaceefc4244e0$export$e03cf52d50503939);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $puoq5;
    const $b03aaceefc4244e0$export$e03cf52d50503939 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("puoq5")).globalSettingsIssuesSubtasksTranlationsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("puoq5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRoute", ()=>$789ca64b279fbe43$export$5ebaadfa47e727e6);
    var $65Ltd;
    const $789ca64b279fbe43$export$5ebaadfa47e727e6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE),
        path: '/secure/admin/subtasks/ViewTranslations!default.jspa'
    };
});
parcelRegister("5V9SB", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRouteEntry", ()=>$ea8e7270b1219d50$export$5d0300325c3e456c);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $ac6PZ;
    const $ea8e7270b1219d50$export$5d0300325c3e456c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ac6PZ")).globalSettingsIssuesTypesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ac6PZ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRoute", ()=>$4658633d8d05add9$export$53c2f4353355a41b);
    var $65Ltd;
    const $4658633d8d05add9$export$53c2f4353355a41b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE),
        path: '/secure/admin/DeleteIssueType!default.jspa'
    };
});
parcelRegister("9H4pw", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesEditRouteEntry", ()=>$7f0a22396959f34a$export$7e3e6487b18f13dd);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $ked5L;
    const $7f0a22396959f34a$export$7e3e6487b18f13dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ked5L")).globalSettingsIssuesTypesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ked5L", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesEditRoute", ()=>$d08419b1d98e3f44$export$26b7c50d91022a7);
    var $65Ltd;
    const $d08419b1d98e3f44$export$26b7c50d91022a7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT),
        path: '/secure/admin/EditIssueType!default.jspa'
    };
});
parcelRegister("fmiQQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRouteEntry", ()=>$bc755167648db09e$export$5d1defdba7aabb03);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $6L2ex;
    const $bc755167648db09e$export$5d1defdba7aabb03 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6L2ex")).globalSettingsIssuesTypesMigrateRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("6L2ex", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRoute", ()=>$33d488b1a34f6367$export$6f6923c45a7c3d7d);
    const $33d488b1a34f6367$var$defaultSuffix = '([!%]?[\\w]*)';
    const $33d488b1a34f6367$export$6f6923c45a7c3d7d = {
        name: 'global-settings-issues-types-migrate',
        path: `/secure/admin/MigrateIssueTypes${$33d488b1a34f6367$var$defaultSuffix}.jspa`
    };
});
parcelRegister("dPPJY", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry", ()=>$db2c67cc1e0455ef$export$7c04fddca02bf5e5);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $2OMcF;
    const $db2c67cc1e0455ef$export$7c04fddca02bf5e5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2OMcF")).globalSettingsIssuesTypesSchemesAssociateDefaultRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("2OMcF", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRoute", ()=>$cfcca1973db1da58$export$ce555a4492eeb41);
    var $65Ltd;
    const $cfcca1973db1da58$export$ce555a4492eeb41 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE),
        path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa'
    };
});
parcelRegister("9AJay", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRouteEntry", ()=>$c20891372c72b290$export$a4322d0977a716ec);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $7bq4v;
    const $c20891372c72b290$export$a4322d0977a716ec = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7bq4v")).globalSettingsIssuesTypesSchemesAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7bq4v", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRoute", ()=>$e505523724bd79e8$export$695947f4bf787b08);
    const $e505523724bd79e8$export$695947f4bf787b08 = {
        name: 'global-settings-issues-types-schemes-associate',
        path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa'
    };
});
parcelRegister("8bpAh", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry", ()=>$4ae6c5d4fb274fba$export$2486d5cbf90be36f);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $g25Xc;
    const $4ae6c5d4fb274fba$export$2486d5cbf90be36f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("g25Xc")).globalSettingsIssuesTypesSchemesOptionDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("g25Xc", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRoute", ()=>$0aecc12f4d13477b$export$c6dca032125109f7);
    var $65Ltd;
    const $0aecc12f4d13477b$export$c6dca032125109f7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE),
        path: '/secure/admin/DeleteOptionScheme!default.jspa'
    };
});
parcelRegister("58oS1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRouteEntry", ()=>$a88c96e0bf525245$export$c604bf31fc1ec79f);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $bNBjv;
    const $a88c96e0bf525245$export$c604bf31fc1ec79f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bNBjv")).globalSettingsIssuesTypesSchemesOptionRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("bNBjv", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRoute", ()=>$492c5ab84e753aff$export$e77dd31f52063355);
    var $65Ltd;
    const $492c5ab84e753aff$var$defaultSuffix = '([!%]?[\\w]*)';
    const $492c5ab84e753aff$export$e77dd31f52063355 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY),
        path: `/secure/admin/ConfigureOptionSchemes${$492c5ab84e753aff$var$defaultSuffix}.jspa`
    };
});
parcelRegister("6MOc5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry", ()=>$58b31ff441d49ab4$export$953b618d4334efe8);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $36uJ2;
    const $58b31ff441d49ab4$export$953b618d4334efe8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("36uJ2")).globalSettingsIssuesTypesScreenSchemesConfigureRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("36uJ2", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRoute", ()=>$2e01cfbe9d5b9c8d$export$35a08f15e9b959ee);
    var $65Ltd;
    const $2e01cfbe9d5b9c8d$export$35a08f15e9b959ee = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE),
        path: '/secure/admin/ConfigureIssueTypeScreenScheme.jspa'
    };
});
parcelRegister("g6iev", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRouteEntry", ()=>$1e7680b125414f09$export$7f2d678246700c2);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $8aC3a;
    const $1e7680b125414f09$export$7f2d678246700c2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8aC3a")).globalSettingsIssuesTypesScreenSchemesCopyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("8aC3a", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRoute", ()=>$d95e210e584a6b48$export$56cacc1b264d8eec);
    var $65Ltd;
    const $d95e210e584a6b48$export$56cacc1b264d8eec = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY),
        path: '/secure/admin/ViewCopyIssueTypeScreenScheme.jspa'
    };
});
parcelRegister("iQqGv", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry", ()=>$47856ef816b54735$export$5776296a4d01ebfc);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $hPBJu;
    const $47856ef816b54735$export$5776296a4d01ebfc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hPBJu")).globalSettingsIssuesTypesScreenSchemesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hPBJu", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRoute", ()=>$1bfaa71de5f52331$export$3e0cfa858e2af787);
    var $65Ltd;
    const $1bfaa71de5f52331$export$3e0cfa858e2af787 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE),
        path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa'
    };
});
parcelRegister("lqFNV", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRouteEntry", ()=>$7122383ea8393a64$export$c4d5ef3d480983a7);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $9e2tL;
    const $7122383ea8393a64$export$c4d5ef3d480983a7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9e2tL")).globalSettingsIssuesTypesScreenSchemesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("9e2tL", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRoute", ()=>$187f1cad86516aa9$export$1ddbfff8d0b6f652);
    var $65Ltd;
    const $187f1cad86516aa9$var$defaultSuffix = '([!%]?[\\w]*)';
    const $187f1cad86516aa9$export$1ddbfff8d0b6f652 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT),
        path: `/secure/admin/EditIssueTypeScreenScheme${$187f1cad86516aa9$var$defaultSuffix}.jspa`
    };
});
parcelRegister("48mkc", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRouteEntry", ()=>$c87261224645ae86$export$13bfbf88a9e3596d);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $78oys;
    const $c87261224645ae86$export$13bfbf88a9e3596d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("78oys")).globalSettingsIssuesTypesScreenSchemesEntityRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("78oys", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRoute", ()=>$516f67c01580761c$export$dbd4ba90dd0ca938);
    var $65Ltd;
    const $516f67c01580761c$export$dbd4ba90dd0ca938 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY),
        path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa'
    };
});
parcelRegister("fg9n4", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRouteEntry", ()=>$43335c72e8485bac$export$4f9686f0681ca4ae);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $gaADN;
    const $43335c72e8485bac$export$4f9686f0681ca4ae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gaADN")).globalSettingsIssuesTypesTranslationsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("gaADN", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRoute", ()=>$7f79a3b56b922a84$export$58b39a591d56ebd2);
    var $65Ltd;
    const $7f79a3b56b922a84$export$58b39a591d56ebd2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE),
        path: '/secure/admin/ViewTranslations!default.jspa',
        query: [
            'issueConstantType=issuetype'
        ]
    };
});
parcelRegister("jfSTr", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRouteEntry", ()=>$bdf88124282fe838$export$fc7a930108b9d172);
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry", ()=>$bdf88124282fe838$export$bf03c0c6f11d43ea);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $1P7rF;
    const $bdf88124282fe838$export$fc7a930108b9d172 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1P7rF")).globalSettingsIssuesWorkflowTransitionRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
    const $bdf88124282fe838$export$bf03c0c6f11d43ea = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1P7rF")).globalSettingsIssuesWorkflowTransitionMetaAttributesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
            }
        }));
});
parcelRegister("1P7rF", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRoute", ()=>$37d230d855a64cdd$export$1579038a55dade21);
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRoute", ()=>$37d230d855a64cdd$export$bc1d4dae621df0c5);
    var $65Ltd;
    const $37d230d855a64cdd$export$1579038a55dade21 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION),
        path: '/secure/admin/ViewWorkflowTransition.jspa'
    };
    const $37d230d855a64cdd$export$bc1d4dae621df0c5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES),
        path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa'
    };
});
parcelRegister("iWPtZ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRouteEntry", ()=>$b34f6acd67c9151c$export$3c5fdd60ca22958d);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $81EG6;
    const $b34f6acd67c9151c$export$3c5fdd60ca22958d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("81EG6")).globalSettingsIssuesWorkflowsImportRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("81EG6", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRoute", ()=>$d9f8ab832d45ee47$export$81f075f719f41037);
    const $d9f8ab832d45ee47$export$81f075f719f41037 = {
        name: 'global-settings-issues-workflows-import',
        path: '/plugins/servlet/wfshare-(import|export)'
    };
});
parcelRegister("d4DfK", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRouteEntry", ()=>$783f427054cc72ea$export$22172eb9e4a9e4ae);
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $atU1t;
    var $a0Ad9;
    const $783f427054cc72ea$export$22172eb9e4a9e4ae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("a0Ad9")).globalSettingsIssuesWorkflowsSchemesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("a0Ad9", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRoute", ()=>$e3db8c2864122c4d$export$51a0d34ef3d00da8);
    var $65Ltd;
    const $e3db8c2864122c4d$export$51a0d34ef3d00da8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT),
        path: '/secure/admin/EditWorkflowScheme.jspa'
    };
});
parcelRegister("aOHs8", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsAccessRouteEntry", ()=>$a073bb4b497a4ea1$export$1a764e0ec9764809);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $lARhr;
    const $a073bb4b497a4ea1$export$1a764e0ec9764809 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lARhr")).globalSettingsProductsAccessRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("2Fj5v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9ddf603830cf6c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("5qELD")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
    });
    const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
    $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
    var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;
});
parcelRegister("5qELD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3FDyC")
    ]).then(()=>parcelRequire('hTSvC'));
});
parcelRegister("lARhr", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsAccessRoute", ()=>$f67c22037a6ebfa5$export$622d63534e0526a7);
    const $f67c22037a6ebfa5$export$622d63534e0526a7 = {
        name: 'global-settings-products-access',
        path: '/secure/admin/ApplicationAccess.jspa'
    };
});
parcelRegister("l6LGS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry", ()=>$8a46ede569efdc87$export$c3b9f18ebde289c);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $1MamA;
    const $8a46ede569efdc87$export$c3b9f18ebde289c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1MamA")).globalSettingsProductsAdvancedRoadmapsHierarchyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("1MamA", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRoute", ()=>$4e86620a81b5f7d9$export$40d4fd2626eca72c);
    const $4e86620a81b5f7d9$export$40d4fd2626eca72c = {
        name: 'global-settings-products-advanced-roadmaps-hierarchy',
        path: '/secure/PortfolioHierarchy.jspa'
    };
});
parcelRegister("391UN", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsApplinksRouteEntry", ()=>$a58e3c71599a4b32$export$3dcc4ef9452eebbe);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $1Cepy;
    const $a58e3c71599a4b32$export$3dcc4ef9452eebbe = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1Cepy")).globalSettingsProductsApplinksRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("1Cepy", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsApplinksRoute", ()=>$b8b8ce78eadb8a88$export$8ff9863beab5519d);
    var $65Ltd;
    const $b8b8ce78eadb8a88$export$8ff9863beab5519d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS),
        path: '/plugins/servlet/applinks/listApplicationLinks'
    };
});
parcelRegister("9I8yf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRouteEntry", ()=>$b2b9c44596cfc1e5$export$8d7fb911e3ad15ce);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $8da5t;
    const $b2b9c44596cfc1e5$export$8d7fb911e3ad15ce = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8da5t")).globalSettingsProductsDvcsBitbucketRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("8da5t", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRoute", ()=>$799be33ae57c8788$export$463d647a53bdebee);
    const $799be33ae57c8788$export$463d647a53bdebee = {
        name: 'global-settings-products-dvcs-bitbucket',
        path: '/secure/BitbucketPostInstallApprovalAction.jspa'
    };
});
parcelRegister("iaCCR", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsDvcsRouteEntry", ()=>$1f1bcf01030016f8$export$7970dfc3b824c864);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $fR3a1;
    const $1f1bcf01030016f8$export$7970dfc3b824c864 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fR3a1")).globalSettingsProductsDvcsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("fR3a1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsDvcsRoute", ()=>$de001bebcedaa6ba$export$75d086bb3dd16edc);
    var $65Ltd;
    const $de001bebcedaa6ba$export$75d086bb3dd16edc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS),
        path: '/secure/admin/ConfigureDvcsOrganizations!default.jspa'
    };
});
parcelRegister("4erM2", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsJsdStatusRouteEntry", ()=>$2260310ddc3a3827$export$5f4b9c737cade2ac);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $i5ufu;
    const $2260310ddc3a3827$export$5f4b9c737cade2ac = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("i5ufu")).globalSettingsProductsJsdStatusRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("i5ufu", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsJsdStatusRoute", ()=>$37bb80e3179b70e6$export$a0292a772bf703a0);
    var $65Ltd;
    const $37bb80e3179b70e6$export$a0292a772bf703a0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE),
        path: '/plugins/servlet/ac/jsd-status-page'
    };
});
parcelRegister("56QIn", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsSdconfigRouteEntry", ()=>$51868dbf32f3f6e1$export$cb6362a400fffb25);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $cfEYf;
    const $51868dbf32f3f6e1$export$cb6362a400fffb25 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cfEYf")).globalSettingsProductsSdconfigRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("cfEYf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsSdconfigRoute", ()=>$c1a5475729a100a4$export$846e5cd0d5151fde);
    const $c1a5475729a100a4$export$846e5cd0d5151fde = {
        name: 'global-settings-products-sdconfig',
        path: '/secure/admin/SDConfiguration.jspa'
    };
});
parcelRegister("7SwDB", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsSdmailRouteEntry", ()=>$df028b10b5d8ea80$export$e296aae86525a621);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $j8dIq;
    const $df028b10b5d8ea80$export$e296aae86525a621 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("j8dIq")).globalSettingsProductsSdmailRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("j8dIq", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsSdmailRoute", ()=>$8cd295bfceb1179d$export$e35c6c6fbfbb5111);
    var $65Ltd;
    const $8cd295bfceb1179d$export$e35c6c6fbfbb5111 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL),
        path: '/secure/admin/SDMailInfo.jspa'
    };
});
parcelRegister("69II0", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRouteEntry", ()=>$2df4f34e234e9bb9$export$3e9459c1e240d138);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $eNUqi;
    const $2df4f34e234e9bb9$export$3e9459c1e240d138 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eNUqi")).globalSettingsProductsSoftwareConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: (0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
        }));
});
parcelRegister("eNUqi", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRoute", ()=>$bad5577617d8482e$export$5b270f25cf4ae11c);
    const $bad5577617d8482e$export$5b270f25cf4ae11c = {
        name: 'global-settings-products-software-config',
        path: '/secure/SoftwareConfig.jspa',
        query: [
            'decorator=admin'
        ]
    };
});
parcelRegister("2Xl2E", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRouteEntry", ()=>$4633038c328b7959$export$ecfb2cc5a7593980);
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $atU1t;
    var $hH7mQ;
    const $4633038c328b7959$export$ecfb2cc5a7593980 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hH7mQ")).globalSettingsProjectsCategoriesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("4jMkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb7b1354cffbd527$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $kxZPA;
    const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("2n134")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
    });
    const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
    $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
    var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;
});
parcelRegister("2n134", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lhVk0")
    ]).then(()=>parcelRequire('1tunp'));
});
parcelRegister("hH7mQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRoute", ()=>$42708f1ce9028222$export$f155c76657570a56);
    var $65Ltd;
    const $42708f1ce9028222$var$defaultSuffix = '([!%]?[\\w]*)';
    const $42708f1ce9028222$export$f155c76657570a56 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE),
        path: `/secure/admin/projectcategories/DeleteProjectCategory${$42708f1ce9028222$var$defaultSuffix}.jspa`
    };
});
parcelRegister("1DqI0", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRouteEntry", ()=>$67efc914bb0b5e34$export$8364dd961ae6c494);
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $atU1t;
    var $hXtoN;
    const $67efc914bb0b5e34$export$8364dd961ae6c494 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hXtoN")).globalSettingsProjectsCategoriesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hXtoN", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRoute", ()=>$4138934cd75c9b9e$export$53d7a3e6e69ec873);
    var $65Ltd;
    const $4138934cd75c9b9e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $4138934cd75c9b9e$export$53d7a3e6e69ec873 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT),
        path: `/secure/admin/projectcategories/EditProjectCategory${$4138934cd75c9b9e$var$defaultSuffix}.jspa`
    };
});
parcelRegister("erXHa", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRouteEntry", ()=>$1ee2ae9d9f965390$export$f53b9ac05cdf2fe8);
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $atU1t;
    var $6GmKZ;
    const $1ee2ae9d9f965390$export$f53b9ac05cdf2fe8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6GmKZ")).globalSettingsProjectsCategoriesViewRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("6GmKZ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRoute", ()=>$36eb8f477f7cb71a$export$17ada00b0bde9ebc);
    var $65Ltd;
    const $36eb8f477f7cb71a$var$defaultSuffix = '([!%]?[\\w]*)';
    const $36eb8f477f7cb71a$export$17ada00b0bde9ebc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW),
        path: `/secure/admin/projectcategories/ViewProjectCategories${$36eb8f477f7cb71a$var$defaultSuffix}.jspa`
    };
});
parcelRegister("6pQVv", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRouteEntry", ()=>$89b41fbd108e5775$export$48579ce5caedb688);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $6pzH4;
    const $89b41fbd108e5775$export$48579ce5caedb688 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pzH4")).globalSettingsSystemApplicationAdvancedRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("6pzH4", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRoute", ()=>$fab4c933e230fc8c$export$e79dd086a8ca16b7);
    var $65Ltd;
    const $fab4c933e230fc8c$export$e79dd086a8ca16b7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS),
        path: '/secure/admin/AdvancedApplicationProperties.jspa'
    };
});
parcelRegister("BV4TM", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemApplicationEditRouteEntry", ()=>$5c9d714dbebae5e8$export$cb756194922d59f5);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $fXOGD;
    const $5c9d714dbebae5e8$export$cb756194922d59f5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fXOGD")).globalSettingsSystemApplicationEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("fXOGD", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemApplicationEditRoute", ()=>$f2a2ae3688222472$export$3cfb7004aee9915c);
    var $65Ltd;
    const $f2a2ae3688222472$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f2a2ae3688222472$export$3cfb7004aee9915c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS),
        path: `/secure/admin/EditApplicationProperties${$f2a2ae3688222472$var$defaultSuffix}.jspa`
    };
});
parcelRegister("f3iyT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemApplicationViewRouteEntry", ()=>$44e39b4f489cc58d$export$c97a0463677004d2);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $h8WUv;
    const $44e39b4f489cc58d$export$c97a0463677004d2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("h8WUv")).globalSettingsSystemApplicationViewRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("h8WUv", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemApplicationViewRoute", ()=>$b19c6b3bbe0bd2e7$export$5ddf1dd9c57a9326);
    const $b19c6b3bbe0bd2e7$export$5ddf1dd9c57a9326 = {
        name: 'global-settings-system-application-view',
        path: '/secure/admin/ViewApplicationProperties.jspa'
    };
});
parcelRegister("anp69", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemAttachmentsRouteEntry", ()=>$be490902626e0718$export$a692196c89a01817);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $1hK3p;
    const $be490902626e0718$export$a692196c89a01817 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1hK3p")).globalSettingsSystemAttachmentsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("1hK3p", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemAttachmentsRoute", ()=>$0b56a648c325ca0d$export$717d7ab74cb9ce91);
    var $65Ltd;
    const $0b56a648c325ca0d$export$717d7ab74cb9ce91 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS),
        path: '/secure/admin/ViewAttachmentSettings.jspa'
    };
});
parcelRegister("a5QOt", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemAuditingRouteEntry", ()=>$199e4e2df7bf57c9$export$7484cb4db3cfbf3f);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $ibaNZ;
    const $199e4e2df7bf57c9$export$7484cb4db3cfbf3f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ibaNZ")).globalSettingsSystemAuditingRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ibaNZ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemAuditingRoute", ()=>$3085711d7f606884$export$b8241cf6a8335186);
    var $65Ltd;
    const $3085711d7f606884$export$b8241cf6a8335186 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG),
        path: '/auditing/:page'
    };
});
parcelRegister("kBqwn", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemCollectorsRouteEntry", ()=>$b02e6026b12f85b1$export$a46b2c4865857bde);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $399LQ;
    const $b02e6026b12f85b1$export$a46b2c4865857bde = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("399LQ")).globalSettingsSystemCollectorsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("399LQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemCollectorsRoute", ()=>$068ed9810500820a$export$69ef22f1d54c39dc);
    var $65Ltd;
    const $068ed9810500820a$var$defaultSuffix = '([!%]?[\\w]*)';
    const $068ed9810500820a$export$69ef22f1d54c39dc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS),
        path: `/secure/admin/ViewGlobalCollectors${$068ed9810500820a$var$defaultSuffix}.jspa`
    };
});
parcelRegister("84Mhu", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRouteEntry", ()=>$b91438608594003e$export$3ba7ed3247e0da7);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $bNbuU;
    const $b91438608594003e$export$3ba7ed3247e0da7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bNbuU")).globalSettingsSystemDefaultSettingsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("bNbuU", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRoute", ()=>$9b0e85cd52e85a3f$export$d8f4254e5ee116aa);
    var $65Ltd;
    const $9b0e85cd52e85a3f$var$defaultSuffix = '([!%]?[\\w]*)';
    const $9b0e85cd52e85a3f$export$d8f4254e5ee116aa = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS),
        path: `/secure/admin/ViewUserDefaultSettings${$9b0e85cd52e85a3f$var$defaultSuffix}.jspa`
    };
});
parcelRegister("dTxTT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemEventsRouteEntry", ()=>$f04dcff802f0dd89$export$431e68e0ed553cca);
    $parcel$export(module.exports, "globalSettingsSystemEventsAddRouteEntry", ()=>$f04dcff802f0dd89$export$18dc7c450d001255);
    $parcel$export(module.exports, "globalSettingsSystemEventsDeleteRouteEntry", ()=>$f04dcff802f0dd89$export$82ec56d45583ff5a);
    $parcel$export(module.exports, "globalSettingsSystemEventsEditRouteEntry", ()=>$f04dcff802f0dd89$export$5700f7202370e9c4);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $e0CMZ;
    const $f04dcff802f0dd89$export$431e68e0ed553cca = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e0CMZ")).globalSettingsSystemEventsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
    const $f04dcff802f0dd89$export$18dc7c450d001255 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e0CMZ")).globalSettingsSystemEventsAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
    const $f04dcff802f0dd89$export$82ec56d45583ff5a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e0CMZ")).globalSettingsSystemEventsDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
    const $f04dcff802f0dd89$export$5700f7202370e9c4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e0CMZ")).globalSettingsSystemEventsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("e0CMZ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemEventsRoute", ()=>$0e9fb75db90441fa$export$c294ba50eb736e7b);
    $parcel$export(module.exports, "globalSettingsSystemEventsAddRoute", ()=>$0e9fb75db90441fa$export$3bafc84a5f76a507);
    $parcel$export(module.exports, "globalSettingsSystemEventsDeleteRoute", ()=>$0e9fb75db90441fa$export$cf0c62e05603f7e1);
    $parcel$export(module.exports, "globalSettingsSystemEventsEditRoute", ()=>$0e9fb75db90441fa$export$9bf98baef9abe3eb);
    var $65Ltd;
    const $0e9fb75db90441fa$export$c294ba50eb736e7b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS),
        path: '/secure/admin/ListEventTypes.jspa'
    };
    const $0e9fb75db90441fa$export$3bafc84a5f76a507 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD),
        path: '/secure/admin/AddEventType.jspa'
    };
    const $0e9fb75db90441fa$export$cf0c62e05603f7e1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE),
        path: '/secure/admin/DeleteEventType.jspa'
    };
    const $0e9fb75db90441fa$export$9bf98baef9abe3eb = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT),
        path: '/secure/admin/EditEventType.jspa'
    };
});
parcelRegister("lVivS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemExportRouteEntry", ()=>$80ce26fa2dc67e95$export$78effb39671690ca);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $bIbCH;
    const $80ce26fa2dc67e95$export$78effb39671690ca = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bIbCH")).globalSettingsSystemExportRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("bIbCH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemExportRoute", ()=>$7a9a36341fcb2a55$export$e398684ea718a2e7);
    var $65Ltd;
    const $7a9a36341fcb2a55$export$e398684ea718a2e7 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER),
        path: '/secure/admin/CloudExport.jspa'
    };
});
parcelRegister("b1Nwt", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRouteEntry", ()=>$9cabaff0e095eddd$export$ebb311f9ff3b5efb);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $bXYSy;
    const $9cabaff0e095eddd$export$ebb311f9ff3b5efb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bXYSy")).globalSettingsSystemGlobalPermissionsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("bXYSy", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRoute", ()=>$4a506062b5f620bc$export$38ac3717b046eb26);
    var $65Ltd;
    const $4a506062b5f620bc$export$38ac3717b046eb26 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS),
        path: '/secure/admin/jira/GlobalPermissions!default.jspa'
    };
});
parcelRegister("lvMv1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemHelperNotificationRouteEntry", ()=>$96f60e9872892dbc$export$e2befb3c6371d2f2);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $51OCp;
    const $96f60e9872892dbc$export$e2befb3c6371d2f2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("51OCp")).globalSettingsSystemHelperNotificationRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("51OCp", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemHelperNotificationRoute", ()=>$b2307563af46895c$export$7dab38c28c574395);
    var $65Ltd;
    const $b2307563af46895c$export$7dab38c28c574395 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER),
        path: '/secure/admin/NotificationHelperAdmin.jspa'
    };
});
parcelRegister("5b2gi", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemHelperPermissionRouteEntry", ()=>$8fd74952aea7f390$export$b7f8ebfe77163756);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $3jCMN;
    const $8fd74952aea7f390$export$b7f8ebfe77163756 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3jCMN")).globalSettingsSystemHelperPermissionRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("3jCMN", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemHelperPermissionRoute", ()=>$25913f81a7b38c0e$export$5c1770f1a1797fa5);
    var $65Ltd;
    const $25913f81a7b38c0e$export$5c1770f1a1797fa5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER),
        path: '/secure/admin/PermissionHelperAdmin.jspa'
    };
});
parcelRegister("kQ04T", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportBulkRouteEntry", ()=>$4475cd9cc4139dbf$export$dd20078389577d29);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $lYz4o;
    const $4475cd9cc4139dbf$export$dd20078389577d29 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lYz4o")).globalSettingsSystemImportBulkRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("lYz4o", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportBulkRoute", ()=>$e849eb9fcd0a7cd7$export$9de82cbc931fb7d0);
    const $e849eb9fcd0a7cd7$var$defaultSuffix = '([!%]?[\\w]*)';
    const $e849eb9fcd0a7cd7$export$9de82cbc931fb7d0 = {
        name: 'global-settings-system-import-bulk',
        path: `/secure/admin/BulkCreate(\\w+)${$e849eb9fcd0a7cd7$var$defaultSuffix}.jspa`
    };
});
parcelRegister("bj17J", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportCloudRouteEntry", ()=>$777be9204252f49e$export$9d598c957e5bddde);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $86EpS;
    const $777be9204252f49e$export$9d598c957e5bddde = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("86EpS")).globalSettingsSystemImportCloudRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("86EpS", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportCloudRoute", ()=>$17f1ad4537067224$export$9953342c4b995f8);
    var $65Ltd;
    const $17f1ad4537067224$var$defaultSuffix = '([!%]?[\\w]*)';
    const $17f1ad4537067224$export$9953342c4b995f8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT),
        path: `/secure/admin/CloudImport${$17f1ad4537067224$var$defaultSuffix}.jspa`
    };
});
parcelRegister("4eIbF", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportCsvRouteEntry", ()=>$02b232aac263180d$export$9e23dd51b331426c);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $hnttw;
    const $02b232aac263180d$export$9e23dd51b331426c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hnttw")).globalSettingsSystemImportCsvRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hnttw", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportCsvRoute", ()=>$29210923d3b352ba$export$49f0cc3d88107d6b);
    var $65Ltd;
    const $29210923d3b352ba$var$defaultSuffix = '([!%]?[\\w]*)';
    const $29210923d3b352ba$export$49f0cc3d88107d6b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV),
        path: `/(secure|secure/admin)/Csv(\\w+)Page${$29210923d3b352ba$var$defaultSuffix}.jspa`
    };
});
parcelRegister("c6t9I", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportExternalRouteEntry", ()=>$60277bfdfb5be7aa$export$bf4a85badc8c82c9);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $jhVkF;
    const $60277bfdfb5be7aa$export$bf4a85badc8c82c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jhVkF")).globalSettingsSystemImportExternalRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("jhVkF", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportExternalRoute", ()=>$3e6a5d7d52979b87$export$afcc884cbc873f9f);
    var $65Ltd;
    const $3e6a5d7d52979b87$export$afcc884cbc873f9f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT),
        path: '/secure/admin/ExternalImport1.jspa'
    };
});
parcelRegister("luBtt", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRouteEntry", ()=>$57a5ed404ac1b288$export$7ca884816be2470a);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $cKvXT;
    const $57a5ed404ac1b288$export$7ca884816be2470a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cKvXT")).globalSettingsSystemImportExternalPagesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cKvXT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRoute", ()=>$41321bd5803f98ad$export$dffab00ceab69eb2);
    const $41321bd5803f98ad$var$defaultSuffix = '([!%]?[\\w]*)';
    const $41321bd5803f98ad$export$dffab00ceab69eb2 = {
        name: 'global-settings-system-import-external-pages',
        path: `/secure/admin/Importer(\\w+)Page${$41321bd5803f98ad$var$defaultSuffix}.jspa`
    };
});
parcelRegister("dkKsD", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportJsonRouteEntry", ()=>$9e37fccffd70df03$export$fbac3139112fe654);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $jN4Ob;
    const $9e37fccffd70df03$export$fbac3139112fe654 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jN4Ob")).globalSettingsSystemImportJsonRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("jN4Ob", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportJsonRoute", ()=>$6685dfc505bfd9c9$export$169bd8bcabed089d);
    var $65Ltd;
    const $6685dfc505bfd9c9$var$defaultSuffix = '([!%]?[\\w]*)';
    const $6685dfc505bfd9c9$export$169bd8bcabed089d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON),
        path: `/secure/admin/Json(\\w+)Page${$6685dfc505bfd9c9$var$defaultSuffix}.jspa`
    };
});
parcelRegister("ebHSU", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportTrelloRouteEntry", ()=>$4664f6f94fb80f24$export$19f57ac143eecd95);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $7ua0g;
    const $4664f6f94fb80f24$export$19f57ac143eecd95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ua0g")).globalSettingsSystemImportTrelloRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7ua0g", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemImportTrelloRoute", ()=>$c80431b2427a4912$export$b6753e755954098b);
    var $65Ltd;
    const $c80431b2427a4912$var$defaultSuffix = '([!%]?[\\w]*)';
    const $c80431b2427a4912$export$b6753e755954098b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO),
        path: `/secure/admin/Trello(\\w+)Page${$c80431b2427a4912$var$defaultSuffix}.jspa`
    };
});
parcelRegister("6Mj9c", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemLexorankRouteEntry", ()=>$b01dc48f1dbb9c6f$export$5163204c27a4b60f);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $1RPJf;
    const $b01dc48f1dbb9c6f$export$5163204c27a4b60f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1RPJf")).globalSettingsSystemLexorankRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("1RPJf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemLexorankRoute", ()=>$283fc923a22cab7e$export$d4ce3155385fd8cf);
    var $65Ltd;
    const $283fc923a22cab7e$export$d4ce3155385fd8cf = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT),
        path: '/secure/GHLexoRankManage.jspa',
        query: [
            'decorator=admin'
        ]
    };
});
parcelRegister("8gFkr", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemLookRouteEntry", ()=>$6796f6ebfb90e53d$export$bf366af006cda74e);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $hrR2c;
    const $6796f6ebfb90e53d$export$bf366af006cda74e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hrR2c")).globalSettingsSystemLookRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hrR2c", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemLookRoute", ()=>$650a1c42f9a48493$export$61f7b12ec2ac6aa1);
    var $65Ltd;
    const $650a1c42f9a48493$export$61f7b12ec2ac6aa1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL),
        path: '/secure/admin/LookAndFeel!default.jspa'
    };
});
parcelRegister("dZUFc", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailAddRouteEntry", ()=>$244a1ebbae725add$export$c48daf66fa2bb3e);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $csLz8;
    const $244a1ebbae725add$export$c48daf66fa2bb3e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("csLz8")).globalSettingsSystemMailAddRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("csLz8", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailAddRoute", ()=>$d48c8588cc581f6f$export$2874a3735d7cb330);
    const $d48c8588cc581f6f$export$2874a3735d7cb330 = {
        name: 'global-settings-system-mail-add',
        path: '/secure/admin/(Add|Update)PopMailServer!default.jspa'
    };
});
parcelRegister("8SVcH", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailIncomingRouteEntry", ()=>$969c82ba70272bab$export$3ae66df5766592ef);
    $parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRouteEntry", ()=>$969c82ba70272bab$export$a14468794f1b5c83);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $2wGSj;
    const $969c82ba70272bab$export$3ae66df5766592ef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2wGSj")).globalSettingsSystemMailIncomingRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
    const $969c82ba70272bab$export$a14468794f1b5c83 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2wGSj")).globalSettingsSystemMailDeleteMailHandlerRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("2wGSj", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailIncomingRoute", ()=>$666a5d1e9164ebc2$export$90c9c127e433d888);
    $parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRoute", ()=>$666a5d1e9164ebc2$export$140403398c884f90);
    var $65Ltd;
    const $666a5d1e9164ebc2$export$90c9c127e433d888 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL),
        path: '/secure/admin/IncomingMailServers.jspa'
    };
    const $666a5d1e9164ebc2$export$140403398c884f90 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER),
        path: '/secure/admin/DeleteMailHandler.jspa'
    };
});
parcelRegister("79bmJ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailOutgoingRouteEntry", ()=>$558108ab88d8a466$export$cb267b8986031cb7);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $ltA0j;
    const $558108ab88d8a466$export$cb267b8986031cb7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ltA0j")).globalSettingsSystemMailOutgoingRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ltA0j", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailOutgoingRoute", ()=>$b4b97545e2191816$export$6da120a8b84a7872);
    var $65Ltd;
    const $b4b97545e2191816$export$6da120a8b84a7872 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL),
        path: '/secure/admin/OutgoingMailServers.jspa'
    };
});
parcelRegister("8Uour", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailSendRouteEntry", ()=>$ccc2547d9b3f1cc0$export$bff9c3c6b0aba389);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $GJPyI;
    const $ccc2547d9b3f1cc0$export$bff9c3c6b0aba389 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("GJPyI")).globalSettingsSystemMailSendRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("GJPyI", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailSendRoute", ()=>$1dc3467211ab8856$export$a2ae5fa2accd6e5f);
    var $65Ltd;
    const $1dc3467211ab8856$export$a2ae5fa2accd6e5f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL),
        path: '/secure/admin/SendBulkMail!default.jspa'
    };
});
parcelRegister("2RLw5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailSettingsRouteEntry", ()=>$b2d0da4123e38efd$export$3c0d52a24b499e7c);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $afkoZ;
    const $b2d0da4123e38efd$export$3c0d52a24b499e7c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("afkoZ")).globalSettingsSystemMailSettingsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("afkoZ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailSettingsRoute", ()=>$a9d56cc9eb6da380$export$8423ad7a1177552);
    const $a9d56cc9eb6da380$var$defaultSuffix = '([!%]?[\\w]*)';
    const $a9d56cc9eb6da380$export$8423ad7a1177552 = {
        name: 'global-settings-system-mail-settings',
        path: `/secure/admin/GlobalMailSettings${$a9d56cc9eb6da380$var$defaultSuffix}.jspa`
    };
});
parcelRegister("fVyU8", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailVerifyRouteEntry", ()=>$9b39dfde7f648487$export$2fd491752a9501a2);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $12fby;
    const $9b39dfde7f648487$export$2fd491752a9501a2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("12fby")).globalSettingsSystemMailVerifyRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("12fby", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemMailVerifyRoute", ()=>$cc850105a8aef1d6$export$51b4ff8214b9fd7f);
    const $cc850105a8aef1d6$var$defaultSuffix = '([!%]?[\\w]*)';
    const $cc850105a8aef1d6$export$51b4ff8214b9fd7f = {
        name: 'global-settings-system-mail-verify',
        path: `/secure/admin/VerifyPopServerConnection${$cc850105a8aef1d6$var$defaultSuffix}.jspa`
    };
});
parcelRegister("di1Zu", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemPermissionsRouteEntry", ()=>$fd5827e16ef5b2df$export$9fe6a3bc70d75bae);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $hd4dX;
    const $fd5827e16ef5b2df$export$9fe6a3bc70d75bae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hd4dX")).globalSettingsSystemPermissionsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("hd4dX", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemPermissionsRoute", ()=>$fc01abfb6f31b6e8$export$1382458fd6826787);
    var $65Ltd;
    const $fc01abfb6f31b6e8$var$defaultSuffix = '([!%]?[\\w]*)';
    const $fc01abfb6f31b6e8$export$1382458fd6826787 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD),
        path: `/secure/admin/GlobalPermissions${$fc01abfb6f31b6e8$var$defaultSuffix}.jspa`
    };
});
parcelRegister("e1V9T", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRouteEntry", ()=>$ea52210a359c32ff$export$b78eddbedd30951d);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $gmPha;
    const $ea52210a359c32ff$export$b78eddbedd30951d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gmPha")).globalSettingsSystemProjectAssignSecurityRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("gmPha", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRoute", ()=>$9b5be9ad7eeb582d$export$f53750f3a4fc2fde);
    const $9b5be9ad7eeb582d$export$f53750f3a4fc2fde = {
        name: 'global-settings-system-project-assign-security',
        path: '/secure/project/AssignIssueSecuritySchemeProgress.jspa'
    };
});
parcelRegister("ckFGJ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemProjectDeleteRouteEntry", ()=>$4efd6d6039e3728c$export$849f3666529d049e);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $eLRSA;
    const $4efd6d6039e3728c$export$849f3666529d049e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eLRSA")).globalSettingsSystemProjectDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("eLRSA", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemProjectDeleteRoute", ()=>$d099a8b10095f557$export$f31d8748a56aa638);
    const $d099a8b10095f557$export$f31d8748a56aa638 = {
        name: 'global-settings-system-project-delete',
        path: '/secure/project/DeleteProject.jspa'
    };
});
parcelRegister("0PAJi", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemProjectSelectRouteEntry", ()=>$2ccf2e4b85e6faae$export$a1869de90837dac8);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $k24fu;
    const $2ccf2e4b85e6faae$export$a1869de90837dac8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k24fu")).globalSettingsSystemProjectSelectRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("k24fu", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemProjectSelectRoute", ()=>$e1035b65207178a4$export$8f44b9e5553dccec);
    const $e1035b65207178a4$var$defaultSuffix = '([!%]?[\\w]*)';
    const $e1035b65207178a4$export$8f44b9e5553dccec = {
        name: 'global-settings-system-project-select',
        path: `/secure/project/SelectProject(\\w*)${$e1035b65207178a4$var$defaultSuffix}.jspa`
    };
});
parcelRegister("7mtPT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesActorsRouteEntry", ()=>$f2a1e94669067a76$export$7dc567ad40905890);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $55Jq0;
    const $f2a1e94669067a76$export$7dc567ad40905890 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("55Jq0")).globalSettingsSystemRolesActorsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("55Jq0", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesActorsRoute", ()=>$59b7cb32bd5f59bf$export$3dca5fcf3b98db1e);
    var $65Ltd;
    const $59b7cb32bd5f59bf$var$defaultSuffix = '([!%]?[\\w]*)';
    const $59b7cb32bd5f59bf$export$3dca5fcf3b98db1e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS),
        path: `/secure/project/ViewDefaultProjectRoleActors${$59b7cb32bd5f59bf$var$defaultSuffix}.jspa`
    };
});
parcelRegister("5xSTz", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRouteEntry", ()=>$769e91d5446036da$export$ac1028baf6d1bd60);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $k2CBf;
    const $769e91d5446036da$export$ac1028baf6d1bd60 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k2CBf")).globalSettingsSystemRolesActorsGroupsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("k2CBf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRoute", ()=>$60851514273278e3$export$836f3cdea3e238a4);
    var $65Ltd;
    const $60851514273278e3$export$836f3cdea3e238a4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS),
        path: '/secure/project/GroupRoleActorAction.jspa'
    };
});
parcelRegister("hkGft", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRouteEntry", ()=>$818520335ffebdef$export$3186176f09045f35);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $1FpR6;
    const $818520335ffebdef$export$3186176f09045f35 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1FpR6")).globalSettingsSystemRolesActorsUsersRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("1FpR6", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRoute", ()=>$95a27eb82fc1b6da$export$119e823548eefd4f);
    var $65Ltd;
    const $95a27eb82fc1b6da$export$119e823548eefd4f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS),
        path: '/secure/project/UserRoleActorAction.jspa'
    };
});
parcelRegister("6BVPh", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesDeleteRouteEntry", ()=>$ecff85b90dd0ebdb$export$4f2756ef0230f213);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $7ZBdO;
    const $ecff85b90dd0ebdb$export$4f2756ef0230f213 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7ZBdO")).globalSettingsSystemRolesDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7ZBdO", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesDeleteRoute", ()=>$7b92150c7625a0d7$export$c4b2dba31a4a29c8);
    var $65Ltd;
    const $7b92150c7625a0d7$var$defaultSuffix = '([!%]?[\\w]*)';
    const $7b92150c7625a0d7$export$c4b2dba31a4a29c8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE),
        path: `/secure/project/DeleteProjectRole${$7b92150c7625a0d7$var$defaultSuffix}.jspa`
    };
});
parcelRegister("7DU6a", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesEditRouteEntry", ()=>$070c96bc33940ca8$export$18cfabcb0c0c21e5);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $2guZ4;
    const $070c96bc33940ca8$export$18cfabcb0c0c21e5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2guZ4")).globalSettingsSystemRolesEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("2guZ4", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesEditRoute", ()=>$74d153f854208056$export$88917fe447558e55);
    var $65Ltd;
    const $74d153f854208056$var$defaultSuffix = '([!%]?[\\w]*)';
    const $74d153f854208056$export$88917fe447558e55 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT),
        path: `/secure/project/EditProjectRole${$74d153f854208056$var$defaultSuffix}.jspa`
    };
});
parcelRegister("dAqez", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesUsageRouteEntry", ()=>$3efa15d4568e4858$export$d9f7c60572f36835);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $fjqtO;
    const $3efa15d4568e4858$export$d9f7c60572f36835 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fjqtO")).globalSettingsSystemRolesUsageRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("fjqtO", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesUsageRoute", ()=>$264f43dc33dce4df$export$91305e5cb99eb005);
    var $65Ltd;
    const $264f43dc33dce4df$var$defaultSuffix = '([!%]?[\\w]*)';
    const $264f43dc33dce4df$export$91305e5cb99eb005 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE),
        path: `/secure/project/ViewProjectRoleUsage${$264f43dc33dce4df$var$defaultSuffix}.jspa`
    };
});
parcelRegister("6GuVf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesViewRouteEntry", ()=>$fa26b1c467a0f773$export$47efc3b9a4cedfba);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $cBKGD;
    const $fa26b1c467a0f773$export$47efc3b9a4cedfba = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cBKGD")).globalSettingsSystemRolesViewRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("cBKGD", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemRolesViewRoute", ()=>$f873357149ed64bd$export$81d6a9112f47a229);
    var $65Ltd;
    const $f873357149ed64bd$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f873357149ed64bd$export$81d6a9112f47a229 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES),
        path: `/secure/project/ViewProjectRoles${$f873357149ed64bd$var$defaultSuffix}.jspa`
    };
});
parcelRegister("6PPXt", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemServicesRouteEntry", ()=>$4199e3982b0189c0$export$f08661656eef7ad1);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $7Uulf;
    const $4199e3982b0189c0$export$f08661656eef7ad1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7Uulf")).globalSettingsSystemServicesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("7Uulf", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemServicesRoute", ()=>$7354bf552c1cd350$export$a176af71f8d6d872);
    var $65Ltd;
    const $7354bf552c1cd350$export$a176af71f8d6d872 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES),
        path: '/secure/admin/ViewServices!default.jspa'
    };
});
parcelRegister("dizV4", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRouteEntry", ()=>$f56848ea185faee2$export$48cce4d971c37598);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $k9grl;
    const $f56848ea185faee2$export$48cce4d971c37598 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k9grl")).globalSettingsSystemSharedDashboardsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("k9grl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRoute", ()=>$1da37cab4d041f5a$export$64739c332d5146ba);
    var $65Ltd;
    const $1da37cab4d041f5a$export$64739c332d5146ba = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS),
        path: '/secure/admin/dashboards/ViewSharedDashboards.jspa'
    };
});
parcelRegister("fcvqo", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemSharedFiltersRouteEntry", ()=>$98491214f64384fa$export$6777672075f7d618);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $2O11T;
    const $98491214f64384fa$export$6777672075f7d618 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2O11T")).globalSettingsSystemSharedFiltersRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("2O11T", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemSharedFiltersRoute", ()=>$edc3bfff9a7c2c0d$export$684d93e5438fcd69);
    var $65Ltd;
    const $edc3bfff9a7c2c0d$export$684d93e5438fcd69 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS),
        path: '/secure/admin/filters/ViewSharedFilters.jspa'
    };
});
parcelRegister("5YP8f", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRouteEntry", ()=>$db101e38e31c58ad$export$dbe314c372e965d4);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $653n0;
    const $db101e38e31c58ad$export$dbe314c372e965d4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("653n0")).globalSettingsSystemUserInterfaceDashboardEditRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("653n0", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRoute", ()=>$94102da430dbf805$export$78c9a0475c2f9cd0);
    var $65Ltd;
    const $94102da430dbf805$export$78c9a0475c2f9cd0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT),
        path: '/secure/admin/jira/EditApplicationProperties!default.jspa'
    };
});
parcelRegister("k9lPR", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRouteEntry", ()=>$36e89d107e2b8f3a$export$7025983c5e996386);
    var $ibkIl;
    var $lmyls;
    var $2G9Bk;
    var $atU1t;
    var $20sTk;
    const $36e89d107e2b8f3a$export$7025983c5e996386 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("20sTk")).globalSettingsSystemUserInterfacePreferencesRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
            }
        }));
});
parcelRegister("20sTk", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRoute", ()=>$78951080b1607be1$export$6f46032e4fc13ea0);
    var $65Ltd;
    const $78951080b1607be1$export$6f46032e4fc13ea0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY),
        path: '/secure/admin/SetGlobalEmailPreference!default.jspa'
    };
});
parcelRegister("2KRqQ", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemWebhooksRouteEntry", ()=>$a06ce708b9e825e8$export$aff2563c719af2aa);
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $atU1t;
    var $ak0Ja;
    const $a06ce708b9e825e8$export$aff2563c719af2aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ak0Ja")).globalSettingsSystemWebhooksRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ]
        }));
});
parcelRegister("ak0Ja", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemWebhooksRoute", ()=>$b7757bb4d1abb476$export$2c20f3aef4ea16aa);
    var $65Ltd;
    const $b7757bb4d1abb476$export$2c20f3aef4ea16aa = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS),
        path: '/plugins/servlet/webhooks'
    };
});
parcelRegister("kfJc9", function(module, exports) {
    $parcel$export(module.exports, "legacyIssueRouteEntry", ()=>$27fd5684d11844a9$export$e8ba55056b4fde20);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $eOlBz;
    var $dxCvy;
    var $1WlLE;
    var $7GnDe;
    var $7pPkw;
    var $2K2lw;
    const $27fd5684d11844a9$export$e8ba55056b4fde20 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7pPkw")).legacyIssueRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            component: (0, (0, parcelRequire("2K2lw")).LegacyIssueView),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("7pPkw", function(module, exports) {
    $parcel$export(module.exports, "legacyIssueRoute", ()=>$d0eb77026637002b$export$71da6fcc13745fba);
    const $d0eb77026637002b$export$71da6fcc13745fba = {
        name: 'legacy-issue',
        path: '/browse/:issueKey(\\w+-\\d+)(.*)',
        query: [
            'jql!=(.+)',
            'filter!=(.+)'
        ]
    };
});
parcelRegister("2K2lw", function(module, exports) {
    $parcel$export(module.exports, "LegacyIssueView", ()=>$3e6f7c82e1ea76a6$export$34dc6596952b042c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QKrH;
    const $3e6f7c82e1ea76a6$export$34dc6596952b042c = (props)=>{
        const { route: route } = props;
        if (!route) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6QKrH")).LegacyPage), props));
    };
});
parcelRegister("hBU7y", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdCustomersRouteEntry", ()=>$5f2ef9795d2a09a0$export$f458747db287136e);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $5Urnv;
    var $6Z2mh;
    const $5f2ef9795d2a09a0$export$f458747db287136e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Urnv")).legacyJsdCustomersRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("5Urnv", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdCustomersRoute", ()=>$b1e8cf292bce8678$export$3af39e70a286821c);
    var $65Ltd;
    const $b1e8cf292bce8678$export$3af39e70a286821c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_CUSTOMERS),
        path: '/projects/:projectKey/customers'
    };
});
parcelRegister("4C3AQ", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdGettingStartedRouteEntry", ()=>$0c8c35a91a4b607c$export$3c4b4abb062b10e3);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $8m5cD;
    var $6Z2mh;
    const $0c8c35a91a4b607c$export$3c4b4abb062b10e3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8m5cD")).legacyJsdGettingStartedRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("8m5cD", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdGettingStartedRoute", ()=>$5692240bf7dfa890$export$71b946ee427d710);
    var $65Ltd;
    const $5692240bf7dfa890$export$71b946ee427d710 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED),
        path: '/projects/:projectKey/getting-started'
    };
});
parcelRegister("jmGsg", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdJiraAutomationRouteEntry", ()=>$83367be7a588130a$export$d2d1cb3e56d9ba93);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $dCBxg;
    var $6Z2mh;
    const $83367be7a588130a$export$d2d1cb3e56d9ba93 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dCBxg")).legacyJsdJiraAutomationRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("dCBxg", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdJiraAutomationRoute", ()=>$fab9f3f08b66d34b$export$7d38596d701d5776);
    var $65Ltd;
    const $fab9f3f08b66d34b$export$7d38596d701d5776 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION),
        path: '/servicedesk/admin/:projectKey/automation'
    };
});
parcelRegister("iR4bc", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdKnowledgeRouteEntry", ()=>$04c58825d49d012a$export$352579e39711e17);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $51Iju;
    var $6Z2mh;
    const $04c58825d49d012a$export$352579e39711e17 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("51Iju")).legacyJsdKnowledgeRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("51Iju", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdKnowledgeRoute", ()=>$eb1c53e515e35a1a$export$7c7fc282c0c143d);
    var $65Ltd;
    const $eb1c53e515e35a1a$export$7c7fc282c0c143d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE),
        path: '/projects/:projectKey/knowledge/:page?'
    };
});
parcelRegister("aE4J4", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdQueuesRouteEntry", ()=>$dc81ca888feff245$export$7c006e8310e2641a);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $ThBot;
    var $6Z2mh;
    const $dc81ca888feff245$export$7c006e8310e2641a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ThBot")).legacyJsdQueuesRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("ThBot", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdQueuesRoute", ()=>$1cf4a8d0bf4effc6$export$2d08dc2a8c573cf3);
    var $65Ltd;
    const $1cf4a8d0bf4effc6$export$2d08dc2a8c573cf3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_QUEUES),
        path: '/projects/:projectKey/queues/:custom(custom)?/:id?'
    };
});
parcelRegister("bItBj", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdQueuesManageRouteEntry", ()=>$399b31ebb4249a0e$export$cdabf798cd8727fd);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $19Rhv;
    var $6Z2mh;
    const $399b31ebb4249a0e$export$cdabf798cd8727fd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("19Rhv")).legacyJsdQueuesManageRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("19Rhv", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdQueuesManageRoute", ()=>$a19199090251bbc0$export$af365e550fae80);
    var $65Ltd;
    const $a19199090251bbc0$export$af365e550fae80 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE),
        path: '/projects/:projectKey/queues/manage'
    };
});
parcelRegister("hsLjW", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdReportsCustomRouteEntry", ()=>$51580901c9b3e7f3$export$e133645c1a4bdfe7);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $260Gr;
    var $6Z2mh;
    const $51580901c9b3e7f3$export$e133645c1a4bdfe7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("260Gr")).legacyJsdReportsCustomRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("260Gr", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdReportsCustomRoute", ()=>$ebd5d4fdf2788cce$export$e5d83d06029b0f71);
    var $65Ltd;
    const $ebd5d4fdf2788cce$export$e5d83d06029b0f71 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM),
        path: '/projects/:projectKey/reports/custom/:id?'
    };
});
parcelRegister("2U6zO", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdReportsRouteEntry", ()=>$e3e763d127f5cfc9$export$893692ad278d4aa2);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $l3DBT;
    var $6Z2mh;
    const $e3e763d127f5cfc9$export$893692ad278d4aa2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("l3DBT")).legacyJsdReportsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("l3DBT", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdReportsRoute", ()=>$053e4c985e273da2$export$253418b9005ff89e);
    var $65Ltd;
    const $053e4c985e273da2$export$253418b9005ff89e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_REPORTS),
        path: '/projects/:projectKey/reports/:reportType'
    };
});
parcelRegister("47ilh", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdSettingsFallbackRouteEntry", ()=>$090e2e6fac1d5c1a$export$f0bcff1cea783147);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $6C7Ud;
    var $6Z2mh;
    const $090e2e6fac1d5c1a$export$f0bcff1cea783147 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6C7Ud")).legacyJsdSettingsFallbackRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("6C7Ud", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdSettingsFallbackRoute", ()=>$0249a22cd7ac4e76$export$831971c91fbdcd5b);
    var $65Ltd;
    const $0249a22cd7ac4e76$export$831971c91fbdcd5b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK),
        path: '/servicedesk/admin/:projectKey/:adminOption'
    };
});
parcelRegister("4bfvE", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdSettingsLanguageRouteEntry", ()=>$ea44712975c8667b$export$d9063e63677bfd5d);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2qKkH;
    var $6Z2mh;
    const $ea44712975c8667b$export$d9063e63677bfd5d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2qKkH")).legacyJsdSettingsLanguageRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("2qKkH", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdSettingsLanguageRoute", ()=>$76864aafdb4c972e$export$453ac1bfce2eb20e);
    var $65Ltd;
    const $76864aafdb4c972e$export$453ac1bfce2eb20e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE),
        path: '/servicedesk/admin/:projectKey/language',
        exact: true
    };
});
parcelRegister("2s4t1", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRouteEntry", ()=>$6843f49f6be76875$export$492207df7adc0823);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $3Orqo;
    var $6Z2mh;
    const $6843f49f6be76875$export$492207df7adc0823 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3Orqo")).legacyJsdSettingsLanguagePagesRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("3Orqo", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRoute", ()=>$682b616411e09613$export$2fd783c1d45b1a9f);
    var $65Ltd;
    const $682b616411e09613$export$2fd783c1d45b1a9f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES),
        path: '/servicedesk/admin/:projectKey/language/:languageKey/:sidebarItemKey?'
    };
});
parcelRegister("cf68o", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdWidgetsRouteEntry", ()=>$c5ca250618286e99$export$8b6c493f34b243fb);
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5f9iu;
    var $6Z2mh;
    const $c5ca250618286e99$export$8b6c493f34b243fb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5f9iu")).legacyJsdWidgetsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("5f9iu", function(module, exports) {
    $parcel$export(module.exports, "legacyJsdWidgetsRoute", ()=>$418c65d94f7c4523$export$ecfee0d843d9f28a);
    var $65Ltd;
    const $418c65d94f7c4523$export$ecfee0d843d9f28a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_JSD_WIDGETS),
        path: '/servicedesk/admin/:projectKey/addon/:addonName',
        exact: true
    };
});
parcelRegister("6zerj", function(module, exports) {
    $parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRouteEntry", ()=>$6421434b76530c34$export$30ce3fd3c9377561);
    var $2BrOV;
    var $2G9Bk;
    var $hVeOC;
    const $6421434b76530c34$export$30ce3fd3c9377561 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hVeOC")).legacyPersonalSettingsAccessTokensRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("hVeOC", function(module, exports) {
    $parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRoute", ()=>$67baef07f5d2af66$export$49a90c7c39db3dd3);
    const $67baef07f5d2af66$export$49a90c7c39db3dd3 = {
        name: 'legacy-personal-settings-access-tokens',
        path: '/plugins/servlet/oauth/users/access-tokens'
    };
});
parcelRegister("fP5WF", function(module, exports) {
    $parcel$export(module.exports, "legacyPinRouteEntry", ()=>$ef475a11e4995b63$export$2311541dfc64683c);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $hazXq;
    const $ef475a11e4995b63$export$2311541dfc64683c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hazXq")).legacyPinRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("hazXq", function(module, exports) {
    $parcel$export(module.exports, "legacyPinRoute", ()=>$e3943f5e2d9ffc8c$export$5600fbce403620b6);
    var $65Ltd;
    const $e3943f5e2d9ffc8c$export$5600fbce403620b6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PIN),
        path: '/projects/:projectKey/issues/:issueKey?'
    };
});
parcelRegister("esrDU", function(module, exports) {
    $parcel$export(module.exports, "legacyPortfolioPagesRouteEntry", ()=>$8d2ac32a696a6f91$export$200d6f7de97d1e96);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $693Rd;
    const $8d2ac32a696a6f91$export$200d6f7de97d1e96 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("693Rd")).legacyPortfolioPagesRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            }
        }));
});
parcelRegister("693Rd", function(module, exports) {
    $parcel$export(module.exports, "legacyPortfolioPagesRoute", ()=>$efa4b56ca0dfb33c$export$c8591b40ac25c22d);
    const $efa4b56ca0dfb33c$export$c8591b40ac25c22d = {
        name: 'legacy-portfolio-pages',
        path: '/secure/PortfolioPlan(\\w+).jspa'
    };
});
parcelRegister("fScJq", function(module, exports) {
    $parcel$export(module.exports, "legacyPortfolioTeamRouteEntry", ()=>$3df44a33430b3580$export$67d1a57e72c969e);
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $fOkCy;
    const $3df44a33430b3580$export$67d1a57e72c969e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fOkCy")).legacyPortfolioTeamRoute), ()=>({
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            }
        }));
});
parcelRegister("fOkCy", function(module, exports) {
    $parcel$export(module.exports, "legacyPortfolioTeamRoute", ()=>$7546d3d5a631fc9c$export$b61cebfbe2ae0da2);
    const $7546d3d5a631fc9c$export$b61cebfbe2ae0da2 = {
        name: 'legacy-portfolio-team',
        path: '/secure/TeamManagement.jspa'
    };
});
parcelRegister("l6l6T", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesBambooRouteEntry", ()=>$45827b94edfb7f29$export$929a483dcf3c101d);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $hR9Tt;
    const $45827b94edfb7f29$export$929a483dcf3c101d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hR9Tt")).legacyProjectReleasesBambooRoute), ()=>({
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("hR9Tt", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesBambooRoute", ()=>$37206764eb977f9f$export$df7f0213f2f22fc8);
    var $65Ltd;
    const $37206764eb977f9f$var$defaultSuffix = '([!%]?[\\w]*)';
    const $37206764eb977f9f$export$df7f0213f2f22fc8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO),
        path: `/secure/ConfigureBambooRelease${$37206764eb977f9f$var$defaultSuffix}.jspa`
    };
});
parcelRegister("fZCTK", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesRouteEntry", ()=>$6f620917114d416e$export$5d0e55986ed5e2c9);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $akNUK;
    const $6f620917114d416e$export$5d0e55986ed5e2c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("akNUK")).legacyProjectReleasesRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("akNUK", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesRoute", ()=>$cedbd4f493193075$export$577b2cf03e294477);
    var $65Ltd;
    const $cedbd4f493193075$export$577b2cf03e294477 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES),
        path: '/projects/:projectKey/versions/:id?'
    };
});
parcelRegister("lkegl", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", ()=>$814f9cccb997567d$export$836428e7b33b6c6c);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $bNpF5;
    const $814f9cccb997567d$export$836428e7b33b6c6c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bNpF5")).legacyProjectReleasesNoteConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("bNpF5", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", ()=>$d48895a92de90c09$export$a9509017cabb1e30);
    var $65Ltd;
    const $d48895a92de90c09$export$a9509017cabb1e30 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG),
        path: '/secure/ConfigureReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
});
parcelRegister("9YVJw", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", ()=>$7128829a46a566d5$export$781dd53d465d270d);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $aQCpq;
    const $7128829a46a566d5$export$781dd53d465d270d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aQCpq")).legacyProjectReleasesNoteRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("aQCpq", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectReleasesNoteRoute", ()=>$86bd251198cbe0f7$export$6ef734887b6da0c8);
    var $65Ltd;
    const $86bd251198cbe0f7$export$6ef734887b6da0c8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE),
        path: '/secure/ReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
});
parcelRegister("7Aduu", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRouteEntry", ()=>$02d931c131b44269$export$256375c5bbf6166a);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $c2IUN;
    const $02d931c131b44269$export$256375c5bbf6166a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("c2IUN")).legacyProjectSettingsCollectorsAddRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("c2IUN", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRoute", ()=>$9b7723a8d7f461b5$export$a3909b9ad3f61ae6);
    var $65Ltd;
    const $9b7723a8d7f461b5$var$defaultSuffix = '([!%]?[\\w]*)';
    const $9b7723a8d7f461b5$export$a3909b9ad3f61ae6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD),
        path: `/secure/AddCollector${$9b7723a8d7f461b5$var$defaultSuffix}.jspa`,
        query: [
            'projectKey'
        ]
    };
});
parcelRegister("5Zo8J", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsRouteEntry", ()=>$20d38ca050005974$export$e3a7328abebdc329);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $dp0wu;
    const $20d38ca050005974$export$e3a7328abebdc329 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dp0wu")).legacyProjectSettingsCollectorsRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("dp0wu", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsRoute", ()=>$79a88b420898a3dd$export$956a041d0b6694e3);
    var $65Ltd;
    const $79a88b420898a3dd$var$defaultSuffix = '([!%]?[\\w]*)';
    const $79a88b420898a3dd$export$956a041d0b6694e3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS),
        path: `/secure/ViewCollectors${$79a88b420898a3dd$var$defaultSuffix}.jspa`,
        query: [
            'projectKey'
        ]
    };
});
parcelRegister("1IurR", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRouteEntry", ()=>$f815e5e3a9fa5955$export$10edcec0926752a6);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $lbBKO;
    const $f815e5e3a9fa5955$export$10edcec0926752a6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lbBKO")).legacyProjectSettingsCollectorsHelpRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("lbBKO", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRoute", ()=>$f9ddee20e16ca354$export$7433cef5cafafb17);
    var $65Ltd;
    const $f9ddee20e16ca354$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f9ddee20e16ca354$export$7433cef5cafafb17 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP),
        path: `/secure/InsertCollectorHelp${$f9ddee20e16ca354$var$defaultSuffix}.jspa`,
        query: [
            'projectKey'
        ]
    };
});
parcelRegister("7SWln", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRouteEntry", ()=>$1d524745d6b17201$export$7b10472641e87ea);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $49AKz;
    const $1d524745d6b17201$export$7b10472641e87ea = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("49AKz")).legacyProjectSettingsCollectorsViewRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("49AKz", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRoute", ()=>$f6080eedc72b7b3b$export$c3f8831257e68c5a);
    var $65Ltd;
    const $f6080eedc72b7b3b$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f6080eedc72b7b3b$export$c3f8831257e68c5a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW),
        path: `/secure/ViewCollector${$f6080eedc72b7b3b$var$defaultSuffix}.jspa`,
        query: [
            'projectKey'
        ]
    };
});
parcelRegister("dPtSd", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsConfigRouteEntry", ()=>$153586c76a11d3f4$export$3c4ea5135028082);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $fUN5z;
    const $153586c76a11d3f4$export$3c4ea5135028082 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fUN5z")).legacyProjectSettingsConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("fUN5z", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsConfigRoute", ()=>$51882fc8d01140d7$export$3403c95bb82037b2);
    var $65Ltd;
    const $51882fc8d01140d7$export$3403c95bb82037b2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG),
        path: '/plugins/servlet/project-config/:projectKey/:adminOption'
    };
});
parcelRegister("687JO", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsDeleteRouteEntry", ()=>$52965e921eb02378$export$f5fadab402705bc4);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $jYPgT;
    const $52965e921eb02378$export$f5fadab402705bc4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jYPgT")).legacyProjectSettingsDeleteRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("jYPgT", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsDeleteRoute", ()=>$15f90e6eede0724e$export$4e8f3a153f80bfa1);
    var $65Ltd;
    const $15f90e6eede0724e$var$secure = '(/secure/|/)';
    const $15f90e6eede0724e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $15f90e6eede0724e$export$4e8f3a153f80bfa1 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE),
        path: `${$15f90e6eede0724e$var$secure}project/DeleteProject${$15f90e6eede0724e$var$defaultSuffix}.jspa`,
        query: [
            'pid'
        ]
    };
});
parcelRegister("6Y9SN", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsDevRouteEntry", ()=>$9696e99902b39b44$export$bb5131b6203b8f3a);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $1gUmS;
    const $9696e99902b39b44$export$bb5131b6203b8f3a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1gUmS")).legacyProjectSettingsDevRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("1gUmS", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsDevRoute", ()=>$e16e5df4f5cb420a$export$d3fca8ea951ff47f);
    var $65Ltd;
    const $e16e5df4f5cb420a$export$d3fca8ea951ff47f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV),
        path: '/secure/ConfigureDevStatus.jspa',
        query: [
            'projectKey'
        ]
    };
});
parcelRegister("3rTLb", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsEditRouteEntry", ()=>$4b65f46e30af5f58$export$1b930b1155c7c95d);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2YT8O;
    const $4b65f46e30af5f58$export$1b930b1155c7c95d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2YT8O")).legacyProjectSettingsEditRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("2YT8O", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsEditRoute", ()=>$923ea048691e4f0e$export$69813bfb3aa0feb9);
    var $65Ltd;
    const $923ea048691e4f0e$var$secure = '(/secure/|/)';
    const $923ea048691e4f0e$var$defaultSuffix = '([!%]?[\\w]*)';
    const $923ea048691e4f0e$export$69813bfb3aa0feb9 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT),
        path: `${$923ea048691e4f0e$var$secure}project/EditProject${$923ea048691e4f0e$var$defaultSuffix}.jspa`,
        query: [
            'pid'
        ]
    };
});
parcelRegister("jUy8v", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsFieldsRouteEntry", ()=>$928d97e2429d521c$export$cf5230efac88ec18);
    $parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRouteEntry", ()=>$928d97e2429d521c$export$c7cd1115d3e90593);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $7x5iY;
    const $928d97e2429d521c$export$cf5230efac88ec18 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7x5iY")).legacyProjectSettingsFieldsRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $928d97e2429d521c$export$c7cd1115d3e90593 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7x5iY")).legacyProjectSettingsFieldsAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("7x5iY", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsFieldsRoute", ()=>$1a2964cf190416af$export$f8d801c531c09b6e);
    $parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRoute", ()=>$1a2964cf190416af$export$b45ad52ceda09b54);
    var $65Ltd;
    const $1a2964cf190416af$export$f8d801c531c09b6e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        path: '/plugins/servlet/project-config/:projectKey/fields'
    };
    const $1a2964cf190416af$export$b45ad52ceda09b54 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE),
        path: '/secure/admin/SelectFieldLayoutScheme!default.jspa'
    };
});
parcelRegister("llQfO", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRouteEntry", ()=>$922ed701755dd2af$export$ba112336170e9374);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $dz4U0;
    const $922ed701755dd2af$export$ba112336170e9374 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dz4U0")).legacyProjectSettingsIssueLayoutRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("dz4U0", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRoute", ()=>$3f8a9d3429376ea0$export$b9490f2a02690c81);
    var $65Ltd;
    const $3f8a9d3429376ea0$export$b9490f2a02690c81 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT),
        path: '/plugins/servlet/project-config/:projectKey/issuelayout'
    };
});
parcelRegister("kmoqG", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRouteEntry", ()=>$c1a1248cb0ceb9b3$export$50c072825de9f7ec);
    $parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRouteEntry", ()=>$c1a1248cb0ceb9b3$export$31f276ec8affeb65);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $9tX2Z;
    const $c1a1248cb0ceb9b3$export$50c072825de9f7ec = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tX2Z")).legacyProjectSettingsIssueSecurityRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $c1a1248cb0ceb9b3$export$31f276ec8affeb65 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tX2Z")).legacyProjectSettingsIssueSecurityAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("9tX2Z", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRoute", ()=>$949e463076966377$export$71aa1b769739b378);
    $parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRoute", ()=>$949e463076966377$export$8fb428d7ca4ce850);
    var $65Ltd;
    const $949e463076966377$export$71aa1b769739b378 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        path: '/plugins/servlet/project-config/:projectKey/issuesecurity'
    };
    const $949e463076966377$var$defaultSuffix = '([!%]?[\\w]*)';
    const $949e463076966377$export$8fb428d7ca4ce850 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE),
        path: `/secure/project/SelectProjectIssueSecurityScheme${$949e463076966377$var$defaultSuffix}.jspa`
    };
});
parcelRegister("bfZmE", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsIssueTypesRouteEntry", ()=>$2c2b1ae0eef40f34$export$664d9bccf509eab1);
    $parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRouteEntry", ()=>$2c2b1ae0eef40f34$export$997736bd2e54a14b);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $aE5b0;
    const $2c2b1ae0eef40f34$export$664d9bccf509eab1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aE5b0")).legacyProjectSettingsIssueTypesRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $2c2b1ae0eef40f34$export$997736bd2e54a14b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aE5b0")).legacyProjectSettingsIssueTypesAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("aE5b0", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsIssueTypesRoute", ()=>$b90c77538b7016e1$export$f22d4a1fbe6ce2d);
    $parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRoute", ()=>$b90c77538b7016e1$export$64a3a3a4a9e32ab2);
    var $65Ltd;
    const $b90c77538b7016e1$export$f22d4a1fbe6ce2d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        path: '/plugins/servlet/project-config/:projectKey/issuetypes'
    };
    const $b90c77538b7016e1$export$64a3a3a4a9e32ab2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE),
        path: '/secure/admin/SelectIssueTypeSchemeForProject!default.jspa'
    };
});
parcelRegister("3FzLz", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsNotificationsRouteEntry", ()=>$dc5235a22268fcf4$export$ec9c71381b367931);
    $parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRouteEntry", ()=>$dc5235a22268fcf4$export$756ebd18bdb87829);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $i1UFD;
    const $dc5235a22268fcf4$export$ec9c71381b367931 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("i1UFD")).legacyProjectSettingsNotificationsRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $dc5235a22268fcf4$export$756ebd18bdb87829 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("i1UFD")).legacyProjectSettingsNotificationsAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("i1UFD", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsNotificationsRoute", ()=>$b75e396ba8ac1594$export$3053634181f5a1e4);
    $parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRoute", ()=>$b75e396ba8ac1594$export$c3b586e70bfcdfe);
    var $65Ltd;
    const $b75e396ba8ac1594$export$3053634181f5a1e4 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        path: '/plugins/servlet/project-config/:projectKey/notifications'
    };
    const $b75e396ba8ac1594$export$c3b586e70bfcdfe = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE),
        path: '/secure/project/SelectProjectScheme!default.jspa'
    };
});
parcelRegister("kz3Cm", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsOpsgenieRouteEntry", ()=>$879cda26e0eefbd5$export$a0ee66fa0f02ab9a);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $hP3NO;
    const $879cda26e0eefbd5$export$a0ee66fa0f02ab9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hP3NO")).legacyProjectSettingsOpsgenieRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("hP3NO", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsOpsgenieRoute", ()=>$fc20c87107997710$export$9bc923c0dc9a3144);
    var $65Ltd;
    const $fc20c87107997710$export$9bc923c0dc9a3144 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE),
        path: '/plugins/servlet/project-config/:projectKey/opsgenie'
    };
});
parcelRegister("fJ7EK", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsPeopleRouteEntry", ()=>$7c8a75bbbc38fdd5$export$a3355a805216689d);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $6QKrH;
    var $70KdC;
    const $7c8a75bbbc38fdd5$export$a3355a805216689d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("70KdC")).legacyProjectSettingsPeopleRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("70KdC", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsPeopleRoute", ()=>$47a673033d010bae$export$69b69c5831576686);
    var $65Ltd;
    const $47a673033d010bae$export$69b69c5831576686 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        path: '/plugins/servlet/project-config/:projectKey/people'
    };
});
parcelRegister("jd9Qm", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsPermissionsRouteEntry", ()=>$160db87f3078d855$export$f941d7668bb5b4b9);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $6QKrH;
    var $di75P;
    const $160db87f3078d855$export$f941d7668bb5b4b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("di75P")).legacyProjectSettingsPermissionsRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            component: (0, (0, parcelRequire("6QKrH")).LegacyPage),
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("di75P", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsPermissionsRoute", ()=>$9475d3ad5b21db1d$export$e5e3b10fbd5b967);
    var $65Ltd;
    const $9475d3ad5b21db1d$export$e5e3b10fbd5b967 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        path: '/plugins/servlet/project-config/:projectKey/permissions'
    };
});
parcelRegister("llrP2", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsScreensRouteEntry", ()=>$a2fcc8690b1f6c1c$export$f0c4185be35123a4);
    $parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRouteEntry", ()=>$a2fcc8690b1f6c1c$export$c4a7c46acad95724);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $6jGx8;
    const $a2fcc8690b1f6c1c$export$f0c4185be35123a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6jGx8")).legacyProjectSettingsScreensRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $a2fcc8690b1f6c1c$export$c4a7c46acad95724 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6jGx8")).legacyProjectSettingsScreensAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("6jGx8", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsScreensRoute", ()=>$2eea33e8c04046dd$export$a132d85f94cbc75c);
    $parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRoute", ()=>$2eea33e8c04046dd$export$e97df9c9d8af2495);
    var $65Ltd;
    const $2eea33e8c04046dd$export$a132d85f94cbc75c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        path: '/plugins/servlet/project-config/:projectKey/screens'
    };
    const $2eea33e8c04046dd$export$e97df9c9d8af2495 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE),
        path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa'
    };
});
parcelRegister("5WsTv", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsSummaryRouteEntry", ()=>$184bd91b7cb87eea$export$b79434e4cc24dab2);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $lRlxc;
    const $184bd91b7cb87eea$export$b79434e4cc24dab2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lRlxc")).legacyProjectSettingsSummaryRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("lRlxc", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsSummaryRoute", ()=>$09db5ce1276fdef7$export$2c4b88224ff6b238);
    var $65Ltd;
    const $09db5ce1276fdef7$export$2c4b88224ff6b238 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY),
        path: '/plugins/servlet/project-config/:projectKey/summary'
    };
});
parcelRegister("61puu", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsWorkflowsRouteEntry", ()=>$0b95fd52eafb380a$export$a69fefbe6504422d);
    $parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRouteEntry", ()=>$0b95fd52eafb380a$export$496170aba3d2c90a);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $hBYvZ;
    const $0b95fd52eafb380a$export$a69fefbe6504422d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hBYvZ")).legacyProjectSettingsWorkflowsRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $0b95fd52eafb380a$export$496170aba3d2c90a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hBYvZ")).legacyProjectSettingsWorkflowsAssociateRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("hBYvZ", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", ()=>$510da77d28b54994$export$b03606cedffdadf6);
    $parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRoute", ()=>$510da77d28b54994$export$c70512e2d6fd53d);
    var $65Ltd;
    const $510da77d28b54994$export$b03606cedffdadf6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        path: '/plugins/servlet/project-config/:projectKey/workflows'
    };
    const $510da77d28b54994$export$c70512e2d6fd53d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
        path: '/secure/project/SelectProjectWorkflowScheme!default.jspa'
    };
});
parcelRegister("eMPkb", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsAverageAgeRouteEntry", ()=>$8afcf9d2bd3eede0$export$dae04c73273ef29a);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $kp1lo;
    var $6sPah;
    const $8afcf9d2bd3eede0$export$dae04c73273ef29a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kp1lo")).legacyReportsAverageAgeRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("6sPah")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("kp1lo", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsAverageAgeRoute", ()=>$d5b9c329933512e0$export$b40e93dd1042f869);
    var $65Ltd;
    const $d5b9c329933512e0$var$defaultSuffix = '([!%]?[\\w]*)';
    const $d5b9c329933512e0$export$b40e93dd1042f869 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE),
        path: `/secure/ConfigureReport${$d5b9c329933512e0$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:averageage-report'
        ]
    };
});
parcelRegister("6sPah", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$9ee2e9a72d658e32$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $9ee2e9a72d658e32$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $9ee2e9a72d658e32$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("1iPRl", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsConfigRouteEntry", ()=>$339e77cc7cf22f74$export$6dee3bbbe4ff04f);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $aXmBw;
    var $3WgkN;
    const $339e77cc7cf22f74$export$6dee3bbbe4ff04f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aXmBw")).legacyReportsConfigRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("3WgkN")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("aXmBw", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsConfigRoute", ()=>$92e554d4dd9bf7e1$export$b2ef61435fecef69);
    var $65Ltd;
    const $92e554d4dd9bf7e1$var$defaultSuffix = '([!%]?[\\w]*)';
    const $92e554d4dd9bf7e1$export$b2ef61435fecef69 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CONFIG),
        path: `/secure/ConfigureReport${$92e554d4dd9bf7e1$var$defaultSuffix}.jspa`,
        query: [
            'reportKey'
        ]
    };
});
parcelRegister("3WgkN", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$189e4bc2b233ebe2$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $189e4bc2b233ebe2$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $189e4bc2b233ebe2$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("lbAbl", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsCreatedVsResolvedRouteEntry", ()=>$9e227b740baedc87$export$b2ed165752bdb8e5);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $aA6SW;
    var $kJCHC;
    const $9e227b740baedc87$export$b2ed165752bdb8e5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aA6SW")).legacyReportsCreatedVsResolvedRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("kJCHC")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("aA6SW", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsCreatedVsResolvedRoute", ()=>$0b90dddfba61ee79$export$832846047e142646);
    var $65Ltd;
    const $0b90dddfba61ee79$var$defaultSuffix = '([!%]?[\\w]*)';
    const $0b90dddfba61ee79$export$832846047e142646 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED),
        path: `/secure/ConfigureReport${$0b90dddfba61ee79$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report'
        ]
    };
});
parcelRegister("kJCHC", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$07ae8c5e26d47517$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $07ae8c5e26d47517$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $07ae8c5e26d47517$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("1yecM", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsDeveloperWorkloadRouteEntry", ()=>$6bd0dd9e8f30e2b8$export$29e29cddbc430ebe);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $cOzH8;
    var $6sDGD;
    const $6bd0dd9e8f30e2b8$export$29e29cddbc430ebe = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cOzH8")).legacyReportsDeveloperWorkloadRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("6sDGD")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("cOzH8", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsDeveloperWorkloadRoute", ()=>$41d63ff3dda03378$export$a64e86bcf65b3432);
    var $65Ltd;
    const $41d63ff3dda03378$var$defaultSuffix = '([!%]?[\\w]*)';
    const $41d63ff3dda03378$export$a64e86bcf65b3432 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD),
        path: `/secure/ConfigureReport${$41d63ff3dda03378$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:developer-workload'
        ]
    };
});
parcelRegister("6sDGD", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$5468c4274e7a4fc6$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $5468c4274e7a4fc6$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $5468c4274e7a4fc6$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("ffqgy", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsPieRouteEntry", ()=>$d464647b2f3d6631$export$fd3a1495328fefba);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $kKEBV;
    var $l5bpw;
    const $d464647b2f3d6631$export$fd3a1495328fefba = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kKEBV")).legacyReportsPieRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("l5bpw")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("kKEBV", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsPieRoute", ()=>$f24c6e1e1ad50bbc$export$327da6ce208593c2);
    var $65Ltd;
    const $f24c6e1e1ad50bbc$var$defaultSuffix = '([!%]?[\\w]*)';
    const $f24c6e1e1ad50bbc$export$327da6ce208593c2 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_PIE),
        path: `/secure/ConfigureReport${$f24c6e1e1ad50bbc$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:pie-report'
        ]
    };
});
parcelRegister("l5bpw", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$03bf9879e83bb142$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $03bf9879e83bb142$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $03bf9879e83bb142$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("8AXFc", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsRecentlyCreatedRouteEntry", ()=>$7a0dc4faecab0a7b$export$666b8efa07780ffb);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $1yiSS;
    var $10Hh4;
    const $7a0dc4faecab0a7b$export$666b8efa07780ffb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1yiSS")).legacyReportsRecentlyCreatedRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("10Hh4")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("1yiSS", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsRecentlyCreatedRoute", ()=>$286ebd4a61886e46$export$f81f42a6de9ebb5a);
    var $65Ltd;
    const $286ebd4a61886e46$var$defaultSuffix = '([!%]?[\\w]*)';
    const $286ebd4a61886e46$export$f81f42a6de9ebb5a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED),
        path: `/secure/ConfigureReport${$286ebd4a61886e46$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'
        ]
    };
});
parcelRegister("10Hh4", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$60e3cc3cccc0d55e$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $60e3cc3cccc0d55e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $60e3cc3cccc0d55e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("kkkBS", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsResolutionTimeRouteEntry", ()=>$2783cc4fb0a8b2cb$export$53c5b89c8f6f5d76);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $efHVd;
    var $03epm;
    const $2783cc4fb0a8b2cb$export$53c5b89c8f6f5d76 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("efHVd")).legacyReportsResolutionTimeRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("03epm")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("efHVd", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsResolutionTimeRoute", ()=>$389553af269c701c$export$c27dcd4a756d7860);
    var $65Ltd;
    const $389553af269c701c$var$defaultSuffix = '([!%]?[\\w]*)';
    const $389553af269c701c$export$c27dcd4a756d7860 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME),
        path: `/secure/ConfigureReport${$389553af269c701c$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report'
        ]
    };
});
parcelRegister("03epm", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$2fbc10637fd48123$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $2fbc10637fd48123$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $2fbc10637fd48123$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("f620M", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsSingleLevelGroupByRouteEntry", ()=>$93ff03457f918015$export$80cd34d8b30c9fff);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $iobuJ;
    var $curbE;
    const $93ff03457f918015$export$80cd34d8b30c9fff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iobuJ")).legacyReportsSingleLevelGroupByRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("curbE")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("iobuJ", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsSingleLevelGroupByRoute", ()=>$81c601f412dab86c$export$4b7de6966d0318ae);
    var $65Ltd;
    const $81c601f412dab86c$var$defaultSuffix = '([!%]?[\\w]*)';
    const $81c601f412dab86c$export$4b7de6966d0318ae = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY),
        path: `/secure/ConfigureReport${$81c601f412dab86c$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby'
        ]
    };
});
parcelRegister("curbE", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$cccb613036f94172$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $cccb613036f94172$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $cccb613036f94172$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("78hVF", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsTimeSinceRouteEntry", ()=>$42dfa2b98993a4ee$export$c0837717e37bba3b);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $56qxu;
    var $4k3iT;
    const $42dfa2b98993a4ee$export$c0837717e37bba3b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("56qxu")).legacyReportsTimeSinceRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("4k3iT")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("56qxu", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsTimeSinceRoute", ()=>$509966c4afa6a0af$export$e9d8f7977a3e63a8);
    var $65Ltd;
    const $509966c4afa6a0af$var$defaultSuffix = '([!%]?[\\w]*)';
    const $509966c4afa6a0af$export$e9d8f7977a3e63a8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE),
        path: `/secure/ConfigureReport${$509966c4afa6a0af$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:timesince-report'
        ]
    };
});
parcelRegister("4k3iT", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$2bddc68cf89b666e$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $2bddc68cf89b666e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $2bddc68cf89b666e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("cZ7VE", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsTimeTrackingReportRouteEntry", ()=>$402d9ac1b2a5e82c$export$d911abc03d9aac0e);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $jMAt3;
    var $6arIg;
    const $402d9ac1b2a5e82c$export$d911abc03d9aac0e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jMAt3")).legacyReportsTimeTrackingReportRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("6arIg")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("jMAt3", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsTimeTrackingReportRoute", ()=>$ce26123647708051$export$5c05df6c5a65a436);
    var $65Ltd;
    const $ce26123647708051$var$defaultSuffix = '([!%]?[\\w]*)';
    const $ce26123647708051$export$5c05df6c5a65a436 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT),
        path: `/secure/ConfigureReport${$ce26123647708051$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugin.system.reports:time-tracking'
        ]
    };
});
parcelRegister("6arIg", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$d46a8656727f44dc$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $d46a8656727f44dc$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $d46a8656727f44dc$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("cQgjC", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsVersionWorkloadRouteEntry", ()=>$32422fe9cecf3b88$export$225a265884367582);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $b02DH;
    var $5VYNR;
    const $32422fe9cecf3b88$export$225a265884367582 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("b02DH")).legacyReportsVersionWorkloadRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("5VYNR")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("b02DH", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsVersionWorkloadRoute", ()=>$39e41b9e3ffe994b$export$b7a951738ffd54ac);
    var $65Ltd;
    const $39e41b9e3ffe994b$var$defaultSuffix = '([!%]?[\\w]*)';
    const $39e41b9e3ffe994b$export$b7a951738ffd54ac = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD),
        path: `/secure/ConfigureReport${$39e41b9e3ffe994b$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'
        ]
    };
});
parcelRegister("5VYNR", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$ab3ac09d2b00fa0e$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $ab3ac09d2b00fa0e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $ab3ac09d2b00fa0e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("l39a8", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsWorkloadPieRouteEntry", ()=>$b21127a1d35e58ff$export$371af7520206fe98);
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $dxCvy;
    var $7GnDe;
    var $ad34k;
    var $avo9P;
    const $b21127a1d35e58ff$export$371af7520206fe98 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ad34k")).legacyReportsWorkloadPieRoute), ()=>({
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("avo9P")).getReportsCommonResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("ad34k", function(module, exports) {
    $parcel$export(module.exports, "legacyReportsWorkloadPieRoute", ()=>$5b36f9b46c520dd1$export$e8a2e4a5ccbbeff6);
    var $65Ltd;
    const $5b36f9b46c520dd1$var$defaultSuffix = '([!%]?[\\w]*)';
    const $5b36f9b46c520dd1$export$e8a2e4a5ccbbeff6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE),
        path: `/secure/ConfigureReport${$5b36f9b46c520dd1$var$defaultSuffix}.jspa`,
        query: [
            'reportKey=com.atlassian.jira.ext.charting:workloadpie-report'
        ]
    };
});
parcelRegister("avo9P", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$3224e03e72e77e31$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $3224e03e72e77e31$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $3224e03e72e77e31$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("7atcL", function(module, exports) {
    $parcel$export(module.exports, "workflowDesignerRouteEntry", ()=>$c1c86a0ab4c775e9$export$5863c71049541219);
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $5YCZs;
    var $159aY;
    const $c1c86a0ab4c775e9$export$5863c71049541219 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5YCZs")).workflowDesignerRoute), ()=>({
            component: (0, (0, parcelRequire("159aY")).LegacyWorkflowDesigner),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)()
            ]
        }));
});
parcelRegister("5YCZs", function(module, exports) {
    $parcel$export(module.exports, "workflowDesignerRoute", ()=>$5e8a1e4d40946a90$export$7cd61529f5fa5e43);
    var $65Ltd;
    const $5e8a1e4d40946a90$export$7cd61529f5fa5e43 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
        path: '/secure/admin/(workflows/|)(WorkflowDesigner|ViewWorkflowSteps).jspa'
    };
});
parcelRegister("159aY", function(module, exports) {
    $parcel$export(module.exports, "LegacyWorkflowDesigner", ()=>$307a5b1ba1a50b29$export$c264c6032a3fa865);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $39xOx;
    var $6QKrH;
    var $8M7vf;
    const $307a5b1ba1a50b29$export$c264c6032a3fa865 = (props)=>{
        const elm = false ? null : globalThis.document?.getElementById('workflow-editor-preference-dropdown');
        const workflowId = elm?.getAttribute('data-workflow-id') ?? '';
        const workflowName = elm?.getAttribute('data-workflow-name') ?? '';
        const editMode = elm?.getAttribute('data-edit-mode') ?? undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jsm-dropdown-error-boundary",
            packageName: "jiraRouterRoutesLegacyWorkflowDesignerEntries",
            teamName: "jsd-shield",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6QKrH")).LegacyPage), props), elm && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8M7vf")).WorkflowEditorPreferenceDropdown), {
            workflowId: workflowId,
            workflowName: workflowName,
            editMode: editMode
        }), elm));
    };
});
parcelRegister("8M7vf", function(module, exports) {
    $parcel$export(module.exports, "WorkflowEditorPreferenceDropdown", ()=>$bbc7832248e4e47c$export$7194565c2a06a25d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $6Ingq;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $gz6NJ;
    var $4V5oU;
    var $lvRwX;
    var $4K5zd;
    var $8iMd2;
    const $bbc7832248e4e47c$export$7194565c2a06a25d = ({ workflowId: workflowId, workflowName: workflowName, editMode: editMode })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [showDialog, setShowDialog] = (0, $5uXOq.useState)(false);
        const openDialog = ()=>setShowDialog(true);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, (0, parcelRequire("lvRwX")).useChangeToOldEditorSuccessFlag)({
            openDefaultEditorDialog: openDialog
        });
        const fireTrackEvent = (0, $5uXOq.useCallback)((mode)=>{
            const dropdownItemClickEvent = createAnalyticsEvent({
                action: 'click',
                actionSubject: 'dropdownItem'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(dropdownItemClickEvent, 'workflowEditorToolbarNewEditorLink', {
                workflowLegacyEditMode: mode === 'draft' ? 'Draft' : 'Live'
            });
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            testId: "workflow-editor-preference-settings.ui.dropdown-menu",
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    ref: triggerRef,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($bbc7832248e4e47c$var$LegacyButtonText, null, formatMessage((0, (0, parcelRequire("8iMd2")).default).switchEditorButton)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            href: (0, (0, parcelRequire("gz6NJ")).getNewEditorLink)(workflowId),
            onClick: ()=>fireTrackEvent(editMode),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("8iMd2")).default).openInNewEditor)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: openDialog
        }, formatMessage((0, (0, parcelRequire("8iMd2")).default).changeDefaultEditor)))), showDialog && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4K5zd")).DefaultWorkflowEditorDialog), {
            workflowName: workflowName,
            workflowId: workflowId,
            workflowPublicationStatus: editMode === 'draft' ? (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Draft : (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Live,
            onClose: ()=>setShowDialog(false),
            onOpenDefaultEditorDialog: openDialog
        }));
    };
    const $bbc7832248e4e47c$var$LegacyButtonText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1nn1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("gz6NJ", function(module, exports) {
    $parcel$export(module.exports, "isRuleTypeConstrainedByProductOrScope", ()=>$cc944276ef5866fb$export$b5fede90e3f809d6);
    $parcel$export(module.exports, "isRuleTypeConstrainedByTransition", ()=>$cc944276ef5866fb$export$5a818ed7c804c8f1);
    $parcel$export(module.exports, "isRuleTypeConstrainedByAnotherRule", ()=>$cc944276ef5866fb$export$5ddc27f97380bfae);
    $parcel$export(module.exports, "orderStatusesByCategoryAndName", ()=>$cc944276ef5866fb$export$2068d124b6d003c3);
    $parcel$export(module.exports, "getLegacyEditorLink", ()=>$cc944276ef5866fb$export$ff5bc033c9b0efb4);
    $parcel$export(module.exports, "getNewEditorLink", ()=>$cc944276ef5866fb$export$540456165b615498);
    $parcel$export(module.exports, "openLegacyEditor", ()=>$cc944276ef5866fb$export$766368a57fd33bad);
    $parcel$export(module.exports, "buildEditWorkflowJSPUrl", ()=>$cc944276ef5866fb$export$2e17b62c233ea33b);
    $parcel$export(module.exports, "conditionallyNarrowType", ()=>$cc944276ef5866fb$export$1a907429044213b9);
    $parcel$export(module.exports, "findRuleDefinitionForConfiguredRule", ()=>$cc944276ef5866fb$export$5abcac058edd2986);
    var $7qDUb = parcelRequire("7qDUb");
    var $ebyGx = parcelRequire("ebyGx");
    var $4tcSU;
    var $lUJY8;
    const $cc944276ef5866fb$export$b5fede90e3f809d6 = (ruleType, projectType, appEdition, scope)=>{
        if (scope === (0, (0, parcelRequire("lUJY8")).SCOPE_GLOBAL)) return !ruleType.constraints.scope.includes(scope);
        if (!ruleType.constraints.scope.includes(scope)) return true;
        const compatibleProductConstraint = ruleType.constraints.compatibleProducts.find((product)=>product.type === projectType);
        return compatibleProductConstraint ? !compatibleProductConstraint.editions.includes(appEdition) : true;
    };
    const $cc944276ef5866fb$export$5a818ed7c804c8f1 = (ruleType, transition)=>transition ? !ruleType.constraints.availableForInitial && transition.type === (0, (0, parcelRequire("lUJY8")).transitionType).INITIAL : false;
    const $cc944276ef5866fb$export$5ddc27f97380bfae = (ruleType, rules)=>rules.some((rule)=>ruleType.constraints.incompatibleRules.some((constraint)=>rule.ruleKey === constraint.qualifiedKey));
    const $cc944276ef5866fb$export$2068d124b6d003c3 = (statuses)=>(0, ($parcel$interopDefault($7qDUb)))(statuses, [
            (status)=>(0, (0, parcelRequire("lUJY8")).STATUS_CATEGORY_WEIGHTS)[status.statusCategory],
            'name'
        ]);
    const $cc944276ef5866fb$export$ff5bc033c9b0efb4 = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?workflowMode=live&wfName=${encodeURIComponent(workflowName)}`;
    const $cc944276ef5866fb$export$540456165b615498 = (workflowId)=>`/jira/settings/issues/workflows/${workflowId}`;
    const $cc944276ef5866fb$export$766368a57fd33bad = (workflowName)=>{
        const url = $cc944276ef5866fb$export$ff5bc033c9b0efb4(workflowName);
        window.location.href = url;
    };
    const $cc944276ef5866fb$export$2e17b62c233ea33b = (workflowName)=>`/secure/admin/workflows/EditWorkflowDispatcher.jspa?${(0, ($parcel$interopDefault($ebyGx))).stringify({
            atl_token: (0, (0, parcelRequire("4tcSU")).default)(),
            wfName: workflowName
        })}`;
    const $cc944276ef5866fb$export$1a907429044213b9 = (value, condition)=>condition;
    const $cc944276ef5866fb$export$5abcac058edd2986 = (rule, availableRules)=>{
        const ruleKey = rule.ruleKey;
        if (ruleKey.startsWith('connect')) {
            const appKey = rule.config.appKey;
            return availableRules.find((definition)=>definition.variety === 'connect' && definition.key === ruleKey && definition.appKey === appKey);
        }
        return availableRules.find((definition)=>definition.key === ruleKey);
    };
});
parcelRegister("lUJY8", function(module, exports) {
    $parcel$export(module.exports, "START_NODE_ID", ()=>$9b2ad0bd1b0ec248$export$e117396b0784c7cc);
    $parcel$export(module.exports, "transitionType", ()=>$9b2ad0bd1b0ec248$export$331d6399b2e33350);
    $parcel$export(module.exports, "transitionIcon", ()=>$9b2ad0bd1b0ec248$export$bb55b5bf71d8edff);
    $parcel$export(module.exports, "SCOPE_GLOBAL", ()=>$9b2ad0bd1b0ec248$export$9bb188cec3fcc43d);
    $parcel$export(module.exports, "SCOPE_PROJECT", ()=>$9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43);
    $parcel$export(module.exports, "ALL_OPERATION", ()=>$9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5);
    $parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", ()=>$9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e);
    $parcel$export(module.exports, "ANY_OPERATION", ()=>$9b2ad0bd1b0ec248$export$804f62993e553350);
    $parcel$export(module.exports, "errorSeverity", ()=>$9b2ad0bd1b0ec248$export$927c560a42a52ce0);
    var $gULOk;
    const $9b2ad0bd1b0ec248$export$e117396b0784c7cc = 'START';
    const $9b2ad0bd1b0ec248$export$331d6399b2e33350 = {
        INITIAL: 'INITIAL',
        GLOBAL: 'GLOBAL',
        DIRECTED: 'DIRECTED'
    };
    const $9b2ad0bd1b0ec248$export$bb55b5bf71d8edff = {
        BOLT: 'bolt',
        ERROR: 'error',
        CHECK: 'check',
        CHECK_INACTIVE: 'check_inactive',
        CROSS: 'cross',
        CROSS_INACTIVE: 'cross_inactive'
    };
    const $9b2ad0bd1b0ec248$export$9bb188cec3fcc43d = 'GLOBAL';
    const $9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43 = 'PROJECT';
    const $9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5 = 'ALL';
    const $9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e = {
        [(0, (0, parcelRequire("gULOk")).TODO)]: 1,
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 2,
        [(0, (0, parcelRequire("gULOk")).DONE)]: 3,
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 4
    };
    const $9b2ad0bd1b0ec248$export$804f62993e553350 = 'ANY';
    const $9b2ad0bd1b0ec248$export$927c560a42a52ce0 = {
        WARNING: 'WARNING',
        ERROR: 'ERROR'
    };
});
parcelRegister("gULOk", function(module, exports) {
    $parcel$export(module.exports, "UNDEFINED", ()=>$e77315bf13f8b83b$export$6db089fe7b26f5b6);
    $parcel$export(module.exports, "TODO", ()=>$e77315bf13f8b83b$export$aa456a5030160740);
    $parcel$export(module.exports, "IN_PROGRESS", ()=>$e77315bf13f8b83b$export$5a9ac66c2785cc13);
    $parcel$export(module.exports, "DONE", ()=>$e77315bf13f8b83b$export$71efb3495f6084f2);
    $parcel$export(module.exports, "STATUS_CATEGORIES", ()=>$e77315bf13f8b83b$export$d9119300f9d9a815);
    $parcel$export(module.exports, "StatusCategoryTypes", ()=>$e77315bf13f8b83b$export$5d42a08d46cffe7);
    $parcel$export(module.exports, "StatusCategoryIds", ()=>$e77315bf13f8b83b$export$3f42f49c284d5b58);
    $parcel$export(module.exports, "statusCategoryKeys", ()=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb);
    $parcel$export(module.exports, "statusCategoryForId", ()=>$e77315bf13f8b83b$export$3e9e3002956ff4fb);
    $parcel$export(module.exports, "categoryIdForStatusCategory", ()=>$e77315bf13f8b83b$export$7b16b0022aac2d46);
    $parcel$export(module.exports, "isValidStatusCategoryKey", ()=>$e77315bf13f8b83b$export$d928f247c903643a);
    const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
    const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
    const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
    const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
    const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
        $e77315bf13f8b83b$export$6db089fe7b26f5b6,
        $e77315bf13f8b83b$export$aa456a5030160740,
        $e77315bf13f8b83b$export$5a9ac66c2785cc13,
        $e77315bf13f8b83b$export$71efb3495f6084f2
    ];
    const $e77315bf13f8b83b$var$statusCategories = [
        {
            id: '1',
            statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
        },
        {
            id: '2',
            statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
        },
        {
            id: '4',
            statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
        },
        {
            id: '3',
            statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
        }
    ];
    const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
        NEW: 'new',
        INDETERMINATE: 'indeterminate',
        DONE: 'done',
        UNDEFINED: 'undefined'
    });
    const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
    });
    const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
    const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
        return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
    };
    const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
        return Number(value ? value.id : '1');
    };
    const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);
});
parcelRegister("4V5oU", function(module, exports) {
    $parcel$export(module.exports, "NEW_EDITOR", ()=>$7efae616b0ea1988$export$83282786ca4b04f);
    $parcel$export(module.exports, "LEGACY_EDITOR", ()=>$7efae616b0ea1988$export$e2f196e116d3fca2);
    $parcel$export(module.exports, "WorkflowPublicationStatus", ()=>$7efae616b0ea1988$export$8b8b078375514ab6);
    const $7efae616b0ea1988$export$83282786ca4b04f = 'NEW';
    const $7efae616b0ea1988$export$e2f196e116d3fca2 = 'LEGACY';
    var $7efae616b0ea1988$export$8b8b078375514ab6;
    (function(WorkflowPublicationStatus) {
        WorkflowPublicationStatus[WorkflowPublicationStatus["None"] = 0] = "None";
        WorkflowPublicationStatus[WorkflowPublicationStatus["Dirty"] = 1] = "Dirty";
        WorkflowPublicationStatus[WorkflowPublicationStatus["Draft"] = 2] = "Draft";
        WorkflowPublicationStatus[WorkflowPublicationStatus["Live"] = 3] = "Live";
    })($7efae616b0ea1988$export$8b8b078375514ab6 || ($7efae616b0ea1988$export$8b8b078375514ab6 = {}));
});
parcelRegister("lvRwX", function(module, exports) {
    $parcel$export(module.exports, "useChangeToOldEditorSuccessFlag", ()=>$39b45d28dcfb29ea$export$4a8a957b814cf4be);
    var $5uXOq = parcelRequire("5uXOq");
    var $cnlW7;
    var $4mIB9;
    const $39b45d28dcfb29ea$export$4a8a957b814cf4be = ({ openDefaultEditorDialog: openDefaultEditorDialog })=>{
        const { showOldEditorSuccessFlag: showOldEditorSuccessFlag } = (0, (0, parcelRequire("4mIB9")).useChangePreferenceFlag)();
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("cnlW7")).getShouldShowOldEditorSucccessFlag)()) {
                (0, (0, parcelRequire("cnlW7")).clearShowOldEditorSucccessFlag)();
                showOldEditorSuccessFlag(openDefaultEditorDialog);
            }
        }, [
            openDefaultEditorDialog,
            showOldEditorSuccessFlag
        ]);
        return {
            showOldEditorSuccessFlag: showOldEditorSuccessFlag
        };
    };
});
parcelRegister("cnlW7", function(module, exports) {
    $parcel$export(module.exports, "getShouldShowNewEditorSucccessFlag", ()=>$96ba05cf4b39267e$export$b33dd94e7d4068a9);
    $parcel$export(module.exports, "setShowNewEditorSuccessFlag", ()=>$96ba05cf4b39267e$export$38de37b600fe15c7);
    $parcel$export(module.exports, "clearShowNewEditorSucccessFlag", ()=>$96ba05cf4b39267e$export$10794e9068b437c1);
    $parcel$export(module.exports, "getShouldShowOldEditorSucccessFlag", ()=>$96ba05cf4b39267e$export$b07da7bcc8c25b1a);
    $parcel$export(module.exports, "clearShowOldEditorSucccessFlag", ()=>$96ba05cf4b39267e$export$385473acd3052995);
    $parcel$export(module.exports, "setShowOldEditorSuccessFlag", ()=>$96ba05cf4b39267e$export$baea524121407210);
    const $96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG = 'SHOW_NEW_EDITOR_SUCCESS_FLAG';
    const $96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG = 'SHOW_OLD_EDITOR_SUCCESS_FLAG';
    const $96ba05cf4b39267e$var$updateShowNewEditorSucccessFlag = (value)=>{
        sessionStorage.setItem($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString());
    };
    const $96ba05cf4b39267e$export$b33dd94e7d4068a9 = ()=>Boolean(sessionStorage.getItem($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG));
    const $96ba05cf4b39267e$export$38de37b600fe15c7 = ()=>{
        $96ba05cf4b39267e$var$updateShowNewEditorSucccessFlag(true);
    };
    const $96ba05cf4b39267e$export$10794e9068b437c1 = ()=>{
        sessionStorage.removeItem($96ba05cf4b39267e$var$SHOW_NEW_EDITOR_SUCCESS_FLAG);
    };
    const $96ba05cf4b39267e$var$updateShowOldEditorSucccessFlag = (value)=>{
        sessionStorage.setItem($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG, value.toString());
    };
    const $96ba05cf4b39267e$export$b07da7bcc8c25b1a = ()=>Boolean(sessionStorage.getItem($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG));
    const $96ba05cf4b39267e$export$385473acd3052995 = ()=>{
        sessionStorage.removeItem($96ba05cf4b39267e$var$SHOW_OLD_EDITOR_ERROR_FLAG);
    };
    const $96ba05cf4b39267e$export$baea524121407210 = ()=>{
        $96ba05cf4b39267e$var$updateShowOldEditorSucccessFlag(true);
    };
});
parcelRegister("4mIB9", function(module, exports) {
    $parcel$export(module.exports, "useChangePreferenceFlag", ()=>$b701d8a31f793729$export$cb7da29550cd2317);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $pa9q9;
    var $1kCbH;
    const $b701d8a31f793729$var$NEW_EDITOR_SUCCESS_FLAG = 'new-editor-success-flag';
    const $b701d8a31f793729$var$learnMoreLinkNewEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
    const $b701d8a31f793729$var$learnMoreLinkOldEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/changing-your-default-workflow-editor/';
    const $b701d8a31f793729$export$cb7da29550cd2317 = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const onClickLearnMoreOldEditor = ()=>{
            window.open($b701d8a31f793729$var$learnMoreLinkOldEditor, '_blank');
        };
        const onClickLearnMoreNewEditor = ()=>{
            window.open($b701d8a31f793729$var$learnMoreLinkNewEditor, '_blank');
        };
        const showNewEditorSuccessFlag = (0, $5uXOq.useCallback)(()=>showFlag({
                id: $b701d8a31f793729$var$NEW_EDITOR_SUCCESS_FLAG,
                testId: 'workflow-editor-preference-settings.ui.success-flag',
                type: 'success',
                title: (0, (0, parcelRequire("1kCbH")).default).changeToNewEditorTitle,
                description: (0, (0, parcelRequire("1kCbH")).default).changeToNewEditorDescription,
                actions: [
                    {
                        content: (0, (0, parcelRequire("1kCbH")).default).learnMore,
                        onClick: onClickLearnMoreNewEditor
                    },
                    {
                        content: (0, (0, parcelRequire("1kCbH")).default).ok,
                        onClick: ()=>dismissFlag($b701d8a31f793729$var$NEW_EDITOR_SUCCESS_FLAG)
                    }
                ]
            }), [
            dismissFlag,
            showFlag
        ]);
        const showOldEditorSuccessFlag = (0, $5uXOq.useCallback)((openDefaultEditorDialog = (0, ($parcel$interopDefault($8Rkzz))))=>showFlag({
                type: 'success',
                title: (0, (0, parcelRequire("1kCbH")).default).changeToOldEditorTitle,
                description: (0, (0, parcelRequire("1kCbH")).default).changeToOldEditorDescription,
                actions: [
                    {
                        content: (0, (0, parcelRequire("1kCbH")).default).learnMore,
                        onClick: onClickLearnMoreOldEditor
                    },
                    {
                        content: (0, (0, parcelRequire("1kCbH")).default).switchToNewEditor,
                        onClick: openDefaultEditorDialog
                    }
                ]
            }), [
            showFlag
        ]);
        const showErrorFlag = (0, $5uXOq.useCallback)(()=>showFlag({
                type: 'error',
                title: (0, (0, parcelRequire("1kCbH")).default).updatePreferenceErrorFlagTitle,
                description: (0, (0, parcelRequire("1kCbH")).default).updatePreferenceErrorFlagDescription
            }), [
            showFlag
        ]);
        return {
            showNewEditorSuccessFlag: showNewEditorSuccessFlag,
            showOldEditorSuccessFlag: showOldEditorSuccessFlag,
            showErrorFlag: showErrorFlag
        };
    };
});
parcelRegister("1kCbH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94546695a392f955$export$2e2bcd8739ae039);
    var $7VHMR;
    var $94546695a392f955$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeToOldEditorTitle: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-title",
            "defaultMessage": "You've changed the default editor"
        },
        changeToOldEditorDescription: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-description",
            "defaultMessage": "You can use the old editor as needed while we continue building the new editor."
        },
        learnMore: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.learn-more",
            "defaultMessage": "Learn more"
        },
        switchToNewEditor: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.switch-to-new-editor",
            "defaultMessage": "Switch to new editor"
        },
        changeToNewEditorTitle: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-title",
            "defaultMessage": "Welcome to the new workflow editor"
        },
        changeToNewEditorDescription: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-description",
            "defaultMessage": "Enjoy a faster, cleaner, more intuitive experience while creating and editing your workflows."
        },
        ok: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.ok",
            "defaultMessage": "Ok"
        },
        updatePreferenceErrorFlagTitle: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-title",
            "defaultMessage": "We couldn't update your default editor"
        },
        updatePreferenceErrorFlagDescription: {
            "id": "workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-description",
            "defaultMessage": "Select Confirm to try again."
        }
    });
});
parcelRegister("4K5zd", function(module, exports) {
    $parcel$export(module.exports, "DefaultWorkflowEditorDialog", ()=>$b3e3e3cfc7953167$export$6e60a479812ee7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $gtreQ;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $jouoW;
    var $9fuVs;
    var $65Ltd;
    var $39xOx;
    var $ousew;
    var $koVbs;
    var $gz6NJ;
    var $dIdda = parcelRequire("dIdda");
    var $4V5oU;
    var $4mIB9;
    var $f2tXr;
    var $aw33P;
    var $e6zF8;
    var $cnlW7;
    var $ltuRg = parcelRequire("ltuRg");
    var $aNzpN = parcelRequire("aNzpN");
    var $2ogCC;
    var $b3e3e3cfc7953167$export$759a75979ec109e2;
    (function(WarningType) {
        WarningType[WarningType["None"] = 0] = "None";
        WarningType[WarningType["Dirty"] = 1] = "Dirty";
        WarningType[WarningType["Draft"] = 2] = "Draft";
    })($b3e3e3cfc7953167$export$759a75979ec109e2 || ($b3e3e3cfc7953167$export$759a75979ec109e2 = {}));
    const $b3e3e3cfc7953167$var$DefaultWorkflowEditorDialogInner = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, workflowPublicationStatus: workflowPublicationStatus = (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [selectedWorkflowEditor, setSelectedWorkflowEditor] = (0, $5uXOq.useState)(null);
        const [{ route: route }] = (0, $dIdda.useRouter)();
        const { userPreference: userPreference } = (0, (0, parcelRequire("f2tXr")).useNewWorkflowEditorPreference)();
        const { showNewEditorSuccessFlag: showNewEditorSuccessFlag, showOldEditorSuccessFlag: showOldEditorSuccessFlag, showErrorFlag: showErrorFlag } = (0, (0, parcelRequire("4mIB9")).useChangePreferenceFlag)();
        (0, $5uXOq.useEffect)(()=>{
            setSelectedWorkflowEditor(userPreference);
        }, [
            userPreference,
            setSelectedWorkflowEditor
        ]);
        const redirectToLegacyEditorAndShowSuccessFlag = (0, $5uXOq.useCallback)(()=>{
            if (route?.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW)) showOldEditorSuccessFlag(onOpenDefaultEditorDialog);
            else {
                (0, (0, parcelRequire("cnlW7")).setShowOldEditorSuccessFlag)();
                window.location.assign(shouldRedirectToDraftMode ? (0, (0, parcelRequire("gz6NJ")).buildEditWorkflowJSPUrl)(workflowName) : (0, (0, parcelRequire("gz6NJ")).getLegacyEditorLink)(workflowName));
            }
        }, [
            route?.name,
            shouldRedirectToDraftMode,
            showOldEditorSuccessFlag,
            workflowName,
            onOpenDefaultEditorDialog
        ]);
        const redirectToNewEditorAndShowSuccessFlag = (0, $5uXOq.useCallback)(()=>{
            if (route?.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT)) showNewEditorSuccessFlag();
            else {
                (0, (0, parcelRequire("cnlW7")).setShowNewEditorSuccessFlag)();
                route?.name !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT) && workflowId && window.location.assign((0, (0, parcelRequire("gz6NJ")).getNewEditorLink)(workflowId));
            }
        }, [
            route?.name,
            showNewEditorSuccessFlag,
            workflowId
        ]);
        const { renderFeedbackDialog: renderFeedbackDialog } = (0, (0, parcelRequire("aw33P")).useOptOutFeedbackDialog)({
            projectType: projectType,
            onClose: redirectToLegacyEditorAndShowSuccessFlag
        });
        const onSelectNew = ()=>setSelectedWorkflowEditor((0, (0, parcelRequire("4V5oU")).NEW_EDITOR));
        const onSelectOld = ()=>setSelectedWorkflowEditor((0, (0, parcelRequire("4V5oU")).LEGACY_EDITOR));
        const onConfirmButtonClicked = (0, $5uXOq.useCallback)(async (_, analyticsEvent)=>{
            try {
                if (selectedWorkflowEditor === (0, (0, parcelRequire("4V5oU")).LEGACY_EDITOR)) {
                    await (0, (0, parcelRequire("e6zF8")).changeDefaultWorkflowEditorToLegacy)(analyticsEvent, workflowPublicationStatus);
                    renderFeedbackDialog();
                }
                if (selectedWorkflowEditor === (0, (0, parcelRequire("4V5oU")).NEW_EDITOR)) {
                    await (0, (0, parcelRequire("e6zF8")).changeDefaultWorkflowEditorToNew)(analyticsEvent, workflowPublicationStatus);
                    redirectToNewEditorAndShowSuccessFlag();
                }
                onClose();
            } catch (error) {
                showErrorFlag();
            }
        }, [
            selectedWorkflowEditor,
            onClose,
            renderFeedbackDialog,
            redirectToNewEditorAndShowSuccessFlag,
            showErrorFlag,
            workflowPublicationStatus
        ]);
        const link = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
        const learnMoreLink = formatMessage((0, (0, parcelRequire("2ogCC")).default).learnMoreLink, {
            a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: link,
                    target: "_blank"
                }, chunks)
        });
        const shouldShowWarningMessage = workflowPublicationStatus === (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Draft || workflowPublicationStatus === (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Dirty;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            width: "medium",
            shouldCloseOnOverlayClick: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.title"
        }, formatMessage((0, (0, parcelRequire("2ogCC")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2ogCC")).default).body), (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$Info, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, learnMoreLink)), (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$Instruction, null, formatMessage((0, (0, parcelRequire("2ogCC")).default).instruction)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3e3e3cfc7953167$var$boxStyles,
            onClick: onSelectNew,
            backgroundColor: selectedWorkflowEditor === (0, (0, parcelRequire("4V5oU")).NEW_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.new-editor-radio"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
            isChecked: selectedWorkflowEditor === (0, (0, parcelRequire("4V5oU")).NEW_EDITOR),
            ariaLabel: "New editor radio"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$RadioIcon, {
            src: (0, ($parcel$interopDefault($ltuRg))),
            alt: "new editor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2ogCC")).default).newWorkflowEditor))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3e3e3cfc7953167$var$boxStyles,
            onClick: onSelectOld,
            padding: "space.200",
            backgroundColor: selectedWorkflowEditor === (0, (0, parcelRequire("4V5oU")).LEGACY_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
            isChecked: selectedWorkflowEditor === (0, (0, parcelRequire("4V5oU")).LEGACY_EDITOR),
            ariaLabel: "Old editor radio"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$RadioIcon, {
            src: (0, ($parcel$interopDefault($aNzpN))),
            alt: "old editor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2ogCC")).default).oldWorkflowEditor)))), shouldShowWarningMessage && (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$WarningContainer, {
            role: "alert"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            size: "medium",
            label: "Warning",
            primaryColor: `var(--ds-text-warning, ${(0, $829f609a65d26a98$exports).Y300})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$WarningText, null, workflowPublicationStatus === (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Draft && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2ogCC")).default).draftUnpublishedWarning), workflowPublicationStatus === (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Dirty && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("2ogCC")).default).dirtyLossWarning,
            values: {
                workflowName: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, workflowName),
                update: (0, ($parcel$interopDefault($5uXOq))).createElement("i", null, formatMessage((0, (0, parcelRequire("2ogCC")).default).updateButton)),
                cancel: (0, ($parcel$interopDefault($5uXOq))).createElement("i", null, formatMessage((0, (0, parcelRequire("2ogCC")).default).cancelButton))
            }
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage((0, (0, parcelRequire("2ogCC")).default).cancelButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onConfirmButtonClicked,
            isDisabled: userPreference === selectedWorkflowEditor,
            appearance: "primary",
            testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.confirm-button"
        }, formatMessage((0, (0, parcelRequire("2ogCC")).default).confirmButton)))));
    };
    const $b3e3e3cfc7953167$export$6e60a479812ee7d6 = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, workflowPublicationStatus: workflowPublicationStatus = (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jsm-error-boundary-default-workflow-editor-dialog",
            packageName: "workflow-editor-preference-settings",
            teamName: "jsd-shield",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b3e3e3cfc7953167$var$DefaultWorkflowEditorDialogInner, {
            workflowName: workflowName,
            projectType: projectType,
            onClose: onClose,
            onOpenDefaultEditorDialog: onOpenDefaultEditorDialog,
            workflowId: workflowId,
            workflowPublicationStatus: workflowPublicationStatus,
            shouldRedirectToDraftMode: shouldRedirectToDraftMode
        }));
    };
    const $b3e3e3cfc7953167$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        borderColor: 'color.border',
        paddingLeft: 'space.050',
        paddingRight: 'space.500',
        paddingTop: 'space.150',
        paddingBottom: 'space.150'
    });
    const $b3e3e3cfc7953167$var$Info = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $b3e3e3cfc7953167$var$RadioIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1epz _u5f3pxbi _19bvu2gc",
                __cmplp.className
            ])
        });
    });
    const $b3e3e3cfc7953167$var$Instruction = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qpxbi _n3tdu2gc _syaz1rc1 _1wybutpp _vwz4pxbi _k48pbfng",
                __cmplp.className
            ])
        });
    });
    const $b3e3e3cfc7953167$var$WarningContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt41bpf",
                __cmplp.className
            ])
        });
    });
    const $b3e3e3cfc7953167$var$WarningText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _16jlkb7n _syaz1w44",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jouoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d22fafff331be84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    const $5d22fafff331be84$var$packageName = "platform-pkg";
    const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
    const $5d22fafff331be84$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $5d22fafff331be84$var$labelPaddingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $5d22fafff331be84$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        position: 'relative',
        alignItems: 'flex-start',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
            cursor: 'not-allowed'
        }
    });
    const $5d22fafff331be84$var$radioStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '24px',
        height: '24px',
        margin: "var(--ds-space-0, 0px)",
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: 'var(--radio-background-color)',
        border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        MozAppearance: 'none',
        outline: 'none',
        '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-dot-opacity': 0,
        transform: 'scale(calc(7 / 12))',
        transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
        verticalAlign: 'top',
        WebkitAppearance: 'none',
        '&::after': {
            width: 'calc(4px * 12 / 7)',
            height: 'calc(4px * 12 / 7)',
            position: 'absolute',
            background: 'var(--radio-dot-color)',
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: "''",
            opacity: 'var(--radio-dot-opacity)',
            transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
        },
        '&:hover': {
            '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        },
        '&:active': {
            '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&:checked': {
            '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-dot-opacity': 1
        },
        '&:checked:hover': {
            '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        },
        '&:checked:active': {
            '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:checked:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&[data-invalid], &:checked[data-invalid]': {
            '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        },
        '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
            cursor: 'not-allowed',
            '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $5d22fafff331be84$var$InnerRadio = (0, $5uXOq.forwardRef)(function Radio(props, ref) {
        const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props;
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'radio',
            packageName: $5d22fafff331be84$var$packageName,
            packageVersion: $5d22fafff331be84$var$packageVersion
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            "data-testid": testId && `${testId}--radio-label`,
            "data-disabled": isDisabled ? 'true' : undefined,
            css: $5d22fafff331be84$var$labelStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": testId && `${testId}--radio-input`,
            "data-invalid": isInvalid ? 'true' : undefined,
            css: $5d22fafff331be84$var$radioStyles,
            ref: ref
        }), label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5d22fafff331be84$var$labelPaddingStyles
        }, label) : null);
    });
    const $5d22fafff331be84$var$Radio = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Radio(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($5d22fafff331be84$var$InnerRadio, {
            ...props,
            ref: ref
        });
    }));
    var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("f2tXr", function(module, exports) {
    $parcel$export(module.exports, "useNewWorkflowEditorPreference", ()=>$14d2db1156738fef$export$b59c27df71e5edcf);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $jcw0u;
    var $co1wz;
    var $fZneA;
    var $8zOmE;
    var $2NMNM;
    var $4V5oU;
    var $6C0Kc;
    const $14d2db1156738fef$export$b59c27df71e5edcf = ()=>{
        const [editorType, setEditorType] = (0, $5uXOq.useState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("6C0Kc")).getUserWorkflowEditorPreference)().then((pref)=>{
                setEditorType(pref);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'getDefaultWorkflowEditorPreferance success');
            }).catch((error)=>{
                setEditorType(null);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('workflow-Editor.preference', 'Unable to fetch workflow editor user preference', error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getDefaultWorkflowEditorPreference',
                        packageName: 'jiraWorkflowEditorPreferenceSettings'
                    },
                    error: error,
                    attributes: {
                        isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)
                    }
                });
            });
        }, [
            createAnalyticsEvent
        ]);
        const shouldUseNewWorkFlowEditor = (0, $5uXOq.useMemo)(()=>{
            if (editorType) return editorType === (0, (0, parcelRequire("4V5oU")).NEW_EDITOR);
            return (0, (0, parcelRequire("co1wz")).ff)('workflow-editor-default-user-preference_go979');
        }, [
            editorType
        ]);
        return {
            shouldUseNewWorkFlowEditor: shouldUseNewWorkFlowEditor,
            userPreference: editorType
        };
    };
});
parcelRegister("6C0Kc", function(module, exports) {
    $parcel$export(module.exports, "getUserWorkflowEditorPreference", ()=>$7fe92009d53491ea$export$d9664e16e2fb1f27);
    var $eusud;
    const $7fe92009d53491ea$var$workflowEditorPreferenceKey = 'jira.user.workflow.editor.global.scope.enrolment';
    const $7fe92009d53491ea$var$WORKFLOW_EDITOR_PREFERENCE_QUERY = `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [
        "${$7fe92009d53491ea$var$workflowEditorPreferenceKey}"
    ])
}
`;
    const $7fe92009d53491ea$export$d9664e16e2fb1f27 = async ()=>{
        const apiResult = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $7fe92009d53491ea$var$WORKFLOW_EDITOR_PREFERENCE_QUERY
            })
        });
        const preferences = apiResult?.data?.myPreferences;
        if (preferences) return preferences[`${$7fe92009d53491ea$var$workflowEditorPreferenceKey}`];
        const errorResponse = apiResult?.errors;
        if (errorResponse) throw new Error(`Error getting user preference: ${$7fe92009d53491ea$var$workflowEditorPreferenceKey}`, {
            cause: apiResult?.errors?.[0] ?? 'unknown'
        });
        return null;
    };
});
parcelRegister("aw33P", function(module, exports) {
    $parcel$export(module.exports, "useOptOutFeedbackDialog", ()=>$681aba6226e00cfc$export$f692fac382bec058);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $bw7Gm;
    var $9OXo1;
    var $fC6Gn;
    const $681aba6226e00cfc$var$unknownAttributeValue = 'unknown';
    const $681aba6226e00cfc$var$FEEDBACK_GROUP_ID = 'workflow-editor-opt-out';
    const $681aba6226e00cfc$export$e4c3d9ebed5d4509 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrpxbi",
                __cmplp.className
            ])
        });
    });
    const $681aba6226e00cfc$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, projectType: projectType, cloudId: cloudId })=>[
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).LOCATION,
                value: (0, (0, parcelRequire("bw7Gm")).default)(window.location.href)
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).REFERER,
                value: document.referrer ? (0, (0, parcelRequire("bw7Gm")).default)(document.referrer) : ''
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).USER_AGENT,
                value: navigator.userAgent
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).SCREEN_RESOLUTION,
                value: `${window.screen.width} x ${window.screen.height}`
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                value: routeName
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: isSiteAdmin.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                value: projectType
            },
            {
                id: 'cloud-id',
                value: cloudId
            }
        ];
    const $681aba6226e00cfc$export$f692fac382bec058 = ({ onClose: onClose = ()=>undefined, projectType: projectType })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const routeName = route.name ?? $681aba6226e00cfc$var$unknownAttributeValue;
        const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackGroupId: $681aba6226e00cfc$var$FEEDBACK_GROUP_ID,
                onClose: onClose,
                feedbackContext: $681aba6226e00cfc$export$b028e515f8f652e0({
                    isSiteAdmin: isSiteAdmin,
                    cloudId: cloudId,
                    routeName: routeName,
                    projectType: projectType || $681aba6226e00cfc$var$unknownAttributeValue
                }),
                feedbackGroupLabels: {
                    empty: {
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).reasonPlaceholder)
                    },
                    bug: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).fieldLabel),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).reasonBug)
                    },
                    comment: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).fieldLabel),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).reasonComment)
                    },
                    suggestion: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).fieldLabel),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).reasonOthers)
                    },
                    question: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).fieldLabel),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).reasonQuestion)
                    }
                },
                feedbackTitleDetails: (0, ($parcel$interopDefault($5uXOq))).createElement($681aba6226e00cfc$export$e4c3d9ebed5d4509, null, formatMessage((0, (0, parcelRequire("fC6Gn")).default).feedbackTitleDetails)),
                selectLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).feedbackTitleDetailsQuestion),
                cancelButtonLabel: formatMessage((0, (0, parcelRequire("fC6Gn")).default).feedbackCancelButton)
            });
        }, [
            formatMessage,
            openFeedbackCollector,
            onClose,
            isSiteAdmin,
            cloudId,
            routeName,
            projectType
        ]);
        return {
            renderFeedbackDialog: renderFeedbackDialog
        };
    };
});
parcelRegister("7iULw", function(module, exports) {
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", ()=>$384a8a865c8f714d$export$baea5c8192e79adc);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", ()=>$384a8a865c8f714d$export$4eda1e3a4a311d13);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", ()=>$384a8a865c8f714d$export$5fb38521eb7ad63c);
    $parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", ()=>$384a8a865c8f714d$export$345c45dd28f28a32);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", ()=>$384a8a865c8f714d$export$8962f2e618411469);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", ()=>$384a8a865c8f714d$export$7d7f2319141db3c5);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", ()=>$384a8a865c8f714d$export$4725635e6fe1907a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", ()=>$384a8a865c8f714d$export$3a50f2efd6cfd6f3);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", ()=>$384a8a865c8f714d$export$5bd148c13bb23f7a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", ()=>$384a8a865c8f714d$export$b4de0744c1fd450d);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", ()=>$384a8a865c8f714d$export$1a7c42187130faf9);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", ()=>$384a8a865c8f714d$export$e84c34a7e1dbcf78);
    $parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", ()=>$384a8a865c8f714d$export$23f6d7b16d2210c1);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", ()=>$384a8a865c8f714d$export$1b65c2053cba0686);
    $parcel$export(module.exports, "EntryKeys", ()=>$384a8a865c8f714d$export$12d01b6c311a909a);
    const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
    const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
    const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
    const $384a8a865c8f714d$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
    const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
    const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
    const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
    const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
    const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
    const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
    const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
    const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
    const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
    const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
    const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
    const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
        CLOUD_ID: 'cloud-id',
        OPT_OUT: 'Opt-out',
        REASON: 'reason',
        FEELING: 'feeling',
        IS_ADMIN: 'is-admin',
        IS_SITE_ADMIN: 'is-site-admin',
        IS_PROJECT_SETTINGS: 'is-project-settings',
        INLINE_FEEDBACK_ID: 'inlineFeedbackId',
        IS_JSD_EVALUATOR: 'is-jsd-evaluator',
        IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
        SUPPORTED_PROJECT_TYPES: 'supported-project-types',
        FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
        FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
        FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
        LOCATION: 'Location',
        PROJECT_TYPE: 'project-type',
        BOARD_TYPE: 'board-type',
        REFERER: 'Referer',
        ROUTE_GROUP: 'route-group',
        ROUTE_NAME: 'route-name',
        USER_AGENT: 'User-Agent',
        SCREEN_RESOLUTION: 'Screen Resolution',
        SOURCE: 'Source',
        SUB_PRODUCT: 'Sub-product',
        JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
        JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
        DEPLOYMENT_PROVIDERS: 'deployment-providers',
        JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
        VERSION_CONTROL_PROVIDERS: 'version-control-providers',
        DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
        CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
        SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
        INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
        IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
        FEEDBACK_GROUP_ID: 'feedback-group-id',
        EDITION: 'edition',
        ENV: 'environment',
        SMART_REPLIES: 'smart-replies'
    });
});
parcelRegister("dseDh", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$c996142feb877ddb$export$4be696be8a3bff13);
    $parcel$export(module.exports, "useFeedbackCollectorActions", ()=>$c996142feb877ddb$export$dfb2ee2d9e73fa48);
    $parcel$export(module.exports, "FeedbackActionsSubscriber", ()=>$c996142feb877ddb$export$c35dbf16ebe9df04);
    var $7JoAD = parcelRequire("7JoAD");
    const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
        isFeedbackCollectorOpen: false,
        entrypointId: undefined,
        email: undefined,
        additionalFields: undefined,
        feedbackTitle: undefined,
        feedbackContext: undefined,
        feedbackCollectorId: undefined,
        showTypeField: true,
        submitButtonLabel: undefined,
        canBeContactedLabel: undefined,
        summaryPlaceholder: undefined,
        feedbackGroupLabels: undefined,
        onClose: undefined,
        feedbackTitleDetails: undefined,
        triggerRef: undefined,
        renderCustomContent: undefined,
        customFeedbackOptions: []
    };
    const $c996142feb877ddb$export$e324594224ef24da = {
        openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
                dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
                setState({
                    ...feedbackCollectorProps,
                    isFeedbackCollectorOpen: true
                });
            },
        closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
                const { triggerRef: triggerRef } = getState();
                if (triggerRef) setTimeout(()=>triggerRef.current?.focus(), 50);
                setState({
                    isFeedbackCollectorOpen: false,
                    triggerRef: undefined
                });
            },
        resetFeedbackCollectorState: ()=>({ setState: setState })=>{
                setState({
                    ...$c996142feb877ddb$export$d4c72bab9d6cc13a
                });
            },
        updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
                setState({
                    renderCustomContent: updatedCustomRenderContent
                });
            },
        updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
                setState({
                    additionalFields: updatedAdditionalFields
                });
            }
    };
    const $c996142feb877ddb$var$Store = (0, $7JoAD.createStore)({
        name: 'feedback-collector',
        initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
        actions: $c996142feb877ddb$export$e324594224ef24da
    });
    const $c996142feb877ddb$export$4be696be8a3bff13 = (0, $7JoAD.createHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, $7JoAD.createActionsHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, $7JoAD.createSubscriber)($c996142feb877ddb$var$Store, {
        selector: null
    });
});
parcelRegister("fC6Gn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b35f74eb43d3eeed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b35f74eb43d3eeed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reasonPlaceholder: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-placeholder",
            "defaultMessage": "Select an option"
        },
        reasonQuestion: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-question",
            "defaultMessage": "Missing features"
        },
        reasonBug: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-bug",
            "defaultMessage": "Bugs"
        },
        reasonComment: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-comment",
            "defaultMessage": "Prefer old editor"
        },
        reasonOthers: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-others",
            "defaultMessage": "Other"
        },
        fieldLabel: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.field-label",
            "defaultMessage": "Add details to help us improve the workflow editor for everyone."
        },
        feedbackTitleDetails: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details",
            "defaultMessage": "Help us improve your experience with the new workflow editor."
        },
        feedbackTitleDetailsQuestion: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details-question",
            "defaultMessage": "Let us know why you\u2019re moving to the old editor"
        },
        feedbackCancelButton: {
            "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-cancel-button",
            "defaultMessage": "Skip step"
        }
    });
});
parcelRegister("e6zF8", function(module, exports) {
    $parcel$export(module.exports, "changeDefaultWorkflowEditorToLegacy", ()=>$45335b456a778f97$export$f16799cd8f24c0e2);
    $parcel$export(module.exports, "changeDefaultWorkflowEditorToNew", ()=>$45335b456a778f97$export$e03a9424d4619803);
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $4V5oU;
    const $45335b456a778f97$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
    const $45335b456a778f97$var$setGlobalScopeUserPreference = async (input)=>{
        const result = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $45335b456a778f97$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
                variables: {
                    input: input
                }
            })
        });
        if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
            cause: result.errors?.[0] ?? 'unknown'
        });
    };
    const $45335b456a778f97$export$f16799cd8f24c0e2 = async (analyticsEvent, workflowPublicationStatus)=>{
        try {
            await $45335b456a778f97$var$setGlobalScopeUserPreference({
                key: 'jira.user.workflow.editor.global.scope.enrolment',
                value: (0, (0, parcelRequire("4V5oU")).LEGACY_EDITOR)
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'legacyWorkflowEditorUserPreference set', {
                workflowPublicationStatus: workflowPublicationStatus === (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Dirty ? 'Unsaved' : (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus)[workflowPublicationStatus]
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'changeDefaultWorkflowEditorToLegacy',
                    packageName: 'jiraWorkflowEditorPreferenceSettings'
                },
                error: error
            });
            throw error;
        }
    };
    const $45335b456a778f97$export$e03a9424d4619803 = async (analyticsEvent, workflowPublicationStatus)=>{
        try {
            await $45335b456a778f97$var$setGlobalScopeUserPreference({
                key: 'jira.user.workflow.editor.global.scope.enrolment',
                value: (0, (0, parcelRequire("4V5oU")).NEW_EDITOR)
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'newWorkflowEditorUserPreference set', {
                workflowPublicationStatus: workflowPublicationStatus === (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus).Dirty ? 'Unsaved' : (0, (0, parcelRequire("4V5oU")).WorkflowPublicationStatus)[workflowPublicationStatus]
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'changeDefaultWorkflowEditorToNew',
                    packageName: 'jiraWorkflowEditorPreferenceSettings'
                },
                error: error
            });
            throw error;
        }
    };
});
parcelRegister("ltuRg", function(module, exports) {
    module.exports = new URL("newEditorImage.very-specific-illu.103374a4.png", import.meta.url).toString();
});
parcelRegister("aNzpN", function(module, exports) {
    module.exports = new URL("oldEditorImage.very-specific-illu.cd2f1dd1.png", import.meta.url).toString();
});
parcelRegister("2ogCC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a84b03951893833$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0a84b03951893833$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.title",
            "defaultMessage": "Select a default workflow editor"
        },
        body: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.body",
            "defaultMessage": "While we continue building the new workflow editor, you can switch between editors as needed. When you select a default, we\u2019ll always open your workflows in that editor."
        },
        instruction: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.instruction",
            "defaultMessage": "Select a default workflow editor"
        },
        link: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.link",
            "defaultMessage": "Learn more about editing workflows."
        },
        learnMoreLink: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.learn-more-link",
            "defaultMessage": "<a>Learn more about editing workflows</a>."
        },
        newWorkflowEditor: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.new-workflow-editor",
            "defaultMessage": "New editor"
        },
        oldWorkflowEditor: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.old-workflow-editor",
            "defaultMessage": "Old editor"
        },
        cancelButton: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.cancel-button",
            "defaultMessage": "Cancel"
        },
        confirmButton: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.confirm-button",
            "defaultMessage": "Confirm"
        },
        updateButton: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.update-button",
            "defaultMessage": "Update"
        },
        draftLossWarning: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.draft-loss-warning",
            "defaultMessage": "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then publish your draft workflow before continuing."
        },
        draftUnpublishedWarning: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.draft-unpublished-warning",
            "defaultMessage": "Publish your draft workflow before continuing so that your edits will be visible in the new workflow editor."
        },
        dirtyLossWarning: {
            "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.dirty-loss-warning",
            "defaultMessage": "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then {update} workflow before continuing."
        }
    });
});
parcelRegister("8iMd2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cff5443ae1882d3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5cff5443ae1882d3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openInNewEditor: {
            "id": "workflow-editor-preference-settings.open-in-new-editor",
            "defaultMessage": "Open workflow in new editor"
        },
        changeDefaultEditor: {
            "id": "workflow-editor-preference-settings.change-default-editor",
            "defaultMessage": "Change default editor"
        },
        switchEditorButton: {
            "id": "workflow-editor-preference-settings.switch-editor-button",
            "defaultMessage": "Switch editor"
        }
    });
});
parcelRegister("anXSE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$286d76c503aa7d78$export$2e2bcd8739ae039);
    const $286d76c503aa7d78$var$applyLazyOpts = (route)=>{
        if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
            const hydratedRoute = {
                ...route,
                ...route.lazyOpts()
            };
            delete hydratedRoute.lazyOpts;
            return hydratedRoute;
        }
        return route;
    };
    var $286d76c503aa7d78$export$2e2bcd8739ae039 = $286d76c503aa7d78$var$applyLazyOpts;
});
parcelRegister("5HG6S", function(module, exports) {
    $parcel$export(module.exports, "getSpaRouterContext", ()=>$804f5602998bd8a4$export$1f61c5e3f6410afa);
    const $804f5602998bd8a4$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
            tenantContext: tenantContext
        });
});
parcelRegister("3qHVS", function(module, exports) {
    $parcel$export(module.exports, "visualRefreshResolverOverride", ()=>$56907fa85239d7b0$export$73a94df81a7c0f2c);
    var $dCm1o;
    const $56907fa85239d7b0$var$visualRefreshPlatformFlags = [
        'platform-component-visual-refresh',
        'platform-visual-refresh-icons-legacy-facade',
        'platform-visual-refresh-icons'
    ];
    const $56907fa85239d7b0$export$73a94df81a7c0f2c = [
        (flagKey)=>$56907fa85239d7b0$var$visualRefreshPlatformFlags.includes(flagKey),
        (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)
    ];
});
parcelRegister("dCm1o", function(module, exports) {
    $parcel$export(module.exports, "isVisualRefreshEnabled", ()=>$322f7f27e3ad3058$export$48345cb467db19b6);
    var $4R6GH;
    var $1MhR0;
    const $322f7f27e3ad3058$var$DUMMY_CONDITION = true;
    const $322f7f27e3ad3058$export$48345cb467db19b6 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh') && ($322f7f27e3ad3058$var$isVisualRefreshInDogfooding() || $322f7f27e3ad3058$var$isVisualRefreshInEAP() || $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta());
    const $322f7f27e3ad3058$var$isVisualRefreshInDogfooding = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-dogfood') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInEAP = ()=>(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-eap') && !(0, (0, parcelRequire("1MhR0")).getIsNav4UserOptOut)();
    const $322f7f27e3ad3058$var$isVisualRefreshInOpenBeta = ()=>$322f7f27e3ad3058$var$DUMMY_CONDITION && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh-open-beta');
});
parcelRegister("gIFpA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2YViK")
    ]).then(()=>parcelRequire('gkwRL'));
});
$parcel$global.rwr("2BmTd", ()=>{
    parcelRequire("lRSO6");
    parcelRequire("8oLfs");
    var $2cigx;
    var $8aaWz = parcelRequire("8aaWz");
    (0, $8aaWz.default).install();
    (0, (0, parcelRequire("2cigx")).provideHealthcheck)();
}, [
    "eNmuD",
    "dsiAd",
    "hPzOn",
    "2Lfdl",
    "1QYl5",
    "561Jq",
    "i5RRW",
    "92sUi",
    "kWrFZ",
    "bYT2S",
    "h2MrD",
    "fr9NE",
    "cM9em",
    "e97YG"
]);
$parcel$global.rlb("2BmTd");
